// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               v7.36.2
// source: proto/aquaphobia.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "aquaphobia.v1";

/**
 * Aquaphobia wire protocol v3 — single source of truth for Go and TS types.
 * Positions are integer millipixels (mpx): world is 3840 px = 3_840_000 mpx.
 *
 * v4 makes State a delta: frames carry only the fleets whose visible state
 * changed, plus explicit removals, with a periodic full frame as the
 * resync point. v3 turned the map viewer into a game: every connection is a *player* with a
 * home base, resources, buildings, a shared build queue, a tech tree, ships
 * and fleets. Clients still send intents only — never positions, never
 * resource amounts. The Empire message is the player's private snapshot;
 * State stays the public (detection-filtered) world view.
 *
 * State frames are absolute; delta encoding remains a later concern.
 */

export enum CacheOp {
  CACHE_OP_UNSPECIFIED = 0,
  CACHE_OP_DEPOSIT = 1,
  CACHE_OP_NOTE = 2,
  UNRECOGNIZED = -1,
}

export enum SiteKind {
  SITE_KIND_UNSPECIFIED = 0,
  SITE_KIND_BASE = 1,
  SITE_KIND_DEPOSIT = 2,
  SITE_KIND_CONTROL_POINT = 3,
  SITE_KIND_PLAYER_BASE = 4,
  UNRECOGNIZED = -1,
}

/**
 * What a strategic object does for the faction that holds it (numbers.md
 * §8). SiegeInfo.kind carries one of these values, and the client reads
 * the kind to know which object throws a mark of its own. The roster is
 * mirrored in server/internal/world/sites.go — keep the two in sync
 * (R1082).
 */
export enum ObjKind {
  OBJ_KIND_UNSPECIFIED = 0,
  OBJ_KIND_THRONE = 1,
  OBJ_KIND_SPIRE = 2,
  OBJ_KIND_FORGE = 3,
  OBJ_KIND_KELP = 4,
  OBJ_KIND_BATTERY = 5,
  OBJ_KIND_DRYDOCK = 6,
  OBJ_KIND_ARCHIVE = 7,
  OBJ_KIND_MARSHAL = 8,
  OBJ_KIND_WARD = 9,
  /**
   * OBJ_KIND_BREAKWATER - The Reef Breakwater, an arcade structure and no strategic object of
   * the season map (arcade.md §19.9, R2085).
   */
  OBJ_KIND_BREAKWATER = 10,
  UNRECOGNIZED = -1,
}

/** Buildings per docs/design/numbers.md §2. */
export enum Building {
  BUILDING_UNSPECIFIED = 0,
  BUILDING_BASE = 1,
  BUILDING_RESEARCH_LAB = 2,
  BUILDING_CONSTRUCTION = 3,
  BUILDING_SHIP_DESIGN = 4,
  BUILDING_WHARF = 5,
  BUILDING_HARBOUR = 6,
  BUILDING_STORAGE = 7,
  BUILDING_ALLOY_MINE = 8,
  BUILDING_BIOMASS_FARM = 9,
  BUILDING_VOLATILES_EXTRACTOR = 10,
  BUILDING_LOGISTICS = 11,
  BUILDING_COMMUNICATIONS = 12,
  BUILDING_SONAR = 13,
  BUILDING_RADIATION_CONTROL = 14,
  BUILDING_TORPEDOBANKS = 15,
  BUILDING_RECRUITMENT = 16,
  BUILDING_ACADEMY = 17,
  BUILDING_HOSPITAL = 18,
  /** BUILDING_PRISON - holds 1 captured enemy captain per level (§18) */
  BUILDING_PRISON = 19,
  /**
   * BUILDING_DEPOT - The Depot (v2-the-deep.md §11.5), behind the feature flag sapper: a
   * world with the flag off never sends the value.
   */
  BUILDING_DEPOT = 20,
  UNRECOGNIZED = -1,
}

/**
 * The NPC kind of a hull (v2-the-deep.md §8.1, R2622, protocol 38): a
 * hull of faction 0 with a kind is a hull of the NPC side. A hull of a
 * faction carries none.
 */
export enum NpcKind {
  NPC_KIND_NONE = 0,
  NPC_KIND_PIRATE = 1,
  NPC_KIND_MONSTER = 2,
  UNRECOGNIZED = -1,
}

/**
 * The pirate brotherhood of a den and of its group (v2-the-deep.md §8.5,
 * R2720, protocol 39), in the order of [[npc.brotherhoods]] of
 * data/balance/npc.toml: the value is 1 + the row. The flag pirates
 * gates it, so a world with the flag off sends BROTHERHOOD_NONE.
 */
export enum Brotherhood {
  BROTHERHOOD_NONE = 0,
  BROTHERHOOD_LANTERN_KIN = 1,
  BROTHERHOOD_SALTJAW = 2,
  BROTHERHOOD_NINEFATHOM = 3,
  BROTHERHOOD_GRAPNEL_COMPANY = 4,
  BROTHERHOOD_UNDERTOW = 5,
  UNRECOGNIZED = -1,
}

/**
 * The act of a monster now, for the animation of its body
 * (v2-the-deep.md §8.4, R2719, protocol 39). NPC_ACT_NONE is a hull with
 * no act: every hull of a faction and every pirate hull. The flag
 * pirates gates every other value.
 *
 * - IDLE: it holds, at its lair or at an ambush point.
 * - MOVE: it sails.
 * - TELL: the warning before an attack: the dash of the Murkhide, the
 *   charge of the Thrummer.
 * - STRIKE: the attack lands: the bite of the Gulper, the grab of the
 *   Murkhide.
 * - HOLD: the Murkhide grips a hull (ruling R-b).
 * - LAUNCH: the Quillback launches a salvo of quill pods.
 * - PULSE: the Thrummer discharges.
 * - GATHER: the Myriad forms round a hull or at its lair.
 * - SCATTER: the Myriad breaks up after a kill or a shake-off.
 */
export enum NpcAct {
  NPC_ACT_NONE = 0,
  NPC_ACT_IDLE = 1,
  NPC_ACT_MOVE = 2,
  NPC_ACT_TELL = 3,
  NPC_ACT_STRIKE = 4,
  NPC_ACT_HOLD = 5,
  NPC_ACT_LAUNCH = 6,
  NPC_ACT_PULSE = 7,
  NPC_ACT_GATHER = 8,
  NPC_ACT_SCATTER = 9,
  UNRECOGNIZED = -1,
}

/**
 * The state of a den the faction knows (v2-the-deep.md §8.5, R2720,
 * protocol 39): its group lies at the den, its group is at sea, or its
 * group sank and the den waits to sail a new one.
 */
export enum DenState {
  DEN_STATE_NONE = 0,
  DEN_STATE_HOME = 1,
  DEN_STATE_AT_SEA = 2,
  DEN_STATE_SUNK = 3,
  UNRECOGNIZED = -1,
}

/**
 * The pirate cache of a den for the holder of its chart fragment
 * (v2-the-deep.md §8.2, §9.1, R2720, protocol 39). DEN_CACHE_NONE: the
 * reader holds no fragment of the den, or `treasure` is off. SEEN: the
 * reader holds the fragment and no hull of the reader took the cache this
 * season. TAKEN: a hull of the reader took it.
 */
export enum DenCache {
  DEN_CACHE_NONE = 0,
  DEN_CACHE_SEEN = 1,
  DEN_CACHE_TAKEN = 2,
  UNRECOGNIZED = -1,
}

/** Ship classes per docs/design/numbers.md §3. */
export enum ShipClass {
  SHIP_CLASS_UNSPECIFIED = 0,
  SHIP_CLASS_CORSAIR = 1,
  SHIP_CLASS_CUTLASS = 2,
  SHIP_CLASS_FALCONET = 3,
  SHIP_CLASS_BASILISK = 4,
  SHIP_CLASS_BOMBARD = 5,
  SHIP_CLASS_SENTINEL = 6,
  SHIP_CLASS_VEDETTE = 7,
  SHIP_CLASS_ORACLE = 8,
  SHIP_CLASS_DREDGER = 9,
  /** SHIP_CLASS_LANCER - the torpedo archetype (decided 2026-08-21) */
  SHIP_CLASS_LANCER = 10,
  /**
   * SHIP_CLASS_BEACON - The Beacon (sov-anchor experiment, R114): slow, defenceless, and
   * the only hull that moves territory now.
   */
  SHIP_CLASS_BEACON = 11,
  /**
   * SHIP_CLASS_TENDER - The Tender (R712): a gunless support hull that repairs what
   * sails near it, and that anchors to become a berth.
   */
  SHIP_CLASS_TENDER = 12,
  /**
   * SHIP_CLASS_COMMODORE - The Commodore, the command ship (v2-the-deep.md §16.7, R2535). It
   * plays in every Conquest world (R2805); an arcade map names no
   * Commodore.
   */
  SHIP_CLASS_COMMODORE = 13,
  /**
   * SHIP_CLASS_GULPER - The Gulper, the monster of the NPC side (v2-the-deep.md §8.3,
   * R2622), behind the feature flag pirates: a world with the flag off
   * never sends the value, and no empire builds the hull.
   */
  SHIP_CLASS_GULPER = 14,
  /**
   * SHIP_CLASS_SAPPER - The Sapper, the military engineer (v2-the-deep.md §11.1, R1537),
   * behind the feature flag sapper: a world with the flag off never
   * sends the value.
   */
  SHIP_CLASS_SAPPER = 15,
  /**
   * SHIP_CLASS_MURKHIDE - The four monsters of round 109 (v2-the-deep.md §8.4, R2719, protocol
   * 39), behind the feature flag pirates, as the Gulper: a world with
   * the flag off never sends the values, and no empire builds the hulls.
   */
  SHIP_CLASS_MURKHIDE = 16,
  SHIP_CLASS_QUILLBACK = 17,
  SHIP_CLASS_THRUMMER = 18,
  SHIP_CLASS_MYRIAD = 19,
  UNRECOGNIZED = -1,
}

/** What a queue job produces. One shared queue (game-design §6). */
export enum JobKind {
  JOB_KIND_UNSPECIFIED = 0,
  /** JOB_KIND_BUILDING - target = Building, level = target level */
  JOB_KIND_BUILDING = 1,
  /** JOB_KIND_SHIP - target = ShipClass, count = how many */
  JOB_KIND_SHIP = 2,
  /** JOB_KIND_RESEARCH - target = tech node id */
  JOB_KIND_RESEARCH = 3,
  /** JOB_KIND_CREDITS - dedicated minting (numbers.md §1) */
  JOB_KIND_CREDITS = 4,
  /** JOB_KIND_REPAIR - target = fleet id */
  JOB_KIND_REPAIR = 5,
  /** JOB_KIND_TRAINING - target = captain id, count = attribute index */
  JOB_KIND_TRAINING = 6,
  /** JOB_KIND_TORPEDO - target = TorpedoKind, count = how many */
  JOB_KIND_TORPEDO = 7,
  /** JOB_KIND_INVENT - target = ShipClass being designed */
  JOB_KIND_INVENT = 8,
  /** JOB_KIND_EXPEDITION - target = captain id, count = depth */
  JOB_KIND_EXPEDITION = 9,
  /** JOB_KIND_PRINT - target = master id, count = runs (v6) */
  JOB_KIND_PRINT = 10,
  /**
   * JOB_KIND_SEA_OBJECT - A batch of sea objects for the Depot (v2-the-deep.md §11.5), behind
   * the feature flag sapper: target = SeaObjectKind, count = how many.
   */
  JOB_KIND_SEA_OBJECT = 11,
  UNRECOGNIZED = -1,
}

/**
 * The kinds of sea object of v2 phase 6 (v2-the-deep.md §11.2, §11.3),
 * behind the feature flag sapper: four sea mines, then six deployables.
 * The values follow game.SeaObjectKind.
 */
export enum SeaObjectKind {
  SEA_OBJECT_KIND_NONE = 0,
  SEA_OBJECT_KIND_BARB = 1,
  SEA_OBJECT_KIND_BOLA = 2,
  SEA_OBJECT_KIND_SIREN = 3,
  SEA_OBJECT_KIND_PETARD = 4,
  SEA_OBJECT_KIND_SEINE = 5,
  SEA_OBJECT_KIND_CHEVAL = 6,
  SEA_OBJECT_KIND_PICKET_BUOY = 7,
  SEA_OBJECT_KIND_LANE_LIGHT = 8,
  SEA_OBJECT_KIND_DECOY_BUOY = 9,
  SEA_OBJECT_KIND_PALISADE = 10,
  UNRECOGNIZED = -1,
}

/**
 * Torpedo types per docs/design/numbers.md §5. Which hull may load which
 * kind is data on ShipSpec.torpedoes (decided 2026-08-21: the Lancer
 * carries every ship-fired kind, artillery keeps Light targeted only);
 * the heavy, interceptor and bulwark launch from a base's Torpedobanks
 * and are never loadable by any hull.
 */
export enum TorpedoKind {
  TORPEDO_KIND_UNSPECIFIED = 0,
  /** TORPEDO_KIND_LIGHT - targeted: flies to where the contact was */
  TORPEDO_KIND_LIGHT = 1,
  /** TORPEDO_KIND_SEEKER - chases, hits for less */
  TORPEDO_KIND_SEEKER = 2,
  /** TORPEDO_KIND_DISRUPTOR - little damage, slows the target */
  TORPEDO_KIND_DISRUPTOR = 3,
  /** TORPEDO_KIND_HEAVY - Torpedobank, splash */
  TORPEDO_KIND_HEAVY = 4,
  /**
   * TORPEDO_KIND_INTERCEPTOR - Point-defence ammunition (decided 2026-08-21, R86): base-only rounds
   * the base auto-fires — the Interceptor at support hulls, the Bulwark
   * at combat hulls. Both also fire manually through the base aim flow.
   */
  TORPEDO_KIND_INTERCEPTOR = 5,
  TORPEDO_KIND_BULWARK = 6,
  /**
   * TORPEDO_KIND_POD - The quill pod of the Quillback (v2-the-deep.md §8.4, R2719, ruling
   * R-c, protocol 39): a round of the NPC side, behind the feature flag
   * pirates. No hull of a faction loads it, no empire builds it, and no
   * catalog names it.
   */
  TORPEDO_KIND_POD = 7,
  /**
   * TORPEDO_KIND_COUNTERMINE - The five rounds of the torpedo refresh (numbers.md §5, R2779,
   * protocol 41). Only the Lancer loads them, and AUTO takes none of
   * them. The last three are own-side rounds: their effect lands on own
   * hulls.
   */
  TORPEDO_KIND_COUNTERMINE = 8,
  /** TORPEDO_KIND_STONEFISH - waits at its aim point for a hostile hull */
  TORPEDO_KIND_STONEFISH = 9,
  /** TORPEDO_KIND_WRASSE - repairs an own hull */
  TORPEDO_KIND_WRASSE = 10,
  /** TORPEDO_KIND_SEPIA - a quiet screen on own hulls */
  TORPEDO_KIND_SEPIA = 11,
  /** TORPEDO_KIND_SAILFISH - a speed surge on own hulls */
  TORPEDO_KIND_SAILFISH = 12,
  UNRECOGNIZED = -1,
}

export enum Mission {
  MISSION_UNSPECIFIED = 0,
  MISSION_MOVE = 1,
  /** MISSION_GATHER - hauler fleet cutting a deposit into its hold */
  MISSION_GATHER = 2,
  /** MISSION_PATROL - shuttle between origin and destination, guarding */
  MISSION_PATROL = 3,
  /** MISSION_DEFEND - hold position, first engagement */
  MISSION_DEFEND = 4,
  /** MISSION_RETURN - hold full: hauling it home to be unloaded */
  MISSION_RETURN = 5,
  /** MISSION_HOME - sailing home to unload and dock */
  MISSION_HOME = 6,
  /** MISSION_CAPTURE - DISABLED (R114): the capture cycle is gone. Kept on the */
  MISSION_CAPTURE = 7,
  /**
   * MISSION_ESCORT - wire so flipping the experiment back is a code change,
   * not a protocol change. Never sent, never accepted.
   */
  MISSION_ESCORT = 8,
  /** MISSION_ATTACK_MOVE - advance on a point, hunting audible hostiles en route (R79) */
  MISSION_ATTACK_MOVE = 9,
  /** MISSION_ANCHOR - Beacon pinned to its tile, radiating sov (R114) */
  MISSION_ANCHOR = 10,
  /** MISSION_STEER - the helm of the sea view: a heading and a throttle step under a lease (R2638) */
  MISSION_STEER = 11,
  /**
   * MISSION_SEARCH - SEARCH (v2-the-deep.md §9.1, §9.2, R2629, R2643, R2860): a
   * FleetOrder at a point. The fleet sails there, works on the map clock,
   * loud as a launch, and takes a cache within reach and the cargo share
   * of the wrecks within reach. Only while `treasure` is latched.
   */
  MISSION_SEARCH = 12,
  UNRECOGNIZED = -1,
}

/**
 * AnchorState is the Beacon's four-state machine (R114). Setting and
 * weighing each take one full cycle; only SET radiates.
 */
export enum AnchorState {
  /** ANCHOR_STATE_UNSPECIFIED - under way, or not an anchor hull */
  ANCHOR_STATE_UNSPECIFIED = 0,
  /** ANCHOR_STATE_SETTING - dropping: cycle running, no radiation yet */
  ANCHOR_STATE_SETTING = 1,
  /** ANCHOR_STATE_SET - fully anchored and radiating */
  ANCHOR_STATE_SET = 2,
  /** ANCHOR_STATE_WEIGHING - lifting: cycle running, radiation already off */
  ANCHOR_STATE_WEIGHING = 3,
  UNRECOGNIZED = -1,
}

/**
 * Chat channels (game-design §10). Global is world-wide; the rest follow
 * the three tiers of belonging in §5.
 */
export enum ChatChannel {
  CHAT_CHANNEL_UNSPECIFIED = 0,
  CHAT_CHANNEL_GLOBAL = 1,
  CHAT_CHANNEL_FACTION = 2,
  CHAT_CHANNEL_CLAN = 3,
  CHAT_CHANNEL_SQUAD = 4,
  UNRECOGNIZED = -1,
}

/** What a commander is doing to a scheduled contest (game-design §4). */
export enum SiegeOp {
  SIEGE_OP_UNSPECIFIED = 0,
  /**
   * SIEGE_OP_COMMIT - §8 revamp: one op — COMMIT. Attack or defence falls out of the
   * fleet's faction against the object's owner. There is no withdrawing
   * from a pledge: the fleet is off the map until the window resolves.
   */
  SIEGE_OP_COMMIT = 1,
  UNRECOGNIZED = -1,
}

export enum FleetOp {
  FLEET_OP_UNSPECIFIED = 0,
  /** FLEET_OP_DOCK - return ships to the base pool (must be at base) */
  FLEET_OP_DOCK = 1,
  /** FLEET_OP_MERGE - arg = other fleet id (same class, co-located) */
  FLEET_OP_MERGE = 2,
  /** FLEET_OP_SPLIT - arg = ships to peel off into a new fleet */
  FLEET_OP_SPLIT = 3,
  /** FLEET_OP_RETURN - sail home; unload and dock on arrival */
  FLEET_OP_RETURN = 4,
  /** FLEET_OP_ESCORT - arg = fleet to follow (own faction) */
  FLEET_OP_ESCORT = 5,
  /** FLEET_OP_SCAN - scout: active ping, report to squad chat */
  FLEET_OP_SCAN = 7,
  /** FLEET_OP_ANCHOR - Beacon: toggle the anchor (drop if up, lift if down) */
  FLEET_OP_ANCHOR = 8,
  /** FLEET_OP_HOLD_FAST - toggle auto-withdraw: off = fight where you stand */
  FLEET_OP_HOLD_FAST = 9,
  /**
   * FLEET_OP_SET_CAPTAIN - Pens-side operations. A fleet is a persistent object, so these address a
   * hull that is docked rather than at sea.
   */
  FLEET_OP_SET_CAPTAIN = 10,
  /** FLEET_OP_BREAK - scrap a docked hull for parts */
  FLEET_OP_BREAK = 12,
  /**
   * FLEET_OP_SHARE_SONAR - Oracle: share the array with the whole faction for sim.oracle_share_sec
   * of map time at oracle_share_sensitivity times its reach; costs hull (R453).
   */
  FLEET_OP_SHARE_SONAR = 13,
  /**
   * FLEET_OP_FOCUS - Chase one named hostile and fire at it alone (R544): arg = the contact's
   * fleet id. The fleet holds fire while that contact is out of its band,
   * sails to the last point it heard it at when it goes silent, and stands
   * down where it is when the contact sinks.
   */
  FLEET_OP_FOCUS = 14,
  /**
   * FLEET_OP_DEEP_RUN - Thermocline running (Thermocline Running, A8): toggle the gait that halves speed,
   * wears the hull and takes the fleet off every fixed listener.
   */
  FLEET_OP_DEEP_RUN = 15,
  /**
   * FLEET_OP_DECOY - A Vedette drops a noisemaker (Decoys, A6): a false contact that reads
   * as the dropper standing still.
   */
  FLEET_OP_DECOY = 16,
  /**
   * FLEET_OP_SET_BATTLE_PLAN - Set the fleet's battle plan for a window battle (numbers.md §8, R796):
   * arg packs the position in the low byte and the behaviour in the next
   * one — arg = position | behaviour << 8. Position is 0 CENTRE, 1 FRONT,
   * 2 REAR; behaviour is 0 ENGAGE, 1 HOLD, 2 FLANK. The server refuses a
   * value it does not know. The op reaches a fleet wherever it stands,
   * the pens and a pledge at an object included, because a commander sets
   * the plan of a fleet that already waits at the window.
   */
  FLEET_OP_SET_BATTLE_PLAN = 17,
  /**
   * FLEET_OP_AUTO_FIELD - Toggle the dredger brain for one hauler (R1226): on, the hauler takes
   * the next field in own water by itself when its field dies; off, it
   * parks. The server refuses the op for a hull that is not a Dredger and
   * for an empire that does not hold the `dredger_brain` perk.
   */
  FLEET_OP_AUTO_FIELD = 18,
  /**
   * FLEET_OP_HOLD_FIRE - Toggle hold fire on one armed fleet (numbers.md §4, R1437): on, the
   * gun takes no target by itself, so the fleet can lie still and silent;
   * a FOCUS still fires. The flag stays until the owner toggles it again.
   * The server refuses the op for a hull with no gun (DPS 0).
   */
  FLEET_OP_HOLD_FIRE = 19,
  /**
   * FLEET_OP_SET_ROUND - Pick the active round of a hull (R2017): arg = TorpedoKind. Every
   * shot fires the active round until the commander picks again; when it
   * is empty, the next kind in the fixed order Harpoon, Remora, Torpor
   * fires. The op reaches a hull at sea and in the pens, and it leaves
   * the reload clock alone. The server refuses a kind the hull cannot
   * fire.
   */
  FLEET_OP_SET_ROUND = 20,
  /**
   * FLEET_OP_SET_LOAD - Set the load mix of a docked hull (R2017): FleetAction.load carries
   * the count of each kind, and an empty list is AUTO. The whole mix must
   * fit the magazine, and the hull must load every kind in it. The hull
   * keeps the mix for every later deploy. Docked only.
   */
  FLEET_OP_SET_LOAD = 21,
  /**
   * FLEET_OP_SIGNATURE - Spend the signature order of a hull at sea now (numbers.md §4.1,
   * R2371). The server refuses it in a window battle (the arena plays
   * without the approach), for a hull without an order, and for a spent
   * charge.
   */
  FLEET_OP_SIGNATURE = 22,
  /**
   * FLEET_OP_LAY - A Sapper lays one sea object at its own point (v2-the-deep.md §11.1,
   * R2651): arg = the SeaObjectKind, and 0 lays the last kind again
   * (R2635). The server refuses a hull that is not a Sapper, a kind not
   * in the stow, a lay before the lay cadence ends, water the kind may
   * not take (§11.4), a lay inside the lay spacing of an own sea mine
   * and a lay past the live count of the Depot. Only while `sapper` is
   * latched.
   */
  FLEET_OP_LAY = 25,
  /**
   * FLEET_OP_COLLECT - A Sapper at rest collects (§11.1, R2651): after the collect time it
   * takes every allowed item inside the collect radius aboard, the
   * nearest first; an item that does not fit the stow stays. Only while
   * `sapper` is latched.
   */
  FLEET_OP_COLLECT = 26,
  /**
   * FLEET_OP_SET_STOW - The stow a Sapper in the pens loads at its next deploy (v2-the-deep.md
   * §11.1, R2654): FleetAction.stow, one row for each kind; an empty list
   * is AUTO. The prep door of the rounds (FLEET_OP_SET_LOAD, R2017) works
   * the same way: nothing leaves the Depot here, and the deploy takes the
   * stow out of the stock. The server refuses a hull that is not a Sapper
   * in the pens and a stow past its cargo room. Only while `sapper` is
   * latched.
   */
  FLEET_OP_SET_STOW = 27,
  /**
   * FLEET_OP_BEAM - Start the beam order of a SET Beacon (numbers.md §8, R2858): it beams
   * for sov.beacon_beam_sec of map time. The anchor reaching SET starts it
   * by itself, and a weigh stops it. The server refuses a hull that is not
   * a Beacon, an anchor that is not SET and a beam that runs.
   */
  FLEET_OP_BEAM = 28,
  UNRECOGNIZED = -1,
}

/**
 * The kind of a fairway buoy (v2-the-deep.md §7.1, R2717), in the order of
 * world.BuoyKind.
 */
export enum BuoyKind {
  BUOY_KIND_NONE = 0,
  BUOY_KIND_PORT = 1,
  BUOY_KIND_STARBOARD = 2,
  BUOY_KIND_MARK = 3,
  BUOY_KIND_JUNCTION = 4,
  UNRECOGNIZED = -1,
}

/**
 * The kind of a point of interest (v2-the-deep.md §4.2, R2611), in the
 * order of world.POIKind.
 */
export enum PoiKind {
  POI_KIND_NONE = 0,
  POI_KIND_VENT = 1,
  POI_KIND_CACHE = 2,
  POI_KIND_LAIR = 3,
  POI_KIND_GATE = 4,
  POI_KIND_RUIN = 5,
  UNRECOGNIZED = -1,
}

/**
 * The state of the monster of a lair on a PoiLive row (v2-the-deep.md
 * §8.3, R2735): at home inside the home radius of its lair, out on the
 * roam past it, or gone (sunk, or not at sea yet) until it sails again.
 */
export enum PoiMonster {
  POI_MONSTER_NONE = 0,
  POI_MONSTER_HOME = 1,
  POI_MONSTER_OUT = 2,
  POI_MONSTER_GONE = 3,
  UNRECOGNIZED = -1,
}

/**
 * The depth band of a cell and the depth rating of a hull
 * (v2-the-deep.md §3.1, §3.2, R2609), from the shallowest. NONE is rock,
 * or no band.
 */
export enum DepthBand {
  DEPTH_BAND_NONE = 0,
  DEPTH_BAND_SHELF = 1,
  DEPTH_BAND_SLOPE = 2,
  DEPTH_BAND_DEEP = 3,
  DEPTH_BAND_ABYSS = 4,
  UNRECOGNIZED = -1,
}

export enum MonumentKind {
  MONUMENT_KIND_UNSPECIFIED = 0,
  MONUMENT_KIND_REEF = 1,
  MONUMENT_KIND_HOLD_SITE = 2,
  /** MONUMENT_KIND_POOL - a pool entry of another world (R1243) */
  MONUMENT_KIND_POOL = 3,
  UNRECOGNIZED = -1,
}

/**
 * What a level of a building opens. The ladder is static, so it rides the
 * hello catalog and not every Empire frame (R1081).
 */
export enum LevelUnlockKind {
  LEVEL_UNLOCK_UNSPECIFIED = 0,
  /** LEVEL_UNLOCK_BUILD_SLOT - value = the slot this level buys */
  LEVEL_UNLOCK_BUILD_SLOT = 1,
  /** LEVEL_UNLOCK_TECH_TIER - value = the tech tier */
  LEVEL_UNLOCK_TECH_TIER = 2,
  /** LEVEL_UNLOCK_RECV_WARSHIP - see every warship hull of your squad */
  LEVEL_UNLOCK_RECV_WARSHIP = 4,
  /** LEVEL_UNLOCK_RECV_INSTALLATION - receive the installation rings */
  LEVEL_UNLOCK_RECV_INSTALLATION = 5,
  /** LEVEL_UNLOCK_SHARE_FLEET - your fleets' rings join the pool */
  LEVEL_UNLOCK_SHARE_FLEET = 6,
  /** LEVEL_UNLOCK_ORACLE_SHARE - press SHARE on an Oracle */
  LEVEL_UNLOCK_ORACLE_SHARE = 7,
  /** LEVEL_UNLOCK_RECV_FLEET - read the squad's pooled fleet rings */
  LEVEL_UNLOCK_RECV_FLEET = 8,
  /** LEVEL_UNLOCK_SHIPYARD_HULL - value = the ShipClass this level lays */
  LEVEL_UNLOCK_SHIPYARD_HULL = 9,
  /** LEVEL_UNLOCK_BASE_TUBES - the hold fires its own rounds */
  LEVEL_UNLOCK_BASE_TUBES = 10,
  /** LEVEL_UNLOCK_WEAPON_TYPES - a draft may pick a weapon type */
  LEVEL_UNLOCK_WEAPON_TYPES = 11,
  /** LEVEL_UNLOCK_SHIELD_TYPES - a draft may pick a shield type */
  LEVEL_UNLOCK_SHIELD_TYPES = 12,
  /** LEVEL_UNLOCK_MODULE_SLOT - value = the module slots a design carries */
  LEVEL_UNLOCK_MODULE_SLOT = 13,
  /** LEVEL_UNLOCK_POINT_DEFENCE - the hold fires point defence by itself (R1154) */
  LEVEL_UNLOCK_POINT_DEFENCE = 14,
  /**
   * LEVEL_UNLOCK_SEA_OBJECT - The Depot (v2-the-deep.md §11.5, R2653), behind the feature flag
   * sapper: value = the SeaObjectKind this Depot level opens. The client
   * names the kind from Catalog.sea_objects.
   */
  LEVEL_UNLOCK_SEA_OBJECT = 15,
  UNRECOGNIZED = -1,
}

/**
 * What a market listing sells (v12). The enum leaves room for more kinds;
 * UNSPECIFIED reads as BLUEPRINT so a pre-v12 listing keeps its meaning.
 */
export enum MarketItemKind {
  MARKET_ITEM_KIND_UNSPECIFIED = 0,
  /** MARKET_ITEM_KIND_BLUEPRINT - a print; `print` is filled */
  MARKET_ITEM_KIND_BLUEPRINT = 1,
  /** MARKET_ITEM_KIND_ISOTOPES - an escrowed lot; `qty` is filled */
  MARKET_ITEM_KIND_ISOTOPES = 2,
  UNRECOGNIZED = -1,
}

/**
 * The career phase of a captain (numbers.md §12, R1170). The client
 * switches on it, because the `phase` string is a translated label.
 */
export enum CaptainPhase {
  CAPTAIN_PHASE_UNSPECIFIED = 0,
  CAPTAIN_PHASE_RISE = 1,
  CAPTAIN_PHASE_PEAK = 2,
  CAPTAIN_PHASE_DECLINE = 3,
  UNRECOGNIZED = -1,
}

/**
 * The stack keys of a modifier (v2-the-deep.md §6.1), in the one global
 * order the stat accessors multiply them in, then the two conditions of
 * phase 2 that are not stack keys of a multiplier: PRESSURE (a hull below
 * its depth rating loses hull, §3.2) and DRIFT (the current moves the
 * hull, §5.2), and COMMAND of the command ship (the command aura lifts
 * one attribute or more of the hull, §16.7, R2732; pct 0). SCREEN and
 * SURGE, the two stack keys of the own-side rounds (numbers.md §5,
 * R2779), follow COMMAND, so no value of before moves; the row lists
 * them in the order of the stack keys, after WIRE. The sea view and the
 * client read an unknown key as no chip.
 */
export enum ConditionKey {
  CONDITION_KEY_UNSPECIFIED = 0,
  CONDITION_KEY_GHOST = 1,
  CONDITION_KEY_ANCHOR = 2,
  CONDITION_KEY_SLOW = 3,
  CONDITION_KEY_ECHO = 4,
  CONDITION_KEY_DEEP_RUN = 5,
  CONDITION_KEY_TERRAIN = 6,
  CONDITION_KEY_SIGNATURE = 7,
  CONDITION_KEY_HARBOUR = 8,
  CONDITION_KEY_LANE = 9,
  CONDITION_KEY_NET = 10,
  CONDITION_KEY_WIRE = 11,
  CONDITION_KEY_PRESSURE = 12,
  CONDITION_KEY_DRIFT = 13,
  CONDITION_KEY_COMMAND = 14,
  CONDITION_KEY_SCREEN = 15,
  CONDITION_KEY_SURGE = 16,
  UNRECOGNIZED = -1,
}

/**
 * The signature order of a warship class, and of the Dredger (numbers.md §4.1,
 * R2371). The client owns the word of each (ui.toml) and mirrors no
 * figure: CatalogRules.approach states them.
 */
export enum SignatureOrder {
  SIGNATURE_ORDER_NONE = 0,
  /** SIGNATURE_ORDER_OUTFLANK - Corsair */
  SIGNATURE_ORDER_OUTFLANK = 1,
  /** SIGNATURE_ORDER_BRACE - Cutlass */
  SIGNATURE_ORDER_BRACE = 2,
  /** SIGNATURE_ORDER_CANISTER - Falconet */
  SIGNATURE_ORDER_CANISTER = 3,
  /** SIGNATURE_ORDER_DIG_IN - Basilisk */
  SIGNATURE_ORDER_DIG_IN = 4,
  /** SIGNATURE_ORDER_BROADSIDE - Bombard */
  SIGNATURE_ORDER_BROADSIDE = 5,
  /** SIGNATURE_ORDER_CRASH_DIVE - Lancer */
  SIGNATURE_ORDER_CRASH_DIVE = 6,
  /** SIGNATURE_ORDER_MUSTER - Commodore (v2-the-deep.md §16.7) */
  SIGNATURE_ORDER_MUSTER = 7,
  /** SIGNATURE_ORDER_GETAWAY - Dredger, the one support hull with an order (R2857) */
  SIGNATURE_ORDER_GETAWAY = 8,
  UNRECOGNIZED = -1,
}

/**
 * The condition on which the sim spends the charge of a hull whose
 * commander is absent: the class default (numbers.md §4.1, R2371,
 * R2387). MANUAL arms nothing: the button alone spends it. 0 is "no
 * trigger": a hull without an order.
 */
export enum SignatureTrigger {
  SIGNATURE_TRIGGER_NONE = 0,
  SIGNATURE_TRIGGER_MANUAL = 1,
  /** SIGNATURE_TRIGGER_OPENING_SHOT - AT THE OPENING SHOT */
  SIGNATURE_TRIGGER_OPENING_SHOT = 2,
  /** SIGNATURE_TRIGGER_HIT_FIRST - WHEN HIT FIRST */
  SIGNATURE_TRIGGER_HIT_FIRST = 3,
  /** SIGNATURE_TRIGGER_BELOW_HALF - BELOW 50 % HULL */
  SIGNATURE_TRIGGER_BELOW_HALF = 4,
  /** SIGNATURE_TRIGGER_FORMATION_TRAVEL - IN FORMATION TRAVEL (v2-the-deep.md §16.7) */
  SIGNATURE_TRIGGER_FORMATION_TRAVEL = 5,
  UNRECOGNIZED = -1,
}

/**
 * The charge of a signature order (numbers.md §4.1, R2371). 0 is "not
 * sent": a hull without an order, a viewer who may not see it, or a
 * sim without the approach.
 */
export enum SignatureCharge {
  SIGNATURE_CHARGE_NONE = 0,
  SIGNATURE_CHARGE_READY = 1,
  SIGNATURE_CHARGE_SPENT = 2,
  UNRECOGNIZED = -1,
}

/**
 * Which figure of the empire a building level drives (R1081). One value per
 * figure, so the client picks a sentence and computes nothing.
 */
export enum LevelEffectKind {
  LEVEL_EFFECT_UNSPECIFIED = 0,
  /** LEVEL_EFFECT_BASE_CAP - the level cap every other building may reach */
  LEVEL_EFFECT_BASE_CAP = 1,
  LEVEL_EFFECT_RESEARCH_SPEED = 2,
  LEVEL_EFFECT_BUILD_SLOTS = 3,
  LEVEL_EFFECT_QUEUE_SPEED = 4,
  LEVEL_EFFECT_MASTER_SLOTS = 5,
  LEVEL_EFFECT_COPY_SLOTS = 6,
  /** LEVEL_EFFECT_PRINT_LISTINGS - auction listings for prints */
  LEVEL_EFFECT_PRINT_LISTINGS = 7,
  /** LEVEL_EFFECT_SHIP_SPEED - ship build and repair multiplier */
  LEVEL_EFFECT_SHIP_SPEED = 8,
  LEVEL_EFFECT_COMBAT_CAP = 9,
  LEVEL_EFFECT_SUPPORT_CAP = 10,
  /** LEVEL_EFFECT_STORAGE_CAP - the per-resource cap */
  LEVEL_EFFECT_STORAGE_CAP = 11,
  /** LEVEL_EFFECT_ALLOY_RATE - alloy an hour */
  LEVEL_EFFECT_ALLOY_RATE = 12,
  LEVEL_EFFECT_BIOMASS_RATE = 13,
  LEVEL_EFFECT_VOLATILES_RATE = 14,
  /** LEVEL_EFFECT_MISSION_CAP - fleets at sea */
  LEVEL_EFFECT_MISSION_CAP = 15,
  /** LEVEL_EFFECT_SONAR_RANGE - the hold's listening range in px */
  LEVEL_EFFECT_SONAR_RANGE = 16,
  /** LEVEL_EFFECT_DIVE_RISK - the dive injury-risk multiplier */
  LEVEL_EFFECT_DIVE_RISK = 17,
  /** LEVEL_EFFECT_ISOTOPE_LOTS - isotope auction lots */
  LEVEL_EFFECT_ISOTOPE_LOTS = 18,
  LEVEL_EFFECT_BASE_TUBES = 19,
  /** LEVEL_EFFECT_TORPEDO_STORAGE - rounds the banks hold */
  LEVEL_EFFECT_TORPEDO_STORAGE = 20,
  LEVEL_EFFECT_CAPTAIN_SLOTS = 21,
  LEVEL_EFFECT_TRAINING_SPEED = 22,
  /** LEVEL_EFFECT_HOSPITAL_HOURS - hours a wounded captain rests */
  LEVEL_EFFECT_HOSPITAL_HOURS = 23,
  LEVEL_EFFECT_PRISON_CELLS = 24,
  /** LEVEL_EFFECT_CAPTURE_RANGE - the Brig's capture range in px (R1488) */
  LEVEL_EFFECT_CAPTURE_RANGE = 25,
  /** LEVEL_EFFECT_CAPTURE_CHANCE - the Brig's capture chance, a share (R1488) */
  LEVEL_EFFECT_CAPTURE_CHANCE = 26,
  /** LEVEL_EFFECT_SHIP_ROUND_STORAGE - ship rounds the hold stocks, every kind together (R1788) */
  LEVEL_EFFECT_SHIP_ROUND_STORAGE = 27,
  /** LEVEL_EFFECT_SEA_MINE_CAP - The Depot (v2-the-deep.md §11.5), behind the feature flag sapper. */
  LEVEL_EFFECT_SEA_MINE_CAP = 28,
  /** LEVEL_EFFECT_DEPLOYABLE_CAP - deployables one commander keeps on the map */
  LEVEL_EFFECT_DEPLOYABLE_CAP = 29,
  /** LEVEL_EFFECT_PALISADE_CAP - Palisades among those deployables */
  LEVEL_EFFECT_PALISADE_CAP = 30,
  /** LEVEL_EFFECT_SEA_OBJECT_RACK - sea objects the stock and the queue hold together */
  LEVEL_EFFECT_SEA_OBJECT_RACK = 31,
  /** LEVEL_EFFECT_LANE_LIGHT_CAP - Fanals among the deployables (R3073) */
  LEVEL_EFFECT_LANE_LIGHT_CAP = 32,
  UNRECOGNIZED = -1,
}

/** Module families (numbers.md §6). */
export enum ModuleFamily {
  MODULE_FAMILY_UNSPECIFIED = 0,
  MODULE_FAMILY_WEAPON = 1,
  MODULE_FAMILY_SHIELDS = 2,
  MODULE_FAMILY_PROPULSION = 3,
  MODULE_FAMILY_DAMPENING = 4,
  /** MODULE_FAMILY_SONAR - R691 */
  MODULE_FAMILY_SONAR = 5,
  UNRECOGNIZED = -1,
}

/** The kind of a cache (v2-the-deep.md §9.1, R2643). */
export enum CacheKind {
  CACHE_KIND_UNSPECIFIED = 0,
  CACHE_KIND_SEEDED = 1,
  CACHE_KIND_RUIN = 2,
  CACHE_KIND_PIRATE = 3,
  CACHE_KIND_PLAYER = 4,
  CACHE_KIND_EVENT = 5,
  UNRECOGNIZED = -1,
}

/**
 * The task of a commission (v2-the-deep.md §10). CACHE is a kind of the
 * pack that the board does not offer yet.
 */
export enum CommissionKind {
  COMMISSION_KIND_NONE = 0,
  /** COMMISSION_KIND_SURVEY - survey a region (discovery) */
  COMMISSION_KIND_SURVEY = 1,
  /** COMMISSION_KIND_SOUND - sound a trench (depth) */
  COMMISSION_KIND_SOUND = 2,
  /** COMMISSION_KIND_DEN - sink a pirate den (pirates) */
  COMMISSION_KIND_DEN = 3,
  /** COMMISSION_KIND_CACHE - recover a cache (treasure) */
  COMMISSION_KIND_CACHE = 4,
  /** COMMISSION_KIND_ESCORT - escort a fleet on a shipping lane (lanes, R2646) */
  COMMISSION_KIND_ESCORT = 5,
  UNRECOGNIZED = -1,
}

/** The pay of a commission (v2-the-deep.md §10). */
export enum CommissionReward {
  COMMISSION_REWARD_NONE = 0,
  COMMISSION_REWARD_RESOURCES = 1,
  COMMISSION_REWARD_ROUNDS = 2,
  COMMISSION_REWARD_PRACTICE = 3,
  COMMISSION_REWARD_SHIP = 4,
  UNRECOGNIZED = -1,
}

/**
 * What the advice proposes (R1305). Each kind names its catalog row in
 * `Advice.id`.
 */
export enum AdviceKind {
  ADVICE_KIND_NONE = 0,
  /** ADVICE_KIND_BUILDING - id: the Building; amount: the level to build */
  ADVICE_KIND_BUILDING = 1,
  /** ADVICE_KIND_RESEARCH - id: the tech node */
  ADVICE_KIND_RESEARCH = 2,
  /** ADVICE_KIND_SHIP - id: the ShipClass; amount: the hulls */
  ADVICE_KIND_SHIP = 3,
  /** ADVICE_KIND_TORPEDO - id: the TorpedoKind; amount: the rounds */
  ADVICE_KIND_TORPEDO = 4,
  /** ADVICE_KIND_PRINT - id: the master blueprint; amount: the runs */
  ADVICE_KIND_PRINT = 5,
  /** ADVICE_KIND_DESIGN - id: the ShipClass of the draft */
  ADVICE_KIND_DESIGN = 6,
  /** ADVICE_KIND_FLEET - id: the own fleet; amount: 0 (R1567) */
  ADVICE_KIND_FLEET = 7,
  /**
   * ADVICE_KIND_COMMISSION - id: an open offer of the board; amount: 0 (v2-the-deep.md §10,
   * R2634). Only while `commissions` is latched.
   */
  ADVICE_KIND_COMMISSION = 8,
  UNRECOGNIZED = -1,
}

/** Why the advice is what it is (R1305). */
export enum AdviceReason {
  ADVICE_REASON_NONE = 0,
  /** ADVICE_REASON_AFFORDABLE - The stores pay for the job now, and the queue takes it. */
  ADVICE_REASON_AFFORDABLE = 1,
  /**
   * ADVICE_REASON_SAVING - The goal ladder saves for this purchase: the stores do not pay for
   * it yet, and they hold enough of it that the ladder spends nothing
   * cheaper (autopilot.md §2.2). `held_permille` states how much.
   */
  ADVICE_REASON_SAVING = 2,
  /**
   * ADVICE_REASON_IDLE - FLEET only: a Dredger of the empire stands at sea with no order and
   * gathers nothing (R1567). The advice names the fleet and never a
   * target (R1307).
   */
  ADVICE_REASON_IDLE = 3,
  UNRECOGNIZED = -1,
}

export enum EventKind {
  EVENT_KIND_UNSPECIFIED = 0,
  /** EVENT_KIND_EXPLOSION - fleet destroyed */
  EVENT_KIND_EXPLOSION = 1,
  /** EVENT_KIND_HIT - combat exchange */
  EVENT_KIND_HIT = 2,
  /** EVENT_KIND_FLIP - cell captured */
  EVENT_KIND_FLIP = 3,
  /** EVENT_KIND_CAPTURE - site captured */
  EVENT_KIND_CAPTURE = 4,
  /** EVENT_KIND_LAUNCH - torpedo away — loud, and it reveals you */
  EVENT_KIND_LAUNCH = 5,
  EVENT_KIND_TORPEDO_HIT = 6,
  /**
   * EVENT_KIND_TORPEDO_EXPIRE - End-of-flight detonation (decided 2026-08-21: every round explodes):
   * fuel exhaustion or rock impact, splash applied at the point.
   */
  EVENT_KIND_TORPEDO_EXPIRE = 7,
  /**
   * EVENT_KIND_ROUND_KILL - A round taken out of the water with no detonation (R2080): a guard's
   * kill (the Sentinel Refit, R719) or a round burst (R2018, R2787).
   * x/y is the round; source_x/source_y is the killer's point (the
   * guard, or the burst's detonation); faction and actor are the
   * killer's; victim_faction is the round's faction; torpedo_kind and
   * heading_mrad are the round's kind and heading. A fuel end stays
   * TORPEDO_EXPIRE.
   */
  EVENT_KIND_ROUND_KILL = 8,
  /**
   * EVENT_KIND_SIGNATURE - A hull spent its signature order (numbers.md §4.1, R2371): `fleet`
   * is the hull, `signature` the order, `actor` the commander, x/y the
   * hull's point and `faction` its faction. It reaches a client on the
   * gate of the State frame, like a hit: the viewer must have the hull
   * on its picture.
   */
  EVENT_KIND_SIGNATURE = 9,
  UNRECOGNIZED = -1,
}

/**
 * The source of a ROUND_KILL (R3118). A Reef Breakwater names no
 * commander, so its event carries `actor` 0 and the faction of the team
 * that holds it.
 */
export enum RoundKillSource {
  ROUND_KILL_SOURCE_NONE = 0,
  ROUND_KILL_SOURCE_GUARD = 1,
  ROUND_KILL_SOURCE_BURST = 2,
  UNRECOGNIZED = -1,
}

/**
 * The arc of a hull a gun shot struck (numbers.md §4.1, R2371). The bow
 * and the stern are each 90° wide; the two side arcs are the beam. 0 is
 * "no aspect": a torpedo, a splash victim, or a sim without the approach.
 */
export enum HitAspect {
  HIT_ASPECT_NONE = 0,
  HIT_ASPECT_BOW = 1,
  HIT_ASPECT_BEAM = 2,
  HIT_ASPECT_STERN = 3,
  UNRECOGNIZED = -1,
}

/**
 * What a notice reports. The client keys presentation off it; the text
 * stays the authority on what happened. An unset kind is a plain notice.
 */
export enum NoticeKind {
  NOTICE_KIND_NONE = 0,
  /** NOTICE_KIND_QUEUE_DONE - a build queue job finished */
  NOTICE_KIND_QUEUE_DONE = 1,
  NOTICE_KIND_SHIP_READY = 2,
  NOTICE_KIND_RESEARCH_DONE = 3,
  NOTICE_KIND_FLEET_DOCKED = 4,
  NOTICE_KIND_FLEET_LOST = 5,
  /** NOTICE_KIND_CARGO_LANDED - a hold emptied into storage */
  NOTICE_KIND_CARGO_LANDED = 6,
  /** NOTICE_KIND_MARKET_SOLD - a lot bought or sold */
  NOTICE_KIND_MARKET_SOLD = 7,
  NOTICE_KIND_CAPTAIN_RECRUITED = 8,
  /** NOTICE_KIND_CAPTAIN_CAPTURED - taken prisoner, either side of it */
  NOTICE_KIND_CAPTAIN_CAPTURED = 9,
  NOTICE_KIND_EXPEDITION_RETURNED = 10,
  UNRECOGNIZED = -1,
}

export enum InboxKind {
  INBOX_KIND_UNSPECIFIED = 0,
  /** INBOX_KIND_BATTLE - a tier-2 window the player fought in, or a torpedo report */
  INBOX_KIND_BATTLE = 1,
  /** INBOX_KIND_SEASON - the season report */
  INBOX_KIND_SEASON = 2,
  /** INBOX_KIND_FLEET_LOST - one of the player's hulls went down */
  INBOX_KIND_FLEET_LOST = 3,
  /** INBOX_KIND_FLEET_KILLED - the player's fire sank an enemy hull */
  INBOX_KIND_FLEET_KILLED = 4,
  /** INBOX_KIND_TERRITORY - credited water lost (coalesced) */
  INBOX_KIND_TERRITORY = 5,
  /** INBOX_KIND_EXPEDITION - a dive surfaced */
  INBOX_KIND_EXPEDITION = 6,
  /** INBOX_KIND_MARKET - a listing sold */
  INBOX_KIND_MARKET = 7,
  /** INBOX_KIND_BASE - combat at the player's hold (coalesced) */
  INBOX_KIND_BASE = 8,
  UNRECOGNIZED = -1,
}

/**
 * What a replay follows (R526). The kind picks the reader's framing: a
 * sinking follows one hull to its end, a torpedo report follows the struck
 * hulls around one detonation, a window is the tableau of R128.
 */
export enum ReplayKind {
  REPLAY_KIND_UNSPECIFIED = 0,
  REPLAY_KIND_SINK = 1,
  REPLAY_KIND_TORPEDO = 2,
  REPLAY_KIND_WINDOW = 3,
  UNRECOGNIZED = -1,
}

/**
 * The cause of one damage record (numbers.md §20). A gun run is fire from
 * one hull coalesced over a short span; every other kind is one event.
 */
export enum DamageKind {
  DAMAGE_KIND_UNSPECIFIED = 0,
  /** DAMAGE_KIND_GUN - close-in fire, the primary target */
  DAMAGE_KIND_GUN = 1,
  /** DAMAGE_KIND_GUN_SPLASH - close-in fire spread over a neighbour */
  DAMAGE_KIND_GUN_SPLASH = 2,
  /** DAMAGE_KIND_TORPEDO - a warhead's primary contact */
  DAMAGE_KIND_TORPEDO = 3,
  /** DAMAGE_KIND_TORPEDO_SPLASH - a warhead's splash */
  DAMAGE_KIND_TORPEDO_SPLASH = 4,
  /** DAMAGE_KIND_QUAKE_GRIND - the seaquake's attrition */
  DAMAGE_KIND_QUAKE_GRIND = 5,
  /** DAMAGE_KIND_QUAKE_SHOCK - a seaquake shock wave */
  DAMAGE_KIND_QUAKE_SHOCK = 6,
  /** DAMAGE_KIND_SCAN_COST - the hull a Vedette pays for an active ping */
  DAMAGE_KIND_SCAN_COST = 7,
  /** DAMAGE_KIND_SHARE_COST - the hull an Oracle pays to share its array */
  DAMAGE_KIND_SHARE_COST = 8,
  /** DAMAGE_KIND_WINDOW - a tier-2 window stripped the shield */
  DAMAGE_KIND_WINDOW = 9,
  /** DAMAGE_KIND_SETTLEMENT - the hold fell in on its pens */
  DAMAGE_KIND_SETTLEMENT = 10,
  /** DAMAGE_KIND_ANCHOR_COST - the hull a Tender pays to drop its anchor */
  DAMAGE_KIND_ANCHOR_COST = 11,
  /** DAMAGE_KIND_DEEP_RUN - the wear of a thermocline run */
  DAMAGE_KIND_DEEP_RUN = 12,
  /** DAMAGE_KIND_PRESSURE - the wear of a band deeper than the depth rating (R2608) */
  DAMAGE_KIND_PRESSURE = 13,
  /** DAMAGE_KIND_SEA_MINE - the detonation of a sea mine (R2651, R2654) */
  DAMAGE_KIND_SEA_MINE = 14,
  /** DAMAGE_KIND_CHEVAL - the wire of a Cheval (R2651, R2654) */
  DAMAGE_KIND_CHEVAL = 15,
  UNRECOGNIZED = -1,
}

/**
 * Which map filter a client watches. NONE is the default view: no overlay,
 * and the client's unsubscribe.
 */
export enum HeatmapKind {
  HEATMAP_KIND_NONE = 0,
  /** HEATMAP_KIND_SOV - live sov gauge on owned cells */
  HEATMAP_KIND_SOV = 1,
  /** HEATMAP_KIND_ACTIVITY - recent sov credit, decaying */
  HEATMAP_KIND_ACTIVITY = 2,
  /** HEATMAP_KIND_ACTIVITY_SEASON - sov credit for the whole season */
  HEATMAP_KIND_ACTIVITY_SEASON = 3,
  /** HEATMAP_KIND_KILLS - recent fleets destroyed, decaying */
  HEATMAP_KIND_KILLS = 4,
  /** HEATMAP_KIND_KILLS_SEASON - fleets destroyed this season */
  HEATMAP_KIND_KILLS_SEASON = 5,
  /** HEATMAP_KIND_BEACON - recent beam progress from anchored Beacons */
  HEATMAP_KIND_BEACON = 7,
  /** HEATMAP_KIND_STABILITY - how recently a cell last changed owner */
  HEATMAP_KIND_STABILITY = 9,
  /**
   * HEATMAP_KIND_CURRENTS - The client draws CURRENTS and DEPTH itself, from Hello.currents and
   * Hello.depth. The server computes no field for them and takes a
   * HeatmapMode of either kind as NONE (R2868).
   */
  HEATMAP_KIND_CURRENTS = 10,
  /** HEATMAP_KIND_DEPTH - depth bands, client-drawn */
  HEATMAP_KIND_DEPTH = 11,
  UNRECOGNIZED = -1,
}

export enum CommissionOp {
  COMMISSION_OP_UNSPECIFIED = 0,
  COMMISSION_OP_ASSIGN = 1,
  UNRECOGNIZED = -1,
}

export enum PlotOp {
  PLOT_OP_UNSPECIFIED = 0,
  PLOT_OP_SAVE = 1,
  PLOT_OP_RENAME = 2,
  PLOT_OP_DELETE = 3,
  /**
   * PLOT_OP_LANE - The LANE switch of a plot: `lane` marks the plot as a shipping lane
   * or clears the mark (v2-the-deep.md §7.2, R2646).
   */
  PLOT_OP_LANE = 4,
  UNRECOGNIZED = -1,
}

/**
 * ArcadePhaseKind is the match lifecycle (arcade.md §7.1). The countdown
 * that goes with it is on one of two clocks, and the phase says which. The
 * loading grace and the pre-start countdown are **real seconds**: they are
 * human moments — a browser loads, a player reads "Starting in 10" — and
 * they must last the same wall time on every map. The match timeout is on
 * the **map clock**, so a map's `tacticalscale` moves it like everything
 * else a player watches.
 */
export enum ArcadePhaseKind {
  ARCADE_PHASE_UNSPECIFIED = 0,
  /** ARCADE_PHASE_LOADING - grace period; nothing moves */
  ARCADE_PHASE_LOADING = 1,
  /** ARCADE_PHASE_PRESTART - "Starting in 10", then 3-2-1-Fight */
  ARCADE_PHASE_PRESTART = 2,
  /** ARCADE_PHASE_FIGHT - input unlocked, the map runs */
  ARCADE_PHASE_FIGHT = 3,
  /** ARCADE_PHASE_ENDED - a verdict stands; the summary is out */
  ARCADE_PHASE_ENDED = 4,
  UNRECOGNIZED = -1,
}

/** ArcadeQueueKind is where a player stands in a queue (arcade.md §5). */
export enum ArcadeQueueKind {
  ARCADE_QUEUE_UNSPECIFIED = 0,
  /** ARCADE_QUEUE_IDLE - not queued */
  ARCADE_QUEUE_IDLE = 1,
  /** ARCADE_QUEUE_WAITING - queued, waiting for seats */
  ARCADE_QUEUE_WAITING = 2,
  /** ARCADE_QUEUE_FILLING - the fill timer runs; bots take the rest */
  ARCADE_QUEUE_FILLING = 3,
  /** ARCADE_QUEUE_LOCKED - a match locked; ArcadeMatchFound follows */
  ARCADE_QUEUE_LOCKED = 4,
  /** ARCADE_QUEUE_REFUSED - the queue said no; `reason` says why */
  ARCADE_QUEUE_REFUSED = 5,
  UNRECOGNIZED = -1,
}

/** ArcadeVerdict is what the end card says to the client that reads it. */
export enum ArcadeVerdict {
  ARCADE_VERDICT_UNSPECIFIED = 0,
  ARCADE_VERDICT_WIN = 1,
  ARCADE_VERDICT_LOSE = 2,
  ARCADE_VERDICT_DRAW = 3,
  UNRECOGNIZED = -1,
}

/**
 * ArcadeLadderStatus says whether a finished match moved the arcade ladder,
 * and why not (arcade.md §18.3, R1600). Only a match of the public queue
 * is rated.
 */
export enum ArcadeLadderStatus {
  /**
   * ARCADE_LADDER_UNSPECIFIED - No answer: the coordinator holds no meta link, or the ladder report
   * failed or came after the card hold. The profile still shows the
   * ladder number the meta server stored.
   */
  ARCADE_LADDER_UNSPECIFIED = 0,
  /** ARCADE_LADDER_RATED - the match rated at least one seat */
  ARCADE_LADDER_RATED = 1,
  /** ARCADE_LADDER_PRIVATE - a private game (arcade.md §16) is not rated */
  ARCADE_LADDER_PRIVATE = 2,
  /** ARCADE_LADDER_DRILL - a drill (arcade.md §17) is not rated */
  ARCADE_LADDER_DRILL = 3,
  /**
   * ARCADE_LADDER_UNRATED - A match of the public queue that rated no seat: no seat played a
   * human opponent with a ladder (bots and guests are none, R1601, R1603).
   */
  ARCADE_LADDER_UNRATED = 4,
  UNRECOGNIZED = -1,
}

/** ArcadeHostActionKind is what one control of the hosting window does. */
export enum ArcadeHostActionKind {
  ARCADE_HOST_ACTION_UNSPECIFIED = 0,
  ARCADE_HOST_ACTION_TAKE_SEAT = 1,
  ARCADE_HOST_ACTION_LEAVE_SEAT = 2,
  ARCADE_HOST_ACTION_SET_BOT = 3,
  ARCADE_HOST_ACTION_SET_OPEN = 4,
  ARCADE_HOST_ACTION_KICK = 5,
  ARCADE_HOST_ACTION_BAN = 6,
  ARCADE_HOST_ACTION_PICK_MAP = 7,
  ARCADE_HOST_ACTION_SET_DELAY = 8,
  ARCADE_HOST_ACTION_START = 9,
  ARCADE_HOST_ACTION_LEAVE = 10,
  UNRECOGNIZED = -1,
}

/**
 * ArcadeHostingReason says why the last frame of a hosting was sent. OK
 * is the ordinary push; every other value ends the hosting for the
 * reader, or refuses the act it answers.
 */
export enum ArcadeHostingReason {
  ARCADE_HOSTING_OK = 0,
  ARCADE_HOSTING_NO_SUCH_CODE = 1,
  ARCADE_HOSTING_BANNED = 2,
  ARCADE_HOSTING_FULL = 3,
  ARCADE_HOSTING_HOST_LEFT = 4,
  ARCADE_HOSTING_TIMED_OUT = 5,
  ARCADE_HOSTING_KICKED = 6,
  ARCADE_HOSTING_DRAINING = 7,
  ARCADE_HOSTING_START_FAILED = 8,
  ARCADE_HOSTING_NOT_HOST = 9,
  ARCADE_HOSTING_SEAT_TAKEN = 10,
  UNRECOGNIZED = -1,
}

/** CasinoGame is one of the four games the house runs (casino.md §2). */
export enum CasinoGame {
  CASINO_GAME_UNSPECIFIED = 0,
  CASINO_GAME_ROULETTE = 1,
  CASINO_GAME_BLACKJACK = 2,
  CASINO_GAME_SLOTS = 3,
  CASINO_GAME_HOLDEM = 4,
  UNRECOGNIZED = -1,
}

/**
 * CasinoPhase is where one table stands in its hand (casino.md §4). Every
 * game walks a subset: roulette BETTING to SPINNING to SETTLED, blackjack
 * BETTING to DEALING to ACTING to SHOWDOWN to SETTLED, hold'em DEALING to
 * ACTING to SHOWDOWN to SETTLED. DISSOLVED is the last frame of a table.
 */
export enum CasinoPhase {
  CASINO_PHASE_UNSPECIFIED = 0,
  /** CASINO_PHASE_WAITING - the table waits for seats */
  CASINO_PHASE_WAITING = 1,
  /** CASINO_PHASE_BETTING - the shared betting window is open */
  CASINO_PHASE_BETTING = 2,
  /** CASINO_PHASE_DEALING - cards go out; nobody acts */
  CASINO_PHASE_DEALING = 3,
  /** CASINO_PHASE_ACTING - `turn_seat` acts before `act_left_sec` */
  CASINO_PHASE_ACTING = 4,
  /** CASINO_PHASE_SPINNING - the wheel or the reels run; the result stands */
  CASINO_PHASE_SPINNING = 5,
  /** CASINO_PHASE_SHOWDOWN - every hand is face up */
  CASINO_PHASE_SHOWDOWN = 6,
  /** CASINO_PHASE_SETTLED - the deltas are booked; the next hand follows */
  CASINO_PHASE_SETTLED = 7,
  /** CASINO_PHASE_DISSOLVED - the table is gone; every stake is refunded */
  CASINO_PHASE_DISSOLVED = 8,
  UNRECOGNIZED = -1,
}

/**
 * CasinoAction is one act a seat may take. The server states which acts
 * are legal in `CasinoTable.allowed_actions`, and the client never
 * computes the list itself.
 */
export enum CasinoAction {
  CASINO_ACTION_UNSPECIFIED = 0,
  CASINO_ACTION_CHECK = 1,
  CASINO_ACTION_CALL = 2,
  CASINO_ACTION_BET = 3,
  CASINO_ACTION_RAISE = 4,
  CASINO_ACTION_FOLD = 5,
  CASINO_ACTION_ALL_IN = 6,
  CASINO_ACTION_HIT = 7,
  CASINO_ACTION_STAND = 8,
  CASINO_ACTION_DOUBLE = 9,
  CASINO_ACTION_SPLIT = 10,
  CASINO_ACTION_INSURE = 11,
  CASINO_ACTION_DECLINE_INSURANCE = 12,
  /** CASINO_ACTION_PLACE_BET - roulette: one bet on the shared window */
  CASINO_ACTION_PLACE_BET = 13,
  /** CASINO_ACTION_CLEAR_BETS - roulette: take every own bet back */
  CASINO_ACTION_CLEAR_BETS = 14,
  /** CASINO_ACTION_TOP_UP - hold'em: refill the seat at hand end */
  CASINO_ACTION_TOP_UP = 15,
  /** CASINO_ACTION_TAKE_BACK_BET - roulette: take one own bet back (R2117) */
  CASINO_ACTION_TAKE_BACK_BET = 16,
  UNRECOGNIZED = -1,
}

/**
 * CasinoQueueKind mirrors ArcadeQueueKind: where a player stands in the
 * quick queue of one game and one stake tier (casino.md §5).
 */
export enum CasinoQueueKind {
  CASINO_QUEUE_UNSPECIFIED = 0,
  /** CASINO_QUEUE_IDLE - not queued */
  CASINO_QUEUE_IDLE = 1,
  /** CASINO_QUEUE_WAITING - queued, waiting for seats */
  CASINO_QUEUE_WAITING = 2,
  /** CASINO_QUEUE_FILLING - the fill timer runs; the house fills the rest */
  CASINO_QUEUE_FILLING = 3,
  /** CASINO_QUEUE_SEATED - a table took this seat; CasinoTable follows */
  CASINO_QUEUE_SEATED = 4,
  /** CASINO_QUEUE_REFUSED - the queue said no; a Notice says why */
  CASINO_QUEUE_REFUSED = 5,
  UNRECOGNIZED = -1,
}

/** What a map marker asks its audience to do. */
export enum MarkerKind {
  MARKER_KIND_UNSPECIFIED = 0,
  MARKER_KIND_ATTACK = 1,
  MARKER_KIND_DEFEND = 2,
  MARKER_KIND_GATHER = 3,
  MARKER_KIND_DANGER = 4,
  UNRECOGNIZED = -1,
}

/**
 * Who sees a map marker. The clan is not an audience: in one world the
 * squad is the clan (player-reach.md §2.1).
 */
export enum MarkerAudience {
  MARKER_AUDIENCE_UNSPECIFIED = 0,
  MARKER_AUDIENCE_SQUAD = 1,
  MARKER_AUDIENCE_FACTION = 2,
  UNRECOGNIZED = -1,
}

/** ReportKind says what a Report names (deployment.md §7.6, R1323). */
export enum ReportKind {
  REPORT_KIND_UNSPECIFIED = 0,
  /** REPORT_KIND_CHAT - A line of the WORLD, FACTION or SQUAD channel, by `line_id`. */
  REPORT_KIND_CHAT = 1,
  /** REPORT_KIND_COMMANDER - The name of a commander of this world, by `account_id`. */
  REPORT_KIND_COMMANDER = 2,
  /**
   * REPORT_KIND_FLEET - The name of a hull of another commander of the reporter's faction,
   * by `fleet_id`: a name of the fleet name pool or of a live rename.
   */
  REPORT_KIND_FLEET = 3,
  /** REPORT_KIND_SEAMOUNT - The name of a seamount, by `body` (v2-the-deep.md §4.3, R2620). */
  REPORT_KIND_SEAMOUNT = 4,
  /**
   * REPORT_KIND_CACHE_NOTE - A free-text cache note, by `cache` (v2-the-deep.md §9.4, R2631,
   * R2643). Only a finder of the cache reports it.
   */
  REPORT_KIND_CACHE_NOTE = 5,
  UNRECOGNIZED = -1,
}

/**
 * What a quick line names (R1608). The sender names a reference, never a
 * position: the hub resolves the cell from its own state, so a quick line
 * leaks no position its sender could not mark with a map marker.
 */
export enum QuickRefKind {
  QUICK_REF_KIND_NONE = 0,
  /** QUICK_REF_KIND_MARKER - The sender's newest live map marker. `id` is not read. */
  QUICK_REF_KIND_MARKER = 1,
  /** QUICK_REF_KIND_HOLD - The sender's own hold. `id` is not read. */
  QUICK_REF_KIND_HOLD = 2,
  /** QUICK_REF_KIND_FLEET - One own fleet on the map, by fleet id. */
  QUICK_REF_KIND_FLEET = 3,
  /** QUICK_REF_KIND_CONTACT - One fleet of another faction that the sender hears now, by fleet id. */
  QUICK_REF_KIND_CONTACT = 4,
  /** QUICK_REF_KIND_OBJECT - One strategic object, by site id. An object is public. */
  QUICK_REF_KIND_OBJECT = 5,
  UNRECOGNIZED = -1,
}

export interface ServerMsg {
  hello?: Hello | undefined;
  state?: State | undefined;
  pong?: Pong | undefined;
  siteOwner?:
    | SiteOwner
    | undefined;
  /** private: the connected player's own state */
  empire?:
    | Empire
    | undefined;
  /** transient world effects (explosions, flashes) */
  events?:
    | Events
    | undefined;
  /** human-readable feedback ("not enough alloy") */
  notice?: Notice | undefined;
  siteAdded?: SiteAdded | undefined;
  chat?: ChatMsg | undefined;
  clan?: ClanInfo | undefined;
  sieges?: Sieges | undefined;
  scoreboard?: Scoreboard | undefined;
  seasonReport?: SeasonReport | undefined;
  market?:
    | Market
    | undefined;
  /** WAR-dock data, answered on demand (WarQuery) */
  war?:
    | WarState
    | undefined;
  /** dev only: the running build vs the repo's HEAD */
  devBuild?:
    | DevBuild
    | undefined;
  /** the durable message list, answered on demand (v12) */
  inbox?:
    | Inbox
    | undefined;
  /** one combat-log replay, on demand (v12; v17 reads the log, R526) */
  replay?:
    | Replay
    | undefined;
  /** one map-filter field, pushed to subscribers (v13) */
  heatmap?:
    | Heatmap
    | undefined;
  /** a site that is gone from the map for good */
  siteRemoved?:
    | SiteRemoved
    | undefined;
  /** Arcade (arcade.md §9). */
  arcadeQueue?:
    | ArcadeQueue
    | undefined;
  /** a match locked and this seat is in it */
  arcadeMatch?:
    | ArcadeMatchFound
    | undefined;
  /** loading / prestart / fight / ended */
  arcadePhase?:
    | ArcadePhase
    | undefined;
  /** the end card, built per viewer */
  arcadeSummary?:
    | ArcadeSummary
    | undefined;
  /**
   * The wrecks of one step (R801): every hull the step sank, one frame
   * for every client, because a wreck is public. A step that sank
   * nothing sends none.
   */
  wrecks?:
    | Wrecks
    | undefined;
  /** where the next seaquake shock strikes (R803) */
  quake?:
    | QuakeInfo
    | undefined;
  /**
   * The maintenance window ahead (the release manager, deployment.md
   * §6.1). Sent on hello and on every change of the directive.
   */
  maintenanceInfo?:
    | MaintenanceInfo
    | undefined;
  /**
   * One batch of match-replay records (arcade.md §15.6, R889). The
   * bytes are the replay FILE's own framing, so a spectator socket and
   * a downloaded file reach one reader.
   */
  replayChunk?:
    | ReplayChunk
    | undefined;
  /**
   * The hosting window of a private game (arcade.md §16.2). The whole
   * window travels on every change.
   */
  arcadeHosting?:
    | ArcadeHosting
    | undefined;
  /** One achievement grade the seat just reached (achievements.md §4). */
  achievementUnlock?:
    | AchievementUnlock
    | undefined;
  /**
   * The casino (casino.md §13). The lobby rides a cadence, the table
   * travels on a change alone, and the result carries what the client
   * animates.
   */
  casinoLobby?: CasinoLobby | undefined;
  casinoTable?: CasinoTable | undefined;
  casinoResult?:
    | CasinoResult
    | undefined;
  /**
   * The map markers the receiver may see (player-reach.md §2.4, R1291):
   * the WHOLE list of its squad's and its faction's markers. The hub
   * sends it when that list changes, on a join and with a full frame.
   */
  markers?:
    | Markers
    | undefined;
  /**
   * ECONOMY · PRODUCTION data, answered on demand (ProductionQuery,
   * R1489): the asking empire's own income ring.
   */
  production?:
    | ProductionState
    | undefined;
  /**
   * The season summary (ui-map-interface.md §3.4, R1518): the card
   * that closes a season. The hub sends it when the scores lock
   * (seaquake stage 3), to a commander who joins while they stand
   * locked, and again when the calendar's hold changes.
   */
  seasonSummary?:
    | SeasonSummary
    | undefined;
  /**
   * The season timelapse of the running season, answered on demand
   * (TimelapseQuery, chronicle.md §10.3, R1595).
   */
  timelapse?:
    | TimelapseState
    | undefined;
  /**
   * The return briefing (ui-map-interface.md §12.6, R1605): the sums
   * of an absence. The hub sends it one time, after the first Empire
   * frame of a return from an absence of `hub.briefing.away_sec` world
   * seconds or more.
   */
  returnBriefing?:
    | ReturnBriefing
    | undefined;
  /**
   * The levels of one building past the next, answering a PreviewQuery
   * (R1839): the level picker of the build card.
   */
  buildingPreview?:
    | BuildingPreview
    | undefined;
  /**
   * The inbox ledger of the asking seat, answered on demand
   * (InboxLedgerQuery, inbox.md §5, R1831).
   */
  inboxLedger?:
    | InboxLedgerState
    | undefined;
  /**
   * The settlement clock of seaquake stage 3 (R2093): when the drain
   * ends and when the settlement ends.
   */
  settlement?: SettlementClock | undefined;
}

/**
 * An achievement grade the seat just reached (achievements.md §4).
 *
 * The hub evaluates the thresholds itself, so the fly-in is immediate.
 * The service is the record and recomputes the grade on ingest; a grade
 * the service reached that the hub did not announce rides back in the
 * batch answer instead of on this message.
 */
export interface AchievementUnlock {
  /** the catalog code of data/contracts/achievements.toml */
  code: string;
  /** the grade reached, 1 to 6 */
  grade: number;
  /** the value that crossed the threshold */
  value: number;
  /** 0 lifetime, 1 journey, 2 recognition */
  kind: number;
}

export interface ClientMsg {
  order?: FleetOrder | undefined;
  view?: Viewport | undefined;
  ping?: Ping | undefined;
  enqueue?: Enqueue | undefined;
  job?: JobAction | undefined;
  createFleet?: CreateFleet | undefined;
  fleetAction?: FleetAction | undefined;
  captain?: CaptainAction | undefined;
  chat?: Chat | undefined;
  clan?: ClanAction | undefined;
  siege?: SiegeAction | undefined;
  invent?: Invent | undefined;
  expedition?: ExpeditionOrder | undefined;
  design?: DesignAction | undefined;
  fire?: FireOrder | undefined;
  market?: MarketAction | undefined;
  admin?: AdminAction | undefined;
  warQuery?:
    | WarQuery
    | undefined;
  /** fetch / mark read / fetch a replay (v12) */
  inbox?:
    | InboxAction
    | undefined;
  /** subscribe / switch / unsubscribe (v13) */
  heatmapMode?:
    | HeatmapMode
    | undefined;
  /** a named per-empire toggle */
  empireSetting?:
    | EmpireSetting
    | undefined;
  /**
   * Arcade (arcade.md §9). The lobby and the match share one socket, so
   * the queue arms and the match arm live in the same envelope.
   */
  arcadeQueueJoin?: ArcadeQueueJoin | undefined;
  arcadeQueueLeave?: ArcadeQueueLeave | undefined;
  arcadeBuild?:
    | ArcadeBuild
    | undefined;
  /**
   * A fleet control group (ui-map-interface.md §9, R539): put one own
   * fleet on one numbered slot. The server stores the groups with the
   * empire and echoes them in every Empire frame.
   */
  controlGroup?:
    | ControlGroup
    | undefined;
  /**
   * "Send me a fresh picture" (R778). The server forgets what this
   * connection holds and states the world again.
   */
  resync?:
    | Resync
    | undefined;
  /**
   * One second of this seat's pointer and keyboard work (arcade.md
   * §15.2, R907). The client sends it only while the match's
   * `record_input` is on, and no rule of the sim reads it.
   */
  arcadeInput?:
    | ArcadeInput
    | undefined;
  /**
   * Private games (arcade.md §16). Open a hosting, join one by its
   * code, and act inside the hosting window.
   */
  arcadeHost?: ArcadeHost | undefined;
  arcadeHostJoin?: ArcadeHostJoin | undefined;
  arcadeHostAction?:
    | ArcadeHostAction
    | undefined;
  /**
   * A control-group RECALL (ui-map-interface.md §9, R539). The digit
   * keys select a group on the client alone, so the server never heard
   * about a recall at all. It hears now, because an achievement counts
   * them (achievements.md §3). The server counts the press and does
   * NOTHING else with it: no selection, no camera, no order.
   */
  controlGroupRecall?:
    | ControlGroupRecall
    | undefined;
  /**
   * The casino (casino.md §13). A seat belongs to the EMPIRE, not to the
   * socket, so two tabs share one seat and every arm is an empire
   * command like the market ones.
   */
  casinoQueueJoin?: CasinoQueueJoin | undefined;
  casinoQueueLeave?: CasinoQueueLeave | undefined;
  casinoJoinTable?: CasinoJoinTable | undefined;
  casinoLeave?: CasinoLeave | undefined;
  casinoAct?: CasinoAct | undefined;
  casinoSpin?:
    | CasinoSpin
    | undefined;
  /**
   * The live rename of one own hull (monetization.md §3.2, R1250). It
   * needs the `fleet_designer` key, and an arcade match refuses it.
   */
  renameFleet?:
    | RenameFleet
    | undefined;
  /**
   * Place or remove one map marker (player-reach.md §2.3). A marker
   * never enters the sim; a refusal arrives as an error notice.
   */
  markerAction?:
    | MarkerAction
    | undefined;
  /**
   * REPLACE: press the Replace action of one loss message
   * (fleet-atom-redesign.md §11, R1308). The server queues one build of
   * the lost fleet's pattern at the end of the queue, at the full price;
   * a refusal arrives as an error notice, and the Inbox frame follows.
   */
  inboxReplace?:
    | InboxReplace
    | undefined;
  /**
   * REPORT: one piece of content another player wrote (deployment.md
   * §7.6, R1323). The hub copies the piece and hands the report to the
   * meta server. The server sends no answer: the client marks the
   * control at once, and a report the hub cannot resolve is dropped.
   */
  report?:
    | Report
    | undefined;
  /**
   * BLOCK: hide one commander's chat lines from this seat on every chat
   * channel (deployment.md §7.6, R1328). The hub hides the next line at
   * once and hands the block to the meta server, which stores it in the
   * one block list of the account. The server sends no answer.
   */
  block?:
    | Block
    | undefined;
  /**
   * Ask for the ECONOMY · PRODUCTION income ring (R1489). The client
   * asks when the pill opens; the answer is a ProductionState.
   */
  productionQuery?:
    | ProductionQuery
    | undefined;
  /**
   * Start a drill (arcade.md §17, R1564): a lobby arm of the arcade
   * coordinator. The coordinator builds a match for this one player at
   * once, with no queue, and takes no daily run for it.
   */
  arcadeDrill?:
    | ArcadeDrill
    | undefined;
  /**
   * NEXT on a reading drill step: the one done check a client completes
   * (arcade.md §17.3). It names the step it answers, so a press that
   * arrives after the step moved on does nothing.
   */
  arcadeDrillNext?:
    | ArcadeDrillNext
    | undefined;
  /**
   * Ask for the season timelapse of the running season (chronicle.md
   * §10.3, R1595). The answer is a TimelapseState.
   */
  timelapseQuery?:
    | TimelapseQuery
    | undefined;
  /**
   * Ask for the levels of one building past the one the BUILD button
   * buys (R1839, ui-map-interface.md §8): the level picker of the build
   * card. The client asks when a building card opens; the answer is a
   * BuildingPreview to this connection alone.
   */
  previewQuery?:
    | PreviewQuery
    | undefined;
  /**
   * Ask for the inbox ledger of this seat (inbox.md §5, R1831). The
   * answer is an InboxLedgerState.
   */
  inboxLedgerQuery?:
    | InboxLedgerQuery
    | undefined;
  /**
   * SURRENDER of the readout line of an arcade match (arcade.md §6.2,
   * R2000, R2013): the seat leaves the fight, and its team plays on.
   */
  arcadeSurrender?:
    | ArcadeSurrender
    | undefined;
  /**
   * Save, rename or delete one course plot of this empire
   * (v2-the-deep.md §7, protocol 38). The flag `routes` gates it, and
   * the hub refuses it with an error notice while the flag is off. A
   * course itself rides FleetOrder.legs.
   */
  plot?:
    | PlotAction
    | undefined;
  /**
   * Name one seamount that a hull of this commander found
   * (v2-the-deep.md §4.3, R2620). The flag `discovery` gates it, and the
   * hub refuses it with an error notice while the flag is off.
   */
  nameSeamount?:
    | NameSeamount
    | undefined;
  /**
   * A commission intent (v2-the-deep.md §10, R2634): ASSIGN gives one
   * fleet to one offer of the board. Only while `commissions` is
   * latched; an arcade world refuses it.
   */
  commission?:
    | CommissionAction
    | undefined;
  /**
   * A cache intent (v2-the-deep.md §9.3, §9.4, R2643): DEPOSIT a player
   * cache from an own fleet at its position, or write the NOTE of an own
   * player cache. Only while `treasure` is latched; an arcade world
   * refuses it.
   */
  cache?:
    | CacheAction
    | undefined;
  /**
   * I'M IN of the window head and the roster card (R3279): the commander
   * commits to the next vulnerability window of one object, or takes the
   * commitment back. It is intent only: it books no pledge, moves no
   * hull and changes no siege rule. An arcade world refuses it.
   */
  windowCommit?: WindowCommit | undefined;
}

/**
 * WindowCommit is one window commitment intent (R3279,
 * ui-map-interface.md §12.1). The hub keys the commitment by the object
 * and the opening of its next window (the open one, or the next opening),
 * so the client names the object alone. `withdraw` takes the commitment
 * back. A refusal arrives as an error notice; the Sieges frame carries
 * `you_in` and `squad_in`, and ClanInfo carries `committed`.
 */
export interface WindowCommit {
  siteId: number;
  withdraw: boolean;
}

/**
 * CacheAction is one cache intent (v2-the-deep.md §9.3, §9.4, R2643).
 * DEPOSIT reads `fleet_id`, and it may carry the note in `text` or
 * `phrase`. NOTE reads `cache_id` and the note. `text` is free text, which
 * needs the entitlement key `free_text`; `phrase` is the place of a phrase
 * of [ui.cache_note] plus one, and 0 names none. A refusal arrives as an
 * error notice, and the Empire frame carries the cache.
 */
export interface CacheAction {
  op: CacheOp;
  fleetId: number;
  cacheId: number;
  text: string;
  phrase: number;
}

export interface Hello {
  /** protocol version, bump on breaking change */
  protocol: number;
  cols: number;
  rows: number;
  faction: number;
  /** cols*rows cell owner bytes (0 = unclaimed) */
  owners: Uint8Array;
  /** cols*rows terrain bytes (0 open, 1 trench, 2 ridge) */
  blocked: Uint8Array;
  tick: number;
  sites: Site[];
  /** player identity; client stores and re-sends it */
  token: string;
  playerId: number;
  playerName: string;
  /** the player's base cell */
  homeCell: number;
  season: number;
  seasonEndsUnix: number;
  /** world clock: economy, queue, season, events */
  timescale: number;
  /** the rule tables, so the client mirrors nothing */
  catalog: Catalog | undefined;
  worldId: number;
  worldName: string;
  /** matchmaking timezone group (EMEA/AMER/APAC) */
  region: string;
  /** commanders placed in this world */
  population: number;
  /** every shard this server hosts */
  worlds: WorldInfo[];
  accountId: number;
  /** the finale is running */
  cataclysm: boolean;
  honour: number;
  title: string;
  /** this client may use AdminAction (dev servers) */
  admin: boolean;
  /**
   * Founding truce (R51) remaining, in game-seconds; 0 once weapons are
   * live. The client's banner countdown anchors on it (additive, plan §5.2).
   */
  truceLeftSec: number;
  /**
   * The world runs two clocks (R91). This is the tactical one: movement,
   * combat, torpedoes, detection, capture cycles. Countdowns measured on
   * it (reload, point defence, a capture cycle) convert to wall time with
   * this, everything economic with `timescale` above.
   */
  tacticalScale: number;
  /**
   * Where the two dev toggles actually stand for this seat (R94), so the
   * panel shows server truth instead of a client-side guess that a reload
   * resets. `reveal` lives on the connection and is off on every fresh
   * one; `autopilot` lives on the empire's commander and survives a
   * reload. Both are false for a non-admin seat.
   */
  adminReveal: boolean;
  adminAutopilot: boolean;
  /**
   * The world's game mode (deployment.md §4): 0 core, 1 event, 2 clanwar,
   * 3 arcade. The instance config gives the world its mode, and the join
   * ticket must name the same one. Zero is core, so a world with no mode
   * descriptor is a core world.
   */
  mode: number;
  /**
   * The world's time of day, in world game-seconds since world midnight
   * (0..86399). This is the clock the strategic objects' vulnerability
   * windows are scheduled on (`SiegeInfo.window_hour`), so the client shows
   * it and counts every window against it. Re-anchored by every Scoreboard.
   */
  clockSec: number;
  /**
   * The feature keys this seat's account resolves to (deployment.md §12).
   * A join-time snapshot: the server resolves the account's entitlements
   * once at join and again on every rejoin, so a grant made while the
   * client is connected arrives with the next reconnect (R139).
   */
  features: string[];
  /**
   * Arcade only (arcade.md §9): the match's own tables. The client mirrors
   * nothing — the map's win condition, prices, unlocked hulls, rounds and
   * seat roster all arrive here, exactly as core ships `catalog`. Absent on
   * a core world.
   */
  arcade:
    | ArcadeInfo
    | undefined;
  /**
   * The sheet's own provenance (R548, ui-map-interface.md §17.3, card
   * 24). `build` is the revision the server runs, and `pack` is the
   * fingerprint of the balance pack it applied. The chart furniture's
   * imprint prints both, the way a chart prints its plate and its
   * correction. Both are empty on a server that cannot say either.
   */
  build: string;
  pack: string;
  /**
   * Every wreck of the season so far (R801, ui-map-interface.md §17.3.08):
   * one entry per sunk hull, in the order the hub recorded them. The chart
   * furniture draws them; a `Wrecks` frame appends to the list.
   */
  wrecks: Wreck[];
  /**
   * Where the next seaquake shock strikes (R803), so a client that joins
   * in the arc draws the epicentre at once. Absent on an arcade world.
   */
  quake:
    | QuakeInfo
    | undefined;
  /**
   * Every monument of this world's past winners (R964, numbers.md
   * §14.1). A monument is public: every client receives the same list,
   * whatever its faction heard. Empty on a world with no closed season,
   * and on an arcade world.
   */
  monuments: Monument[];
  /**
   * The named trenches of the Clan War champions (R1251, numbers.md
   * §14.2): at most two, the largest trench first. A trench a grant does
   * not name keeps the client's random name. Public, like the monuments.
   */
  namedTrenches: NamedTrench[];
  /**
   * The five banners of a Clan War world (R1260, autopilot.md §15): the
   * clan that holds each faction slot, or the NPC house (R1262). The
   * client names a faction by its banner wherever it names a faction.
   * Empty on every other world, which keeps the faction names.
   */
  banners: WarBanner[];
  /**
   * The feature flags this world plays with (v2-the-deep.md §17, R1574):
   * the set the hub latched when it founded the map, in the order of
   * data/contracts/features.toml. Empty is every flag off. Not the
   * account's entitlement keys, which ride `features`.
   */
  featureFlags: string[];
  /**
   * The calm gate of the shield regen (numbers.md §4), in MAP seconds at
   * this world's combat pace (`Sim.MapSecs`): how long a hull must go
   * without damage before its shields refill. The gun-shot layer reads it
   * to find the opening hit of a fight, which alone draws the shield look
   * at full strength (R1979). It is the class figure, without R2 Field
   * Repairs, because the viewer cannot read an enemy's tech. 0 on a page
   * that plays no fight: every hit then opens.
   */
  regenCalmMapSec: number;
  /**
   * The settlement clock (R2093), so a client that joins in stage 3 draws
   * the drain banner and the two clocks at once. Absent outside stage 3
   * and on an arcade world.
   */
  settlement:
    | SettlementClock
    | undefined;
  /**
   * The time of day, in world game-seconds (0..86399), that the season's
   * world clock opened at (R2519). The founding and every roll take it
   * from the clock zone of the server, or 12:00 without one. The client
   * turns a stamp in world seconds since the start into a time of day
   * with it.
   */
  clockOriginSec: number;
  /**
   * The depth band of each cell (v2-the-deep.md §3.1, §14.9, R2609):
   * cols*rows bytes, a DepthBand value each, 0 on rock. A band is
   * faction knowledge: while the flag discovery is latched only the
   * surveyed cells of the viewer's faction carry their band, and the rest
   * read 0 (§4.1). Absent while the flag depth is off.
   */
  depth: Uint8Array;
  /**
   * The current field (v2-the-deep.md §5.1, §14.9, R2609): one pair vx, vy
   * for each cell, 2*cols*rows bytes, each a signed int8 in two's
   * complement, in the unit `CatalogRules.current_unit_px_h` (px a map
   * hour). The field is the strength at tide factor 1; the tide of
   * `CatalogRules.tide_steps` scales it. 0 on rock. Absent while the flag
   * currents is off. While the flag discovery is latched only the
   * surveyed cells of the viewer's faction carry their pair, and the rest
   * read 0 (§4.1, R2611).
   */
  currents: Uint8Array;
  /**
   * The survey of the viewer's faction (v2-the-deep.md §4.1, §14.9,
   * R2611): a bitset of the cells in cell order, bit c%8 of byte c/8 is
   * cell c, the low bit first. Absent while the flag discovery is off.
   */
  survey: Uint8Array;
  /**
   * The points of interest that the survey of the viewer's faction holds
   * (§4.2, R2611), in id order. Absent while the flag discovery is off.
   */
  pois: PointOfInterest[];
  /**
   * Every named seamount of the world (v2-the-deep.md §4.3, R2620), in
   * body order. A name is public: every client gets every name, in the
   * language of the reader. Absent while the flag discovery is off.
   */
  namedSeamounts: NamedSeamount[];
  /**
   * The fairways of the map and their buoys (v2-the-deep.md §7.1,
   * R2717). The generator makes both from the terrain and the sites with
   * no draw, so the hello sends them once and no frame changes them. A
   * fairway and a buoy are public: every client gets the whole list,
   * whatever its survey holds. Absent while the flag routes is off.
   */
  fairways: Fairway[];
  buoys: FairwayBuoy[];
  /**
   * Where TOGGLE CACHES of the admin panel stands for this seat (R2825).
   * It lives on the connection like `admin_reveal`, so it is off on every
   * fresh one, and false for a non-admin seat.
   */
  adminCaches: boolean;
  /**
   * Where TOGGLE VEIL of the admin panel stands for this seat (R2825):
   * while it is on, every survey field of this connection reads every
   * cell as surveyed (`survey`, `pois`, `depth`, `currents` here and the
   * same fields of State). The survey of the faction does not change. It
   * lives on the connection like `admin_reveal`.
   */
  adminVeil: boolean;
  /**
   * The factions that hold commanders on this world (R3095): the enabled
   * set of a custom world's `seating`, in ascending order. Empty is every
   * faction, as on every world that is not custom. A client hides the rows
   * of a faction this list leaves out.
   */
  factions: number[];
}

/**
 * One fairway (v2-the-deep.md §7.1, R2717): its chains, each a line of
 * neighbouring water cells, and its narrows cells, in the order a walk of
 * the chains first meets them. Two chains of one fairway meet at a
 * junction cell.
 */
export interface Fairway {
  chains: FairwayChain[];
  narrows: number[];
}

/** One chain of a fairway: the cell indices of its water cells, in order. */
export interface FairwayChain {
  cells: number[];
}

/**
 * One buoy of a fairway (v2-the-deep.md §7.1, R2717): its kind, its point
 * and the chain it marks, counted over the chains of every fairway of
 * `Hello.fairways` in order.
 */
export interface FairwayBuoy {
  kind: BuoyKind;
  xMpx: number;
  yMpx: number;
  chain: number;
}

/**
 * One point of interest (v2-the-deep.md §4.2, R2611): the stable id of
 * the generator, the kind and the water cell.
 */
export interface PointOfInterest {
  id: number;
  kind: PoiKind;
  cell: number;
  /**
   * A lair only, while the flag pirates is latched (v2-the-deep.md §8.4,
   * R2719, protocol 39): the class of the monster that sails from it, and
   * its design of that class, 0 to 3, in the card order of round 109
   * (`designs` of [[npc.monsters]]). A lair of a world with the flag off
   * sends SHIP_CLASS_UNSPECIFIED and 0: no monster sails there.
   */
  monster: ShipClass;
  design: number;
  /**
   * The credit bounty of a lair object of an arcade match (arcade.md
   * §20, R3216): the seat of the last hit on its beast takes it. 0
   * outside a match.
   */
  bounty: number;
}

/**
 * The live state of one point of interest (v2-the-deep.md §4.2, §14.9,
 * R2735), as the sim keeps it. A vent carries its stock in isotopes and,
 * while it is worked out, the world seconds until it fills again (flag
 * discovery). A lair carries the state of its monster and, while the
 * monster is gone, the world seconds until it sails again (flag pirates).
 * A seeded cache carries `dug`: a commander took it (flag treasure). A
 * gate and a ruin carry no row. `left_sec` counts at the send: the client
 * counts it down, and the row goes out again only when a fact changes.
 */
export interface PoiLive {
  id: number;
  stock: number;
  leftSec: number;
  monster: PoiMonster;
  dug: boolean;
}

/**
 * One seamount and its name (v2-the-deep.md §4.3, R2620). `body` is the
 * seamount id of the map (world.Seamount.ID, 1, 2, ...), and `cell` is
 * the rock cell of the body nearest to its centre, where the chart writes
 * the name. `name` is the free text, or the word-list name in the
 * language of the reader; an empty name on a State frame says that an
 * operator deleted the name. `commander` is the name of the commander who
 * named it. In Empire.seamount_finds the name is empty.
 */
export interface NamedSeamount {
  body: number;
  cell: number;
  faction: number;
  name: string;
  commander: string;
}

/**
 * NameSeamount names one seamount (v2-the-deep.md §4.3, R2606, R2620).
 * A free-text name sets `text`, which needs the key `free_text`; an empty
 * `text` is a word-list name, the place `first` in the first list and
 * the place `second` in the second list of `[ui.seamount_name]`. A
 * refusal arrives as an error notice.
 */
export interface NameSeamount {
  body: number;
  text: string;
  first: number;
  second: number;
}

/**
 * The settlement clock of seaquake stage 3 (numbers.md §15, R2091-R2093).
 * The settlement runs on the WALL clock, so both figures are wall
 * instants in Unix milliseconds and need no timescale. The hub sends the
 * message when stage 3 opens, when the card phase opens, on every
 * scoreboard beat of stage 3 and after a dev panel jump; the Hello
 * carries it too. Each send states the instants again from the hub's
 * own countdown, so a client takes the newest one and drops the rest.
 */
export interface SettlementClock {
  /**
   * The end of the drain: the shocks, the falling holds and the
   * sovereignty fade stop here, and the season summary card opens.
   */
  drainEndsUnixMs: number;
  /**
   * The end of the settlement: the roll, or the close of a world the
   * calendar holds (`held`).
   */
  endsUnixMs: number;
  /**
   * The meta calendar holds this world (R613): no season follows at the
   * end, so the client states no roll clock.
   */
  held: boolean;
}

/**
 * One banner of a Clan War world (R1260). `faction` is the slot 1..5.
 * `name` and `tag` are the clan's; for an NPC house `name` is the bare
 * house name and the client writes "House <name>" in its own language.
 */
export interface WarBanner {
  faction: number;
  name: string;
  tag: string;
  house: boolean;
}

/**
 * One trench a Clan War champion named (R1251). The map does not change:
 * `cell` is the lowest cell index of a trench body the terrain already
 * holds, so the client finds the body in its own mirror of `blocked`.
 */
export interface NamedTrench {
  cell: number;
  /** the granted trench name */
  name: string;
  /** the Clan War number */
  war: number;
  /** the winning clan's name, a copy */
  clan: string;
}

/**
 * One memorial on the map (R964). A world remembers the first commander
 * of every season it closed, and the next map carries that winner list.
 *
 * A monument is NOT a site: it carries no site id, it takes no press, no
 * hull docks at one, and no claim grows from one. The client draws it and
 * nothing else.
 *
 * MONUMENT_KIND_REEF names the winner of the LAST season: three rock
 * cells in a crescent in open water. Those cells are rock in `blocked` as
 * well, so a client that draws terrain alone still draws the reef.
 * MONUMENT_KIND_HOLD_SITE names a winner of an earlier season: one water
 * cell, which the client draws with the broken hold symbol.
 */
export interface Monument {
  kind: MonumentKind;
  /** reef: three cells; hold site and pool: one */
  cells: number[];
  /** the winner's name as the season closed */
  commander: string;
  faction: number;
  /** the season this commander won */
  season: number;
  score: number;
  /**
   * The origin world's name of a pool monument (R1243). Empty for a
   * monument of this world.
   */
  world: string;
}

/**
 * One sunk hull on the sea bed (R801). A wreck is public: every client
 * receives every wreck, whatever its faction heard. `fleet` is the sunk
 * hull's id, which a sinking message's replay names, so a client can hide
 * the wreck under its own battle mark.
 */
export interface Wreck {
  fleet: number;
  xMpx: number;
  yMpx: number;
  cls: ShipClass;
  faction: number;
  /**
   * When the hull went down, in world seconds since the season began
   * (R804). The client drops a wreck older than
   * `CatalogRules.wreck_window_sec`, the same age the hello cuts at.
   */
  sunkSec: number;
  /**
   * v2 (protocol 38): the NPC kind of the sunk hull (v2-the-deep.md §8.1,
   * §14.5, R2622). A wreck of the NPC side is of faction 0, and the client
   * draws it in the NPC ink. A hull of a faction leaves none.
   */
  npc: NpcKind;
}

/**
 * One cargo sighting (v2-the-deep.md §9.6, §14.9, R2843): the last thing
 * the sonar of this commander heard of a wreck of the wreck window that
 * holds cargo. `fleet` is the id of the sunk hull, as in Wreck. `take` is
 * what a SEARCH in reach takes of the cargo (recover_share of `[deep.search]`, by
 * resource kind), as the server computed it at the sighting. `seen_sec`
 * is the world clock of the sighting, in world seconds since the season
 * began (the clock of Wreck.sunk_sec). The sighting stays after the wreck
 * leaves the hearing, so it can be stale.
 *
 * Protocol 43 (R2850): `recovered` marks a row of a wreck that this
 * commander knows is recovered: his sonar heard it recovered, or his own
 * SEARCH ended in reach of it (R2860). Such a row has no take, and `seen_sec` is the world clock of
 * the moment he learned it. The row stays until the wreck leaves the
 * wreck window. A wreck he never heard recovered has no such row.
 */
export interface CargoSighting {
  fleet: number;
  take: Resources | undefined;
  seenSec: number;
  recovered: boolean;
}

/** The wrecks one step added (R801). */
export interface Wrecks {
  wrecks: Wreck[];
}

/**
 * One shard in the server's world list, for the client's world picker.
 * Worlds are independent: nothing crosses them but accounts (game-design §3).
 */
export interface WorldInfo {
  id: number;
  name: string;
  region: string;
  season: number;
  population: number;
}

/** What a level of this building opens, and the level that opens it. */
export interface LevelUnlock {
  level: number;
  kind: LevelUnlockKind;
  /** the tier, the slot count or the hull class; 0 when the kind needs none */
  value: number;
}

export interface BuildingSpec {
  id: Building;
  name: string;
  max: number;
  /** level 1 */
  cost:
    | Resources
    | undefined;
  /** level 1 */
  timeSec: number;
  effect: string;
  /** required node, 0 = none */
  tech: number;
  /** The unlock ladder of this building, in level order (R1081). */
  unlocks: LevelUnlock[];
}

export interface ShipSpec {
  id: ShipClass;
  name: string;
  weight: number;
  hull: number;
  shield: number;
  speedUh: number;
  noise: number;
  cargo: number;
  cost: Resources | undefined;
  timeSec: number;
  sonar: number;
  dps: number;
  range: number;
  support: boolean;
  tech: number;
  /**
   * Torpedo kinds this hull may load (decided 2026-08-21: capability is
   * data on the ship spec). Empty = the class carries no tubes.
   */
  torpedoes: TorpedoKind[];
  /**
   * The dead zone in px (R407): this class holds fire against anything
   * nearer, so it fires into the band from min_range to range. 0 = no
   * dead zone. Same unit as range, which is whole px on the wire.
   */
  minRange: number;
  /**
   * The hull's place in the counter web (R407), as the pack word:
   * skirmish, brawler, artillery, torpedo, tower or support. The client
   * prints the word and reads Catalog.role_bonuses for the matchups.
   */
  role: string;
  /**
   * The gun range in px this hull fires at while its anchor is SET
   * (R661). It is also the capability flag: a hull with one takes the
   * ANCHOR order and becomes a planted tower, and the client offers the
   * control on it. 0 = the hull refuses the order, which is every hull
   * but the Sentinel. The Beacon anchors under its own doctrine (R114)
   * and carries 0 here, because it mounts no gun. Same unit as range,
   * which is whole px on the wire.
   */
  anchorRange: number;
  /**
   * The Shipyard level the empire must hold to lay this hull down
   * (R684). The ladder is the hull's weight class: 1 for a light hull, 3
   * for a medium one, 5 for a heavy one. The client greys the row and
   * says which level the hull waits for; it computes nothing from it.
   */
  wharf: number;
  /**
   * What DRAFTING a design on this hull costs in isotopes, on top of the
   * usual share of the hull price (ships.toml draft_isotopes, numbers.md
   * §6). The draft form prices a design before the press (R700).
   */
  draftIsotopes: number;
  /**
   * Torpedo kinds this hull takes aboard but never fires (R712).
   * The Tender stows light rounds and hands them to an allied hull; the
   * client prints the stow where a tubed hull prints its magazine. A kind
   * never appears in both `torpedoes` and `stows`.
   */
  stows: TorpedoKind[];
  /**
   * The hull takes the ANCHOR order (R712). It is the whole rule
   * the client asks: the Beacon, every hull with an `anchor_range`, and
   * every hull the pack marks here. A gunless hull carries no anchor
   * range, so the flag is what makes its anchor offerable.
   */
  anchors: boolean;
  /**
   * The gun's shot (numbers.md §4, R1135, R1136). `fire_period_sec` is the
   * fire period in COMBAT seconds: the gun lands one shot, then cools for
   * this long. `shot_damage_x10` is what one shot of the printed hull
   * deals, `dps` x `fire_period_sec`, in tenths of a point and before the
   * role and triangle multipliers. The server computes the product, so the
   * client prints it and mirrors no rule. Both are 0 on an unarmed hull.
   * The combat pace never goes on the wire, so the client states the
   * period in combat seconds and not in wall seconds.
   */
  firePeriodSec: number;
  shotDamageX10: number;
  /**
   * The captain attribute that leads this hull class, as its index into
   * Catalog.attrs (numbers.md §12, ships.toml lead_attr, R1900); -1 =
   * none, which is every support hull. The captain picker lights that
   * column of the ability strip. No rule reads it.
   */
  leadAttr: number;
  /**
   * The hull mounts no gun (dps 0), so a draft on it takes no Weapon
   * module and no typed weapon (numbers.md §6, R1911). The draft form
   * locks those picks off this flag and mirrors no rule.
   */
  unarmed: boolean;
  /**
   * The approach (numbers.md §4.1, R2371): the class's signature order
   * and the class default trigger, on which the sim spends the charge of
   * a hull whose commander is absent (R2387); both 0 on a support
   * hull and the Sentinel. `turn_rate_deg_s` is the class turn rate in
   * degrees per MAP second, before the Helmsmanship lift. They are facts of
   * the pack and always sent.
   */
  signature: SignatureOrder;
  signatureTrigger: SignatureTrigger;
  turnRateDegS: number;
  /**
   * The width in degrees of the gun arc round the bow (ships.toml
   * gun_arc_deg, numbers.md §4.1, R2389): the gun fires only on a target
   * inside it. 360 on the Corsair and the Sentinel, 0 on an unarmed
   * hull and from a server older than the field. The map hatches the
   * rest of the gun-ring disc as the rear dead zone; 0 and 360 draw none.
   */
  gunArcDeg: number;
  /**
   * The depth rating (ships.toml depth_rating, v2-the-deep.md §3.2, R2608,
   * R2609): the deepest depth band the hull holds with no pressure loss.
   * A fact of the pack, always sent; the client reads it while the flag
   * depth is on. DEPTH_BAND_NONE from a server older than the field.
   */
  depthRating: DepthBand;
  /**
   * The class cap (ships.toml cap, v2-the-deep.md §16.7, R2584): the most
   * hulls of the class one empire holds, at sea, in the pens and in the
   * build queue together. 0 is no cap, so every row but the Commodore
   * sends no byte. The build row states it and locks BUILD at the cap.
   */
  cap: number;
}

/**
 * One cell of the counter web (R407): what an attacker of one role does
 * to a target of another, as a multiplier on close-in damage. A pair the
 * catalog does not carry is 1. The client prints what a hull is strong
 * and weak against from this list; it mirrors no table of its own.
 */
export interface RoleBonus {
  attacker: string;
  target: string;
  mul: number;
}

export interface TechSpec {
  id: number;
  code: string;
  name: string;
  branch: string;
  tier: number;
  cost: Resources | undefined;
  timeSec: number;
  requires: number[];
  unlocks: string;
  /** Research Lab level that opens this tier */
  labLevel: number;
  /**
   * The short form of the node for line 2 of its build row: a key and a
   * figure, 13 characters or fewer (R1862). The build card keeps
   * `unlocks`.
   */
  brief: string;
  /**
   * The Command Centre level cap this Foundations node opens; 0 on any
   * other node. The build row of the Command Centre reads it to show
   * LOCKED when the next level needs the next node.
   */
  baseCap: number;
}

export interface TorpedoSpec {
  id: TorpedoKind;
  name: string;
  damage: number;
  splash: number;
  speedUh: number;
  range: number;
  cost: Resources | undefined;
  timeSec: number;
  /** cargo units one round occupies */
  cargo: number;
  /** launched by Torpedobanks rather than a hull */
  fromBase: boolean;
  tech: number;
  effect: string;
  /** Splash hits friendly fleets too (decided 2026-08-21: the Heavy). */
  friendlyFire: boolean;
  /**
   * What the round is FOR, in two or three words: "Standard Round",
   * "Light Auto-Defense" (R698). The BUILD menu prints it beside the
   * launcher, so the list reads as a set of jobs rather than a set of
   * figures. The figures moved to the round's info card.
   */
  use: string;
  /**
   * The round burst (R2018): the radius in px in which the round's
   * detonation kills every other round in flight. 0 is none.
   */
  burstPx: number;
  /**
   * The keys of the torpedo refresh (numbers.md §5, R2779, protocol 41).
   * `own` marks an own-side round: its effect lands on hulls of the
   * launcher's own faction, and it never strikes a hostile hull. `auto`
   * is false for a round AUTO does not take; a player loads it by hand.
   * `heal` is the hull an own-side round repairs on its primary own hull.
   * `burst_hostile` makes the burst skip the launcher's own rounds.
   * `loiter_sec` is the map seconds the round waits at its aim point, 0
   * for none.
   */
  own: boolean;
  auto: boolean;
  heal: number;
  burstHostile: boolean;
  loiterSec: number;
}

/**
 * One kind of sea object of the Depot (v2-the-deep.md §11.2, §11.3,
 * §11.5, R2653): what the DEPOT pill orders and the build card of the
 * Depot names. The order of one item costs `cost` and takes `time_sec`
 * at speed 1, as a round job does; `tech` is the gate node (0 for none)
 * and `depot_level` the Depot level that opens the kind.
 */
export interface SeaObjectSpec {
  id: SeaObjectKind;
  name: string;
  /** a sea mine; false is a deployable */
  seaMine: boolean;
  cost: Resources | undefined;
  timeSec: number;
  tech: number;
  depotLevel: number;
  /** the room of one item in the stow of a Sapper */
  cargo: number;
  /**
   * A Hark: the listening range in px of the anchored buoy, a fixed
   * listener (R2654); 0 for every other kind. The client draws the ring
   * of an own buoy from it.
   */
  sonarPx: number;
  /**
   * The figures the marks of the canvas draw to scale (v2-the-deep.md
   * §11.2, §11.3, §11.9 "The canvas", R2657, R2659), read off the applied
   * pack, so a live pack patch moves the marks with the rule. A figure
   * the kind does not have is 0. A sea mine: the contact radius, the
   * hearing radius of the Siren, the splash and the lump of a detonation
   * (the film reads the kind of a sea mine hit off the lump). A
   * deployable: the length of a line or the radius of a disc, and the
   * reach of the Fanal. All in world px; the lump in hull points.
   */
  triggerPx: number;
  hearPx: number;
  splashPx: number;
  damage: number;
  lengthPx: number;
  reachPx: number;
  /**
   * The speed factor the kind gives a hull it acts on (seaobjects.toml
   * speed_mul): the lift of an armed Fanal, which the on-ramp offer
   * of the map prices (v2-the-deep.md §7.2 "The lane course", R3075). 0 for a kind
   * that changes no speed.
   */
  speedMul: number;
}

/**
 * One market listing: an item for sale, credits only, per world (v12 adds
 * item kinds; prints keep their exact pre-v12 behaviour).
 */
export interface MarketListing {
  id: number;
  /** account id */
  seller: number;
  sellerName: string;
  /** BLUEPRINT only: runs included; provenance in `inventor` */
  print:
    | Blueprint
    | undefined;
  /** credits, for the whole listing */
  price: number;
  item: MarketItemKind;
  /** ISOTOPES only: units in the escrowed lot */
  qty: number;
}

export interface Market {
  listings: MarketListing[];
}

/**
 * Dev/admin controls (v6, additive): only honoured for an admin seat of a
 * server started with -admin, which is off by default. In ticket mode an
 * admin seat is one the meta server granted the admin entitlement to; in
 * open mode it is any human seat.
 */
export interface AdminAction {
  /** grant | maxbase | maxfleet | rush | timescale | tacticalscale | advance | quake | roll | reveal | autopilot | reloadwardroom | restart */
  op: string;
  /**
   * timescale/tacticalscale: multiplier; quake: target stage 1..3;
   * advance: world seconds to push the world clock forward by.
   */
  value: number;
}

/**
 * Dev build watch (R89, additive): what commit the running binary was
 * built from and how far the working repo's HEAD has moved past it. Only
 * a server started with -watch-git ever fills this, and only admin seats
 * ever receive it — a real deployment never sends the frame at all, so
 * the client's dev badge cannot appear there.
 */
export interface DevBuild {
  /** short hash the running server was built from */
  build: string;
  /** short hash of the repo's HEAD right now */
  head: string;
  /** commits HEAD is ahead of `build` (0 = up to date) */
  behind: number;
  /** branch HEAD points at, for the tooltip */
  branch: string;
}

export interface MarketAction {
  /** sell this print */
  listDesign: number;
  /** shared by both list intents */
  price: number;
  /** listing id */
  buy: number;
  /** listing id */
  cancel: number;
  /** v12: sell this many isotopes for `price` credits */
  listIsotopes: number;
}

export interface Catalog {
  buildings: BuildingSpec[];
  ships: ShipSpec[];
  tech: TechSpec[];
  /** captain attribute names, in wire order */
  attrs: string[];
  torpedoes: TorpedoSpec[];
  expeditions: ExpeditionSpec[];
  /** index 1..3; 0 is "—" */
  weaponTypes: string[];
  shieldTypes: string[];
  /** DISABLED (R114): always 0 — see MISSION_CAPTURE */
  captureSec: number;
  /** one anchor set/weigh cycle, game-seconds (R114) */
  anchorCycleSec: number;
  /** how many hex rings an anchored ship radiates over */
  anchorRings: number;
  /** the client's half of the event table */
  events: EventSpec[];
  /** what an event row leaves unsaid */
  eventDefaults:
    | EventDefaults
    | undefined;
  /** the loose rule figures the DOM states (R355) */
  rules:
    | CatalogRules
    | undefined;
  /** the §4 counter web (R407) */
  roleBonuses: RoleBonus[];
  /** the §6 module table (R700) */
  modules: ModuleSpec[];
  /** a draft costs this share of the hull price */
  inventionCostShare: number;
  /** the flat draft clock */
  inventionTimeSec: number;
  /** the casino's rule table (casino.md §3) */
  casino:
    | CasinoRules
    | undefined;
  /** The redraft of one slot costs this share of the hull price (R1194). */
  redraftCostShare: number;
  /**
   * The kinds of sea object the Depot builds (v2-the-deep.md §11.5,
   * R2653), in SeaObjectKind order. The flag sapper gates them, so a
   * world with the flag off sends none.
   */
  seaObjects: SeaObjectSpec[];
  /**
   * How long the beam order of a SET Beacon runs, map seconds (R2858).
   * The anchoring look draws the share of the beam left against it.
   */
  beaconBeamSec: number;
}

/**
 * The rule figures the client's own sentences state (R355).
 *
 * The client renders no table from these and computes nothing with them.
 * Every one of them is a WORD in a sentence that data/locale/en/ui.toml
 * owns, and a sentence that states a figure the balance pack can patch
 * must state the figure this server booted with. That is the whole
 * purpose of the message: a pack patched by restart moves the words.
 *
 * What does NOT belong here: anything on the compile-time lane (the
 * product policy of data/product/, the contracts, the world topology),
 * which balancegen bakes into both sides and `-balance` does not move;
 * and anything the client already receives — the sov survey cadence
 * rides WarState.sample_every_sec, so it is not repeated here.
 */
export interface CatalogRules {
  /** an idle build queue mints this */
  idleCreditsPerHour: number;
  /** the auction's isotope lot bounds */
  isotopeLotMin: number;
  isotopeLotMax: number;
  /** runs one standard print lays down */
  standardPrintRuns: number;
  /** a module's invention roll range */
  inventionRollMin: number;
  inventionRollMax: number;
  /** Ship Design level a typed weapon needs */
  weapTypeShipDesign: number;
  /** and a typed shield */
  shieldTypeShipDesign: number;
  /** how long a scan stays on the Intel shelf */
  intelTtlSec: number;
  /** a talent trains this much faster */
  talentTrainingMul: number;
  /**
   * The whole of each timer the bar's foot drains (R430), in world
   * game-seconds: the drain needs the total the countdown started from,
   * and a mid-truce joiner must see the share that is left, not a full
   * line. The season figure is the calendar length a stage 1 or 2
   * seaquake counts against. The two settlement figures sit at 40 and 41.
   */
  truceSec: number;
  seasonSec: number;
  /**
   * The Communications level that opens SHARE on an Oracle (R453): the
   * panel shows the button only at that level, and the figure is the
   * pack's, not the client's.
   */
  oracleShareComms: number;
  /**
   * How near a hull a round must come before it detonates, in world px
   * (numbers.md §5, R548). The chart furniture draws the fuse circle on
   * the aim point with it, so the figure the map draws is the pack's and
   * never the client's.
   */
  torpedoFusePx: number;
  /**
   * The two coefficients of the dive injury risk (numbers.md §11, R137,
   * R669, R673): risk = base x (1 - rad_risk_cut_per_level x Radiation
   * Control level - prospecting_injury_cut_per_point x Prospecting). The
   * two cuts add inside one factor, so the risk never reaches zero.
   * ExpeditionSpec carries the base of the depth, and that base is one
   * figure for the whole world. The client needs both coefficients to
   * print the risk this empire runs and the risk one captain runs.
   */
  radRiskCutPerLevel: number;
  prospectingInjuryCutPerPoint: number;
  /**
   * The two auction-slot rates (R692): how many isotope lots one seat
   * may hold open per Radiation Control level, and how many print
   * listings per Ship Design level. The auction panel states the rule in
   * one sentence and takes both figures from here.
   */
  isotopeLotsPerRadControlLevel: number;
  printListingsPerShipDesignLevel: number;
  /**
   * The keystone tier (R708). `keystone_tier` is the tier whose nodes
   * are exclusive: one a commander a season, and the choice is final
   * (R1785). The TECH tab greys the other three once one is held or
   * queued.
   */
  keystoneTier: number;
  /**
   * The radius of a set Tender's aura in world px (numbers.md §3, R723).
   * The map draws the regen wave to it, so the ring shows the applied
   * pack's figure and never the client's.
   */
  tenderAuraPx: number;
  /**
   * How long a strategic object's vulnerability window stays open, in
   * world game-seconds (numbers.md §8, R787). The client draws the
   * countdown to the next window and must know when the open one shuts,
   * so the figure is the applied pack's and never a client literal.
   */
  objWindowSec: number;
  /**
   * How old a wreck may be before a client stops drawing it, in world
   * game-seconds (R804). The hello carries only the wrecks younger than
   * this, and the client drops one at this age, so a client that stays
   * connected shows the same sea bed as one that just joined.
   */
  wreckWindowSec: number;
  /**
   * The radius of a held Coral Ward's aura in world px (numbers.md §8,
   * R1082), the tender_aura_px precedent: the map draws the ring to this
   * radius, so the figure is the applied pack's and the client computes
   * no distance of its own.
   */
  wardAuraPx: number;
  /** The captain figures the CAPTAIN pages state (numbers.md §12, R1118). */
  captain:
    | CaptainRules
    | undefined;
  /**
   * The Torpedo Battery level at which the automated point defence starts
   * to fire (numbers.md §5, R1154). Below it the base panel says when the
   * defence starts, and never that it is ready.
   */
  torpedobankPointDefenceLevel: number;
  /**
   * The skew of the invention draw (numbers.md §6, R1194): a roll is
   * invention_roll_min + span x u^skew. A sentence that states the draw
   * must not call it uniform.
   */
  inventionRollSkew: number;
  /** The grades of the roll, lowest first, each with its chance (R1194). */
  moduleGrades: ModuleGrade[];
  /**
   * How long a map marker lives, in WALL seconds (player-reach.md §2.3,
   * R1292). The chart draws the life of a marker as the share of this
   * figure that is left before `MapMarker.expires_unix`, so the figure is
   * the applied pack's and never a client literal.
   */
  markerLifeSec: number;
  /**
   * The Tender's trade as the hull's info card states it (numbers.md §3,
   * R712, R1495). Under way or set, a Tender repairs the nearest friendly
   * hull inside `tender_repair_range_px`, at `tender_repair_per_map_minute`
   * of that hull's maximum each MAP minute. Set, its aura (the reach is
   * `tender_aura_px`) gives `tender_shield_per_combat_sec` of maximum
   * shield each COMBAT second, and it hands one stowed round to an allied
   * hull every `tender_restock_every_sec` of map time. The shares are
   * fractions (0.005 is 0.5%).
   */
  tenderRepairRangePx: number;
  tenderRepairPerMapMinute: number;
  tenderShieldPerCombatSec: number;
  tenderRestockEverySec: number;
  /**
   * What a SET anchor multiplies a hull's noise by (numbers.md §3, §7,
   * R661, R1495). The info card of every anchoring hull states it.
   */
  anchorNoiseMul: number;
  /**
   * The top of a sovereignty gauge, `sov.gauge_max` (numbers.md §7). A
   * cell gauge and a strategic object's gauge both stop there, so the
   * objective card states its gauge as `GAUGE n/max` and the water peek
   * fills its gauge bar against it; the client keeps no literal
   * (ui-map-interface.md §8, mockup round 084 open point 8).
   */
  gaugeMax: number;
  /**
   * How long a scan reveal holds a contact, in map seconds (R412,
   * sim.scan_reveal_sec). The contact card states the age of a scan as
   * this figure less the contact's `scan_left_sec`, so the figure is the
   * applied pack's and never a client literal (ui-map-interface.md §8).
   */
  scanRevealSec: number;
  /**
   * The Command Centre level cap before any Foundations node is held
   * (`tech.base_cap_default`).
   */
  baseCapDefault: number;
  /**
   * The work of the outfit job a dive takes first, in work-seconds at 1x
   * (numbers.md §11, expedition_tuning.prep_minutes, R1899). The queue rate of
   * JOB_KIND_EXPEDITION divides it, as it divides every catalog work
   * figure (R688). The start sheet adds it to BACK, so the return clock
   * counts the outfit and the wait for a build slot.
   */
  expeditionPrepSec: number;
  /**
   * The two phases of the settlement, in WALL seconds (numbers.md §15,
   * R2091, R2092): the drain, then the card phase. The drain banner and
   * the bar's foot drain against the first, the roll clock against the
   * second.
   */
  settlementDrainSec: number;
  settlementCardSec: number;
  /**
   * The figures of the approach the client's sentences state (numbers.md
   * §4.1, R2371). The figures are facts of the pack and always sent.
   */
  approach:
    | ApproachRules
    | undefined;
  /**
   * The course caps (v2-the-deep.md §7, R2549, protocol 38): the legs a
   * commander sets on one order, the pass cap of a loop part and the pass
   * count a part takes at first (sim.route_legs_max,
   * sim.route_loop_passes_max, sim.route_loop_passes_default). The plot
   * line reads them. Facts of the pack, always sent.
   */
  routeLegsMax: number;
  routeLoopPassesMax: number;
  routeLoopPassesDefault: number;
  /**
   * The radius of harbour limits around a hold, in world px
   * (v2-the-deep.md §6.3, sim.harbour.radius_px). Chart card 28 draws it.
   * A fact of the pack, always sent.
   */
  harbourLimitsPx: number;
  /**
   * The course plots a commander keeps (v2-the-deep.md §7,
   * sim.route_plots_max, R2587, R2594): the client reads the cap of the
   * saved plots, and the hub refuses a SAVE past it. A fact of the pack,
   * always sent.
   */
  routePlotsMax: number;
  /**
   * The tide (v2-the-deep.md §5.3, world.currents.tide_period_sec and
   * tide_steps, R2565, R2609): one cycle of `tide_period_sec` world
   * seconds in equal steps, each step a factor of the current field in
   * [-1, 1]. The tide clock of the legend reads them. Facts of the pack,
   * always sent.
   */
  tidePeriodSec: number;
  tideSteps: number[];
  /**
   * One int8 unit of `Hello.currents` in px a map hour
   * (world.CurrentUnitPxH, R2609). A fact of the pack, always sent.
   */
  currentUnitPxH: number;
  /**
   * The thermocline (v2-the-deep.md §3.2, sim.depth.thermo, R2608): the
   * factor on a sonar reach from a source band (row) to a target band
   * (column), shelf, slope, deep, abyss, row by row: 16 factors. A fact
   * of the pack, always sent.
   */
  thermocline: number[];
  /**
   * The pressure wear (v2-the-deep.md §3.2,
   * sim.depth.pressure_per_map_minute, R2608): the share of its maximum
   * hull a hull loses each map minute in a band deeper than its depth
   * rating. The PRESSURE chip states it. A fact of the pack, always sent.
   */
  pressurePerMapMinute: number;
  /**
   * The figures of the command ship the fleet card states (v2-the-deep.md
   * §16.7, ships.toml [command_ship]). Every hello carries them, as it
   * carries the Commodore row (R2805).
   */
  command:
    | CommandShipRules
    | undefined;
  /**
   * The shipping lanes a commander keeps of the course plots
   * (v2-the-deep.md §7.2, sim.route_lanes_max, R2646). Sent only while
   * the world latched routes, so a world with the flag off keeps the
   * bytes of its hello.
   */
  routeLanesMax: number;
  /**
   * The treasure (v2-the-deep.md §9, data/balance/deep.toml [deep.caches],
   * R2643): the fee of a player cache in credits, the finds that pay in
   * one world day, the player caches of one commander in a season, the
   * reach of the search hint in px, and the longest free-text cache note
   * in runes. Facts of the applied pack, sent with every flag set, as the
   * course caps are.
   */
  cacheFeeCredits: number;
  cacheFindsPerWorldDay: number;
  cacheDepositsPerSeason: number;
  cacheHintPx: number;
  cacheNoteMaxRunes: number;
  /**
   * The rules of the sea objects the canvas draws to scale
   * (v2-the-deep.md §11.1, §11.4, §11.9 "The canvas", R2659). Sent only
   * while the world latched sapper, as the rows of `Catalog.sea_objects`
   * are (§14.1 rule 8), so a world with the flag off keeps the bytes of
   * its hello.
   */
  seaObjects:
    | SeaObjectRules
    | undefined;
  /**
   * The figures the point of interest marks draw to scale (v2-the-deep.md
   * §4.2, §5.1, §8.3, R2714): the factor a current gate multiplies the
   * current by and its reach in hex steps (world.toml [world.poi]
   * gate_mul, gate_reach_cells), and the home radius of a monster round
   * its lair in world px (home_px of the first row of npc.toml
   * [[npc.monsters]], the Gulper; R2719). Facts of the
   * applied pack, sent only while the world latched discovery, so a world
   * with the flag off keeps the bytes of its hello.
   */
  poiGateMul: number;
  poiGateReachCells: number;
  poiLairHomePx: number;
  /**
   * The stock of a full vent in isotopes (`stock` of [sim.vents],
   * R2735): the share a mark draws of `PoiLive.stock`. Sent only while
   * the world latched discovery.
   */
  poiVentStock: number;
  /**
   * The hull classes that take a SEARCH (v2-the-deep.md §9.6, deep.toml
   * [deep.search] support_hulls): every combat ship and the support hulls
   * of the list, in display order. The client lists only these hulls for
   * the order; the server judges every order.
   * Sent with every flag set, as the cache figures are.
   */
  workFitClasses: ShipClass[];
  /**
   * The two caps of the commission board (v2-the-deep.md §10, R3065,
   * R3069): the takes of one commander in one world day
   * (max_taken_per_commander_per_day) and the offers one commander
   * holds at one time (max_taken_per_commander) of deep.toml
   * [deep.commissions]. FLEET · COMMISSIONS states both. Sent only while
   * the world latched commissions, so a world with the flag off keeps
   * the bytes of its hello.
   */
  commissionDayCap: number;
  commissionHoldCap: number;
  /**
   * The legs a shipping lane holds at least (v2-the-deep.md §7.2 rule 2,
   * sim.route_lane_legs_min, R3067): the LANE switch stays off for a plot
   * of fewer legs. Sent only while the world latched routes, as
   * route_lanes_max is.
   */
  routeLaneLegsMin: number;
  /**
   * The lane course rule (v2-the-deep.md §7.2 "The lane course", sim.toml
   * route_lane_use_margin, route_lane_use_min_px, R3075): the share of
   * the time of the direct run that a course along a lane of the faction
   * must save, the shortest run that a lane course serves, and the lift
   * of lit water (seaobjects.toml buoy_speed_mul). The on-ramp offer of
   * the map prices a lane course with them; the server judges every
   * course. Sent only while the world latched routes, as
   * route_lanes_max is.
   */
  routeLaneUseMargin: number;
  routeLaneUseMinPx: number;
  buoySpeedMul: number;
  /**
   * The lift of a faction hull on a cell that a shipping lane of its
   * faction crosses, with no Fanal (v2-the-deep.md §7.2 rule 17,
   * seaobjects.toml lane_speed_mul, R3217). The on-ramp offer prices a
   * bare lane with it. Sent only while the world latched routes.
   */
  laneSpeedMul: number;
}

/**
 * The rules of the sea objects a mark of the canvas reads (seaobjects.toml
 * [sea_objects.rules], tech.toml [tech.effects], R2659). The client
 * computes no rule with them: the sim lays, arms, collects and sweeps.
 * Every distance is world px and every time map seconds.
 */
export interface SeaObjectRules {
  /** A laid sea mine arms when its Sapper is this far off. */
  armClearPx: number;
  /** The loud lay: the noise of a Sapper is × this for this long after a lay. */
  layNoiseMul: number;
  layNoiseSec: number;
  /** A Sapper collects an own object inside this radius. */
  collectPx: number;
  /** The sweep radius of a Sapper, and the lift of A4 Signature Masking on it. */
  sweepPx: number;
  sweepRadiusMul: number;
  /** The anchor time of a deployable, and of the Palisade. */
  anchorSec: number;
  palisadeAnchorSec: number;
  /**
   * A sea mine arms this many map seconds after its layer is clear
   * (v2-the-deep.md §11.2 rule 2, R2737): the length of the arm window.
   */
  armAfterSec: number;
  /**
   * The chain of the Fanals (v2-the-deep.md §11.4, R3066): two Fanals
   * chain this far apart along a lane of the faction, and a LAY of
   * a Fanal inside the snap of a free chain point lays it there. The
   * guide of the map draws them; the server decides every lay.
   */
  laneChainPx: number;
  laneSnapPx: number;
}

/**
 * The figures of the approach a sentence states (numbers.md §4.1,
 * sim.toml [sim.approach], R2371). The client computes no rule with them:
 * the server decides every aspect, ambush and spend. A duration in
 * COMBAT seconds stays in combat seconds, as ShipSpec.fire_period_sec
 * does, `gun_noise_sec` too (R2385). A share is a fraction (0.3 is
 * 30 %). The cosine thresholds let the client draw the arcs of a hull
 * (bow and stern each 90° wide at 0.7071).
 */
export interface ApproachRules {
  /**
   * Pillar 1, the aspect: the damage a shot deals by the arc it
   * strikes, and the cap on role cell x aspect x ambush.
   */
  bowCos: number;
  sternCos: number;
  bowMul: number;
  beamMul: number;
  sternMul: number;
  damageCap: number;
  /**
   * Pillar 2, hearing first: a moving hull hears at `baffles_hearing` of
   * its range in its baffles; the first shot of an unheard hull deals
   * `ambush_mul`; every gun shot makes the shooter loud (noise x
   * `gun_noise_mul` for `gun_noise_sec` combat seconds); the shield mends
   * after `quiet_gate_sec` combat seconds that no hostile faction hears
   * the hull.
   */
  bafflesCos: number;
  bafflesHearing: number;
  ambushMul: number;
  gunNoiseMul: number;
  gunNoiseSec: number;
  quietGateSec: number;
  /**
   * Pillar 3, the signature order: the charge returns not earlier than
   * `recharge_floor_sec` combat seconds after the spend (for CANISTER and
   * BROADSIDE, after the effect ends, R2412), and BELOW 50 % HULL fires at
   * `below_hull_frac`.
   */
  rechargeFloorSec: number;
  belowHullFrac: number;
  /**
   * The figures of each order. Each `*_sec` is the window of a timed
   * order; DIG IN also ends when the hull moves (R2856). Every BROADSIDE
   * shot deals `broadside_shot_mul`, and its splash reaches
   * `broadside_splash_mul` of the class splash.
   */
  outflankSec: number;
  outflankSpeedMul: number;
  braceSec: number;
  braceDamageTakenMul: number;
  digInReachPx: number;
  broadsideShotMul: number;
  crashDiveSec: number;
  crashDiveNoiseMul: number;
  crashDiveSpeedMul: number;
  canisterSec: number;
  broadsideSec: number;
  digInSec: number;
  broadsideSplashMul: number;
  /**
   * GETAWAY of the Dredger (R2857): for `getaway_sec` the hull sails at
   * speed x `getaway_speed_mul` and turns at `getaway_turn_mul` of its
   * two turn rates. The spend drops the whole cargo.
   */
  getawaySec: number;
  getawaySpeedMul: number;
  getawayTurnMul: number;
}

/**
 * The figures of the command ship a sentence states (v2-the-deep.md §16.7,
 * ships.toml [command_ship]). The client computes no rule with them: the
 * sim decides the aura, the formation and MUSTER. A share is a fraction
 * (0.5 is 50 %).
 */
export interface CommandShipRules {
  /**
   * The command aura: an own hull inside the reach uses the higher of its
   * own captain's points and this share of the command ship captain's.
   */
  auraReachPx: number;
  auraShare: number;
  /**
   * MUSTER calls the own hulls inside its reach; an answering hull sails
   * to its station at this multiple of the higher of its own speed and
   * the formation pace.
   */
  musterReachPx: number;
  musterBoostMul: number;
  /**
   * The attributes the aura lifts, by the index of Captain.attrs
   * (R2732): the COMMAND chip names the lifted points of each.
   */
  auraAttrs: number[];
  /**
   * The flat lift of an arcade match in whole percent (R3218): the aura
   * lifts the damage, the speed, the turn and the shield regen of an own
   * hull inside the reach by this much, with no captain. 0 outside a
   * match that names the Commodore.
   */
  arcadeLiftPct: number;
}

/**
 * One grade of the invention roll (numbers.md §6, R1194). It runs from
 * min_roll up to max_roll. The server computes the chance from the draw,
 * so the client states it and computes nothing.
 */
export interface ModuleGrade {
  /** the id; the client owns the word (ui.toml) */
  code: string;
  minRoll: number;
  maxRoll: number;
  /** 0..1, the share of drafted modules in this band */
  chance: number;
}

/**
 * The per-point rate of each captain attribute and the career arc, as the
 * captain card and the HOW IT WORKS fold of CAPTAIN state them (R1118,
 * R1895). The rates are percent, rounded to one decimal.
 */
export interface CaptainRules {
  /** One rate per attribute index; Prospecting is the dive yield rate. */
  perPointPct: number[];
  /** Prospecting: dive risk cut */
  injuryCutPerPointPct: number;
  /** the noise cut never passes this */
  silentMaxCutPct: number;
  /** a point takes this many times as long in peak */
  peakTrainingFactor: number;
  attrTrainCap: number;
  /** the decline roll at the first decline season */
  retireBasePct: number;
  /** and its climb per season past it */
  retirePerSeasonPct: number;
  /**
   * The age arc in whole years (numbers.md §12, R1170): a captain ages
   * years_per_season for every season aged, peaks at peak_at_age and
   * declines at decline_at_age. A cadet joins at an age in
   * recruit_age_min .. recruit_age_max.
   */
  yearsPerSeason: number;
  peakAtAge: number;
  declineAtAge: number;
  recruitAgeMin: number;
  recruitAgeMax: number;
  /**
   * Practice (numbers.md §12, R1478): the practice points one attribute
   * can earn in a season, and the share of the measure a captain in
   * decline counts, in percent.
   */
  practiceSeasonCap: number;
  practiceDeclinePct: number;
  /**
   * The HOW IT WORKS fold of CAPTAIN (R2087): the work hours of one
   * Academy point per point of value (numbers.md §12), and the factor by
   * which each further practice point of a season costs more (R1508).
   */
  trainingHoursPerPoint: number;
  practicePointGrowth: number;
  /**
   * The turn rate one Helmsmanship point adds, in percent of the class
   * figure (numbers.md §4.1, captains.helm_turn_per_point, R2371). The
   * per_point_pct row of Helmsmanship stays the speed rate.
   */
  helmTurnPerPointPct: number;
}

/**
 * One event, as much of it as the client needs.
 *
 * The server owns the event table and renders every message it sends, so
 * this row carries presentation only: whether the news toasts, how it
 * sounds, and how long it stays. The client mirrors none of the rest.
 */
export interface EventSpec {
  /** the event id, matching Notice.event */
  id: string;
  /** put the text on screen */
  toast: boolean;
  /** cue id from audio.md; empty plays nothing */
  sfx: string;
  /** 0 uses EventDefaults.toast_ms */
  toastMs: number;
  /**
   * The toast text, for the events the client raises itself: the link, a
   * chat line, a rejoin. A server event arrives already rendered in
   * Notice.text and leaves this empty.
   */
  toastTemplate: string;
  /** the event is always bad news */
  toastError: boolean;
}

/** What an event row leaves unsaid. */
export interface EventDefaults {
  /** how long a toast stays when its row says nothing */
  toastMs: number;
  /** repeat this soon restarts the toast on screen */
  toastDedupMs: number;
}

/**
 * One sov beam in flight (R116): a source — a base, a faction installation,
 * a held strategic object or a settled Beacon — working one tile.
 *
 * One row per source, not per tile. The client draws the line from the
 * source to the target and the gauge arc on the target itself; the server
 * decides which of these a viewer is entitled to see (bases are public, an
 * enemy Beacon has to be heard, and anything eroding your own water is
 * always shown because you can feel your ground going).
 */
export interface SovBeam {
  /** fleet id for a Beacon, site id for anything else */
  sourceId: number;
  beacon: boolean;
  faction: number;
  /** where the source sits */
  xMpx: number;
  yMpx: number;
  targetCell: number;
  /** 0..100 toward the flip */
  progress: number;
  /** pushing strength x10; the pip's speed */
  margin10: number;
  /** faction losing the tile, 0 if it is unclaimed */
  against: number;
  /** the viewer's own source */
  own: boolean;
}

/**
 * A torpedo in flight. Travel time is visible and dodgeable, which is the
 * whole point of the aimed layer (game-design §8).
 */
export interface TorpedoState {
  id: number;
  faction: number;
  kind: TorpedoKind;
  xMpx: number;
  yMpx: number;
  /** milliradians, for drawing the trail */
  headingMrad: number;
  /**
   * How far along its run the round is, 0..100 (R164). The client's flight
   * look reads its heat, its stretch and its pulse rate off this one number,
   * because the sim moves every round at a constant speed and a client that
   * simulates nothing cannot know where a round stops. A round is already
   * exempt from the detection filter, so this adds the endpoint to a line of
   * flight an observer can already read — the warning a target dodges on.
   */
  runPct: number;
  /**
   * The launcher owner's effect, a catalog wire id of
   * data/contracts/effects.toml, 0 = none (R910). A round is already
   * exempt from the detection filter, so it carries no class gate.
   */
  effect: number;
  /**
   * The torpedo refresh (numbers.md §5, R2779, protocol 41). `slowed`
   * marks a round a Torpor slowed. `loiter_pct` is the wait a Stonefish
   * has left at its aim point, 0..100, and 0 on a round that flies.
   */
  slowed: boolean;
  loiterPct: number;
}

/**
 * A fleet as seen by one client. Composition (cls/ships/hull_pct) is only
 * filled in for the viewer's own faction — enemy contacts stay classified.
 * SonarRing is one listening circle this commander receives (R112). The
 * server decides who hears through what — faction installations, a held Relay
 * Spire, your own hold, a squadmate's behind the Communications gates — and
 * sends the finished list, so the client never re-derives a fog-of-war rule
 * it would inevitably get wrong (R110, R111).
 */
export interface SonarRing {
  xMpx: number;
  yMpx: number;
  rangePx: number;
}

export interface FleetState {
  id: number;
  faction: number;
  xMpx: number;
  yMpx: number;
  /**
   * cls is the hull class. Own faction always; for *enemy* contacts it is
   * sent only for support hulls, and withheld for warships — so a dart on
   * the map means "class withheld" and a support icon means "class given"
   * (the fleet-as-atom redesign; only a scan classifies a warship). It is
   * also filled while a scan reveal holds the contact, R412.
   */
  cls: ShipClass;
  hullPct: number;
  shieldPct: number;
  mission: Mission;
  /** ordered target (own fleets only) */
  txMpx: number;
  tyMpx: number;
  /** belongs to the receiving player */
  own: boolean;
  captainId: number;
  /** hull name, own faction only */
  name: string;
  /** carrying a disruptor debuff */
  slowed: boolean;
  /** blueprint the hulls were built to */
  design: number;
  /** tubes ready in, own fleets only */
  reloadSec: number;
  /** The reach of the firing kind, own fleets only. */
  torpedoRange: number;
  /**
   * What is in the hold: per-commodity stacks (protocol v5 — holds mix).
   * A hauler only earns when it gets home, so a laden convoy is a target
   * (game-design §6).
   */
  hold: HoldStack[];
  cargoCap: number;
  /** DISABLED (R114): always 0 while the anchor experiment runs */
  captureLeftSec: number;
  /** own fleets: the fleet being followed */
  escorting: number;
  /**
   * Own fleets: the hostile this fleet chases and fires at alone (R544),
   * 0 when the attack-move hunts whatever it hears.
   */
  focus: number;
  /**
   * Own fleets: the hostile this fleet chases now, the focus or the prey
   * an attack-move or a patrol took up (sim HuntID), 0 for none. The
   * order line ends on that hull and not on the course end, which is the
   * stand-off point of the intercept course (R2754).
   */
  chase: number;
  /**
   * The pattern's systems. Own faction always, and also filled while a scan
   * reveal holds the contact, R412 — a revealed enemy carries its class and
   * its systems and nothing else.
   */
  weapType: number;
  shieldType: number;
  /**
   * Patrol's other end (own fleets, patrol only): the client draws the
   * whole lane, not just the leg currently being sailed.
   */
  pxMpx: number;
  pyMpx: number;
  /**
   * Which commander owns this fleet, own faction only (same rule as name).
   * The client matches it against ClanInfo.members to tell a squadmate's
   * hulls from the rest of the faction's.
   */
  ownerPlayer: number;
  /**
   * The owning commander's name. The server sends it for the own faction,
   * and for an enemy contact while a scan reveal holds it (R412, R1436),
   * where it agrees with the scan report. The hull name and owner_player
   * stay own faction only. The
   * hover tooltip prints the owner, because the faction is already the
   * colour the hull wears. The client cannot derive this: it knows the
   * names of its clanmates only, and the faction is larger than the clan.
   */
  ownerName: string;
  /**
   * Running a trench: half speed, half noise (numbers.md §14). Own fleets
   * only — that a contact is in the deep is exactly what you do not know.
   */
  deep: boolean;
  /**
   * Projection fatigue (numbers.md §4, R80): current readiness in whole
   * percent, 50..100. Own fleets only; 0 means "not sent", not exhausted.
   */
  readinessPct: number;
  /**
   * The lowest readiness THIS hull can reach, in whole percent (§4, R657,
   * R769). It is 50 with no captain, and the Command attribute of the
   * captain aboard lifts it. Own fleets only; 0 means "not sent". The
   * client needs it because the fatigue cue speaks at the floor and at no
   * fixed line, and the floor is a fact of the hull and not of the pack.
   */
  readinessFloorPct: number;
  /**
   * Vedette only, own fleets only: whole game-seconds until the active ping
   * is ready again; 0 = ready (plan §4.5, R83).
   */
  scanReadySec: number;
  /**
   * The listening range this receiver gets *through* this fleet, in px, or 0
   * if they get none (R112). Own hulls always carry it; a squadmate's only
   * once the squad has paid both sides of the Communications fleet gate. It
   * is per-receiver, like the rest of the frame — the same hull is a source
   * for its owner and not for a stranger.
   */
  sonarPx: number;
  /**
   * The Oracle array broadcast (R453). sonar_share is sent to the whole
   * faction: this Oracle is sharing its array, and the client draws the
   * brighter, pulsing ring on it. sonar_share_left_sec is own fleets only:
   * whole MAP seconds of the share left; 0 = SHARE is pressable. Neither is
   * a combat-clock figure, so no conversion applies.
   */
  sonarShare: boolean;
  sonarShareLeftSec: number;
  /**
   * The anchor machine (R114), and only ever non-zero on a Beacon: which of
   * the four states it is in, and the game-seconds left in a running
   * set/weigh cycle (0 when no cycle is running).
   *
   * **Public to anyone who can see the hull** (decided 2026-08-22,
   * fleet-atom-redesign §12), which retires R114's "own fleets only".
   * Detection is the whole gate: a viewer who hears a beacon already gets
   * its beam, its target tile and that tile's progress, so hiding the hull's
   * own state meant watching water be eaten without being able to tell
   * whether the beacon eating it had finished dropping its cable. The
   * countdown travels because the client's ring is drawn *from* it — there
   * is no animation without the number behind it.
   */
  anchor: AnchorState;
  anchorLeftSec: number;
  /**
   * Own fleets only: at least one hostile faction hears this hull right
   * now, as the sim's Detect pass left it. The client's "we are detected"
   * cue reads the rising edge of this flag, so a hull that slips back into
   * the quiet and is heard again cues twice.
   */
  heard: boolean;
  /**
   * Own fleets only: the fleet runs the thermocline (Thermocline Running, A8), so it
   * sails at half speed, wears its hull, and no fixed listener hears it.
   */
  deepRun: boolean;
  /**
   * Own fleets only: the fleet works a shaft on a worked-out deposit
   * (Deep Mining, I2), which draws at a quarter rate and never touches the
   * field's own stock.
   */
  shaft: boolean;
  /**
   * Own faction only, like sonar_share (R453): the hull this Tender
   * tends this tick, 0 when none (R723). The client draws the beam to
   * the id and rises a plus on that hull; it mirrors no range or claim.
   */
  tending: number;
  /**
   * Own faction only: the set Tender whose aura this hull stands in,
   * 0 when none (R723). The Tender carries its own id. The server
   * answers membership: it is a rule outcome on the sim's positions,
   * and the Tender may sit outside the viewer's AOI.
   */
  aura: number;
  /**
   * Own fleets only: the fleet's battle plan for a window battle (R796),
   * packed as position | behaviour << 8 — the same number FleetAction.arg
   * carries for FLEET_OP_SET_BATTLE_PLAN. 0 is CENTRE and ENGAGE, which
   * is what a fleet nobody gave a plan fights on. Ordinary map combat
   * never reads it (numbers.md §8).
   */
  battlePlan: number;
  /**
   * The owner's effect, a catalog wire id of data/contracts/effects.toml,
   * 0 = none (R910, docs/design/effects.md). It is cosmetic: no rule
   * reads it. A HULL-SCOPED effect names the class, so it obeys the
   * class-reveal gate of `cls` above — a viewer of another faction sees
   * it only on a support hull or under a scan reveal, and reads the
   * owner's every-hull effect otherwise.
   */
  effect: number;
  /**
   * Own fleets only: the strategic object this fleet sails to commit at
   * (R788), 0 = none. The server sails a commit as a plain MISSION_MOVE,
   * so the mission alone cannot tell it from a move; the client draws the
   * standing line in the commit gold while this is set (R1208). An enemy
   * that hears the hull must not learn which object it will pledge to.
   */
  pledgeSite: number;
  /**
   * Own fleets only: the owner switched the dredger brain off for this
   * hauler (R1226). The name is the opt-out so that the wire default,
   * false, reads as ON, which is what a new hauler has. The client shows
   * the switch only on a Dredger of an empire whose Empire.dredger_brain
   * is set.
   */
  autoFieldOff: boolean;
  /**
   * The owner's livery, a wire number of data/product/meta.toml
   * [meta.fleet_designer.livery], 0 = NONE (R1252, monetization.md §3.2).
   * It is cosmetic: no rule reads it. It is one pick per ACCOUNT, so it
   * names no class and gives nothing away: every viewer that sees the
   * hull receives it, an enemy contact too. The fleet digest holds it, so
   * a delta frame sends it only on a change.
   */
  livery: number;
  /**
   * The hull's own maximum hull and shield in whole points, own faction
   * only (R1278). The class row is not the maximum: a Shields module and a
   * typed shield lift the shield, and R5 Hull Reinforcement and the Drydock
   * Shoal move the hull. The panel states `pct × max` against these, and
   * 0 means "not sent".
   */
  hullMax: number;
  shieldMax: number;
  /**
   * Own fleets only: the fleet holds fire (R1437). Its gun takes no target
   * by itself and fires at a FOCUS alone. An enemy that hears the hull
   * must not learn that it will not shoot.
   */
  holdFire: boolean;
  /**
   * Own fleets only: the whole tube reload this hull pays after a shot, in
   * map seconds, the unit of `reload_sec` (R1474). W6 Letters of Marque
   * and the combat pace of the world move it, so the client reads the
   * share of the reload left against this figure and never a literal. 0
   * on a hull that launches no torpedo, so the tube reload look of
   * ui-map-interface.md §6.3 draws nothing there.
   */
  reloadFullSec: number;
  /**
   * Own fleets only: the hull's live noise, NoiseFactor() of the sim in
   * thousandths, rounded half away from zero (R1500). It is the class
   * figure with the gait, the captain, the blueprint, Silent Running, a
   * SET fixture, a launch and the trench on it. The panel prints it, and
   * the client mirrors none of the terms. 0 means "not sent"; a hull
   * quieter than 0.0005 reads 1. An enemy that hears the hull must not
   * learn how loud the hull thinks it is.
   */
  noiseMilli: number;
  /**
   * Own fleets only: whole MAP seconds until the natural shield regen
   * starts, rounded up (R1503). It is what the calm gate of numbers.md §4
   * still waits for, with R2 Field Repairs on it, converted from the
   * combat clock. 0 when the shield is full or the regen already runs.
   * The fleet digest holds it in 60 s buckets, and the client counts it
   * down between frames at the tactical scale, the way it counts
   * `reload_sec`, so a still hull re-sends once a map minute.
   */
  regenInSec: number;
  /**
   * Vedette only, own fleets only: whole map seconds until the hull can
   * drop its next A6 noisemaker, rounded up; 0 = ready (R722, R1507). The
   * cooldown covers the life of the noisemaker, so one countdown covers
   * both refusals. The noisemaker has no owner and never carries the
   * field, so an enemy learns nothing from it.
   */
  decoyReadySec: number;
  /**
   * A contact of another faction only, while a scan reveal holds it for
   * this viewer (R412): whole map seconds until the reveal ends, rounded
   * up; 0 = no reveal. It is per viewer, like the reveal itself. The
   * contact card states the age of the scan as `scan_reveal_sec` of the
   * catalog rules less this figure, and fades the hull and shield bars
   * back to "?" as it runs out, so a reload or a join reads the same
   * age as a client that saw the ping (ui-map-interface.md §8, R1837).
   * The fleet digest holds it in 60 s buckets, and the client counts it
   * down between frames at the tactical scale.
   */
  scanLeftSec: number;
  /**
   * Own faction only, like `name`: the name part of the hull name is not in
   * the faction pool, so the owner wrote it, in the Fleet Designer pool or
   * in a rename (monetization.md §3.2). The client offers REPORT on a hull
   * name only when this is set. A name from the faction pool (with its
   * designator and its Roman ordinal) leaves it clear.
   */
  customName: boolean;
  /**
   * Own fleets only (R2017): the load by kind, one row for each kind with
   * a round aboard, in the fixed order Harpoon, Remora, Torpor.
   */
  rounds: TorpedoStock[];
  /**
   * Own fleets only (R2017): the active round the commander picked. The
   * next shot fires it while it holds a round. The client derives the kind
   * that actually fires from `rounds` (R2017).
   */
  activeRound: TorpedoKind;
  /**
   * Own fleets only (R2080): the guard this hull is now — a SET Sentinel
   * whose commander holds the Refit node (R719) — with its reach, its
   * reload period and its clock. Unset on every other hull. A hostile
   * viewer never receives it: the map must not show the cooldown of an
   * enemy (the owner's ruling of 2026-10-13), so a contact draws the kill
   * alone.
   */
  guard:
    | GuardState
    | undefined;
  /**
   * The approach (numbers.md §4.1, R2371). Every field below is 0 on a
   * sim without the approach (a window battle).
   *
   * The heading of the bow in milliradians, the convention of
   * TorpedoState.heading_mrad: the sim's atan2 sense, from +x (east)
   * toward +y (down the screen), in -3142..3142. Own fleets and every
   * contact the frame carries: a heard contact shows its heading, so the
   * client can name the aspect a hull shows the viewer. 0 is east, so
   * the client reads the field only when Hello.feature_flags holds
   * `approach`.
   */
  headingMrad: number;
  /**
   * Own fleets only: the break contact mends the shield now (R2458). The
   * bit is set while no hostile faction has heard the hull for the quiet
   * gate (CatalogRules.approach.quiet_gate_sec), the calm gate is still
   * shut, the world mends shields and the shield is not full. The client
   * shows "QUIET · shields mending". The instant DETECTED alarm stays
   * `heard`; this bit gives the all-clear late, never at once.
   */
  quiet: boolean;
  /**
   * The charge of the hull's signature order: READY or SPENT. Own
   * fleets, and a contact the viewer hears or holds by a scan reveal. 0
   * on a hull without an order (a support hull, the Sentinel).
   */
  signatureCharge: SignatureCharge;
  /**
   * An order effect holds now (OUTFLANK, BRACE, DIG IN, CANISTER,
   * BROADSIDE, CRASH DIVE), and the whole MAP seconds left of a timed
   * one, rounded up; 0 for DIG IN, which has no clock and holds until the
   * hull moves. CANISTER and BROADSIDE count their window, and they end
   * earlier at the hull's next shot (R2412). Own fleets, and a contact the
   * viewer hears or holds by a scan reveal: the order state is public.
   */
  signatureActive: boolean;
  signatureLeftSec: number;
  /**
   * The order whose effect holds now, beside signature_active, for the
   * same viewers; 0 while no effect holds. It names the class of a hull
   * whose class is withheld, as the SIGNATURE event does (R2376).
   */
  signatureOrder: SignatureOrder;
  /**
   * Own fleets only: the hull an OUTFLANK sails to the stern of, while the
   * order holds; 0 otherwise.
   */
  signatureTarget: number;
  /**
   * Own fleets only: the whole MAP seconds left on the recharge floor of
   * a spent charge, rounded up (R2405); 0 on a READY charge and once the
   * floor has run out. The charge then waits for the regen gate and a
   * full shield. The client counts it down between frames. While a
   * CANISTER or BROADSIDE effect holds the floor stands still at its
   * whole figure, and it runs from the effect's end (R2412).
   */
  signatureFloorSec: number;
  /**
   * Own fleets only, v2 (protocol 38). The course of the order
   * (v2-the-deep.md §7): legs[0] is the position of the fleet when the
   * commander gave the order, and the commander's legs follow it. Empty
   * for an order that is no course. `leg` is the index of the leg the
   * fleet sails to now, and `pass` the round of the loop part it sails
   * now, from 0. The flag `routes` gates a course, so a world with the
   * flag off sends none of the three.
   */
  legs: Waypoint[];
  leg: number;
  pass: number;
  /**
   * Own fleets only, v2 (protocol 38): one row for each stack key that
   * acts on the fleet now (v2-the-deep.md §6.1, §18.2), in the order of
   * ConditionKey. A contact carries none, because detection hides the
   * modifiers of a hostile hull. The flag `modifiers` gates the rows.
   */
  conditions: Condition[];
  /**
   * Own fleets only, v2 (protocol 38): the formation of the command ship
   * (v2-the-deep.md §16.7, R2584). `formation` is set on a command ship
   * whose formation is on (GUNS TIGHT); `formation_of` is the fleet id of
   * the command ship a member keeps its station by, 0 for none. An arcade
   * match plays no command ship, so it sends neither (R2805).
   */
  formation: boolean;
  formationOf: number;
  /**
   * v2 (protocol 38): the NPC kind of a hull of the NPC side, which is
   * faction 0 on the wire (v2-the-deep.md §8.1, R2622). Every hull of a
   * faction carries none, and only a world with the flag `pirates`
   * latched sails an NPC hull.
   */
  npc: NpcKind;
  /**
   * Own fleets only, v2 (protocol 38): the depth rating the hull carries
   * everywhere (v2-the-deep.md §3.2, R2625), the class rating of
   * ShipSpec.depth_rating plus the band of R4 Maintenance Corps, at most
   * the abyss (sim Fleet.DepthRating). The card reads "rated to the
   * <band>" from it. A set Tender berth is not in it, because a berth
   * moves. Sent only while the flag depth is latched; DEPTH_BAND_NONE
   * otherwise.
   */
  depthRating: DepthBand;
  /**
   * Own fleets only, while `treasure` is latched (v2-the-deep.md §9.1,
   * R2643): the search hint, 0 when no cache that the commander may take
   * lies within CatalogRules.cache_hint_px of the hull, and 1, 2 or 3 for
   * the far, the middle and the near third of that reach. It carries no
   * position. A contact never carries it.
   */
  searchHint: number;
  /**
   * Own fleets only: the map seconds a SEARCH still works at
   * its point, rounded up; 0 while the fleet sails there.
   */
  workLeftSec: number;
  /**
   * Own Sappers only, while `sapper` is latched (v2-the-deep.md §11.1,
   * R2654): the stow aboard, one row for each kind; the map seconds until
   * the next LAY, rounded up, 0 when LAY is ready; and the map seconds the
   * loud lay still runs, rounded up. The server sends the fleet again once
   * in 5 s while a timer only counts down, and the client counts down
   * between two frames (the digest rule of R2594).
   */
  stow: SeaObjectStock[];
  layReadySec: number;
  loudLeftSec: number;
  /**
   * v2 (protocol 39): a monster, while the flag pirates is latched
   * (v2-the-deep.md §8.4, R2719). `monster_design` is its
   * design of its class, 0 to 3, the design of its lair
   * (PointOfInterest.design). `npc_act` is what the body does now, and
   * `npc_act_left_ms` the map milliseconds left of a timed act (the tell,
   * the grip, the reload after a launch), 0 for an act with no clock. The
   * server sends the fleet again when the act changes and once in 5 s
   * while the figure only counts down; the client counts down between
   * two frames (the digest rule of R2594). A monster is never a scan
   * secret: its class is on every frame that carries it.
   */
  monsterDesign: number;
  npcAct: NpcAct;
  npcActLeftMs: number;
  /**
   * v2 (protocol 39): the brotherhood of a pirate hull and of a taken
   * hull, while the flag pirates is latched (v2-the-deep.md §8.5,
   * R2720). BROTHERHOOD_NONE on every other hull.
   */
  brotherhood: Brotherhood;
  /**
   * v2 (protocol 39): a boarding, while the flag pirates is latched
   * (v2-the-deep.md §8.6, R2721). On the pirate hull that boards,
   * `boarding_target` is the fleet id of the hull it boards; on the
   * boarded hull, `boarded_by` is the fleet id of the pirate. Both carry
   * `boarding_milli`, the share of the boarding done, 0 to 1000, and
   * `boarding_left_ms`, the map milliseconds left until the hull is
   * taken. A boarding that stops sends 0 in all four. The server sends
   * the fleet again on a start, on a stop and at each fifth of the share;
   * the client grows the share between two frames from the two figures.
   * When the hull is taken, the server drops the old fleet id and sends a
   * new fleet of the NPC side (ruling R-g), so the client must forget the
   * old id.
   */
  boardingTarget: number;
  boardedBy: number;
  boardingMilli: number;
  boardingLeftMs: number;
  /**
   * Own fleets only (R2834): the full map seconds of
   * the work of the current SEARCH at its point, `search_sec` of
   * [deep.search], while the work runs; 0 while the
   * fleet sails there or flies another mission. The client reads the
   * share of the work done as 1 - work_left_sec / work_full_sec.
   */
  workFullSec: number;
  /**
   * Own fleets only (R2858): the map seconds the beam order of a SET
   * Beacon has left, rounded up; 0 while the beam is off. A SET Beacon at
   * 0 beams nothing, and FLEET_OP_BEAM starts it again. The server sends
   * the fleet again each 60 map seconds of the count.
   */
  beamLeftSec: number;
  /**
   * Own fleets only (R3261): the auto-withdraw turned the hull for home
   * under the hull line (numbers.md §4), and the run home has not ended.
   * The fleet row and the card read WITHDRAWING in place of the mission
   * word. A new order, the pens or a pledge ends the run and clears it.
   */
  withdrawing: boolean;
  /**
   * Own fleets only: the auto-withdraw is off for this hull (HOLD FAST,
   * numbers.md §4). FLEET_OP_HOLD_FAST toggles it, and the HOLD FAST
   * press of the fleet card shows it lit. The pens keep it on
   * `ShipStock.hold_fast`.
   */
  holdFast: boolean;
}

/**
 * One point of a course (v2-the-deep.md §7, R2549, protocol 38).
 *
 * A loop part is a run of legs with `loop` set. It opens at the point
 * before its first leg, and its last leg is the leg that carries a pass
 * count in `passes`, or the last leg of the course. So two loop parts
 * can stand side by side: the first one ends at the leg with its count.
 * `passes` is the pass count of the part that this leg ends, 1 to
 * CatalogRules.route_loop_passes_max. 0 on the last leg of the course
 * is a part with no end, which only the last part can be (§7 rule 4).
 * `passes` is 0 on every other leg.
 */
export interface Waypoint {
  xMpx: number;
  yMpx: number;
  loop: boolean;
  passes: number;
}

/**
 * One condition of an own fleet (v2-the-deep.md §6.1, §18.2, protocol
 * 38): a chip of the conditions row of the card. `pct` is the factor of
 * the stack key on its stat, in percent, rounded: 50 is half speed and
 * 200 is twice the noise. A key that changes two stats states the first
 * of speed and noise (a trench, CRASH DIVE), and harbour limits state 100
 * (R2594). PRESSURE changes no stat and states 100; DRIFT states the
 * drift speed in percent of the hull's own speed (R2609).
 * `left_sec` is the whole MAP seconds left on a timed condition, rounded
 * up, and 0 for an area condition or one with no expiry. A key with two
 * timers (the echo) states the longer one. A combat-clock timer is
 * converted to map seconds before it is sent (server/CLAUDE.md "Three
 * clocks"). The client counts `left_sec` down between two frames: the
 * server sends the fleet again once in 5 s while a timer only counts down.
 */
export interface Condition {
  key: ConditionKey;
  pct: number;
  leftSec: number;
}

/**
 * GuardState is one guard as the client draws its cooldown (R2080,
 * numbers.md §5): any object that takes one hostile round out of the
 * water on a cooldown. `reach_px` is the radius of the water it guards;
 * `every_sec` is its reload period and `left_sec` the time left on its
 * clock, both in whole MAP seconds (left rounded up; 0 = ready). The
 * client counts `left_sec` down between frames at the tactical scale.
 */
export interface GuardState {
  reachPx: number;
  everySec: number;
  leftSec: number;
}

/**
 * State is a delta by default: it carries the fleets whose visible state
 * changed since this client's last frame, plus the ids of contacts it must
 * drop. A frame with full = true replaces the client's whole picture, and
 * the server sends one whenever a client's continuity is in doubt (first
 * frame, a dropped frame, a new season).
 */
export interface State {
  tick: number;
  /** added or changed since the last frame */
  fleets: FleetState[];
  /** rounds in flight inside the AOI */
  torpedoes: TorpedoState[];
  /** contacts lost: forget these ids */
  removed: number[];
  /** this frame is the whole picture */
  full: boolean;
  /**
   * Sov gauges (§8 revamp): owned cells in AOI whose quantized gauge
   * changed since the client last heard it (delta; full frames restate).
   */
  gauges: CellGauge[];
  /**
   * The sov beams this viewer is entitled to see (R116), as deltas
   * (R2442): a row goes out when it is new to this client or one of its
   * fields changed, and silence means "unchanged". A row is keyed by
   * (beacon, source_id), because a Beacon's id is a fleet id and a site's
   * id is a site id. A full frame restates every entitled row. The rows
   * drive both the beam animation and the WAR panel. A row carries the
   * target cell and its progress: one source of truth for a tile being
   * taken.
   */
  beams: SovBeam[];
  /**
   * Territory changes this tick, one entry per cell that changed owner
   * (v15). They ride the state frame so a dropped frame marks the client
   * for a full resync; the old per-flip ServerMsg broadcast was silently
   * droppable and a lost flip stayed lost until the next hello.
   */
  flips: CellFlip[];
  /**
   * cols*rows owner bytes, same encoding as Hello.owners. Set only when
   * `full`: the complete territory picture, so a resync after dropped
   * frames repairs territory too.
   */
  owners: Uint8Array;
  /**
   * The beam rows that left this client's picture (R2442): the source went
   * idle, left the entitlement, or its Beacon sank or weighed anchor. One
   * key per row, source_id << 1 | (beacon ? 1 : 0). A full frame carries
   * none, because it replaces the whole beam picture.
   */
  beamsGone: number[];
  /**
   * The survey of the viewer's faction (v2-the-deep.md §4.1, §14.9,
   * R2611), while the flag discovery is latched. A delta frame carries
   * the cells that the last survey pass added, in cell order. A full
   * frame restates the whole bitset in `survey`, in the encoding of
   * Hello.survey, and carries here the cells the client lacks: the cells
   * the faction surveyed since the last frame that reached the client
   * (R2633).
   */
  surveyed: number[];
  /**
   * One band byte for each cell of `surveyed`, in its order, while the
   * flag depth is latched (the encoding of Hello.depth).
   */
  surveyedBands: Uint8Array;
  /**
   * One pair vx, vy for each cell of `surveyed`, in its order, while the
   * flag currents is latched (the encoding of Hello.currents).
   */
  surveyedCurrents: Uint8Array;
  survey: Uint8Array;
  /**
   * The points of interest that the cells of `surveyed` hold, in id
   * order; a full frame restates every point the survey holds.
   */
  pois: PointOfInterest[];
  /**
   * The seamount names that changed since the last frame (R2620), in
   * body order: a new name, or an empty name for a name an operator
   * deleted. A full frame restates every name.
   */
  namedSeamounts: NamedSeamount[];
  /**
   * The sea objects in this viewer's picture (v2-the-deep.md §11.9,
   * §14.9, R2654), while the flag sapper is latched, as deltas: a row
   * goes out when it is new to this client or one of its fields changed,
   * in id order. An own object rides every frame that changes it,
   * wherever it is; another object rides inside the area of interest.
   * A full frame restates every row.
   */
  objects: SeaObject[];
  /**
   * The ids of the sea objects that left this client's picture: the
   * object left the map, the hearing, or the area of interest. A full
   * frame carries none, because it replaces the whole picture.
   */
  objectsGone: number[];
  /**
   * The live state of the points of interest (v2-the-deep.md §4.2,
   * §14.9, R2735), as deltas: a row goes out when it is new to this
   * client or one of its facts changed, in id order, and silence means
   * "unchanged". A row rides only while the viewer hears the cell of the
   * point (the sources of the contact gate) and the survey of its faction
   * holds the point; elsewhere the client keeps the last row it had. A
   * full frame restates every row the viewer hears now.
   */
  poiLive: PoiLive[];
  /**
   * Every cache of the season for an admin seat with TOGGLE CACHES on
   * (R2825), in cache id order, while the flag treasure is latched.
   * Presence replaces the whole list; absence means "unchanged". A full
   * frame restates it, a delta carries it after the list changed, and the
   * frame after the toggle goes off carries an empty list once. No other
   * seat ever takes it.
   */
  adminCaches:
    | AdminCaches
    | undefined;
  /**
   * The cargo sightings of this commander (v2-the-deep.md §9.6, §14.9,
   * R2843), while the flag treasure is latched, as deltas in the style of
   * `poi_live`: a row goes out when it is new to this client or one of
   * its facts changed, in fleet order, and silence means "unchanged". A
   * full frame restates every sighting.
   */
  cargoSightings: CargoSighting[];
  /**
   * The fleet ids of the sightings this commander no longer holds: the
   * sonar heard the wreck recovered or empty, or the wreck left the wreck
   * window. A full frame carries none, because it replaces the list.
   */
  cargoSightingsGone: number[];
}

/** The cache list of an admin seat (State.admin_caches, R2825). */
export interface AdminCaches {
  rows: AdminCache[];
}

/**
 * One cache on the admin chart (R2825). `taken`: a seeded cache and an
 * event cache pay their first finder alone, so they are taken once any
 * commander found them; a ruin, a pirate cache and a player cache pay each
 * commander once, so they are taken when this commander already took them.
 */
export interface AdminCache {
  id: number;
  kind: CacheKind;
  cell: number;
  taken: boolean;
}

/**
 * One sea mine or one deployable in a viewer's picture (v2-the-deep.md
 * §11.9, §14.9, R2654). A known row carries the kind, the heading, the
 * arm and the hull (R2894). A sea mine that a hull at sea alone hears sets
 * `heard` and carries the id, the faction and the point alone (R2902).
 * The entry of a Feint never rides the wire, because the buoy is a
 * contact (§11.3).
 */
export interface SeaObject {
  id: number;
  faction: number;
  kind: SeaObjectKind;
  xMpx: number;
  yMpx: number;
  /** The heading of the Sapper at the lay: a line lies across it. */
  headingMrad: number;
  /** A sea mine: armed. A deployable: its anchor holds and it acts. */
  armed: boolean;
  hullPct: number;
  own: boolean;
  /**
   * A sea mine that the viewer holds through the sonar of a hull at sea
   * alone (v2-the-deep.md §14.9, R2902): the row carries the id, the
   * faction and the point, and no kind, no heading, no arm, no arm window,
   * no hull and no target bit. The map draws the generic mine mark.
   */
  heard: boolean;
  /**
   * An own sea mine (R2697): the map seconds of its life left, rounded
   * up. The client counts it down on the map clock; the row goes out again
   * only when another field changes.
   */
  leftMapSec: number;
  /**
   * A sea mine whose arm window runs (R2737): the map ms until it arms. The
   * server sets the window when its layer is clear (§11.2 rule 2); the
   * field is 0 while the layer is near, and on an armed or an inert row.
   * The client counts it down on the map clock, so the row goes out again
   * only when another field changes. A heard row carries nothing.
   */
  armLeftMapMs: number;
  /**
   * A sea mine that drifted into harbour limits: it stays unarmed for good
   * (§11.2 rule 5). A heard row carries nothing.
   */
  inert: boolean;
  /**
   * The object is a target for the viewer (§11.2, R2894): a gun of the
   * viewer fires at it. The hub sets it per viewer from the predicate the
   * gun reads, so the map and the gun agree (R1159). It is false on every
   * row of the viewer's own faction and on a heard row. The 2D map and the
   * sea view draw the target bracket.
   */
  target: boolean;
}

export interface CellGauge {
  index: number;
  /** 0..50 */
  gauge10: number;
}

export interface CellFlip {
  index: number;
  from: number;
  to: number;
}

export interface Pong {
  nonce: number;
}

/**
 * A static map site. Position is a cell index; clients derive the pixel
 * center. faction = current owner (0 = neutral). resource/amount are only
 * meaningful for deposits (1 alloy, 2 biomass, 3 volatiles).
 */
export interface Site {
  id: number;
  kind: SiteKind;
  cell: number;
  faction: number;
  name: string;
  resource: number;
  amount: number;
  /** player bases only */
  ownerPlayer: number;
  /** deposits: the stock the field held when it was last filled (R475) */
  capacity: number;
  /**
   * World seconds until a worked-out field silts back up, 0 when the
   * server keeps no such clock for it (R548). The chart furniture's
   * spoil ground counts it down on the world clock.
   */
  respawnSec: number;
  /**
   * Player bases only: the commander's display name. Site.name is
   * "<name>'s Hold", so a client that draws the commander's initials on
   * the hold mark cannot read the name back out of it (R633).
   */
  commander: string;
  /**
   * Player bases only: the owner's hold effect, a catalog wire id of
   * data/contracts/effects.toml, 0 = none (R910). A hold is public, so
   * the mark carries no gate.
   */
  effect: number;
  /**
   * Player bases only: the clan tag of the commander, '' for a commander
   * in no clan (R2614). A clan tag is public, as a chat line shows it.
   * A world plays the clan plan of its season roll (R245), so the tag
   * holds for the season; a seat that takes another clan at a join shows
   * it at the next hello, as the hold name does.
   */
  clanTag: string;
}

/** Control-point (later: any site) ownership change. */
export interface SiteOwner {
  siteId: number;
  faction: number;
  /** deposits: remaining amount after gathering */
  amount: number;
  /** deposits: the stock the field held when it was last filled (R475) */
  capacity: number;
  /**
   * World seconds until a worked-out field silts back up, 0 otherwise
   * (R548). Same field as Site.respawn_sec.
   */
  respawnSec: number;
  /**
   * Player bases only: the owner's hold effect, a catalog wire id of
   * data/contracts/effects.toml, 0 = none (R910). Same field as
   * Site.effect. EVERY SiteOwner of a player base states it, because the
   * message is applied whole and a resource update that left it out
   * would take the mark off the hold.
   */
  effect: number;
}

/** A site that appeared after the hello (player bases as people join). */
export interface SiteAdded {
  site: Site | undefined;
}

/**
 * A site that is gone from the map for good. The seaquake's stage 2 kills
 * every deposit this way: the fields do not silt back up, so the marker
 * must not stay on the map to promise a hauler somewhere to go. A client
 * must forget the id — it is not in the next hello either.
 */
export interface SiteRemoved {
  siteId: number;
}

/**
 * Where the next seaquake shock strikes (R803, numbers.md §15). The quake
 * holds one trench at a time and strikes at its epicentre cell; after every
 * shock it moves to another trench. The seaquake is on the world clock and
 * is no secret, so every commander receives the same frame. The hub sends
 * one on a stage entry, on every shock and with the hello.
 */
export interface QuakeInfo {
  /** 0 before the arc, 1 and 2, 3 in the settlement */
  stage: number;
  /** false: no epicentre (stage 0, or a map with no trench) */
  placed: boolean;
  /** the epicentre cell's centre, millipixels */
  xMpx: number;
  yMpx: number;
  /** the reach of the next shock */
  radiusPx: number;
  /** its flat share of max hull, in tenths of a percent */
  damagePctX10: number;
  /**
   * World seconds to the next shock. At stage 1 it is the time until
   * stage 2 opens, which is the first shock. 0 when no shock waits.
   */
  nextShockSec: number;
}

/**
 * MaintenanceInfo is the maintenance window the meta server plans (the
 * release manager, deployment.md §6.1). The server sends it on hello and
 * again on every change, so a client that joined before the operator
 * scheduled the window still learns of it.
 *
 * A zero starts_at_unix means NO WINDOW. The directive went away, and a
 * client that counts down takes the countdown off the screen.
 */
export interface MaintenanceInfo {
  /** the wall-clock second the gate goes up */
  startsAtUnix: number;
  /** the second the gate is planned to come down */
  endsAtUnix: number;
  /** the operator's line for the player; empty when none */
  note: string;
}

export interface Resources {
  alloy: number;
  biomass: number;
  volatiles: number;
  isotopes: number;
  credits: number;
}

/**
 * What one figure of the empire is, and what a level of this building
 * makes it. The client owns no rule table, so the server computes both
 * ends and the client only picks the sentence.
 */
export interface LevelEffect {
  kind: LevelEffectKind;
  /** at the level the empire holds */
  now: number;
  /** at the level the BUILD button buys; unset when maxed */
  next: number;
}

export interface PreviewQuery {
  building: Building;
}

export interface BuildingPreview {
  building: Building;
  /** the level the empire holds at the answer */
  level: number;
  /** upgrades of it already in the queue at the answer */
  queued: number;
  /**
   * One row for each level past the level the BUILD button buys, up to
   * the building's cap, in level order. Empty when no such level exists.
   */
  levels: LevelPreview[];
}

export interface LevelPreview {
  level: number;
  /** what the step to this level costs */
  cost:
    | Resources
    | undefined;
  /** and how long the step takes, world seconds */
  timeSec: number;
  /**
   * Every figure the building drives, in the kinds and the order of
   * BuildingLevel.effects: `now` at the level the empire holds, `next`
   * at this level.
   */
  effects: LevelEffect[];
}

/**
 * BuildingLevel carries the current level plus the price of the next one,
 * so the client never recomputes the cost curve.
 */
export interface BuildingLevel {
  building: Building;
  level: number;
  nextCost: Resources | undefined;
  nextTimeSec: number;
  maxed: boolean;
  /** upgrades of this building already in the queue */
  queued: number;
  /**
   * Every figure this building drives, now and at the level the BUILD
   * button buys (R1081).
   */
  effects: LevelEffect[];
  /**
   * The Command Centre level the next level needs (numbers.md §2, R2862):
   * 2L-1 for a 5-ladder, L for a 10-ladder. 0 for the Command Centre
   * itself, which answers to the trunk cap, and for a maxed building.
   */
  nextNeedsBase: number;
}

export interface Job {
  id: number;
  kind: JobKind;
  target: number;
  level: number;
  count: number;
  remainingMs: number;
  totalMs: number;
  /** occupying a build slot right now */
  active: boolean;
  /** credits to finish now (numbers.md §1) */
  rushCost: number;
  label: string;
  /**
   * World game-seconds until this job lands at its current rate; 0 for a
   * job that is not active.
   *
   * `remaining_ms` and `total_ms` are *work*, not time: the queue drains
   * them at a rate the Construction level, the hull class and the
   * strategic-object bonuses decide (numbers.md §1). Only the server holds
   * that table, so only the server can say when a job finishes. The client
   * anchors this figure on the Empire frame and counts it down on the world
   * clock, the way the truce countdown works — an Empire frame is sent only
   * when the empire changes, and a draining job does not count as a change.
   */
  etaSec: number;
  /**
   * World game-seconds until a waiting job takes a build slot (R3286), from
   * the server's queue schedule, rounded up; 0 for a job that runs, and for
   * a job the schedule cannot start. The client counts it down on the world
   * clock from the Empire frame, as it counts `eta_sec`.
   */
  startSec: number;
}

/**
 * One penned fleet. The pens hold objects rather than pools, so a row is a
 * specific hull with its own id, its own wounds and its own repair price.
 */
export interface ShipStock {
  cls: ShipClass;
  /** blueprint id */
  design: number;
  designName: string;
  /** this hull's own damage, 0..100 */
  wearPct: number;
  repairCost: Resources | undefined;
  repairTimeSec: number;
  /** the hull itself — Break, Assign and Repair name it */
  fleetId: number;
  name: string;
  /** the officer aboard, kept across docking */
  captainId: number;
  /** auto-withdraw off */
  holdFast: boolean;
  /**
   * The hull's own fit, for the fit strip of the pen row (R1468). It is
   * a copy the hull keeps from its laydown, because a spent print leaves
   * the library while its hulls live on (R216). A hull from a save older
   * than the field sends an empty fit.
   */
  fit: Module[];
  /** 0 = untyped (numbers.md §17) */
  weapType: number;
  /** 0 = untyped */
  shieldType: number;
  /**
   * The load mix the next deploy loads (R2017): one row for each kind in
   * the mix. An empty list is AUTO.
   */
  loadMix: TorpedoStock[];
  /** The active round the hull keeps (R2017), 0 = none picked. */
  activeRound: TorpedoKind;
  /**
   * The room of the magazine in cargo units (numbers.md §5). A mix fits
   * while the sum of count x TorpedoSpec.cargo stays at or under it. 0 on
   * a hull that loads no round.
   */
  magazineCargo: number;
  /**
   * A Sapper only, while `sapper` is latched (R2654): the stow the next
   * deploy loads from the Depot stock, one row for each kind. An empty
   * list is AUTO.
   */
  stow: SeaObjectStock[];
}

/**
 * The fit of one own fleet on the map (R1501). The fleet window's systems
 * row draws the fit strip from it, the same strip a pen row draws from
 * ShipStock.fit. The fleet keeps its id in and out of the pens (R540), and
 * the fit is the copy the hull keeps from its laydown (R216).
 * The compressed cargo of one own hull (Empire.compressed, v2-the-deep.md
 * §9.6, R2834).
 */
export interface CompressedCargo {
  fleetId: number;
  cargo: Resources | undefined;
}

export interface FleetFit {
  fleetId: number;
  fit: Module[];
}

export interface Module {
  family: ModuleFamily;
  tier: number;
  /** the rolled effect, x10 (so 154 = 15.4%) */
  effectPct: number;
  name: string;
  /**
   * The grade code of the roll (numbers.md §6, R1194), one of the
   * CatalogRules.module_grades codes; empty when the roll has none. The
   * client prints the grade's word next to the effect.
   */
  grade: string;
}

/**
 * One module a design may fit, as the pack defines it (numbers.md §6).
 * This is the SPEC; `Module` above is an instance with its rolled effect.
 * The client renders this table and mirrors none of it (R700).
 */
export interface ModuleSpec {
  family: ModuleFamily;
  /** 1..3 */
  tier: number;
  /** the family's name (identity/labels.toml) */
  name: string;
  /** effect BEFORE the roll, x10, like Module.effect_pct */
  effectPct: number;
  /**
   * The share of the hull cost this module adds at build. It crosses as
   * a double, and not as an integer percent, ON PURPOSE: the client
   * multiplies with it, so it must be the pack's own figure.
   */
  costShare: number;
  /** gate node id; 0 = no gate */
  tech: number;
  /**
   * The isotopes this module adds to a draft. The figure sits on the ROW
   * and not on Catalog ON PURPOSE: the client sums the field over the
   * picked rows and never writes `if (tier === 3)`, which is a rule
   * literal the client must not own.
   */
  draftIsotopes: number;
  /**
   * The isotopes the redraft of a slot of this module adds (R1194). It
   * sits on the row for the reason draft_isotopes does.
   */
  redraftIsotopes: number;
}

/**
 * A ship design: a hull plus its fitted modules (game-design §7).
 * A design (protocol v6). Three kinds share the shape: BASIC (infinite,
 * untyped, everyone's floor), MASTER (an invention — prints, never builds,
 * never trades), and PRINT (a run-limited copy cut from a master; builds
 * hulls, trades on the market, dies at zero runs).
 */
export interface Blueprint {
  id: number;
  name: string;
  hull: ShipClass;
  modules: Module[];
  basic: boolean;
  cost:
    | Resources
    | undefined;
  /** hulls of this design in the pens */
  stock: number;
  master: boolean;
  /** prints: the master this was cut from */
  masterId: number;
  /** prints: hulls it can still produce */
  runs: number;
  /** masters: Mk number of this line */
  generation: number;
  /** 0 untyped, 1 Railspike, 2 Cavitation Hammer, 3 Voltaic Lance */
  weapType: number;
  /** 0 untyped, 1 Ablative Shell, 2 Bubble Veil, 3 Faraday Sheath */
  shieldType: number;
  /** provenance, kept when a print is sold */
  inventor: string;
  /**
   * What the fit makes of the hull class (R1840): every design that is
   * not basic carries it. The hull card writes each figure beside the
   * class figure of the catalog with its gain, and computes none (R701).
   */
  fitted: FittedFigures | undefined;
}

/**
 * The figures of a hull class through a design's fit (R1840,
 * ui-map-interface.md §8 "The build card"). The server reads them with
 * sim.FittedOf, through the accessors a hull at sea reads: no captain,
 * full readiness, no trench and no tech node, so each figure stands
 * beside the class figure of `ShipSpec` it moves.
 */
export interface FittedFigures {
  /** the maximum shield (ShipSpec.shield) */
  shield: number;
  /** units per hour (ShipSpec.speed_uh) */
  speedUh: number;
  /** the listening range, world px (ShipSpec.sonar) */
  sonar: number;
  /** one shot, tenths (ShipSpec.shot_damage_x10) */
  shotDamageX10: number;
  /** the class noise times the fit's multiplier (ShipSpec.noise) */
  noise: number;
}

/** A dive in progress (numbers.md §11). */
export interface ExpeditionState {
  id: number;
  depth: number;
  captainId: number;
  captainName: string;
  remainingSec: number;
  totalSec: number;
}

export interface ExpeditionSpec {
  depth: number;
  name: string;
  radControl: number;
  tech: number;
  durationSec: number;
  isotopes: number;
  coreChancePct: number;
  injuryPct: number;
}

export interface TorpedoStock {
  kind: TorpedoKind;
  count: number;
}

export interface Captain {
  id: number;
  name: string;
  /** gunnery, helm, silent, engineering, command, prospecting */
  attrs: number[];
  /** indices into attrs trained at 1.5x */
  talents: number[];
  seasons: number;
  /** rise | peak | decline */
  phase: string;
  /** 0 = unassigned */
  fleetId: number;
  /** >0 = recovering in the Hospital */
  injuredSecs: number;
  /** offered, not yet recruited */
  cadet: boolean;
  /** dive currently led, 0 = ashore */
  expedition: number;
  /** empire holding this captain, "" = free (§18) */
  capturedBy: string;
  /** fixed buyout price while captured */
  ransom: number;
  /** What the attributes are worth now, for the captain info card (R1118). */
  effects:
    | CaptainEffects
    | undefined;
  /**
   * The age arc (numbers.md §12, R1170). The server computes each figure:
   * the age in whole years, the age the cadet joined at, the seasons to
   * the next phase (0 in decline) and the phase itself.
   */
  age: number;
  recruitAge: number;
  seasonsToNextPhase: number;
  phaseKind: CaptainPhase;
  /**
   * The frozen face of the Captain Designer (monetization.md §3.1, R1240).
   * portrait_seed 0 derives the face from the name and the talents;
   * portrait_gender 0 derives the gender from the first name, 1 is a man
   * and 2 a woman. The backstory and the voice lines never ride the wire.
   */
  portraitSeed: number;
  portraitGender: number;
  /**
   * Practice (numbers.md §12, R1478), one entry per attribute:
   * practice is the share of the next practice point counted, 0 to 1,
   * and 0 when no point can come; practised is the points practice
   * bought this season.
   */
  practice: number[];
  practised: number[];
  /**
   * The Academy time of the next point in each attribute (R2087), in world
   * game-seconds as Job.eta_sec counts a training job: the work time of
   * game.TrainingTimeSec over this empire's training queue rate, rounded
   * up. 0 when the attribute cannot train: a cadet, a prisoner, a captain
   * in the Sickbay (R2343), no Academy, the decline, or an attribute at
   * attr_train_cap.
   */
  trainSecs: number[];
}

/**
 * One captain's current bonuses, in percent, rounded to one decimal
 * (numbers.md §12, R1118). The server reads each one off the rule method
 * the sim calls, so the card prints the rule and computes nothing.
 */
export interface CaptainEffects {
  /** Gunnery: fleet damage bonus */
  damagePct: number;
  /** Helmsmanship: fleet speed bonus */
  speedPct: number;
  /** Silent Running: noise cut, floored */
  noiseCutPct: number;
  /** Engineering: shield regen bonus */
  regenPct: number;
  /** Command: readiness floor lift, in points */
  floorLiftPct: number;
  /** Prospecting: dive isotope yield bonus */
  diveYieldPct: number;
  /** Prospecting: share of a dive's base risk cut */
  injuryCutPct: number;
  /**
   * The chance to retire or die at the next season roll after a season
   * served; 0 when that roll finds the captain before decline.
   */
  retireRiskPct: number;
}

/**
 * One enemy captain held in this empire's Prison (§18). Passive income:
 * the owner may pay the fixed ransom at any moment.
 */
export interface Prisoner {
  captain: string;
  /** the empire the captain belongs to */
  owner: string;
  ransom: number;
  /** for the captor's voluntary release (§18) */
  captainId: number;
  /**
   * The empire the captain belongs to, by id (R2743). A captain id counts
   * per empire, so two prisoners of two owners can carry one captain id;
   * the pair names one prisoner.
   */
  ownerId: number;
  /**
   * World seconds since the capture (R2744), floored; 0 when the server
   * does not know the moment, as for a capture saved before R2744.
   */
  heldSec: number;
}

/**
 * One source of this empire's queue rate for one job kind (numbers.md §1,
 * R688). The info panel names the sources under the rate.
 */
export interface QueueRateSource {
  kind: JobKind;
  name: string;
  /**
   * The level of the source, or 0 for a source that carries no level — a
   * tech node or a strategic object. The client prints the name alone.
   */
  level: number;
}

/**
 * The connected player's private snapshot. Sent on any change (coalesced to
 * at most once per tick) — small enough to stay absolute for now.
 */
export interface Empire {
  playerId: number;
  res:
    | Resources
    | undefined;
  /** storage caps (credits uncapped) */
  caps:
    | Resources
    | undefined;
  /** per hour, from mines */
  income: Resources | undefined;
  buildings: BuildingLevel[];
  queue: Job[];
  /** parallel build slots */
  slots: number;
  /** ships docked at the base */
  stock: ShipStock[];
  /** completed node ids */
  tech: number[];
  /** Harbour buckets (numbers.md §2) */
  combatWeight: number;
  combatCap: number;
  supportWeight: number;
  supportCap: number;
  captains: Captain[];
  captainSlots: number;
  /** fleets at sea plus running dives (R680) */
  missions: number;
  missionCap: number;
  honour: number;
  score: number;
  /** the player base's listening range in px */
  sonarRange: number;
  homeCell: number;
  torpedoes: TorpedoStock[];
  clanId: number;
  clanTag: string;
  blueprints: Blueprint[];
  moduleSlots: number;
  expeditions: ExpeditionState[];
  dataCores: number;
  /**
   * The build-queue budget (numbers.md §1, R33, R726): the world seconds
   * until a build slot is free for one more job, and the ceiling the server
   * refuses a new job at. The wait counts the build slots and every
   * speed-up, so the client prints it beside the row clocks and a player
   * reads how much room is left. It is NOT the time the whole queue takes
   * to empty: with two build slots one long job leaves the second slot
   * free, and the wait is 0. Server-owned, like every other rule the client
   * renders.
   */
  queueWaitSec: number;
  queueMaxSec: number;
  /** enemy captains held in this empire's Prison (§18) */
  brig: Prisoner[];
  /**
   * Whole seconds until the base's automated point defence may fire its
   * next round (R86); 0 = ready. The client extrapolates between frames
   * on the world clock, the way the truce countdown does.
   */
  pointDefenceReadySec: number;
  /**
   * Manual base-tube state (R88). A Torpedobank tube reloads for ten game
   * seconds after a manual shot, so a base with N tubes looses N rounds
   * back to back and then waits: base_tubes_ready is how many are free
   * right now, base_tube_ready_sec the wait until the soonest tube frees
   * (0 while one is already free). Extrapolated client side on the world
   * clock, like the point-defence countdown above. The two clocks are
   * independent: manual fire never touches the automated cadence.
   */
  baseTubesReady: number;
  baseTubeReadySec: number;
  /**
   * Every *static* listening circle this commander receives (R112): the
   * faction installations, a held Relay Spire, their own hold, and their
   * squad's holds once both sides of the Communications base gate are paid.
   * Fleet rings are not here — they move, so they ride on FleetState.
   */
  sonarRings: SonarRing[];
  /**
   * Masters and copies hold separate libraries (numbers.md §17): an
   * invention and a print do different jobs and no longer share a shelf.
   */
  masterSlots: number;
  copySlots: number;
  /**
   * The print installed in each hull class's slot, by blueprint id — what
   * that class builds to until the runs are gone. Index is the ShipClass.
   */
  installed: number[];
  /**
   * Unread inbox messages (v12): the top bar's badge. The list itself is
   * fetched on demand (InboxAction.fetch) — this count rides the frame the
   * client already gets, so the badge needs no polling.
   */
  inboxUnread: number;
  /**
   * The empire's auto-rebuild wish: what the player asked for, not what the
   * seat may have. A seat without the perk holds the wish and acts on
   * nothing, so a lapsed subscription loses no setting.
   */
  autoRebuild: boolean;
  /**
   * The empire's fleet control groups (R539), every taken slot ascending.
   * Stored with the empire, so a reload and a new session keep them, and
   * a fleet keeps its slot through the pens (R540).
   */
  controlGroups: ControlGroup[];
  /**
   * In an arcade match, this seat's count on the map's win rule: `mine`
   * counts the units it mined, `scan_class` counts the enemy hulls its
   * pings found, each hull once. Both read the same counters that fill
   * ArcadePlayerStats on the end card. 0 outside a match, and 0 for every
   * other win rule, because those the client can count for itself.
   */
  arcadeSteps: number;
  /**
   * The recruiter's drain (R679, numbers.md §12). `pass_price` is what the
   * NEXT cadet out of the recruiter costs in credits — a pass, or the
   * dismissal of a roster captain, both pay it. `next_offer_sec` is the
   * whole world seconds until the empty berth that fills soonest offers a
   * cadet, and 0 while the pool is full. Both are server-owned rules the
   * client states on the button, so no client mirrors the table.
   */
  passPrice: number;
  nextOfferSec: number;
  /**
   * How fast this empire's queue drains a job of each kind, in
   * work-seconds per world second (numbers.md §1). The index is the
   * JobKind enum value and the array is dense, NumJobKinds long, exactly
   * as `installed` is indexed by ShipClass. A menu divides a catalog
   * `time_sec` — the list time — by it to state the time THIS empire
   * pays. An absent or non-positive value reads as 1.
   *
   * DISPLAY ONLY. `Job.eta_sec` stays the authoritative countdown of a
   * running job, because only the server knows the slot order (R688).
   */
  queueRate: number[];
  /**
   * What earned that rate, for the info panel to name (§8). `level` is 0
   * for a source that has no level — a tech node or a strategic object —
   * and the client then prints the name alone.
   */
  queueRateSources: QueueRateSource[];
  /**
   * What one Data Core takes off the active research job right now, in
   * work-seconds (R776). It is the pack figure with Cryptolinguistics
   * applied, and the world clock does not divide it (R775). The confirm
   * card states the figure, so the client computes no rule. It is work
   * and not time, exactly as `Job.remaining_ms` is: the card divides it
   * by `queue_rate` to say how much sooner the node lands.
   */
  dataCoreSec: number;
  /**
   * The empire holds the `dredger_brain` perk (monetization.md §4, R1226),
   * so the fleet window shows the per-hauler switch (FLEET_OP_AUTO_FIELD).
   */
  dredgerBrain: boolean;
  /**
   * The autopilot plays this empire under standing orders (R1256,
   * autopilot.md §14): its player holds a seat in an open Event or Clan
   * War window and left the switch on. The HUD shows a badge.
   */
  standingOrders: boolean;
  /**
   * The advisor's one next good action (player-reach.md §4, R1305): a
   * job of the build queue, or an idle Dredger (R1567). The hub fills it
   * only while the advisor is on for this empire (`advisor_on`), a
   * connection sits at it and a person commands it; absent means no
   * advice. The client builds the sentence from the catalog names and
   * its own locale lines, so no text rides here.
   */
  advice:
    | Advice
    | undefined;
  /**
   * The fit of each own fleet on the map that carries a module (R1501).
   * A fleet with no module has no entry, and a penned fleet states its
   * fit in `stock`. The window's systems row reads it; the list rides
   * the empire frame and not the fleet delta, because a fit does not
   * change while the fleet is at sea.
   */
  fleetFits: FleetFit[];
  /**
   * The advisor switch of this empire (player-reach.md §4.7, R1566). The
   * hub keeps it on the empire and in the snapshot, so every device of
   * the player shows one state. The join ticket states the account's
   * flag, and the EmpireSetting key `advisor` changes it.
   */
  advisorOn: boolean;
  /**
   * The sea trials of a new commander (player-reach.md §8, R1572): one
   * bit per row of data/product/trials.toml, in row order, set on the
   * first act of its kind. The hub keeps the mask on the empire and in
   * the snapshot, so a reload and a second device read one state.
   */
  seaTrials: number;
  /**
   * The card of the sea trials shows: the seat is a new commander's
   * (R1566) on a core world, and the progress ledger counts it. False
   * means no card, whatever `sea_trials` holds.
   */
  seaTrialsOn: boolean;
  /**
   * The welcome card is due (player-reach.md §8.5, R1572): the first
   * Core season of the account, and the player has not closed the card
   * yet. The EmpireSetting key `welcome_seen` clears it for good.
   */
  welcome: boolean;
  /**
   * The ship-round rack (numbers.md §2, R1788): the ship-fired rounds of
   * every kind together, in the stock and on the queue, and the most the
   * hold may stock at its Torpedo Battery level. BUILD · TORPEDO heads its
   * ship rounds with the pair, the way the yard heads its hull buckets.
   */
  shipRounds: number;
  shipRoundCap: number;
  /**
   * The clock of every arcade guard structure this seat may read
   * (arcade.md §19.9, R2085): a Reef Breakwater of the seat's team, and a
   * public one. A breakwater of another team, and a neutral one that waits
   * for a taker, is not in the list: the map must not show the cooldown of
   * an enemy (R2080). The frame goes out when a clock starts and when a
   * breakwater changes hands; the client counts the clock down between
   * frames at the tactical scale.
   */
  structureGuards: StructureGuard[];
  /**
   * The course plots of this empire, at most 8 for the season
   * (v2-the-deep.md §7, chart card 38, protocol 38), in the order the
   * commander saved them. The flag `routes` gates them, so a world with
   * the flag off sends none.
   */
  plots: CoursePlot[];
  /**
   * The seamounts that a hull of this commander found and that carry no
   * name yet (v2-the-deep.md §4.3, R2620), in body order, with an empty
   * name: the commander may name each one. The flag `discovery` gates
   * them, so a world with the flag off sends none.
   */
  seamountFinds: NamedSeamount[];
  /**
   * The chart fragments the empire holds (v2-the-deep.md §8.2, R2622,
   * protocol 38): the id of the pirate cache of each, which is the id of
   * its den, ascending. The flag `pirates` gates them, so a world with
   * the flag off sends none.
   */
  fragments: number[];
  /**
   * The commissions of this commander (v2-the-deep.md §10, R2634): first
   * the taken offers, in the order of the takes, each with its fleet;
   * then every open offer of the board of the faction, in id order. An
   * offer that pays a ship shows also to a commander who cannot build
   * the class (R2939). The flag `commissions` gates them, so a world
   * with the flag off sends none.
   */
  commissions: Commission[];
  /**
   * The shipping lanes of the faction mates of this commander
   * (v2-the-deep.md §7.2 rule 3, R2646), each with its owner and the
   * name of its commander, in the order of the seats and of the plots.
   * The own lanes ride `plots` with `lane` set. The flag `routes` gates
   * them, so a world with the flag off sends none.
   */
  lanes: CoursePlot[];
  /**
   * The caches of v2 phase 5 (v2-the-deep.md §9.3, §9.4, R2643), while
   * `treasure` is latched: the player caches this commander deposited this
   * season, with their notes, in cache id order; the caches a hull of this
   * commander took this season, in cache id order, each with the note of
   * its depositor in the reader's language (only the finder reads it);
   * and the finds of the current world day, against
   * CatalogRules.cache_finds_per_world_day.
   */
  caches: CacheRow[];
  cacheFinds: CacheRow[];
  cacheFindsToday: number;
  /**
   * The compressed cargo of the own hulls at sea (v2-the-deep.md §9.6,
   * R2834), while `treasure` is latched: one row for each hull that
   * carries some, in fleet order. A row names the resources that a
   * finished SEARCH took aboard and that land at the own hold;
   * they can be more than the cargo room of the class. The fleet card
   * reads the row of its hull, as it reads `fleet_fits`.
   */
  compressed: CompressedCargo[];
  /**
   * The Depot of this commander (v2-the-deep.md §11.5, R2653): the
   * stock, the rack and the live counts against the live caps of the
   * Depot level. The flag sapper gates it, so a world with the flag off
   * sends none.
   */
  depot:
    | DepotState
    | undefined;
  /**
   * The chart fragments of `fragments` with the place each points to
   * (v2-the-deep.md §8.2, §14.9, R2700), in the same order: the den, the
   * cell of its pirate cache, and whether a hull of this commander took
   * that cache this season. The TREASURE pill of ECONOMY reads it. The
   * flag `pirates` gates it, so a world with the flag off sends none.
   */
  chartFragments: ChartFragment[];
  /**
   * The archive of this commander (v2-the-deep.md §10, R2715): each
   * commission this commander finished and was paid for this season, in
   * the order of the pays, at most `archive_max` of [deep.commissions].
   * The flag `commissions` gates it, so a world with the flag off sends
   * none.
   */
  commissionsPaid: CommissionPaid[];
  /**
   * The dens this faction knows (v2-the-deep.md §8.5, R2720, ruling R-f,
   * protocol 39), in den id order: each den whose group a hull of the
   * faction heard this season. The flag pirates gates it, so a world
   * with the flag off sends none.
   */
  dens: DenInfo[];
  /**
   * The commissions this commander took in the current world day
   * (v2-the-deep.md §10, R3065, R3069): Player.CommissionTakesOn of the
   * world day, so it reads 0 after the day changes. FLEET · COMMISSIONS
   * states it against CatalogRules.commission_day_cap. The flag
   * commissions gates it, so a world with the flag off sends 0.
   */
  commissionTakesToday: number;
}

/**
 * One record of the archive of an empire (v2-the-deep.md §10, R2715).
 * `offer` is the commission as it was paid: the kind, the target cell,
 * the pay with its figures and the fleet id, with `done` set and
 * `left_sec` 0. `fleet_name` is the name of the fleet at the pay, empty
 * when the fleet was gone. `paid_sec` is the world second of the season
 * clock at the pay.
 */
export interface CommissionPaid {
  offer: Commission | undefined;
  fleetName: string;
  paidSec: number;
}

/**
 * One den the faction knows (v2-the-deep.md §8.5, R2720). `den` is the
 * den id (world.Den.ID), `cell` its water cell, `design` its den design of
 * the brotherhood, 0 or 1, in the card order of round 118 (`dens` of
 * [[npc.brotherhoods]]). `respawn_sec` is the world seconds until a sunk
 * group sails again, rounded up, 0 in every other state; the client
 * counts it down. `cache` is the pirate cache of the den for the holder
 * of its chart fragment. `prize` is what the den holds in its pirate
 * cache beyond the reward row of the cache: the cargo of each taken hull
 * that reached the den and the refund of its class (ruling R-i). It is
 * sent only to the holder of the fragment.
 */
export interface DenInfo {
  den: number;
  cell: number;
  brotherhood: Brotherhood;
  design: number;
  state: DenState;
  respawnSec: number;
  cache: DenCache;
  prize: Resources | undefined;
}

/**
 * One chart fragment of an empire (v2-the-deep.md §8.2, R2700). `cell`
 * is the cell of the den; `x_mpx` and `y_mpx` are the point of its
 * pirate cache, the den cell centre plus the offset of the den design,
 * where the den art draws the cache mark (§9.1, R2859); `taken` says a
 * hull of this commander took that cache this season, which needs
 * `treasure` latched, so it stays false while the flag is off.
 */
export interface ChartFragment {
  den: number;
  cell: number;
  taken: boolean;
  xMpx: number;
  yMpx: number;
}

/**
 * The Depot of one commander (v2-the-deep.md §11.5, R2653). The server
 * computes every figure, so the DEPOT pill mirrors no table.
 */
export interface DepotState {
  /**
   * The sea objects in the stock of the hold, one row for each kind
   * with an item, in SeaObjectKind order.
   */
  stock: SeaObjectStock[];
  /**
   * What counts against the rack: the stock and the sea object jobs on
   * the queue, every kind together (R1788).
   */
  stocked: number;
  rack: number;
  /**
   * The sea objects of this commander on the map, against the live caps
   * of the Depot level. A Palisade counts as a deployable and against
   * `palisades_cap` too, and a Fanal against `lane_lights_cap`
   * (R3073).
   */
  liveSeaMines: number;
  seaMinesCap: number;
  liveDeployables: number;
  deployablesCap: number;
  livePalisades: number;
  palisadesCap: number;
  liveLaneLights: number;
  laneLightsCap: number;
}

export interface SeaObjectStock {
  kind: SeaObjectKind;
  count: number;
}

/**
 * One cache of the Empire (v2-the-deep.md §9, R2643). `note` is the note
 * in the reader's language, empty for none and for a note an operator
 * deleted; `free_note` says it is free text, which the finder may REPORT
 * (REPORT_KIND_CACHE_NOTE). `finds` is the finders of an own player cache
 * so far. `label` is the name an operator gave an event cache.
 */
export interface CacheRow {
  id: number;
  kind: CacheKind;
  cell: number;
  note: string;
  freeNote: boolean;
  noteSet: boolean;
  finds: number;
  label: string;
}

/**
 * One commission (v2-the-deep.md §10, R2634). `fleet_id` is 0 for an
 * open offer of the board and names the fleet of a taken offer. The pay
 * fields that `reward` does not name are 0.
 */
export interface Commission {
  id: number;
  kind: CommissionKind;
  /** The target cell: the region to survey, or the trench cell to sound. */
  cell: number;
  /**
   * World seconds to the deadline, 0 once it passed. A done offer that
   * waits for room in the Dock keeps 0.
   */
  leftSec: number;
  reward: CommissionReward;
  /** RESOURCES: the bundle, banked through the storage cap. */
  resources:
    | Resources
    | undefined;
  /** ROUNDS: the ship rounds and their kind, held to the room of the rack. */
  rounds: number;
  roundKind: TorpedoKind;
  /**
   * PRACTICE: the practice in points of the first point of the lead
   * attribute of the hull.
   */
  practice: number;
  /** SHIP: the class of the basic hull. */
  ship: ShipClass;
  fleetId: number;
  /** The task is finished, and the ship waits for room in the Dock. */
  done: boolean;
  /**
   * The share of the escort time an escort offer counted, in whole
   * percent (v2-the-deep.md §7.2 rule 6, R2646); 0 on every other kind.
   */
  escortPct: number;
}

/**
 * One saved course (v2-the-deep.md §7, protocol 38). A plot keeps no leg
 * 0: the hub writes the position of the fleet when a commander sends the
 * plot to a fleet.
 */
export interface CoursePlot {
  id: number;
  name: string;
  legs: Waypoint[];
  /**
   * The plot is a shipping lane (v2-the-deep.md §7.2, R2646). The flag
   * `routes` gates the switch.
   */
  lane: boolean;
  /**
   * The commander of a lane of a faction mate (`Empire.lanes`): the
   * player id and the name. 0 and empty on an own plot.
   */
  owner: number;
  ownerName: string;
  /**
   * The fields 7 to 12 ride a lane alone, while `routes` is latched
   * (v2-the-deep.md §7.2 rules 10 to 14, R3074).
   * The road of the lane: an id that this frame shares with every lane of
   * the road, and the name of its longest lane, which the client writes
   * with the road word. 0 and empty for a lane of no road.
   */
  road: number;
  roadName: string;
  /**
   * The lane credit: the map minutes that fleets of the faction spent
   * under a lift on the cells of the lane, rounded down.
   */
  liftMin: number;
  /**
   * The lane is a quiet lane: its traffic stayed low, and pirates do not
   * hunt on it.
   */
  quiet: boolean;
  /**
   * The lane gaps, in track order: the chain point that one Fanal
   * closes each gap with.
   */
  gaps: LaneGap[];
  /**
   * The commanders whose Fanals stand on the lane, in commander
   * order, with the count of their lights.
   */
  lighters: LaneLighter[];
}

/**
 * LaneGap is one lane gap of a shipping lane (R3074): the chain point
 * that closes it, and the leg of the plot that the gap lies on (1 = the
 * leg from point 1 to point 2).
 */
export interface LaneGap {
  xMpx: number;
  yMpx: number;
  leg: number;
}

/**
 * LaneLighter is one commander whose Fanals stand on a shipping lane
 * (R3074): the name and the count of the lights.
 */
export interface LaneLighter {
  name: string;
  lights: number;
}

/**
 * StructureGuard is the clock of one arcade guard structure (R2085):
 * the site, its owner team (0 for a public one) and the MAP seconds left
 * on its clock (0 = ready). The reach and the period ride
 * `ArcadeStructure`.
 */
export interface StructureGuard {
  siteId: number;
  owner: number;
  leftSec: number;
}

/** The advice of the advisor (player-reach.md §4.5, R1305). */
export interface Advice {
  kind: AdviceKind;
  id: number;
  /**
   * The level of a building, the count of a batch, the runs of a print;
   * 0 for a research node and a draft.
   */
  amount: number;
  reason: AdviceReason;
  /**
   * SAVING only: the share of the cost the stores hold, in thousandths,
   * for the resource the stores cover worst.
   */
  heldPermille: number;
}

export interface Event {
  kind: EventKind;
  xMpx: number;
  yMpx: number;
  faction: number;
  /**
   * Who did it and who it was done to, as player ids; 0 where the sim has
   * nobody to name. A torpedo carries both — the commander who fired it and
   * the commander whose fleet it struck — because the camera jolt belongs
   * to the two people in the exchange and to nobody else. Attribution is a
   * field and not a per-client filter, so every whole-map viewer still
   * shares one marshalled frame.
   */
  actor: number;
  subject: number;
  /**
   * The damage figure (R538). `damage_x10` is what the hit took off the
   * struck hull, shield and hull together, in tenths of a point; 0 on an
   * event that carries no amount (a flip, a capture, a launch, an expiry).
   * A gun HIT is one SHOT (R1135): one event per victim per shot, raised
   * once per fire period of the shooter's hull, so its figure is the whole
   * damage of that one shot — the same record the combat log keeps
   * (R526). A Bombard splash on a second hull is a second event. `victim`
   * is the struck fleet's id, 0 when
   * nobody was struck, so the client can pin the figure to the hull.
   * `splash` marks a torpedo splash on a hull beside the primary target:
   * the client draws the figure only, because the blast and the camera
   * jolt ride the primary event.
   */
  damageX10: number;
  victim: number;
  splash: boolean;
  /**
   * Where the damage came from, so a figure can fly out along the shot:
   * the shooter's position for a gun hit, the launch point for a torpedo.
   * 0/0 when nothing fired (a quake, a window).
   */
  sourceXMpx: number;
  sourceYMpx: number;
  /**
   * The struck fleet's faction, so a dealt figure wears the ink of the
   * hull it came off (R538). 0 when nobody was struck. On a CAPTURE it is
   * the faction that lost the structure, 0 for a neutral one, so the old
   * owner hears `sfx-object-lost` (audio.md §4.4, R3120).
   */
  victimFaction: number;
  /**
   * The TorpedoKind of the round that went off, on the primary
   * TORPEDO_HIT and on the TORPEDO_EXPIRE of a detonation (R2079). The
   * client draws the detonation look out to the splash of that kind. It
   * is 0 on every other event. A ROUND_KILL carries the kind of the round
   * it took out (R2080): that round did not go off, so nothing splashed.
   */
  torpedoKind: number;
  /**
   * The heading of the round a ROUND_KILL took out, in milliradians
   * (R2080), so the client draws the round as it flew. 0 on every other
   * event.
   */
  headingMrad: number;
  /**
   * The approach (numbers.md §4.1, R2371). On a gun HIT: the arc of the
   * victim the shot struck (BOW, BEAM or STERN), and `ambush` when the
   * victim's commander did not hear the shooter at the shot, so the shot
   * dealt the ambush multiplier. A splash victim takes the base shot, so
   * its event carries neither. On a SIGNATURE event: the order the hull
   * (`victim` is 0, `actor` its commander, x/y the hull) spent. All three
   * are 0 on every other event and on a sim without the approach. The
   * after-action line and the ambush sector read them.
   */
  aspect: HitAspect;
  ambush: boolean;
  signature: SignatureOrder;
  /**
   * The hull that spent a signature order, on a SIGNATURE event; 0 on
   * every other event.
   */
  fleet: number;
  /**
   * The event figure is a repair and not damage (R2779, protocol 41): a
   * Wrasse put `damage_x10` back on the hull `victim`. False on every
   * other event.
   */
  heal: boolean;
  /**
   * The sea object a gun HIT struck (v2-the-deep.md §11.2, R3031); 0 on
   * every other event. x/y is the object, source_x/source_y the shooter,
   * `victim` and `subject` are 0 because no hull was struck, and
   * `victim_faction` is the faction of the object. The event reaches a
   * client that holds the row of the object. The client draws the salvo
   * of a shot at a hull; a gun hit on an armed sea mine sets it off, and
   * the detonation look starts when the first round arrives
   * (ui-map-interface.md §6.1.14).
   */
  seaObject: number;
  /**
   * Who took the round of a ROUND_KILL out of the water (audio.md §4.4,
   * R3118): GUARD for a set Sentinel or a Reef Breakwater, BURST for a
   * round burst. NONE on every other event. The client plays
   * `sfx-guard-kill` for a guard and one `sfx-torpor-burst` for each
   * burst point.
   */
  roundKillSource: RoundKillSource;
}

export interface Events {
  events: Event[];
}

export interface Notice {
  text: string;
  error: boolean;
  kind: NoticeKind;
  /**
   * Which event said this, from the server's event table. The client looks
   * the id up in Catalog.events for the cue and the toast style. Empty
   * means untagged: a refused order, which the client routes through the
   * `refusal` pseudo-event. Empty `text` with an id set is cue-only — the
   * client plays the sound and shows nothing.
   */
  event: string;
  /**
   * A kept notice (R2059): the notice lane keeps the line for its whole
   * life, and a newer line drops an older line that is not kept first.
   * The hub keeps the surrender notice of an arcade match, so a burst of
   * build receipts cannot push it off the lane before a player reads it.
   */
  keep: boolean;
  /**
   * The place of the event (R2370): the hex cell of its emission, the
   * cell the INBOX files beside the message. 0 means no place: a world
   * event, a refusal and an event that names no cell carry 0. The
   * notice lane makes a line with a cell a GO TO press.
   */
  cell: number;
  /**
   * The fleet the notice is about (R3261), 0 for none: the
   * auto-withdraw and the two stops of the dredger brain. The client
   * keeps the words as the last reason of that fleet and shows them on
   * its row and its card until the fleet takes a new order.
   */
  fleet: number;
}

/** One commodity in a hold. */
export interface HoldStack {
  /** 1 alloy, 2 biomass, 3 volatiles */
  resource: number;
  amount: number;
}

/**
 * A scout's active-ping report: what it heard, at the moment of the ping.
 * Attached to a squad-chat line; the client renders it clickable.
 */
export interface ScanReport {
  fleets: ScannedFleet[];
  /**
   * The cell the scout pinged from. The report's SHOW button jumps the
   * camera here, so a squadmate can act on the contacts without hunting
   * for the water they are in.
   */
  cell: number;
}

export interface ScannedFleet {
  faction: number;
  cls: ShipClass;
  hullPct: number;
  xMpx: number;
  yMpx: number;
  /**
   * The ping classifies the pattern too — scouting is the counter-play
   * engine of the weapon/shield triangle (numbers.md §17).
   */
  weapType: number;
  shieldType: number;
  /**
   * The commander who owns the contact. A scan names the enemy: this is
   * wider than the `own faction only` rule the rest of the wire keeps, and
   * it is what the scan is sold as buying. Empty for a contact whose owner
   * is not a seated commander.
   */
  ownerName: string;
  /**
   * The account id of that commander, 0 when `owner_name` is empty. The
   * scan report's REPORT control names the commander by it (R1323).
   */
  ownerId: number;
}

export interface ChatMsg {
  channel: ChatChannel;
  /** account id, 0 = the world itself */
  fromId: number;
  fromName: string;
  text: string;
  unix: number;
  faction: number;
  clanTag: string;
  /**
   * Set on the backlog a joining client is replayed. History is not news:
   * without this the client counts every line it has already seen as
   * unread again on every reconnect.
   */
  history: boolean;
  /** scout scan attachment, if any */
  report:
    | ScanReport
    | undefined;
  /**
   * The map marker this line announces, if any (player-reach.md §2.1).
   * A copy of the marker as it was placed: the client's SHOW button
   * moves the camera to its cell, and the kind names the glyph.
   */
  marker:
    | MapMarker
    | undefined;
  /**
   * The line id the hub gives every line of a player (R1323): one
   * sequence per world, rising, and 0 for a line of the world itself. A
   * REPORT names the line by it, and the hub copies the text from its own
   * backlog. The sequence starts at the wall-clock millisecond of the
   * boot, so an id of an earlier boot never names a line of this one.
   */
  lineId: number;
  /**
   * A quick line (R1607): the row of data/contracts/quickchat.toml, 1 to
   * 12, and 0 for a free line. `text` is empty on a quick line: the
   * reader's client writes the line from its own locale table.
   */
  quick: number;
  /**
   * The position the quick line carries, as the hub resolved it (R1608).
   * Unset when the line carries none.
   */
  quickPos: QuickPos | undefined;
}

/**
 * A live contest of a strategic object. Public: a stake is visible to
 * everyone, which is what makes it a commitment (game-design §4).
 * One strategic object's public status (§8 revamp). Composition of the
 * committed fleets is never on the wire before resolution.
 */
export interface SiegeInfo {
  siteId: number;
  siteName: string;
  cell: number;
  /** faction, 0 = neutral */
  owner: number;
  /** world object kind (Throne, Spire, ...) */
  kind: number;
  kindName: string;
  /** 18 / 19 / 20, world clock */
  windowHour: number;
  /** to the window start; <0 while it is open */
  windowInSec: number;
  /** object sov gauge x10 */
  gauge10: number;
  contested: boolean;
  youCommitted: boolean;
  /**
   * Faction of the pledged attackers (0 = none): commits are faction-vs-
   * owner, so one faction attacks a window (plan §4.3).
   */
  attacker: number;
  /**
   * How many fleets YOUR OWN faction has pledged at this object (R794).
   * Per receiver, like the rest of this frame. A faction pledges against
   * an object or for it and never both, so one count says everything
   * your side did here.
   */
  ownCommits: number;
  /**
   * Another faction has pledged something at this object (R794). It is a
   * FLAG and never a count: a reader learns that the window is contested
   * and learns nothing about the strength or the composition standing
   * against them.
   */
  enemyPledged: boolean;
  /**
   * Your own pledged fleets at this object, in pledge order (R76, R796):
   * a committed fleet appears on nobody's map, so this is where its owner
   * tracks it. Each entry carries the battle plan the fleet fights on, so
   * the STRUCTURES panel can offer the two pickers.
   */
  yourFleets: PledgedFleet[];
  /**
   * The object's gauge does not heal until its next window closes
   * (R1449): the attackers won the last window and the object did not
   * fall. The client shows it beside the gauge (R1454).
   */
  healBlocked: boolean;
  /**
   * What holding the object gives (numbers.md §8), as figures: the client
   * words them per kind. The unit follows the kind: a fraction for Forge,
   * Kelp, Archive, Marshal and Drydock (repair speed; benefit2 is its
   * hull share), px for Spire (sonar) and Ward (aura), season points an
   * hour for Throne (benefit2 is the gauge hit it turns away).
   */
  benefit: number;
  benefit2: number;
  /**
   * The object is the featured object of this world day (numbers.md §8
   * "The featured object", R3272): its holder takes featured_bonus_mult
   * times its bonus, and a won window pays featured_siege_mult times the
   * siege score. `benefit` stays the plain figure.
   */
  featured: boolean;
  /**
   * The window commitments of the next window (R3279): how many members
   * of the reader's squad, the reader included, committed to this
   * object's next window (the open one, or the next opening). A reader in
   * no squad reads the own commitment alone. Per receiver.
   */
  squadIn: number;
  /** The reader committed to this object's next window (R3279). */
  youIn: boolean;
}

/**
 * One of the receiving player's own fleets, pledged at an object (R796).
 * Own fleets only, like every other name on this frame.
 */
export interface PledgedFleet {
  fleetId: number;
  name: string;
  /**
   * The battle plan, packed as position | behaviour << 8 — the same
   * number FleetState.battle_plan and FleetAction.arg carry.
   */
  battlePlan: number;
}

export interface Sieges {
  sieges: SiegeInfo[];
}

export interface WarQuery {
}

export interface WarState {
  /**
   * Season-scoped sovereignty series: cells owned per faction, sampled
   * every sample_every_sec game-seconds (index 0 = unclaimed, then
   * factions 1..5). Downsampled on the wire to a drawable point count.
   */
  sov: SovSample[];
  sampleEverySec: number;
  /** top 10 commanders */
  players: SovLedgerRow[];
  /** top 10 clan squads */
  squads: SovLedgerRow[];
  /** newest first, at most 20 */
  log: CaptureLogEntry[];
  /** scan-intel ledger (24 game-hours) */
  intel: IntelEntry[];
}

/** One sample of the sovereignty distribution, on the world clock. */
export interface SovSample {
  /** gameElapsed at the sample */
  tSec: number;
  /** [unclaimed, faction 1..5] */
  cells: number[];
}

export interface ProductionQuery {
}

export interface ProductionState {
  /**
   * The ring, oldest sample first, sampled every sample_every_sec
   * game-seconds (the sov cadence). The counters are cumulative for the
   * season, so the client differences two samples into a rate.
   */
  samples: ProductionSample[];
  sampleEverySec: number;
}

/**
 * One sample of the season counters Ledger.Earned[mined] and
 * Ledger.Earned[gathered], on the world clock. Each list is
 * [alloy, biomass, volatiles].
 */
export interface ProductionSample {
  /** gameElapsed at the sample */
  tSec: number;
  mined: number[];
  gathered: number[];
}

export interface InboxLedgerQuery {
}

export interface InboxLedgerState {
  /**
   * The number of counters a row holds on this server: the length of the
   * list in data/contracts/inboxledger.toml. Counter i of a row is key i
   * of that list.
   */
  keyCount: number;
  /**
   * The wall hours of the hour ring (`hour_rows` of the list) that hold a
   * count, oldest first. An hour with no count is not sent.
   */
  hours: InboxLedgerRow[];
  /** The wall days (UTC) of the season that hold a count, oldest first. */
  days: InboxLedgerRow[];
  /**
   * The wall second the seat's last absence began, 0 for none: the start
   * of SINCE YOU LEFT. The return briefing's departure mark, converted to
   * the wall clock.
   */
  awayUnix: number;
  /** The server's wall clock at the answer, in Unix seconds. */
  nowUnix: number;
}

/** One wall hour or one wall day of counts. */
export interface InboxLedgerRow {
  /** The wall second the hour or the day starts at. */
  startUnix: number;
  /**
   * The counters in list order, with the trailing zeros cut: a counter
   * past the end of the list is 0.
   */
  counts: number[];
}

export interface TimelapseQuery {
}

export interface TimelapseState {
  /**
   * The owner frames of the running season, from day 0 to the newest
   * frame, in the byte string of internal/timelapse (chronicle.md §10.1).
   * The public route of the meta server serves the same bytes. Empty on
   * an arcade match, which records no timelapse.
   */
  data: Uint8Array;
}

/**
 * One ledger line: cells this commander (or squad) captured this season,
 * and how many of those captures they still hold.
 */
export interface SovLedgerRow {
  name: string;
  faction: number;
  owned: number;
  captured: number;
}

/** One tier-1 flip for the capture log. */
export interface CaptureLogEntry {
  cell: number;
  /** faction that took the cell */
  taker: number;
  /** faction that lost it (0 = unclaimed) */
  from: number;
  /** world clock (gameElapsed) of the flip */
  atSec: number;
  /**
   * The hull name and the commander of the Beacon that took the cell.
   * The server sends both for the viewer's own faction alone (the rule of
   * FleetState.name), and neither for a cell a base beam took (R1570).
   */
  fleetName: string;
  ownerName: string;
}

/**
 * One remembered scan contact (War → Intel). Re-scanning the same fleet
 * updates the entry in place; entries expire after 24 game-hours.
 */
export interface IntelEntry {
  /** composition at the moment of the ping */
  fleet: ScannedFleet | undefined;
  fleetId: number;
  /** commander whose scout pinged it */
  scanner: string;
  /** game-seconds since the (re)scan */
  ageSec: number;
}

/** One line of the season table (game-design §10: rankings are MVP). */
export interface Standing {
  rank: number;
  accountId: number;
  name: string;
  clanTag: string;
  faction: number;
  score: number;
  honour: number;
  honourRank: number;
  title: string;
  cells: number;
  kills: number;
  sieges: number;
  /** resource units cut from deposits this season (R1523) */
  gathered: number;
}

export interface Scoreboard {
  season: number;
  cataclysm: boolean;
  seasonLeftSec: number;
  rows: Standing[];
  you:
    | Standing
    | undefined;
  /**
   * Seaquake arc (numbers.md §15): 0 calm, 1 relocated, 2 war economy,
   * 3 settlement. The client labels the top bar from it.
   */
  quakeStage: number;
  /**
   * Current timescales: the admin panel can retune either live, and every
   * client's stats readout follows the scoreboard broadcast. `timescale`
   * is the world clock, `tactical_scale` the map's (R91).
   */
  timescale: number;
  /**
   * Founding truce remaining (game-seconds, 0 = over): re-anchors the
   * client's banner countdown the way season_left_sec re-anchors the
   * season clock (additive, plan §5.2).
   */
  truceLeftSec: number;
  tacticalScale: number;
  /**
   * Settlement remaining (world game-seconds, 0 outside stage 3): the
   * client's menu-bar countdown and the tremor ramp key off it the way
   * truce_left_sec anchors the truce banner (additive, R126).
   */
  settlementLeftSec: number;
  /**
   * The world's time of day (world game-seconds, 0..86399), the same field
   * the hello carries. The board re-anchors the client's clock the way
   * season_left_sec re-anchors the season countdown, so a live timescale
   * retune cannot leave the reading running at the old rate.
   */
  clockSec: number;
  /**
   * The origin of the world clock, the same field the hello carries. A
   * roll moves it, so the board carries it too (R2519).
   */
  clockOriginSec: number;
}

/** What a commander gets told when the season closes. */
export interface SeasonReport {
  season: number;
  rank: number;
  score: number;
  honourGained: number;
  honour: number;
  honourRankNow: number;
  title: string;
  cells: number;
  kills: number;
  sieges: number;
  expeditions: number;
  unix: number;
}

/**
 * The season summary (ui-map-interface.md §3.4, R1518): the card a
 * commander reads from the lock of the scores (seaquake stage 3) to the
 * roll. It is built per reader, because `you` and `stats` are the
 * reader's own and every other field is shared.
 */
export interface SeasonSummary {
  /** the Hello's mode: 0 core, 1 event, 2 clanwar */
  mode: number;
  season: number;
  /**
   * The meta server holds this world (R613): no roll follows the
   * settlement. The world closes its season when the settlement drains
   * and rests on the settled map (R1528): a run world until its slot
   * releases, a static event or clanwar world for good (R3004). A core
   * world never holds (deployment.md §5).
   */
  held: boolean;
  /**
   * WALL seconds from this frame to the roll of a world that is not held:
   * the settlement's remainder at the world clock's rate. 0 for a held
   * world. The client anchors it on its own clock, as it anchors every
   * countdown.
   */
  nextSeasonInSec: number;
  /**
   * The locked final table, whole, best first (R517). The client states
   * the top rows and the reader's own row.
   */
  rows: Standing[];
  /** absent for a reader the table does not rank */
  you: Standing | undefined;
  stats:
    | SeasonSummaryStats
    | undefined;
  /**
   * A Clan War world: its banners ranked by the summed locked score of
   * their seats (numbers.md §14.2). Empty on every other world.
   */
  banners: SeasonSummaryBanner[];
  /**
   * The wall unix second the season started at. The client names the
   * achievement grades the reader reached after it.
   */
  seasonStartedUnix: number;
  /**
   * The road builder of the reader's faction (R3074): the commander whose
   * shipping lanes hold the most lane credit, and the fleet hours of it,
   * rounded down. Empty while `routes` is off and while no lane of the
   * faction holds a credit hour.
   */
  roadBuilder: string;
  roadBuilderHours: number;
}

/** The reader's own season, as the scores locked it (R1518). */
export interface SeasonSummaryStats {
  /**
   * The locked score term by term, in game.ScoreSource order: cells,
   * kills, sieges, gathered, expeditions, buildings, tech, throne,
   * captains.
   */
  scoreBySource: number[];
  /**
   * The Honour the roll awards for this rank and score (numbers.md §14):
   * a projection, because the roll pays it. A Clan War world pays it as
   * Clan Honour (R1512).
   */
  honour: number;
  fleetsLost: number;
  siegesLost: number;
  gathered: number;
  expeditions: number;
  buildingLevels: number;
  techRecovered: number;
  throneHours: number;
  captainsLost: number;
  prisoners: number;
  trades: number;
}

/** One banner of a Clan War world on the season summary (R1518). */
export interface SeasonSummaryBanner {
  rank: number;
  faction: number;
  name: string;
  tag: string;
  /** an NPC house holds the banner (R1262) */
  house: boolean;
  /** the summed locked score of the banner's seats */
  score: number;
  seats: number;
}

export interface InboxMsg {
  id: number;
  kind: InboxKind;
  /** wall clock when the message was filed */
  unix: number;
  title: string;
  body: string;
  /** deep link: centre the map here; 0 = none */
  cell: number;
  /** the combat-log window this message replays; unset = none */
  replay: ReplayRef | undefined;
  read: boolean;
  /**
   * Wall clock when the server deletes the message. The clock is the same
   * one `unix` is on, because a message goes stale with the player's own
   * day and not with the world's. 0 means the message was filed before the
   * field existed, and the server applies its default lifetime to it.
   */
  expiresUnix: number;
  /** The Replace action of a loss message (R1308); unset = none. */
  replace:
    | ReplaceOffer
    | undefined;
  /**
   * ---- the facts of the message (inbox.md §3) ----
   * The server sends the facts and the client writes the words. A
   * message filed before the facts existed has no `event`, and the client
   * draws its `title` and `body`. `title` and `body` stay filled until the
   * client writes every message from its facts.
   */
  event: string;
  /** loss, war, hold, dive, trade or world (inbox.md §2) */
  bucket: string;
  /** the typed figures: decimal integers, wall Unix seconds, names, flags "1" */
  params: { [key: string]: string };
  /** the named tables of the message */
  rows: InboxTable[];
  /**
   * The fold (inbox.md §4): a row that holds two or more members. For a
   * fold, `params` holds the sums of the summed keys and the last member's
   * other keys, `unix` is the stamp of the last member, and `rows` is
   * empty: each member carries its own tables. A single message has
   * count 0 and no members.
   */
  count: number;
  /** the stamp of the first member */
  firstUnix: number;
  /** oldest first */
  members: InboxMember[];
  /**
   * NEEDS YOU (inbox.md §4): the server sets it on each send of the list.
   * An open REPLACE on an unread message, a captured captain whose ransom
   * is open, or a siege whose window has not ended.
   */
  needs: boolean;
}

export interface InboxMsg_ParamsEntry {
  key: string;
  value: string;
}

/**
 * One named table of an inbox message, such as the `damage` rows of a
 * loss or the `hits` of a torpedo report (inbox.md §3).
 */
export interface InboxTable {
  name: string;
  rows: InboxRow[];
}

/** One row of an InboxTable: its cells by key, as strings. */
export interface InboxRow {
  cells: { [key: string]: string };
}

export interface InboxRow_CellsEntry {
  key: string;
  value: string;
}

/**
 * One member of a fold (inbox.md §4): one message that the fold holds,
 * with its own stamp, figures, tables, map link and replay.
 */
export interface InboxMember {
  unix: number;
  params: { [key: string]: string };
  rows: InboxTable[];
  cell: number;
  replay: ReplayRef | undefined;
}

export interface InboxMember_ParamsEntry {
  key: string;
  value: string;
}

/**
 * ReplaceOffer is the Replace action a loss message carries
 * (fleet-atom-redesign.md §11, R1308). The server fills it when it sends
 * the list: the price is what one hull of the pattern costs now, and the
 * refusal is the check half of the build, in the reader's language. The
 * client draws the button, greys it out when `refusal` is set, and says
 * "queued" when `queued` is set.
 */
export interface ReplaceOffer {
  /** the active design of the hull, which a press builds now (R1882); 0 once queued */
  design: number;
  /** the hull class of the lost fleet */
  hull: ShipClass;
  /** the full price of one hull of that pattern, now */
  price:
    | Resources
    | undefined;
  /** the one press was spent: a build is in the queue */
  queued: boolean;
  /** why a press would be refused now; empty = it would pass */
  refusal: string;
}

/**
 * InboxReplace is the REPLACE intent (R1308): the id of the loss message
 * whose Replace action the player pressed.
 */
export interface InboxReplace {
  msgId: number;
}

/** The whole list, newest first — small enough to send whole on demand. */
export interface Inbox {
  msgs: InboxMsg[];
}

export interface InboxAction {
  /** send me the Inbox frame */
  fetch: boolean;
  /** one message id */
  markRead: number;
  /** every message */
  markAll: boolean;
  /** the window an inbox message named: send me the Replay frame */
  fetchReplay:
    | ReplayRef
    | undefined;
  /**
   * Several message ids at once (inbox.md §3, R1851): MARK THESE READ marks
   * the messages of a range with one action, and the hub answers with one
   * Inbox frame. The hub takes at most `economy.inbox_cap` ids of one
   * action and ignores an id the inbox does not hold.
   */
  markIds: number[];
}

/**
 * ReplayRef names a window of the combat log: the hulls the film follows
 * and the span of the map clock it covers. The client treats it as opaque
 * and sends it back unchanged in InboxAction.fetch_replay.
 */
export interface ReplayRef {
  kind: ReplayKind;
  /** the focus hulls: the sunk hull, the struck hulls, the fighters */
  fleets: number[];
  /** map clock, milliseconds */
  t0Ms: number;
  t1Ms: number;
  /** where it happened, for the deep link */
  cell: number;
}

/**
 * A replay (v17, R526): the hulls a window of the combat log names, their
 * sampled tracks, and every damage record inside the window. Chunky, so
 * it is only ever sent in answer to InboxAction.fetch_replay. Every t_ds
 * is deciseconds of the map clock since ReplayRef.t0_ms.
 */
export interface ReplayHull {
  /** sim fleet id, stable across the timeline */
  id: number;
  faction: number;
  cls: ShipClass;
  /** hull name */
  name: string;
  /** owning commander, "" for a faction bot */
  commander: string;
  /**
   * The NPC kind of a hull of the NPC side (v2-the-deep.md §8.1, R2622),
   * NONE for a hull of a faction. The film draws the NPC mark from it, as
   * the live map does from FleetState.npc. A stream header written before
   * the field holds none: the reader then names a monster by its class,
   * because only a monster sails an npc class (R2622).
   */
  npc: NpcKind;
}

export interface ReplayPoint {
  tDs: number;
  xMpx: number;
  yMpx: number;
  hullPct: number;
  shieldPct: number;
}

export interface ReplayTrack {
  /** index into Replay.hulls */
  hull: number;
  /** ascending t_ds */
  points: ReplayPoint[];
  /**
   * Did this hull go down inside the window? The log holds a Sunk record
   * per hull, so the frame states the sinking rather than leaving the
   * client to infer one from the damage records it was sent (R534). A
   * sinking at or before the window's start reads as sunk_t_ds 0.
   */
  sunk: boolean;
  sunkTDs: number;
  /**
   * Did this hull break off inside a window battle (R791)? The arena takes
   * a hull whose shield reached zero off the water, so the track ends at
   * withdrawn_t_ds and the client fades the hull out there, with no blast
   * and no wreck (R1451). Only a window film sets it.
   */
  withdrawn: boolean;
  withdrawnTDs: number;
}

export interface ReplayHit {
  t0Ds: number;
  /** equals t0_ds for a single event */
  t1Ds: number;
  /** index into Replay.hulls */
  victim: number;
  /** index into Replay.hulls; -1 = no hull (a base tube, the sea) */
  source: number;
  kind: DamageKind;
  /** the round's kind, for the torpedo kinds */
  torpedo: TorpedoKind;
  /** the owner of a base tube when source is -1, else "" */
  sourceLabel: string;
  /** sub-step volleys in a gun run; 1 for one event */
  shots: number;
  /** damage that applied, tenths */
  damageX10: number;
  shieldBeforeX10: number;
  shieldAfterX10: number;
  hullBeforeX10: number;
  hullAfterX10: number;
  /** the source's point at t1, or a round's launch point */
  sxMpx: number;
  syMpx: number;
  /** the victim's point at t1 */
  vxMpx: number;
  vyMpx: number;
  /** when a round left its tube, torpedo kinds only */
  launchTDs: number;
  /**
   * The report's own WORDS for this hit, written by the server with the
   * vocabulary the inbox message carries (R527, R534). The film aggregates
   * the hits into one row per source and writes no word of its own, so a
   * film and the message name one source the same way.
   */
  sourceText: string;
  /** what the report calls this kind of damage */
  kindWord: string;
  /** wall clock of the damage record, for the row's time */
  unix: number;
  /**
   * Who the source answers to (R535). The film's table holds the commander
   * and the faction in columns of their own, so the phrase above names the
   * hull or the round alone. The commander is "" for a faction bot, and
   * the faction is 0 where the log names no hull.
   */
  sourceFaction: number;
  sourceCommander: string;
}

export interface Replay {
  ref: ReplayRef | undefined;
  title: string;
  durationDs: number;
  /** where it happened, for the deep link */
  cell: number;
  /** wall clock of the window's end */
  unix: number;
  hulls: ReplayHull[];
  tracks: ReplayTrack[];
  hits: ReplayHit[];
}

/**
 * One heatmap field.
 *
 * `cells` is dense: one uint8 intensity per cell, in cell-index order, of
 * length world.Cells. 0 means no heat, and a blocked cell is always 0. The
 * scale belongs to the kind; the server quantizes, so no float and no cell
 * index crosses the wire.
 */
export interface Heatmap {
  kind: HeatmapKind;
  cells: Uint8Array;
}

/**
 * Which map filter this client wants. The client sends it when the view mode
 * changes, and HEATMAP_KIND_NONE unsubscribes. The subscription lives on the
 * connection, so the client sends it again after a reconnect.
 */
export interface HeatmapMode {
  kind: HeatmapKind;
}

/**
 * One named per-empire toggle. `key` is the name of the setting, and `on`
 * is the wish. The server refuses an unknown key, so a client of a newer
 * build cannot turn on a setting this server does not hold.
 *
 * The key `advisor` is the advisor switch (R1305). The hub keeps it on
 * the empire and in the snapshot (R1566), states it as
 * `Empire.advisor_on`, and sends the advice while it is on. The client
 * sends it when the player presses the switch, and never after a hello.
 */
export interface EmpireSetting {
  key: string;
  on: boolean;
}

export interface ClanMember {
  accountId: number;
  name: string;
  faction: number;
  /** squad number, 0 = unassigned */
  squad: number;
  online: boolean;
  /** this member's Communications level */
  comms: number;
  /**
   * A reserve empire of a Clan War banner (R1261): an autopilot seat of
   * the clan that no clan member holds yet. A late member takes one.
   */
  reserve: boolean;
  /**
   * The objects whose next window this member committed to (R3279), in
   * site order. The roster card reads I'M IN for the reader's window.
   */
  committed: number[];
}

/**
 * The clan the player belongs to, resent whenever it changes. Clan identity
 * survives the season reset (game-design §3).
 */
export interface ClanInfo {
  id: number;
  name: string;
  tag: string;
  /** the viewer's squad */
  squad: number;
  /** clan Communications level (best among members) */
  comms: number;
  members: ClanMember[];
  /** what the current Comms level unlocks */
  bonuses: string[];
  /**
   * The clan is a default clan the world seeded, not a clan a person
   * founded on the hub page (R245). The tab is read-only either way; this
   * is what lets it say which of the two the player sails with.
   */
  npc: boolean;
}

export interface FleetOrder {
  fleetId: number;
  xMpx: number;
  yMpx: number;
  mission: Mission;
  /**
   * A course, v2 (v2-the-deep.md §7, protocol 38): the commander's legs,
   * at most CatalogRules.route_legs_max, with no leg 0. The hub writes
   * the position of the fleet as leg 0. When legs is not empty the order
   * is a course, and the hub does not read x_mpx and y_mpx. The flag
   * `routes` gates it, and the hub refuses a course while the flag is
   * off. To send a saved plot, the client sends its legs here.
   */
  legs: Waypoint[];
  /**
   * The STEER order (MISSION_STEER, numbers.md §4.2, R2638): the wanted
   * heading in milliradians, in the sense of FleetState.heading_mrad (from
   * +x east, toward +y), and the throttle step: 0 STOP, 1 SLOW, 2 HALF,
   * 3 FULL. The hub reads both only for MISSION_STEER, and does not read
   * x_mpx and y_mpx then. The order holds for a lease, and each STEER
   * renews it. Every Conquest world gives it, and an arcade match
   * refuses it (R2830).
   */
  headingMrad: number;
  throttle: number;
}

/**
 * PlotAction saves, renames or deletes one course plot (v2-the-deep.md
 * §7, protocol 38). SAVE reads `name` and `legs` and adds a plot; RENAME
 * reads `plot_id` and `name`; DELETE reads `plot_id`. A refusal arrives
 * as an error notice, and the Empire frame carries the new list.
 * One commission intent (v2-the-deep.md §10, R2634). ASSIGN names an
 * open offer of the board of the faction and one own fleet (round 088
 * card 15 (a), R2629).
 */
export interface CommissionAction {
  op: CommissionOp;
  id: number;
  fleetId: number;
}

export interface PlotAction {
  op: PlotOp;
  plotId: number;
  name: string;
  legs: Waypoint[];
  /** The state of the LANE switch that PLOT_OP_LANE sets (R2646). */
  lane: boolean;
}

/**
 * The world-space rect the client's camera can see; used for interest
 * management. Send on camera change (debounced), never on a timer.
 */
export interface Viewport {
  x0Mpx: number;
  y0Mpx: number;
  x1Mpx: number;
  y1Mpx: number;
}

export interface Ping {
  nonce: number;
}

/**
 * Resync asks the server to state the world again (R778). It is a property
 * of the CONNECTION and not of the empire: the server forgets the picture it
 * believes this socket holds, sends a new Hello, and marks the next State
 * frame full.
 *
 * One client needs it. The arcade page destroys its match view when the
 * player steps out to the lobby, and the seat behind it keeps playing, so the
 * view that steps back in has no picture to apply a delta to (R777).
 */
export interface Resync {
}

/** Append a job to the shared build queue. */
export interface Enqueue {
  kind: JobKind;
  /** Building / ShipClass / tech node id / fleet id */
  target: number;
  /** ships: how many; training: attribute index */
  count: number;
}

export interface JobAction {
  jobId: number;
  /** otherwise: rush with credits */
  cancel: boolean;
  /** places to shift: + toward the front, - toward the */
  move: number;
}

/**
 * CreateFleet puts a hull that already exists to sea. The pens hold real
 * fleet objects, so this is a deploy order and not a construction: `fleet_id`
 * names the hull. `cls`/`design` remain as a fallback for "the oldest one of
 * this kind", which is what the autopilot sends.
 */
export interface CreateFleet {
  /** hull class; ignored when design or fleet_id is set */
  cls: ShipClass;
  /** 0 = uncaptained */
  captainId: number;
  /** blueprint id */
  design: number;
  /**
   * Optional immediate order (R-batch client-UX fix): when mission is set
   * (or the coords are nonzero), the new fleet is sent off with this order
   * the moment it spawns, instead of sitting idle at the home base.
   */
  xMpx: number;
  yMpx: number;
  mission: Mission;
  /** the penned hull to put to sea; 0 = oldest of `design` */
  fleetId: number;
  /**
   * The load mix of this deploy (R2017), one row for each kind; the hull
   * keeps it for later deploys. An empty list loads the hull's own mix.
   * A mix that does not fit the hull refuses the deploy; a kind short in
   * the stock sails with what the stock holds and a why-notice.
   */
  loadMix: TorpedoStock[];
}

export interface FleetAction {
  fleetId: number;
  op: FleetOp;
  arg: number;
  /**
   * FLEET_OP_SET_LOAD only (R2017): the load mix, one row for each kind.
   * An empty list is AUTO.
   */
  load: TorpedoStock[];
  /**
   * FLEET_OP_SET_STOW only (R2654): the stow, one row for each kind. An
   * empty list is AUTO.
   */
  stow: SeaObjectStock[];
}

/**
 * One fleet control group (ui-map-interface.md §9, R539). As an intent it
 * puts `fleet_id` on `slot`; a slot holds one fleet and a fleet holds one
 * slot, so the assignment silently releases whatever either one held
 * before. `fleet_id` 0 empties the slot. `slot` runs from 1 to
 * hub.ControlGroupSlots (data/contracts/protocol.toml). In an Empire
 * frame the list carries every taken slot, ascending. A fleet that sinks
 * leaves its slot with it; a fleet in the pens keeps it (R540).
 */
export interface ControlGroup {
  slot: number;
  fleetId: number;
}

/**
 * One press of a control-group digit that recalled a group (R539). The
 * client sends it when the slot held a fleet; an empty slot sends
 * nothing, because nothing was recalled.
 */
export interface ControlGroupRecall {
  slot: number;
}

export interface Chat {
  channel: ChatChannel;
  text: string;
  /**
   * A quick line (ui-map-interface.md §8 "Quick chat", R1607): the row of
   * data/contracts/quickchat.toml, 1 to 12, and 0 for a free line. A quick
   * line carries no text, because each reader's client writes it in its own
   * language. The hub takes it on the SQUAD and the FACTION channel alone.
   */
  quick: number;
  /**
   * What the quick line names, if anything. The hub resolves the position
   * from its own state and refuses a name the sender may not give (R1608).
   */
  quickRef: QuickRef | undefined;
}

/** Draft a blueprint. The module rolls happen when the job finishes. */
export interface Invent {
  hull: ShipClass;
  /** family + tier; effect is ignored */
  modules: Module[];
  /** 0 or 1..3; typed systems gate on Ship Design level */
  weapType: number;
  shieldType: number;
}

export interface DesignAction {
  design: number;
  scrap: boolean;
  useDataCore: boolean;
  /** v6 print economy: */
  printRuns: number;
  /** >0: convert `count` hulls of this design onto print `design` */
  convertFrom: number;
  count: number;
  /**
   * Installing a print puts it in its hull's slot, where it replaces the
   * default pattern until its runs run out. One-way: installing over an
   * occupied slot destroys whatever is left of the old print.
   */
  install: boolean;
  /**
   * The redraft of one slot (numbers.md §6, R1194): roll slot
   * `redraft_slot` (zero-based) of master `design` again. The other slots
   * keep their rolls, and the server files a new master with the next Mk
   * number; the source stays.
   */
  redraft: boolean;
  redraftSlot: number;
}

export interface ExpeditionOrder {
  depth: number;
  captainId: number;
}

/**
 * Launch one aimed round (game-design §8: leading and dodging are skills).
 *
 * A targeted round flies to the point given and runs out of fuel there, so
 * the aim *is* the shot: lead the contact or waste the round. A seeker is
 * given a contact to chase instead, and may only be locked onto something
 * the firing commander can currently hear.
 */
export interface FireOrder {
  /** the launching fleet; 0 = the commander's base tubes */
  fleetId: number;
  /** aim point */
  xMpx: number;
  yMpx: number;
  /** seekers: the contact to chase */
  lockFleetId: number;
  /**
   * Base fire only (fleet_id 0, R86): which stocked base round to launch.
   * 0 = the Heavy. Ignored for fleets —
   * a fleet fires its firing kind: the active round while it holds a
   * round, and else the next kind in the fixed order (R2017).
   */
  kind: TorpedoKind;
}

export interface SiegeAction {
  op: SiegeOp;
  siteId: number;
  fleetId: number;
}

/**
 * Clan management. Founding or joining is how a player leaves the pickup
 * pool (game-design §5).
 */
export interface ClanAction {
  create: boolean;
  join: boolean;
  leave: boolean;
  name: string;
  /** join: which clan */
  tag: string;
  /** squad number, 0 = let the clan place you */
  squad: number;
}

export interface CaptainAction {
  captainId: number;
  /** accept an offered cadet */
  recruit: boolean;
  dismiss: boolean;
  assignFleet: number;
  /** pay the fixed ransom for a captured captain (§18) */
  ransom: boolean;
  /** captor frees a prisoner voluntarily (§18) */
  release: boolean;
  /**
   * release: the empire the prisoner belongs to (Prisoner.owner_id,
   * R2743). 0 frees the first prisoner with captain_id in player order.
   */
  ownerId: number;
}

/** ArcadeQueueJoin enters one category's queue, or every queue at once. */
export interface ArcadeQueueJoin {
  /** the map category; ignored when quickjoin is set */
  category: string;
  /** enter every queue and take the first match */
  quickjoin: boolean;
  /**
   * Party id, carried from day one so team queueing arrives later without a
   * wire break (arcade.md §5.1). Empty means a solo queue.
   */
  partyId: string;
}

/** ArcadeQueueLeave leaves every queue this connection stands in. */
export interface ArcadeQueueLeave {
}

/**
 * ArcadeDrill asks the coordinator for a drill (arcade.md §17, R1564). Both
 * fields empty start the first drill of the map folder. A refusal comes
 * back as an ArcadeQueue frame in state REFUSED, like a queue refusal.
 */
export interface ArcadeDrill {
  /** the drill's map folder */
  category: string;
  /** the drill map, `<slug>-v<revision>` */
  mapId: string;
}

/**
 * ArcadeDrillNext answers a reading drill step (done check `ack`). `step`
 * is the index of the step the client shows, counting from 0; the hub
 * ignores a press for any other step.
 */
export interface ArcadeDrillNext {
  step: number;
}

/**
 * ArcadeSurrender puts the seat out of the running match (arcade.md §6.2,
 * R2000, R2013). The hub takes it during FIGHT alone, and never in a drill.
 * The hulls of the seat sink and its teammates play on. A team is out when
 * every seat of it surrendered; when one team that is not out remains,
 * that team wins at once. It carries nothing: the socket names the seat.
 */
export interface ArcadeSurrender {
}

/**
 * ArcadeBuild is the instant build intent (arcade.md §6). Exactly one of
 * the two is set: a ship variant by the name the map gave it, or a round by
 * kind. The ship arrives at the player's base at once — no queue, no tech,
 * no captain, no mission cap.
 */
export interface ArcadeBuild {
  variantName: string;
  torpedoKind: TorpedoKind;
  /**
   * A sea object kind the map sells into the seat stock (arcade.md §6,
   * R3220). The buy lands in the stock at once; a Sapper loads it.
   */
  seaObjectKind: SeaObjectKind;
}

/** ArcadeQueue is the queue status push. */
export interface ArcadeQueue {
  state: ArcadeQueueKind;
  category: string;
  seatsFilled: number;
  seatsTotal: number;
  /**
   * Seconds left before bots fill the empty seats (0 when no fill timer
   * runs). Wall seconds: a queue is not inside a match and has no map clock.
   */
  fillLeftSec: number;
  waitedSec: number;
  /** place in the queue, 1-based; 0 when unknown */
  position: number;
  /** why a REFUSED queue said no */
  reason: string;
  /** daily runs this account has left (arcade.md §2.3) */
  runsLeft: number;
  /**
   * True when the account holds no daily cap. `runs_left` cannot say it: 0
   * already means a spent account, and the client must render "unlimited"
   * from a flag rather than recognise a number (R264). It is also true when
   * the process runs without a meta server, because there is no counter
   * there to spend.
   */
  runsUnlimited: boolean;
}

/**
 * ArcadeMatchFound tells a seated client which match it is in. The lobby
 * connection rolls straight into the match on the same socket, so this is a
 * notice, not an address handoff (arcade.md §9).
 */
export interface ArcadeMatchFound {
  worldId: number;
  mapName: string;
  category: string;
  /** this client's seat */
  slot: number;
  team: number;
  /** seats in the match */
  seats: number;
  /** of which humans; the rest are bots */
  humans: number;
}

/**
 * ArcadePhase is a lifecycle transition and its countdown. Pushed on every
 * transition and again on the periodic board cadence, so a client that
 * dropped a frame still counts down against server truth.
 */
export interface ArcadePhase {
  phase: ArcadePhaseKind;
  /**
   * Seconds left in this phase. In LOADING and PRESTART these are **real**
   * seconds and the client prints them as they arrive. In FIGHT they are
   * map-clock game-seconds and the client divides by `tacticalscale`. 0 in
   * ENDED.
   */
  leftSec: number;
  /** Map-clock game-seconds since FIGHT began; 0 before it. */
  elapsedSec: number;
  /**
   * The slots whose client has arrived, in slot order. It is sent during
   * LOADING only, where the loading panel names every seat the match still
   * waits for; it is empty in every other phase. A bot seat is always in
   * the list, because nobody waits for a bot.
   */
  loadedSlots: number[];
  /**
   * The team whose hold timer runs, or 0 when no team holds (R405). A
   * `sov_share` or a `sov_cell` map with a `hold_sec` above zero makes a
   * team meet the target and then keep it for a time, and only the server
   * knows how much of that time is left. One team is named, and it is the
   * team whose hold is closest to done, because the map ends on that one.
   * It is sent in FIGHT only.
   */
  holdTeam: number;
  /**
   * Map-clock game-seconds left in that hold; 0 when no hold runs. It is
   * the same clock `left_sec` uses in FIGHT, so the client divides by
   * `tacticalscale` in the same way (R91, R397). The frame is pushed when
   * the hold starts, stops or changes team, and the client counts the
   * figure down between frames.
   */
  holdLeftSec: number;
  /**
   * Map-clock game-seconds until each auto-spawn delivers again,
   * index-for-index with `ArcadeInfo.auto_spawns`. It is the same clock
   * `hold_left_sec` uses, so the client divides by `tacticalscale` in the
   * same way (R422). The client counts the figures down between frames and
   * wraps each one on its own period. It is sent in FIGHT only, and it is
   * empty when the map has no auto-spawn.
   */
  autoSpawnInSec: number[];
  /**
   * How many people watch this match (arcade.md §15.9). `spectators` is
   * the public ones and `ops_spectators` the operators. A SILENT
   * operator spectator is in neither count, which is what makes it
   * silent (R900). The client draws the eye badge from the pair and
   * hides the badge at 0 and 0.
   */
  spectators: number;
  opsSpectators: number;
  /**
   * The drill step that stands, counting from 0 (arcade.md §17, R1564),
   * index-for-index with `ArcadeInfo.drill_steps`. It equals the length of
   * that list once the last step is done. The frame goes out on the tick a
   * step opens. It is 0 on a map that is not a drill.
   */
  drillStep: number;
  /**
   * The capture state of every capturable structure, in the order of
   * `ArcadeInfo.structures` (arcade.md §19.6, R2021). Empty on a map with
   * no capturable structure.
   */
  captures: ArcadeCapture[];
  /**
   * The step resets of the drill so far (arcade.md §17.3). The count
   * rises on the tick a step starts again, so the client pans the camera
   * back to its own hulls. It is 0 on a map that is not a drill.
   */
  drillResets: number;
}

/**
 * ArcadeCapture is the capture state of one capturable arcade structure
 * (arcade.md §19.2, R2021). `owner` is the owner team, 0 for neutral.
 * `taker` is the team whose fleets stand alone in the capture ring, 0
 * while no capture runs. `left_sec` is the map seconds until the
 * structure switches to the taker; a client counts down between two
 * phase frames.
 */
export interface ArcadeCapture {
  siteId: number;
  owner: number;
  taker: number;
  leftSec: number;
}

/**
 * ArcadeStructure is one arcade structure of the map (arcade.md §19.6,
 * R2021). The site itself rides the ordinary site path, so `site_id`
 * names the site the client already draws. The facts here never change
 * during a match, so they ride the hello one time, like the markers.
 */
export interface ArcadeStructure {
  siteId: number;
  cell: number;
  kind: ObjKind;
  capturable: boolean;
  objective: boolean;
  /**
   * A guard structure (the Reef Breakwater, arcade.md §19.9, R2085): its
   * reach in world px and its reload period in MAP seconds, both public
   * facts of the map file. 0 on every other kind. The clock of a
   * breakwater rides `Empire.structure_guards` of the seats that may read
   * it.
   */
  reachPx: number;
  reloadSec: number;
}

/**
 * ArcadeWin is the map's win condition, rendered for the client
 * (arcade.md §4.5). `type` and the parameters are the machine-readable
 * half; `line` is the same rule in words, written by the server so the
 * client mirrors no rule text.
 */
export interface ArcadeWin {
  /** kill_all | sov_share | sov_cell | mine | kill_class | kills | scan_class | drill | hold_structures */
  type: string;
  percent: number;
  /** WALL seconds, the figure the map file states (R397) */
  holdSec: number;
  cell: number;
  units: number;
  className: string;
  count: number;
  /** any | ship | torpedo */
  means: string;
  line: string;
}

/** ArcadeVariant is one buildable ship in the match's build pane. */
export interface ArcadeVariant {
  /** the map's name for the variant */
  name: string;
  cls: ShipClass;
  /** the hull's own name */
  className: string;
  priceCredits: number;
  /**
   * The fitted modules, already rendered ("Weapon II (+15.4%)"). A summary,
   * not a table: the client shows the line and computes nothing.
   */
  modules: string[];
  /** a support hull sails without a captain */
  support: boolean;
  /**
   * The rounds mix of the variant (arcade.md §4.6, R3215): the load the
   * hull takes from the base magazine at every deploy, one row per kind in
   * the fixed order. Empty is AUTO. Display only: the server loads it.
   */
  rounds: TorpedoStock[];
  /**
   * The stow of a Sapper variant (arcade.md §4.6, R3220): the load the
   * hull takes from the seat stock at every deploy, one row per kind in
   * the fixed order. Empty is AUTO. Display only: the server loads it.
   */
  stow: SeaObjectStock[];
}

/**
 * ArcadeSeaObject is one sea object kind the build pane sells into the
 * seat stock (arcade.md §6, R3220). `cap` counts the stock, the stow of
 * every own Sapper and the live objects on the water together.
 */
export interface ArcadeSeaObject {
  kind: SeaObjectKind;
  name: string;
  priceCredits: number;
  cap: number;
  seaMine: boolean;
}

/** ArcadeTorpedo is one buildable round. */
export interface ArcadeTorpedo {
  kind: TorpedoKind;
  name: string;
  priceCredits: number;
  /** fired by the base rather than carried by a hull */
  fromBase: boolean;
}

/** ArcadeSeatInfo is one seat on the map's roster. */
export interface ArcadeSeatInfo {
  slot: number;
  /** the seat's faction; a team is a faction colour */
  team: number;
  playerId: number;
  name: string;
  bot: boolean;
  /**
   * True when a client sits at this seat, or when a bot drives it. It is
   * the state the loading panel prints, and it is here for the same reason
   * `phase` and `phase_left_sec` are: a client that connects mid-LOADING
   * must draw the roster from its hello, without waiting for the next
   * ArcadePhase frame. `ArcadePhase.loaded_slots` carries it live.
   */
  loaded: boolean;
  /**
   * The seat's ladder number at the match lock (arcade.md §18.6, R1617).
   * The meta server states it in the answer of the run consume.
   * `has_ladder` is false for a bot, a guest and every seat of a lock the
   * meta server did not answer, and `ladder` is then 0. The client reads
   * the ladder tier from the number and draws the ladder mark beside the
   * name. A ladder number can be below zero.
   */
  hasLadder: boolean;
  ladder: number;
}

/** ArcadeInfo is the match's whole rule set, sent inside Hello. */
export interface ArcadeInfo {
  mapName: string;
  category: string;
  description: string;
  win:
    | ArcadeWin
    | undefined;
  /** map clock */
  timeoutSec: number;
  /** world clock */
  creditsPerSec: number;
  startingCredits: number;
  minedCreditRate: number;
  ships: ArcadeVariant[];
  torpedoes: ArcadeTorpedo[];
  sovEnabled: boolean;
  seats: ArcadeSeatInfo[];
  /** map clock; the map's override or the core figure */
  scanCooldownSec: number;
  /** this client's own seat */
  slot: number;
  team: number;
  /**
   * Where the match stands right now, so a reconnect resyncs without
   * waiting for the next transition.
   */
  phase: ArcadePhaseKind;
  /**
   * Seconds left in `phase`, on the clock `ArcadePhaseKind` names: real
   * seconds in LOADING and PRESTART, map-clock game-seconds in FIGHT.
   */
  phaseLeftSec: number;
  /**
   * True when this map lets a player base fire a stocked base round
   * (arcade.md §4.3). Arcade has no buildings, so the core gate — a
   * Torpedobanks level — can never open in a match, and this map setting
   * takes its place. The client shows the base FIRE control from it.
   */
  baseCanFireTorpedoes: boolean;
  /**
   * The map author's static annotations (arcade.md §4.9). They never change
   * during a match, so they ride the hello one time and no state frame
   * carries them.
   */
  markers: ArcadeMarker[];
  /**
   * The map's free spawns and their periods (arcade.md §7.2). The list is
   * match-global: every seat gets the same delivery at the same moment, so
   * one countdown serves every client. `ArcadePhase.auto_spawn_in_sec`
   * carries the live figure index-for-index with this list.
   */
  autoSpawns: ArcadeAutoSpawn[];
  /**
   * True while this match records what the seats do with the pointer and
   * the keyboard (arcade.md §15.2, R907). The client builds its input
   * batch only on this field, and the viewer hides its INPUTS control
   * when the recorded header says false.
   */
  recordInput: boolean;
  /**
   * The match's replay code, twelve symbols of the theme alphabet
   * (arcade.md §15.5, R897). It is the share link and the file name. It
   * is empty when the coordinator records nothing.
   */
  replayCode: string;
  /**
   * How many seconds behind the match a public spectator watches
   * (arcade.md §15.6, R892). The client prints it beside the LIVE chip,
   * so a player knows what a spectator can and cannot see.
   */
  spectateDelaySec: number;
  /**
   * The drill steps, in the order the match plays them (arcade.md §17,
   * R1564). They never change during a match, so they ride the hello one
   * time. The list is empty on a map that is not a drill, and that is how
   * a client knows it plays one.
   */
  drillSteps: ArcadeDrillStep[];
  /**
   * The drill step that stands at hello time, so a client that reconnects
   * draws the right card before the next ArcadePhase frame.
   */
  drillStep: number;
  /**
   * The arcade structures of the map, in cell order (arcade.md §19.6,
   * R2021). They never change during a match, so they ride the hello one
   * time; an owner change rides `SiteOwner`, and the capture state rides
   * `ArcadePhase.captures`.
   */
  structures: ArcadeStructure[];
  /**
   * The match rules of the map (v2-the-deep.md §17.6, arcade.md §6.1):
   * the v2 rules the map turns on through its settings. The map is the
   * gate, and a match latches no flag. The arcade page reads its own
   * choices here; the shared client code reads Hello.feature_flags,
   * which reports the same rules as gates.
   */
  rules:
    | ArcadeRules
    | undefined;
  /**
   * The sea object kinds the build pane sells, in the order of the map's
   * list (arcade.md §6, R3220). Empty on a map that sells none.
   */
  seaObjects: ArcadeSeaObject[];
}

/**
 * ArcadeRules are the match rules of an arcade map (v2-the-deep.md §17.6).
 * Each field is one v2 rule the map turns on through a setting or carries
 * the data of. Every field is false on a map that says nothing: the game
 * of today (R2559 rule 1).
 */
export interface ArcadeRules {
  depth: boolean;
  currents: boolean;
  /** the intensity of the currents; 0 while currents is off */
  currentScale: number;
  /** a course with loop parts, in place of PATROL */
  plot: boolean;
  /** the map paints fairways */
  fairways: boolean;
  /** the map places a den */
  pirates: boolean;
  /** the map places a lair */
  monsters: boolean;
  /** the map sells, grants or lays a sea object */
  seaObjects: boolean;
  /** the map names the Commodore */
  commandShip: boolean;
}

/**
 * ArcadeDrillStep is one drill step for the step card (arcade.md §17.2).
 * `text` is the step's words, written by the server in the reading
 * client's language. The step highlights one chrome element (`chrome`),
 * one map spot (`spot`) or nothing.
 */
export interface ArcadeDrillStep {
  id: string;
  text: string;
  /** bank | clock | objective | build_pane | selection | orders | base_fire | groups, or "" */
  chrome: string;
  spot:
    | ArcadeDrillSpot
    | undefined;
  /** ack | reach | build | ping | sink | launch | take | … | goal */
  done: string;
  /** the acts a counted check asks for; 0 otherwise */
  count: number;
  /**
   * The win of a lane a `goal` step asks for, with its line in the
   * reader's language, as `ArcadeInfo.win` carries the map's own (R1689).
   * While the step stands the banner lane states it. Unset on every other
   * step.
   */
  win:
    | ArcadeWin
    | undefined;
  /**
   * Where the camera goes when the step opens: the centre of the hulls the
   * step puts to sea for the player's own slot. Unset on a step that
   * spawns no hull for the player (arcade.md §17.6, R1709).
   */
  camera:
    | ArcadeDrillPoint
    | undefined;
  /**
   * The touch sentence of the step, in the reader's language: how a finger
   * does the act (`<key>_touch` of the step's table, R1710). A client
   * shows it on a touchscreen alone, so a mouse never reads it; empty on a
   * step whose act is the same for a mouse and a finger (R1938).
   */
  touch: string;
  /**
   * The mouse sentence of the step, in the reader's language: how a mouse
   * does the act (`<key>_mouse` of the step's table, R2126). A client shows
   * it under a mouse alone, so a finger never reads it; empty on a step
   * whose act is the same for a mouse and a finger.
   */
  mouse: string;
  /**
   * The hull class the step's act needs selected, or empty (arcade.md
   * §17.8). The client marks the press of the step on a selected hull of
   * that class alone, and marks the hull on the map while another hull or
   * no hull is selected.
   */
  select: string;
}

/** ArcadeDrillPoint is one point on the map in millipixels. */
export interface ArcadeDrillPoint {
  xMpx: number;
  yMpx: number;
}

/**
 * ArcadeDrillSpot is a ring on the map. It carries the cell and the same
 * ring as a point and a radius in millipixels, so a client draws a cell
 * outline or a circle from the one frame.
 */
export interface ArcadeDrillSpot {
  cell: number;
  xMpx: number;
  yMpx: number;
  rMpx: number;
}

/**
 * ArcadeAutoSpawn is one free spawn the map delivers to every player base
 * on a period (arcade.md §4.3). `every_sec` and `in_sec` are map-clock
 * game-seconds, like `ArcadeInfo.timeout_sec`.
 */
export interface ArcadeAutoSpawn {
  /** the variant name, or the round's own name */
  name: string;
  /** a round rather than a hull */
  torpedo: boolean;
  /** the period the map states */
  everySec: number;
  /** seconds until the next delivery */
  inSec: number;
}

/**
 * ArcadeMarker is one static annotation on a tile (arcade.md §4.9): a
 * coloured arrow or circle that says "this tile", and nothing more. It has
 * no gameplay effect. The client draws it and the sim never reads it.
 */
export interface ArcadeMarker {
  cell: number;
  /** "arrow" | "circle" */
  shape: string;
  /** 0 = the neutral white mark, else a faction id */
  color: number;
  /** degrees clockwise from north; "arrow" only */
  heading: number;
}

/** ArcadePlayerStats is one row of the end card (arcade.md §7.2). */
export interface ArcadePlayerStats {
  slot: number;
  team: number;
  playerId: number;
  name: string;
  bot: boolean;
  killsByShip: number;
  killsByTorpedo: number;
  losses: number;
  cellsTaken: number;
  unitsMined: number;
  creditsEarned: number;
  creditsSpent: number;
  /** enemy hulls this seat's pings found, counted once each */
  scans: number;
  /**
   * The seat's ladder number before and after the match (arcade.md §18,
   * R1600). `rated` is false on every seat the match did not rate — a
   * bot, a guest, a seat with no human opponent, and every seat of a
   * match that is not rated — and the two numbers are then 0. A ladder
   * number can be below zero.
   */
  rated: boolean;
  ladderBefore: number;
  ladderAfter: number;
}

/**
 * ArcadeSummary is the end card. It is built per viewer, because `verdict`
 * is what the receiving seat's team achieved and everything else is shared.
 */
export interface ArcadeSummary {
  verdict: ArcadeVerdict;
  /** "Umber holds 60% of the sea", "time ran out" */
  reason: string;
  /** 0 on a draw */
  winTeam: number;
  /** map-clock game-seconds of fighting */
  elapsedSec: number;
  mapName: string;
  rows: ArcadePlayerStats[];
  /**
   * The achievement grades this match reached for the READING seat
   * (achievements.md §4, R957). The arcade coordinator posts the match's
   * progress batch before the card is built and puts the answer's
   * announcements here, so a player reads the grade on the end card
   * rather than one flush later on another page.
   *
   * It is empty for every seat that reached nothing, for a spectator and
   * for the replay's omniscient channel, which sit at no seat.
   */
  achievements: AchievementUnlock[];
  /**
   * Whether the match moved the arcade ladder (arcade.md §18.3, R1600).
   * The rows carry each rated seat's two ladder numbers. The card waits
   * for the ladder answer the way it waits for the grades.
   */
  ladder: ArcadeLadderStatus;
  /**
   * The why of the end as data (arcade.md §7.2, R2055). The client writes
   * the reason line in its own language from it, and reads `reason` only
   * when this is absent or names an id it does not know: a replay
   * recorded before the field, a drill end.
   */
  reasonCode: ArcadeReason | undefined;
}

/**
 * ArcadeReason is the why of a match end: the id of the sentence and its
 * figures (R2055). Every field but `id` is 0 or empty where the sentence
 * takes no such figure.
 */
export interface ArcadeReason {
  /**
   * last_fleet | draw_all_sank | sov_share | sov_cell | mined | kills |
   * kill_class | scan_class | hold_structures | surrender | time_ran_out |
   * time_ran_out_leader
   */
  id: string;
  /** the team the sentence names, a faction id */
  team: number;
  /** the units, the kills, the hull count or the percent */
  figure: number;
  /** the hull's own name in a kill_class or scan_class line */
  className: string;
  /**
   * What the leading team led on in a time_ran_out_leader line: kills |
   * kill_class | scan_class | mined | ground | sea | objectives
   */
  led: string;
}

/**
 * ReplayChunk is one batch of match-replay records (R889). `records`
 * holds the replay FILE's own framing — a uvarint length and one
 * `aquaphobia.replay.ReplayRecord`, repeated — so the client splits a
 * downloaded file and a live socket with one reader. The wire schema
 * cannot name the record type, because the record schema imports this
 * one and protoc refuses the import in both directions.
 */
export interface ReplayChunk {
  records: Uint8Array;
  /** how many whole records the bytes hold */
  count: number;
  /** the match is still running */
  live: boolean;
  /**
   * True when the reader has reached the delayed edge: every record the
   * delay lets the spectator see has been sent. The client shows the
   * LIVE chip on it.
   */
  caughtUp: boolean;
  /** the wall stamp of the newest record in the batch */
  edgeWallMs: number;
  /**
   * True when the batch's first record is a KEYFRAME and not the first
   * record of the file (R921). A late spectator is opened at the newest
   * keyframe, so the client holds no history before this batch: it must
   * build its picture from the keyframe and never look for an earlier
   * record.
   */
  fromKeyframe: boolean;
  /**
   * How many bytes of the replay file lie BEFORE this batch's first
   * record. It is 0 when the batch starts the file. A client that wants
   * the past of a match it joined late fetches exactly that many bytes
   * of the file with one Range request, and the two halves then join
   * with no overlap and no gap.
   */
  historyBytes: number;
}

/**
 * ArcadeInput is one second of a seat's pointer and keyboard work
 * (arcade.md §15.2, R907). It travels only while the match's
 * `record_input` is on, the hub writes it into the replay alone, and no
 * rule of the sim reads a field of it. The server accepts it at every
 * phase, because a batch may arrive after the phase it belongs to.
 */
export interface ArcadeInput {
  /** map clock at the start of the batch */
  tMs: number;
  taps: ArcadeTap[];
  /** the key ids the seat pressed, in order */
  hotkeys: string[];
  /** the zoom band the seat used over the batch */
  zoomMinPct: number;
  zoomMaxPct: number;
  /** the last viewport of the batch */
  view:
    | Viewport
    | undefined;
  /** how many times the camera moved */
  viewChanges: number;
  /** how far the camera travelled, in screen px */
  scrollPx: number;
}

/**
 * ArcadeTap is one press inside a batch. `sx` and `sy` are screen
 * px from the top left of the glass, and `x_mpx`/`y_mpx` are where the
 * press landed on the map. `kind` is 1 order, 2 fire, 3 select,
 * 4 chrome.
 */
export interface ArcadeTap {
  /** ms after the batch's own t_ms */
  dtMs: number;
  sx: number;
  sy: number;
  xMpx: number;
  yMpx: number;
  kind: number;
}

/**
 * ArcadeHost opens a hosting. It carries no field: the coordinator mints
 * the code, and the game host picks the map inside the window.
 */
export interface ArcadeHost {
}

/**
 * ArcadeHostJoin enters a hosting by its code as an observer. The code is
 * three symbols of the theme alphabet, in any case (R896).
 */
export interface ArcadeHostJoin {
  code: string;
}

/**
 * ArcadeHostAction is one press inside the hosting window. The
 * coordinator reads the fields the kind names and ignores the rest.
 * SET_BOT, SET_OPEN, KICK, BAN, PICK_MAP, SET_DELAY and START are the
 * game host's alone.
 */
export interface ArcadeHostAction {
  kind: ArcadeHostActionKind;
  /** the seat of TAKE_SEAT, SET_BOT and SET_OPEN */
  slot: number;
  /** the person of KICK and BAN */
  accountId: number;
  /** PICK_MAP */
  category: string;
  /** PICK_MAP */
  mapId: string;
  /** SET_DELAY, clamped to the configured maximum */
  delaySec: number;
}

/**
 * ArcadeHostPerson is one person in a hosting: in a seat, or in the
 * observers list.
 */
export interface ArcadeHostPerson {
  /** the local account id inside the coordinator */
  accountId: number;
  name: string;
  /** this person is the game host */
  host: boolean;
}

/**
 * ArcadeHostSeat is one seat of the picked map. `kind` is 0 open,
 * 1 human, 2 bot; `who` is set on a human seat alone.
 */
export interface ArcadeHostSeat {
  slot: number;
  team: number;
  kind: number;
  who: ArcadeHostPerson | undefined;
}

/**
 * ArcadeHosting is the whole hosting window (arcade.md §16.2). The
 * coordinator pushes it complete on every change, so the client mirrors
 * no rule and keeps no half state.
 */
export interface ArcadeHosting {
  code: string;
  /** the share link, already built by the server */
  link: string;
  hostAccount: number;
  youAreHost: boolean;
  /** 0 when the reader is an observer */
  yourSlot: number;
  category: string;
  mapId: string;
  mapName: string;
  mapRevision: number;
  /** the map's win rule in words */
  winLine: string;
  cols: number;
  rows: number;
  seats: ArcadeHostSeat[];
  observers: ArcadeHostPerson[];
  /** the spectator delay this hosting starts with */
  delaySec: number;
  /** the whole hosting window */
  timeoutSec: number;
  timeoutLeftSec: number;
  /** every seat is human or bot */
  canStart: boolean;
  /** the hosting is gone; `reason` says why */
  ended: boolean;
  reason: ArcadeHostingReason;
}

/** CasinoQueueJoin enters the quick queue of one game at one stake tier. */
export interface CasinoQueueJoin {
  game: CasinoGame;
  /** the tier index of CasinoRules.stakes */
  stakeTier: number;
}

/** CasinoQueueLeave leaves the quick queue this empire stands in. */
export interface CasinoQueueLeave {
}

/** CasinoJoinTable takes a free seat at one open table by its id. */
export interface CasinoJoinTable {
  tableId: number;
}

/**
 * CasinoLeave gives up the seat this empire holds. Inside a hand it folds
 * at hold'em, stands at blackjack and lets the bet ride at roulette; the
 * seat frees at hand end (casino.md §6).
 */
export interface CasinoLeave {
}

/**
 * CasinoAct is one act at the table. `amount` carries a bet, a raise or a
 * top-up in credits. `bet_kind` and `bet_numbers` carry a roulette bet:
 * the kind is an index of `data/contracts/casino.toml`, and the numbers
 * are the pockets it covers. Pocket 37 is the double zero (R2752). The server rules on every bet; the client
 * validates adjacency for the highlight alone.
 */
export interface CasinoAct {
  action: CasinoAction;
  amount: number;
  betKind: number;
  betNumbers: number[];
}

/**
 * One map marker. A marker holds only a cell its owner chose, so the
 * detection filter does not apply to it; the hub sends it to the members
 * of its audience alone (player-reach.md §2.3).
 */
export interface MapMarker {
  id: number;
  /** account id of the commander who placed it */
  ownerId: number;
  ownerName: string;
  kind: MarkerKind;
  cell: number;
  audience: MarkerAudience;
  /** wall seconds: the marker goes away at this instant (R91) */
  expiresUnix: number;
}

/**
 * MarkerAction places or removes one map marker. A nonzero `remove_id`
 * removes that marker, and the hub then ignores the other fields; only
 * the owner of a marker removes it. Otherwise the action places a marker
 * of `kind` on `cell` for `audience`.
 */
export interface MarkerAction {
  kind: MarkerKind;
  cell: number;
  audience: MarkerAudience;
  removeId: number;
}

/**
 * Report names one piece of content another player wrote. It carries what
 * the piece IS and never a copy of the words: the hub copies the line or
 * the name itself, because a client copy could put words in another
 * player's mouth (R1312). `reason` is one class of
 * data/product/meta.toml [meta.moderation] reasons, and `note` is at most
 * `note_runes` characters. The hub drops a report it cannot resolve in
 * silence, and the server sends no answer (R1323).
 */
export interface Report {
  kind: ReportKind;
  lineId: number;
  accountId: number;
  fleetId: number;
  reason: string;
  note: string;
  /** The seamount id of a REPORT_KIND_SEAMOUNT report (R2620). */
  body: number;
  /** The cache id of a REPORT_KIND_CACHE_NOTE report (R2643). */
  cache: number;
}

/**
 * Block names one commander of this world by the world account id
 * (deployment.md §7.6, R1328). The block is the reader's own: the hub
 * hides that commander's chat lines from this seat on the WORLD, FACTION
 * and SQUAD channels, live and in the backlog, and the meta server stores
 * the row the clan chat and the hub's BLOCKED card read. The hub drops a
 * block in silence when either seat has no meta account, when the list is
 * full, in an arcade match and in a world with no meta link.
 */
export interface Block {
  accountId: number;
}

/**
 * Markers is the whole list of the map markers one client may see: the
 * markers of its squad and of its faction, oldest first. An empty list
 * means "no marker", so a client replaces its list with each frame.
 */
export interface Markers {
  markers: MapMarker[];
}

/** QuickRef is what the sender of a quick line names. */
export interface QuickRef {
  kind: QuickRefKind;
  id: number;
}

/**
 * QuickPos is the position a quick line carries, as the hub resolved it.
 * `cell` is the cell of the reference at the moment of the send. A hold
 * and an object carry their site id, so the reader's client names them
 * from its own site list; an own fleet carries its hull name, which the
 * faction already reads on the map. A marker and a contact carry the cell
 * alone.
 */
export interface QuickPos {
  kind: QuickRefKind;
  cell: number;
  siteId: number;
  fleetName: string;
}

/**
 * RenameFleet gives one own hull a new name part (R1250). The server keeps
 * the designator prefix (R44), so `name` is the name part alone, as the
 * player wrote it. The next State frame and the next Empire frame carry
 * the new hull name; a refusal arrives as an error notice.
 */
export interface RenameFleet {
  fleetId: number;
  name: string;
}

/**
 * CasinoSpin is one slot-machine pull. Slots settle at once and need no
 * table, so the intent carries the tier and nothing else.
 */
export interface CasinoSpin {
  stakeTier: number;
}

/** CasinoLobbyTable is one open table in the lobby list. */
export interface CasinoLobbyTable {
  id: number;
  game: CasinoGame;
  stakeTier: number;
  /** seats the table holds */
  seats: number;
  /** of which are taken */
  seated: number;
  /** of which sit a person */
  humans: number;
  phase: CasinoPhase;
  /**
   * The wall seconds the table frame states as act_left_sec, at the
   * moment of the lobby frame: the betting window of a roulette table is
   * the next spin the lobby leads with (casino.md §16.1, R2165).
   */
  leftSec: number;
}

/**
 * CasinoLobby is the casino front page. It travels to every client of the
 * world on the `ops.casino.lobby_every_sec` cadence.
 */
export interface CasinoLobby {
  tables: CasinoLobbyTable[];
  queueState: CasinoQueueKind;
  queueGame: CasinoGame;
  queueStakeTier: number;
  /** wall seconds this empire has waited */
  waitedSec: number;
  /** wall seconds before the house fills the seats */
  fillLeftSec: number;
  /** the table this empire sits at; 0 for none */
  yourTable: number;
  /** the operator shut the casino of this world */
  closed: boolean;
  /** seats of the table the queue forms */
  queueSeats: number;
  /** seats already taken in that queue */
  queueFilled: number;
  /**
   * The faction club (casino.md §16, R2144). club_faction is the faction
   * that holds the club now, 0 for none. club_net is the signed house
   * net of the open window of the light, the carried loss included: the
   * club is paid CasinoRules.club_share of it at the next turn of the
   * light only while it is above 0. club_carry is the remainder of the
   * last split, which joins the next pot, and club_members the member
   * count of the club faction.
   */
  clubFaction: number;
  clubNet: number;
  clubCarry: number;
  clubMembers: number;
  /**
   * The capturable cells of each faction, the count that decides the
   * club: entry i is faction i+1. The roster bar of the club head draws
   * one segment a faction with a cell (casino.md §16.1, R2165).
   */
  clubCells: number[];
}

/** CasinoBet is one roulette bet on the shared window. */
export interface CasinoBet {
  /** a bet-kind index of data/contracts/casino.toml */
  kind: number;
  /** the pockets it covers; 37 is the double zero (R2752) */
  numbers: number[];
  amount: number;
}

/**
 * CasinoSeatView is one seat as one reader sees it. A hole card reaches
 * its owner alone, so `cards` is empty on a foreign seat until showdown.
 */
export interface CasinoSeatView {
  seat: number;
  /** 0 for a fictive seat */
  playerId: number;
  name: string;
  chips: number;
  bet: number;
  folded: boolean;
  /** a house-run seat, no empire behind it */
  fictive: boolean;
  /** an autopilot empire sits here */
  bot: boolean;
  isYou: boolean;
  /** one card is a casino.Card byte */
  cards: number[];
  insured: boolean;
  sittingOut: boolean;
  /** the seat put every chip in this hand */
  allIn: boolean;
  /**
   * The faction of the empire in the seat, 0 for a fictive seat. The
   * seat wears the badge of that faction (casino.md §16.1, R2165).
   */
  faction: number;
}

/**
 * CasinoTable is the whole table as one reader sees it. It travels on a
 * change alone, and never on a cadence.
 */
export interface CasinoTable {
  id: number;
  game: CasinoGame;
  stakeTier: number;
  phase: CasinoPhase;
  turnSeat: number;
  /** wall seconds left for `turn_seat` */
  actLeftSec: number;
  seats: CasinoSeatView[];
  /** for the reader's own seat */
  allowedActions: CasinoAction[];
  /** roulette: the reader's own bets */
  yourBets: CasinoBet[];
  /** hold'em community cards */
  board: number[];
  yourHole: number[];
  /** blackjack: the dealer's face-up card */
  dealerUp: number;
  /** filled at the reveal */
  dealerCards: number[];
  pot: number;
  buttonSeat: number;
  handId: number;
  /** the tier's minimum, for the client's presets */
  minBet: number;
  /** hold'em: what the reader owes to stay in */
  toCall: number;
  minRaise: number;
  yourSeat: number;
}

/** CasinoSeatResult is what one seat won or lost on one hand. */
export interface CasinoSeatResult {
  seat: number;
  /** credits, signed */
  delta: number;
  /** rendered in the reader's language (R858) */
  handRankLine: string;
}

/**
 * CasinoResult is the settlement of one hand. The client animates from
 * it: the wheel lands on `roulette_number`, the reels stop on `reels`.
 */
export interface CasinoResult {
  tableId: number;
  handId: number;
  game: CasinoGame;
  seats: CasinoSeatResult[];
  /** the pocket; 37 is the double zero (R2752) */
  rouletteNumber: number;
  /** one symbol index per reel */
  reels: number[];
  /** what the slot line paid; 0 for no line */
  slotPays: number;
  rake: number;
  /** the table dissolved; every stake came back */
  aborted: boolean;
  yourDelta: number;
  /** one sentence for the reader (R858) */
  line: string;
  /**
   * What the reader staked on the hand, in credits: every bet at
   * roulette, every hand at blackjack, what the seat put in over the
   * whole hand at hold'em, the pull at the slot machine. `your_delta`
   * is the return less this figure. 0 for a reader with no seat. The
   * big payout cue compares the two (audio.md §4.9).
   */
  yourStake: number;
}

/** CasinoStake is one stake tier (casino.md §3). */
export interface CasinoStake {
  tier: number;
  /** also the hold'em big blind */
  minBet: number;
  /** credits, already multiplied out of big blinds */
  buyInMin: number;
  buyInMax: number;
  /** half the big blind, at least one credit */
  smallBlind: number;
}

/** CasinoRoulettePayout is one bet kind and what it pays to one. */
export interface CasinoRoulettePayout {
  kind: number;
  /** the bet-kind id of data/contracts/casino.toml */
  code: string;
  /** pays this to one, and the stake comes back */
  pays: number;
  /** how many pockets the kind covers */
  covers: number;
}

/** CasinoSlotPay is one line of the slot paytable. */
export interface CasinoSlotPay {
  code: string;
  /** multiples of the stake */
  pays: number;
}

/**
 * CasinoRules is the whole rule table of the casino, shipped in the hello
 * catalog (R355). Every figure the client's sentences state comes from
 * here and never from a client literal.
 */
export interface CasinoRules {
  stakes: CasinoStake[];
  roulette: CasinoRoulettePayout[];
  /** 38: 0, 1-36 and the double zero as 37 (R2752) */
  roulettePockets: number;
  blackjackDecks: number;
  /** a natural pays num/den */
  blackjackPaysNum: number;
  blackjackPaysDen: number;
  /** insurance pays this to one */
  insurancePays: number;
  slotsRtpPct: number;
  slotPaytable: CasinoSlotPay[];
  slotSymbols: string[];
  holdemSeats: number;
  rakePct: number;
  rakeCapBb: number;
  actSec: number;
  fillAfterSec: number;
  rouletteBetSec: number;
  rouletteSpinSec: number;
  humanAbsentSec: number;
  rejoinCooldownSec: number;
  /** the documented house edge of the rule set */
  blackjackEdgePct: number;
  /**
   * The part of the house net of one window of the light that goes to
   * the club (casino.md §16, R2144), 0..1. The rest stays a sink.
   */
  clubShare: number;
  /**
   * The blackjack shoe holds no pip ten: the jack, the queen and the
   * king alone count ten (casino.md §4.2, R2752). The help states it.
   */
  blackjackSpanishShoe: boolean;
}

/**
 * The return briefing (ui-map-interface.md §12.6, R1605, R1606): what
 * changed while the commander was away. The hub sums it from its records
 * and changes nothing. A row of the block is the state of one group of
 * fields, and a group with nothing to say is zero or empty. The hub sends
 * no briefing when every group is empty.
 */
export interface ReturnBriefing {
  /**
   * The absence in world seconds, and its start: world seconds since the
   * season began (the hub's gameElapsed). The client writes both ends
   * with the world clock stamp.
   */
  awaySec: number;
  leftAtSec: number;
  /**
   * The strategic objects of the reader's faction that stand under an
   * enemy pledge now, in site order.
   */
  sieges: BriefingSiege[];
  /**
   * The cells this commander's Beacons took in the absence, and the
   * credited cells that no longer fly the faction's colours.
   */
  cellsWon: number;
  cellsLost: number;
  /** The enemy fleets this commander sank, and the own fleets lost. */
  fleetsSunk: number;
  fleetsLost: number;
  /** The captains in the Sickbay now, in roster order. */
  sickbay: BriefingCaptain[];
  /** The auction lots this seat sold in the absence, and their credits. */
  lotsSold: number;
  saleCredits: number;
  /**
   * The buildings that rose in the absence, in building order, and the
   * tech nodes the empire gained, by id.
   */
  builds: BriefingBuild[];
  techs: number[];
  /**
   * The id of the newest inbox message at the departure: every message
   * with a larger id came in during the absence.
   */
  sinceMsg: number;
  /**
   * Standing orders covered the empire in the absence (R3283,
   * autopilot.md §14.1): absence cover, or the weekend standing orders.
   */
  covered: boolean;
  /**
   * The squad (R3292). These rows read the reader's own channels and the
   * reader's own side, so they reveal nothing the reader's faction could
   * not hear.
   * The squad chat lines posted since the departure, by other commanders:
   * the newest `hub.briefing.chat_lines`, oldest first, and the count of
   * the older ones the world still keeps. A tap opens the chat on SQUAD.
   */
  squadChat: ChatMsg[];
  squadChatMore: number;
  /** The faction chat lines posted since the departure, counted. */
  factionChat: number;
  /**
   * The live map markers of the reader's squad and faction that other
   * commanders placed, in the order of the place.
   */
  markers: MapMarker[];
  /**
   * The siege windows of the next world day that concern the reader, in
   * the order they open, an open window first: the rows of the daily plan
   * (R3280) with the window commitments of the squad (R3279).
   */
  windows: BriefingWindow[];
}

/**
 * One siege window of the return briefing (R3292): an object of the
 * reader's faction (defend), or an object the faction pledged against or
 * committed to (attack).
 */
export interface BriefingWindow {
  siteId: number;
  siteName: string;
  cell: number;
  /** the world hour its window opens */
  windowHour: number;
  attack: boolean;
  /** the squad's commitments, the reader's included */
  squadIn: number;
  youIn: boolean;
}

/** One strategic object of the reader's faction under an enemy pledge. */
export interface BriefingSiege {
  siteId: number;
  siteName: string;
  cell: number;
  /** the faction pledged against it */
  attacker: number;
  /** the world hour its window opens */
  windowHour: number;
}

/** One captain in the Sickbay. */
export interface BriefingCaptain {
  id: number;
  name: string;
  /** When the captain is fit for duty: world seconds since the season began. */
  backAtSec: number;
}

/** One building that rose in the absence. */
export interface BriefingBuild {
  building: Building;
  /** the level now */
  level: number;
  /** the levels it rose */
  raised: number;
}

function createBaseServerMsg(): ServerMsg {
  return {
    hello: undefined,
    state: undefined,
    pong: undefined,
    siteOwner: undefined,
    empire: undefined,
    events: undefined,
    notice: undefined,
    siteAdded: undefined,
    chat: undefined,
    clan: undefined,
    sieges: undefined,
    scoreboard: undefined,
    seasonReport: undefined,
    market: undefined,
    war: undefined,
    devBuild: undefined,
    inbox: undefined,
    replay: undefined,
    heatmap: undefined,
    siteRemoved: undefined,
    arcadeQueue: undefined,
    arcadeMatch: undefined,
    arcadePhase: undefined,
    arcadeSummary: undefined,
    wrecks: undefined,
    quake: undefined,
    maintenanceInfo: undefined,
    replayChunk: undefined,
    arcadeHosting: undefined,
    achievementUnlock: undefined,
    casinoLobby: undefined,
    casinoTable: undefined,
    casinoResult: undefined,
    markers: undefined,
    production: undefined,
    seasonSummary: undefined,
    timelapse: undefined,
    returnBriefing: undefined,
    buildingPreview: undefined,
    inboxLedger: undefined,
    settlement: undefined,
  };
}

export const ServerMsg: MessageFns<ServerMsg> = {
  encode(message: ServerMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hello !== undefined) {
      Hello.encode(message.hello, writer.uint32(10).fork()).join();
    }
    if (message.state !== undefined) {
      State.encode(message.state, writer.uint32(18).fork()).join();
    }
    if (message.pong !== undefined) {
      Pong.encode(message.pong, writer.uint32(34).fork()).join();
    }
    if (message.siteOwner !== undefined) {
      SiteOwner.encode(message.siteOwner, writer.uint32(42).fork()).join();
    }
    if (message.empire !== undefined) {
      Empire.encode(message.empire, writer.uint32(50).fork()).join();
    }
    if (message.events !== undefined) {
      Events.encode(message.events, writer.uint32(58).fork()).join();
    }
    if (message.notice !== undefined) {
      Notice.encode(message.notice, writer.uint32(66).fork()).join();
    }
    if (message.siteAdded !== undefined) {
      SiteAdded.encode(message.siteAdded, writer.uint32(74).fork()).join();
    }
    if (message.chat !== undefined) {
      ChatMsg.encode(message.chat, writer.uint32(82).fork()).join();
    }
    if (message.clan !== undefined) {
      ClanInfo.encode(message.clan, writer.uint32(90).fork()).join();
    }
    if (message.sieges !== undefined) {
      Sieges.encode(message.sieges, writer.uint32(98).fork()).join();
    }
    if (message.scoreboard !== undefined) {
      Scoreboard.encode(message.scoreboard, writer.uint32(114).fork()).join();
    }
    if (message.seasonReport !== undefined) {
      SeasonReport.encode(message.seasonReport, writer.uint32(122).fork()).join();
    }
    if (message.market !== undefined) {
      Market.encode(message.market, writer.uint32(130).fork()).join();
    }
    if (message.war !== undefined) {
      WarState.encode(message.war, writer.uint32(138).fork()).join();
    }
    if (message.devBuild !== undefined) {
      DevBuild.encode(message.devBuild, writer.uint32(146).fork()).join();
    }
    if (message.inbox !== undefined) {
      Inbox.encode(message.inbox, writer.uint32(154).fork()).join();
    }
    if (message.replay !== undefined) {
      Replay.encode(message.replay, writer.uint32(162).fork()).join();
    }
    if (message.heatmap !== undefined) {
      Heatmap.encode(message.heatmap, writer.uint32(170).fork()).join();
    }
    if (message.siteRemoved !== undefined) {
      SiteRemoved.encode(message.siteRemoved, writer.uint32(178).fork()).join();
    }
    if (message.arcadeQueue !== undefined) {
      ArcadeQueue.encode(message.arcadeQueue, writer.uint32(186).fork()).join();
    }
    if (message.arcadeMatch !== undefined) {
      ArcadeMatchFound.encode(message.arcadeMatch, writer.uint32(194).fork()).join();
    }
    if (message.arcadePhase !== undefined) {
      ArcadePhase.encode(message.arcadePhase, writer.uint32(202).fork()).join();
    }
    if (message.arcadeSummary !== undefined) {
      ArcadeSummary.encode(message.arcadeSummary, writer.uint32(210).fork()).join();
    }
    if (message.wrecks !== undefined) {
      Wrecks.encode(message.wrecks, writer.uint32(218).fork()).join();
    }
    if (message.quake !== undefined) {
      QuakeInfo.encode(message.quake, writer.uint32(226).fork()).join();
    }
    if (message.maintenanceInfo !== undefined) {
      MaintenanceInfo.encode(message.maintenanceInfo, writer.uint32(234).fork()).join();
    }
    if (message.replayChunk !== undefined) {
      ReplayChunk.encode(message.replayChunk, writer.uint32(242).fork()).join();
    }
    if (message.arcadeHosting !== undefined) {
      ArcadeHosting.encode(message.arcadeHosting, writer.uint32(250).fork()).join();
    }
    if (message.achievementUnlock !== undefined) {
      AchievementUnlock.encode(message.achievementUnlock, writer.uint32(258).fork()).join();
    }
    if (message.casinoLobby !== undefined) {
      CasinoLobby.encode(message.casinoLobby, writer.uint32(266).fork()).join();
    }
    if (message.casinoTable !== undefined) {
      CasinoTable.encode(message.casinoTable, writer.uint32(274).fork()).join();
    }
    if (message.casinoResult !== undefined) {
      CasinoResult.encode(message.casinoResult, writer.uint32(282).fork()).join();
    }
    if (message.markers !== undefined) {
      Markers.encode(message.markers, writer.uint32(290).fork()).join();
    }
    if (message.production !== undefined) {
      ProductionState.encode(message.production, writer.uint32(298).fork()).join();
    }
    if (message.seasonSummary !== undefined) {
      SeasonSummary.encode(message.seasonSummary, writer.uint32(306).fork()).join();
    }
    if (message.timelapse !== undefined) {
      TimelapseState.encode(message.timelapse, writer.uint32(314).fork()).join();
    }
    if (message.returnBriefing !== undefined) {
      ReturnBriefing.encode(message.returnBriefing, writer.uint32(322).fork()).join();
    }
    if (message.buildingPreview !== undefined) {
      BuildingPreview.encode(message.buildingPreview, writer.uint32(330).fork()).join();
    }
    if (message.inboxLedger !== undefined) {
      InboxLedgerState.encode(message.inboxLedger, writer.uint32(338).fork()).join();
    }
    if (message.settlement !== undefined) {
      SettlementClock.encode(message.settlement, writer.uint32(346).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.hello = Hello.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.state = State.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pong = Pong.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.siteOwner = SiteOwner.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.empire = Empire.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.events = Events.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.notice = Notice.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.siteAdded = SiteAdded.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.chat = ChatMsg.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.clan = ClanInfo.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.sieges = Sieges.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.scoreboard = Scoreboard.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.seasonReport = SeasonReport.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.market = Market.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.war = WarState.decode(reader, reader.uint32());
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.devBuild = DevBuild.decode(reader, reader.uint32());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.inbox = Inbox.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.replay = Replay.decode(reader, reader.uint32());
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.heatmap = Heatmap.decode(reader, reader.uint32());
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.siteRemoved = SiteRemoved.decode(reader, reader.uint32());
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.arcadeQueue = ArcadeQueue.decode(reader, reader.uint32());
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.arcadeMatch = ArcadeMatchFound.decode(reader, reader.uint32());
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.arcadePhase = ArcadePhase.decode(reader, reader.uint32());
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.arcadeSummary = ArcadeSummary.decode(reader, reader.uint32());
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.wrecks = Wrecks.decode(reader, reader.uint32());
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.quake = QuakeInfo.decode(reader, reader.uint32());
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.maintenanceInfo = MaintenanceInfo.decode(reader, reader.uint32());
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.replayChunk = ReplayChunk.decode(reader, reader.uint32());
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.arcadeHosting = ArcadeHosting.decode(reader, reader.uint32());
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.achievementUnlock = AchievementUnlock.decode(reader, reader.uint32());
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.casinoLobby = CasinoLobby.decode(reader, reader.uint32());
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.casinoTable = CasinoTable.decode(reader, reader.uint32());
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.casinoResult = CasinoResult.decode(reader, reader.uint32());
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.markers = Markers.decode(reader, reader.uint32());
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.production = ProductionState.decode(reader, reader.uint32());
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.seasonSummary = SeasonSummary.decode(reader, reader.uint32());
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.timelapse = TimelapseState.decode(reader, reader.uint32());
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.returnBriefing = ReturnBriefing.decode(reader, reader.uint32());
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.buildingPreview = BuildingPreview.decode(reader, reader.uint32());
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.inboxLedger = InboxLedgerState.decode(reader, reader.uint32());
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.settlement = SettlementClock.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ServerMsg>, I>>(base?: I): ServerMsg {
    return ServerMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerMsg>, I>>(object: I): ServerMsg {
    const message = createBaseServerMsg();
    message.hello = (object.hello !== undefined && object.hello !== null) ? Hello.fromPartial(object.hello) : undefined;
    message.state = (object.state !== undefined && object.state !== null) ? State.fromPartial(object.state) : undefined;
    message.pong = (object.pong !== undefined && object.pong !== null) ? Pong.fromPartial(object.pong) : undefined;
    message.siteOwner = (object.siteOwner !== undefined && object.siteOwner !== null)
      ? SiteOwner.fromPartial(object.siteOwner)
      : undefined;
    message.empire = (object.empire !== undefined && object.empire !== null)
      ? Empire.fromPartial(object.empire)
      : undefined;
    message.events = (object.events !== undefined && object.events !== null)
      ? Events.fromPartial(object.events)
      : undefined;
    message.notice = (object.notice !== undefined && object.notice !== null)
      ? Notice.fromPartial(object.notice)
      : undefined;
    message.siteAdded = (object.siteAdded !== undefined && object.siteAdded !== null)
      ? SiteAdded.fromPartial(object.siteAdded)
      : undefined;
    message.chat = (object.chat !== undefined && object.chat !== null) ? ChatMsg.fromPartial(object.chat) : undefined;
    message.clan = (object.clan !== undefined && object.clan !== null) ? ClanInfo.fromPartial(object.clan) : undefined;
    message.sieges = (object.sieges !== undefined && object.sieges !== null)
      ? Sieges.fromPartial(object.sieges)
      : undefined;
    message.scoreboard = (object.scoreboard !== undefined && object.scoreboard !== null)
      ? Scoreboard.fromPartial(object.scoreboard)
      : undefined;
    message.seasonReport = (object.seasonReport !== undefined && object.seasonReport !== null)
      ? SeasonReport.fromPartial(object.seasonReport)
      : undefined;
    message.market = (object.market !== undefined && object.market !== null)
      ? Market.fromPartial(object.market)
      : undefined;
    message.war = (object.war !== undefined && object.war !== null) ? WarState.fromPartial(object.war) : undefined;
    message.devBuild = (object.devBuild !== undefined && object.devBuild !== null)
      ? DevBuild.fromPartial(object.devBuild)
      : undefined;
    message.inbox = (object.inbox !== undefined && object.inbox !== null) ? Inbox.fromPartial(object.inbox) : undefined;
    message.replay = (object.replay !== undefined && object.replay !== null)
      ? Replay.fromPartial(object.replay)
      : undefined;
    message.heatmap = (object.heatmap !== undefined && object.heatmap !== null)
      ? Heatmap.fromPartial(object.heatmap)
      : undefined;
    message.siteRemoved = (object.siteRemoved !== undefined && object.siteRemoved !== null)
      ? SiteRemoved.fromPartial(object.siteRemoved)
      : undefined;
    message.arcadeQueue = (object.arcadeQueue !== undefined && object.arcadeQueue !== null)
      ? ArcadeQueue.fromPartial(object.arcadeQueue)
      : undefined;
    message.arcadeMatch = (object.arcadeMatch !== undefined && object.arcadeMatch !== null)
      ? ArcadeMatchFound.fromPartial(object.arcadeMatch)
      : undefined;
    message.arcadePhase = (object.arcadePhase !== undefined && object.arcadePhase !== null)
      ? ArcadePhase.fromPartial(object.arcadePhase)
      : undefined;
    message.arcadeSummary = (object.arcadeSummary !== undefined && object.arcadeSummary !== null)
      ? ArcadeSummary.fromPartial(object.arcadeSummary)
      : undefined;
    message.wrecks = (object.wrecks !== undefined && object.wrecks !== null)
      ? Wrecks.fromPartial(object.wrecks)
      : undefined;
    message.quake = (object.quake !== undefined && object.quake !== null)
      ? QuakeInfo.fromPartial(object.quake)
      : undefined;
    message.maintenanceInfo = (object.maintenanceInfo !== undefined && object.maintenanceInfo !== null)
      ? MaintenanceInfo.fromPartial(object.maintenanceInfo)
      : undefined;
    message.replayChunk = (object.replayChunk !== undefined && object.replayChunk !== null)
      ? ReplayChunk.fromPartial(object.replayChunk)
      : undefined;
    message.arcadeHosting = (object.arcadeHosting !== undefined && object.arcadeHosting !== null)
      ? ArcadeHosting.fromPartial(object.arcadeHosting)
      : undefined;
    message.achievementUnlock = (object.achievementUnlock !== undefined && object.achievementUnlock !== null)
      ? AchievementUnlock.fromPartial(object.achievementUnlock)
      : undefined;
    message.casinoLobby = (object.casinoLobby !== undefined && object.casinoLobby !== null)
      ? CasinoLobby.fromPartial(object.casinoLobby)
      : undefined;
    message.casinoTable = (object.casinoTable !== undefined && object.casinoTable !== null)
      ? CasinoTable.fromPartial(object.casinoTable)
      : undefined;
    message.casinoResult = (object.casinoResult !== undefined && object.casinoResult !== null)
      ? CasinoResult.fromPartial(object.casinoResult)
      : undefined;
    message.markers = (object.markers !== undefined && object.markers !== null)
      ? Markers.fromPartial(object.markers)
      : undefined;
    message.production = (object.production !== undefined && object.production !== null)
      ? ProductionState.fromPartial(object.production)
      : undefined;
    message.seasonSummary = (object.seasonSummary !== undefined && object.seasonSummary !== null)
      ? SeasonSummary.fromPartial(object.seasonSummary)
      : undefined;
    message.timelapse = (object.timelapse !== undefined && object.timelapse !== null)
      ? TimelapseState.fromPartial(object.timelapse)
      : undefined;
    message.returnBriefing = (object.returnBriefing !== undefined && object.returnBriefing !== null)
      ? ReturnBriefing.fromPartial(object.returnBriefing)
      : undefined;
    message.buildingPreview = (object.buildingPreview !== undefined && object.buildingPreview !== null)
      ? BuildingPreview.fromPartial(object.buildingPreview)
      : undefined;
    message.inboxLedger = (object.inboxLedger !== undefined && object.inboxLedger !== null)
      ? InboxLedgerState.fromPartial(object.inboxLedger)
      : undefined;
    message.settlement = (object.settlement !== undefined && object.settlement !== null)
      ? SettlementClock.fromPartial(object.settlement)
      : undefined;
    return message;
  },
};

function createBaseAchievementUnlock(): AchievementUnlock {
  return { code: "", grade: 0, value: 0, kind: 0 };
}

export const AchievementUnlock: MessageFns<AchievementUnlock> = {
  encode(message: AchievementUnlock, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.grade !== 0) {
      writer.uint32(16).uint32(message.grade);
    }
    if (message.value !== 0) {
      writer.uint32(24).uint64(message.value);
    }
    if (message.kind !== 0) {
      writer.uint32(32).uint32(message.kind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AchievementUnlock {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAchievementUnlock();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.grade = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.value = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.kind = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<AchievementUnlock>, I>>(base?: I): AchievementUnlock {
    return AchievementUnlock.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AchievementUnlock>, I>>(object: I): AchievementUnlock {
    const message = createBaseAchievementUnlock();
    message.code = object.code ?? "";
    message.grade = object.grade ?? 0;
    message.value = object.value ?? 0;
    message.kind = object.kind ?? 0;
    return message;
  },
};

function createBaseClientMsg(): ClientMsg {
  return {
    order: undefined,
    view: undefined,
    ping: undefined,
    enqueue: undefined,
    job: undefined,
    createFleet: undefined,
    fleetAction: undefined,
    captain: undefined,
    chat: undefined,
    clan: undefined,
    siege: undefined,
    invent: undefined,
    expedition: undefined,
    design: undefined,
    fire: undefined,
    market: undefined,
    admin: undefined,
    warQuery: undefined,
    inbox: undefined,
    heatmapMode: undefined,
    empireSetting: undefined,
    arcadeQueueJoin: undefined,
    arcadeQueueLeave: undefined,
    arcadeBuild: undefined,
    controlGroup: undefined,
    resync: undefined,
    arcadeInput: undefined,
    arcadeHost: undefined,
    arcadeHostJoin: undefined,
    arcadeHostAction: undefined,
    controlGroupRecall: undefined,
    casinoQueueJoin: undefined,
    casinoQueueLeave: undefined,
    casinoJoinTable: undefined,
    casinoLeave: undefined,
    casinoAct: undefined,
    casinoSpin: undefined,
    renameFleet: undefined,
    markerAction: undefined,
    inboxReplace: undefined,
    report: undefined,
    block: undefined,
    productionQuery: undefined,
    arcadeDrill: undefined,
    arcadeDrillNext: undefined,
    timelapseQuery: undefined,
    previewQuery: undefined,
    inboxLedgerQuery: undefined,
    arcadeSurrender: undefined,
    plot: undefined,
    nameSeamount: undefined,
    commission: undefined,
    cache: undefined,
    windowCommit: undefined,
  };
}

export const ClientMsg: MessageFns<ClientMsg> = {
  encode(message: ClientMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.order !== undefined) {
      FleetOrder.encode(message.order, writer.uint32(10).fork()).join();
    }
    if (message.view !== undefined) {
      Viewport.encode(message.view, writer.uint32(18).fork()).join();
    }
    if (message.ping !== undefined) {
      Ping.encode(message.ping, writer.uint32(26).fork()).join();
    }
    if (message.enqueue !== undefined) {
      Enqueue.encode(message.enqueue, writer.uint32(34).fork()).join();
    }
    if (message.job !== undefined) {
      JobAction.encode(message.job, writer.uint32(42).fork()).join();
    }
    if (message.createFleet !== undefined) {
      CreateFleet.encode(message.createFleet, writer.uint32(50).fork()).join();
    }
    if (message.fleetAction !== undefined) {
      FleetAction.encode(message.fleetAction, writer.uint32(58).fork()).join();
    }
    if (message.captain !== undefined) {
      CaptainAction.encode(message.captain, writer.uint32(66).fork()).join();
    }
    if (message.chat !== undefined) {
      Chat.encode(message.chat, writer.uint32(74).fork()).join();
    }
    if (message.clan !== undefined) {
      ClanAction.encode(message.clan, writer.uint32(82).fork()).join();
    }
    if (message.siege !== undefined) {
      SiegeAction.encode(message.siege, writer.uint32(90).fork()).join();
    }
    if (message.invent !== undefined) {
      Invent.encode(message.invent, writer.uint32(98).fork()).join();
    }
    if (message.expedition !== undefined) {
      ExpeditionOrder.encode(message.expedition, writer.uint32(106).fork()).join();
    }
    if (message.design !== undefined) {
      DesignAction.encode(message.design, writer.uint32(114).fork()).join();
    }
    if (message.fire !== undefined) {
      FireOrder.encode(message.fire, writer.uint32(122).fork()).join();
    }
    if (message.market !== undefined) {
      MarketAction.encode(message.market, writer.uint32(130).fork()).join();
    }
    if (message.admin !== undefined) {
      AdminAction.encode(message.admin, writer.uint32(138).fork()).join();
    }
    if (message.warQuery !== undefined) {
      WarQuery.encode(message.warQuery, writer.uint32(146).fork()).join();
    }
    if (message.inbox !== undefined) {
      InboxAction.encode(message.inbox, writer.uint32(154).fork()).join();
    }
    if (message.heatmapMode !== undefined) {
      HeatmapMode.encode(message.heatmapMode, writer.uint32(162).fork()).join();
    }
    if (message.empireSetting !== undefined) {
      EmpireSetting.encode(message.empireSetting, writer.uint32(170).fork()).join();
    }
    if (message.arcadeQueueJoin !== undefined) {
      ArcadeQueueJoin.encode(message.arcadeQueueJoin, writer.uint32(178).fork()).join();
    }
    if (message.arcadeQueueLeave !== undefined) {
      ArcadeQueueLeave.encode(message.arcadeQueueLeave, writer.uint32(186).fork()).join();
    }
    if (message.arcadeBuild !== undefined) {
      ArcadeBuild.encode(message.arcadeBuild, writer.uint32(194).fork()).join();
    }
    if (message.controlGroup !== undefined) {
      ControlGroup.encode(message.controlGroup, writer.uint32(202).fork()).join();
    }
    if (message.resync !== undefined) {
      Resync.encode(message.resync, writer.uint32(218).fork()).join();
    }
    if (message.arcadeInput !== undefined) {
      ArcadeInput.encode(message.arcadeInput, writer.uint32(226).fork()).join();
    }
    if (message.arcadeHost !== undefined) {
      ArcadeHost.encode(message.arcadeHost, writer.uint32(234).fork()).join();
    }
    if (message.arcadeHostJoin !== undefined) {
      ArcadeHostJoin.encode(message.arcadeHostJoin, writer.uint32(242).fork()).join();
    }
    if (message.arcadeHostAction !== undefined) {
      ArcadeHostAction.encode(message.arcadeHostAction, writer.uint32(250).fork()).join();
    }
    if (message.controlGroupRecall !== undefined) {
      ControlGroupRecall.encode(message.controlGroupRecall, writer.uint32(258).fork()).join();
    }
    if (message.casinoQueueJoin !== undefined) {
      CasinoQueueJoin.encode(message.casinoQueueJoin, writer.uint32(266).fork()).join();
    }
    if (message.casinoQueueLeave !== undefined) {
      CasinoQueueLeave.encode(message.casinoQueueLeave, writer.uint32(274).fork()).join();
    }
    if (message.casinoJoinTable !== undefined) {
      CasinoJoinTable.encode(message.casinoJoinTable, writer.uint32(282).fork()).join();
    }
    if (message.casinoLeave !== undefined) {
      CasinoLeave.encode(message.casinoLeave, writer.uint32(290).fork()).join();
    }
    if (message.casinoAct !== undefined) {
      CasinoAct.encode(message.casinoAct, writer.uint32(298).fork()).join();
    }
    if (message.casinoSpin !== undefined) {
      CasinoSpin.encode(message.casinoSpin, writer.uint32(306).fork()).join();
    }
    if (message.renameFleet !== undefined) {
      RenameFleet.encode(message.renameFleet, writer.uint32(314).fork()).join();
    }
    if (message.markerAction !== undefined) {
      MarkerAction.encode(message.markerAction, writer.uint32(322).fork()).join();
    }
    if (message.inboxReplace !== undefined) {
      InboxReplace.encode(message.inboxReplace, writer.uint32(330).fork()).join();
    }
    if (message.report !== undefined) {
      Report.encode(message.report, writer.uint32(338).fork()).join();
    }
    if (message.block !== undefined) {
      Block.encode(message.block, writer.uint32(346).fork()).join();
    }
    if (message.productionQuery !== undefined) {
      ProductionQuery.encode(message.productionQuery, writer.uint32(354).fork()).join();
    }
    if (message.arcadeDrill !== undefined) {
      ArcadeDrill.encode(message.arcadeDrill, writer.uint32(362).fork()).join();
    }
    if (message.arcadeDrillNext !== undefined) {
      ArcadeDrillNext.encode(message.arcadeDrillNext, writer.uint32(370).fork()).join();
    }
    if (message.timelapseQuery !== undefined) {
      TimelapseQuery.encode(message.timelapseQuery, writer.uint32(378).fork()).join();
    }
    if (message.previewQuery !== undefined) {
      PreviewQuery.encode(message.previewQuery, writer.uint32(386).fork()).join();
    }
    if (message.inboxLedgerQuery !== undefined) {
      InboxLedgerQuery.encode(message.inboxLedgerQuery, writer.uint32(394).fork()).join();
    }
    if (message.arcadeSurrender !== undefined) {
      ArcadeSurrender.encode(message.arcadeSurrender, writer.uint32(402).fork()).join();
    }
    if (message.plot !== undefined) {
      PlotAction.encode(message.plot, writer.uint32(410).fork()).join();
    }
    if (message.nameSeamount !== undefined) {
      NameSeamount.encode(message.nameSeamount, writer.uint32(418).fork()).join();
    }
    if (message.commission !== undefined) {
      CommissionAction.encode(message.commission, writer.uint32(426).fork()).join();
    }
    if (message.cache !== undefined) {
      CacheAction.encode(message.cache, writer.uint32(434).fork()).join();
    }
    if (message.windowCommit !== undefined) {
      WindowCommit.encode(message.windowCommit, writer.uint32(442).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClientMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.order = FleetOrder.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.view = Viewport.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ping = Ping.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.enqueue = Enqueue.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.job = JobAction.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createFleet = CreateFleet.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fleetAction = FleetAction.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.captain = CaptainAction.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.chat = Chat.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.clan = ClanAction.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.siege = SiegeAction.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.invent = Invent.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.expedition = ExpeditionOrder.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.design = DesignAction.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.fire = FireOrder.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.market = MarketAction.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.admin = AdminAction.decode(reader, reader.uint32());
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.warQuery = WarQuery.decode(reader, reader.uint32());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.inbox = InboxAction.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.heatmapMode = HeatmapMode.decode(reader, reader.uint32());
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.empireSetting = EmpireSetting.decode(reader, reader.uint32());
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.arcadeQueueJoin = ArcadeQueueJoin.decode(reader, reader.uint32());
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.arcadeQueueLeave = ArcadeQueueLeave.decode(reader, reader.uint32());
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.arcadeBuild = ArcadeBuild.decode(reader, reader.uint32());
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.controlGroup = ControlGroup.decode(reader, reader.uint32());
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.resync = Resync.decode(reader, reader.uint32());
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.arcadeInput = ArcadeInput.decode(reader, reader.uint32());
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.arcadeHost = ArcadeHost.decode(reader, reader.uint32());
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.arcadeHostJoin = ArcadeHostJoin.decode(reader, reader.uint32());
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.arcadeHostAction = ArcadeHostAction.decode(reader, reader.uint32());
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.controlGroupRecall = ControlGroupRecall.decode(reader, reader.uint32());
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.casinoQueueJoin = CasinoQueueJoin.decode(reader, reader.uint32());
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.casinoQueueLeave = CasinoQueueLeave.decode(reader, reader.uint32());
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.casinoJoinTable = CasinoJoinTable.decode(reader, reader.uint32());
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.casinoLeave = CasinoLeave.decode(reader, reader.uint32());
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.casinoAct = CasinoAct.decode(reader, reader.uint32());
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.casinoSpin = CasinoSpin.decode(reader, reader.uint32());
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.renameFleet = RenameFleet.decode(reader, reader.uint32());
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.markerAction = MarkerAction.decode(reader, reader.uint32());
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.inboxReplace = InboxReplace.decode(reader, reader.uint32());
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.report = Report.decode(reader, reader.uint32());
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.block = Block.decode(reader, reader.uint32());
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.productionQuery = ProductionQuery.decode(reader, reader.uint32());
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.arcadeDrill = ArcadeDrill.decode(reader, reader.uint32());
          continue;
        }
        case 46: {
          if (tag !== 370) {
            break;
          }

          message.arcadeDrillNext = ArcadeDrillNext.decode(reader, reader.uint32());
          continue;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.timelapseQuery = TimelapseQuery.decode(reader, reader.uint32());
          continue;
        }
        case 48: {
          if (tag !== 386) {
            break;
          }

          message.previewQuery = PreviewQuery.decode(reader, reader.uint32());
          continue;
        }
        case 49: {
          if (tag !== 394) {
            break;
          }

          message.inboxLedgerQuery = InboxLedgerQuery.decode(reader, reader.uint32());
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.arcadeSurrender = ArcadeSurrender.decode(reader, reader.uint32());
          continue;
        }
        case 51: {
          if (tag !== 410) {
            break;
          }

          message.plot = PlotAction.decode(reader, reader.uint32());
          continue;
        }
        case 52: {
          if (tag !== 418) {
            break;
          }

          message.nameSeamount = NameSeamount.decode(reader, reader.uint32());
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.commission = CommissionAction.decode(reader, reader.uint32());
          continue;
        }
        case 54: {
          if (tag !== 434) {
            break;
          }

          message.cache = CacheAction.decode(reader, reader.uint32());
          continue;
        }
        case 55: {
          if (tag !== 442) {
            break;
          }

          message.windowCommit = WindowCommit.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ClientMsg>, I>>(base?: I): ClientMsg {
    return ClientMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClientMsg>, I>>(object: I): ClientMsg {
    const message = createBaseClientMsg();
    message.order = (object.order !== undefined && object.order !== null)
      ? FleetOrder.fromPartial(object.order)
      : undefined;
    message.view = (object.view !== undefined && object.view !== null) ? Viewport.fromPartial(object.view) : undefined;
    message.ping = (object.ping !== undefined && object.ping !== null) ? Ping.fromPartial(object.ping) : undefined;
    message.enqueue = (object.enqueue !== undefined && object.enqueue !== null)
      ? Enqueue.fromPartial(object.enqueue)
      : undefined;
    message.job = (object.job !== undefined && object.job !== null) ? JobAction.fromPartial(object.job) : undefined;
    message.createFleet = (object.createFleet !== undefined && object.createFleet !== null)
      ? CreateFleet.fromPartial(object.createFleet)
      : undefined;
    message.fleetAction = (object.fleetAction !== undefined && object.fleetAction !== null)
      ? FleetAction.fromPartial(object.fleetAction)
      : undefined;
    message.captain = (object.captain !== undefined && object.captain !== null)
      ? CaptainAction.fromPartial(object.captain)
      : undefined;
    message.chat = (object.chat !== undefined && object.chat !== null) ? Chat.fromPartial(object.chat) : undefined;
    message.clan = (object.clan !== undefined && object.clan !== null)
      ? ClanAction.fromPartial(object.clan)
      : undefined;
    message.siege = (object.siege !== undefined && object.siege !== null)
      ? SiegeAction.fromPartial(object.siege)
      : undefined;
    message.invent = (object.invent !== undefined && object.invent !== null)
      ? Invent.fromPartial(object.invent)
      : undefined;
    message.expedition = (object.expedition !== undefined && object.expedition !== null)
      ? ExpeditionOrder.fromPartial(object.expedition)
      : undefined;
    message.design = (object.design !== undefined && object.design !== null)
      ? DesignAction.fromPartial(object.design)
      : undefined;
    message.fire = (object.fire !== undefined && object.fire !== null) ? FireOrder.fromPartial(object.fire) : undefined;
    message.market = (object.market !== undefined && object.market !== null)
      ? MarketAction.fromPartial(object.market)
      : undefined;
    message.admin = (object.admin !== undefined && object.admin !== null)
      ? AdminAction.fromPartial(object.admin)
      : undefined;
    message.warQuery = (object.warQuery !== undefined && object.warQuery !== null)
      ? WarQuery.fromPartial(object.warQuery)
      : undefined;
    message.inbox = (object.inbox !== undefined && object.inbox !== null)
      ? InboxAction.fromPartial(object.inbox)
      : undefined;
    message.heatmapMode = (object.heatmapMode !== undefined && object.heatmapMode !== null)
      ? HeatmapMode.fromPartial(object.heatmapMode)
      : undefined;
    message.empireSetting = (object.empireSetting !== undefined && object.empireSetting !== null)
      ? EmpireSetting.fromPartial(object.empireSetting)
      : undefined;
    message.arcadeQueueJoin = (object.arcadeQueueJoin !== undefined && object.arcadeQueueJoin !== null)
      ? ArcadeQueueJoin.fromPartial(object.arcadeQueueJoin)
      : undefined;
    message.arcadeQueueLeave = (object.arcadeQueueLeave !== undefined && object.arcadeQueueLeave !== null)
      ? ArcadeQueueLeave.fromPartial(object.arcadeQueueLeave)
      : undefined;
    message.arcadeBuild = (object.arcadeBuild !== undefined && object.arcadeBuild !== null)
      ? ArcadeBuild.fromPartial(object.arcadeBuild)
      : undefined;
    message.controlGroup = (object.controlGroup !== undefined && object.controlGroup !== null)
      ? ControlGroup.fromPartial(object.controlGroup)
      : undefined;
    message.resync = (object.resync !== undefined && object.resync !== null)
      ? Resync.fromPartial(object.resync)
      : undefined;
    message.arcadeInput = (object.arcadeInput !== undefined && object.arcadeInput !== null)
      ? ArcadeInput.fromPartial(object.arcadeInput)
      : undefined;
    message.arcadeHost = (object.arcadeHost !== undefined && object.arcadeHost !== null)
      ? ArcadeHost.fromPartial(object.arcadeHost)
      : undefined;
    message.arcadeHostJoin = (object.arcadeHostJoin !== undefined && object.arcadeHostJoin !== null)
      ? ArcadeHostJoin.fromPartial(object.arcadeHostJoin)
      : undefined;
    message.arcadeHostAction = (object.arcadeHostAction !== undefined && object.arcadeHostAction !== null)
      ? ArcadeHostAction.fromPartial(object.arcadeHostAction)
      : undefined;
    message.controlGroupRecall = (object.controlGroupRecall !== undefined && object.controlGroupRecall !== null)
      ? ControlGroupRecall.fromPartial(object.controlGroupRecall)
      : undefined;
    message.casinoQueueJoin = (object.casinoQueueJoin !== undefined && object.casinoQueueJoin !== null)
      ? CasinoQueueJoin.fromPartial(object.casinoQueueJoin)
      : undefined;
    message.casinoQueueLeave = (object.casinoQueueLeave !== undefined && object.casinoQueueLeave !== null)
      ? CasinoQueueLeave.fromPartial(object.casinoQueueLeave)
      : undefined;
    message.casinoJoinTable = (object.casinoJoinTable !== undefined && object.casinoJoinTable !== null)
      ? CasinoJoinTable.fromPartial(object.casinoJoinTable)
      : undefined;
    message.casinoLeave = (object.casinoLeave !== undefined && object.casinoLeave !== null)
      ? CasinoLeave.fromPartial(object.casinoLeave)
      : undefined;
    message.casinoAct = (object.casinoAct !== undefined && object.casinoAct !== null)
      ? CasinoAct.fromPartial(object.casinoAct)
      : undefined;
    message.casinoSpin = (object.casinoSpin !== undefined && object.casinoSpin !== null)
      ? CasinoSpin.fromPartial(object.casinoSpin)
      : undefined;
    message.renameFleet = (object.renameFleet !== undefined && object.renameFleet !== null)
      ? RenameFleet.fromPartial(object.renameFleet)
      : undefined;
    message.markerAction = (object.markerAction !== undefined && object.markerAction !== null)
      ? MarkerAction.fromPartial(object.markerAction)
      : undefined;
    message.inboxReplace = (object.inboxReplace !== undefined && object.inboxReplace !== null)
      ? InboxReplace.fromPartial(object.inboxReplace)
      : undefined;
    message.report = (object.report !== undefined && object.report !== null)
      ? Report.fromPartial(object.report)
      : undefined;
    message.block = (object.block !== undefined && object.block !== null) ? Block.fromPartial(object.block) : undefined;
    message.productionQuery = (object.productionQuery !== undefined && object.productionQuery !== null)
      ? ProductionQuery.fromPartial(object.productionQuery)
      : undefined;
    message.arcadeDrill = (object.arcadeDrill !== undefined && object.arcadeDrill !== null)
      ? ArcadeDrill.fromPartial(object.arcadeDrill)
      : undefined;
    message.arcadeDrillNext = (object.arcadeDrillNext !== undefined && object.arcadeDrillNext !== null)
      ? ArcadeDrillNext.fromPartial(object.arcadeDrillNext)
      : undefined;
    message.timelapseQuery = (object.timelapseQuery !== undefined && object.timelapseQuery !== null)
      ? TimelapseQuery.fromPartial(object.timelapseQuery)
      : undefined;
    message.previewQuery = (object.previewQuery !== undefined && object.previewQuery !== null)
      ? PreviewQuery.fromPartial(object.previewQuery)
      : undefined;
    message.inboxLedgerQuery = (object.inboxLedgerQuery !== undefined && object.inboxLedgerQuery !== null)
      ? InboxLedgerQuery.fromPartial(object.inboxLedgerQuery)
      : undefined;
    message.arcadeSurrender = (object.arcadeSurrender !== undefined && object.arcadeSurrender !== null)
      ? ArcadeSurrender.fromPartial(object.arcadeSurrender)
      : undefined;
    message.plot = (object.plot !== undefined && object.plot !== null)
      ? PlotAction.fromPartial(object.plot)
      : undefined;
    message.nameSeamount = (object.nameSeamount !== undefined && object.nameSeamount !== null)
      ? NameSeamount.fromPartial(object.nameSeamount)
      : undefined;
    message.commission = (object.commission !== undefined && object.commission !== null)
      ? CommissionAction.fromPartial(object.commission)
      : undefined;
    message.cache = (object.cache !== undefined && object.cache !== null)
      ? CacheAction.fromPartial(object.cache)
      : undefined;
    message.windowCommit = (object.windowCommit !== undefined && object.windowCommit !== null)
      ? WindowCommit.fromPartial(object.windowCommit)
      : undefined;
    return message;
  },
};

function createBaseWindowCommit(): WindowCommit {
  return { siteId: 0, withdraw: false };
}

export const WindowCommit: MessageFns<WindowCommit> = {
  encode(message: WindowCommit, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.siteId !== 0) {
      writer.uint32(8).uint32(message.siteId);
    }
    if (message.withdraw !== false) {
      writer.uint32(16).bool(message.withdraw);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WindowCommit {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWindowCommit();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.siteId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.withdraw = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<WindowCommit>, I>>(base?: I): WindowCommit {
    return WindowCommit.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WindowCommit>, I>>(object: I): WindowCommit {
    const message = createBaseWindowCommit();
    message.siteId = object.siteId ?? 0;
    message.withdraw = object.withdraw ?? false;
    return message;
  },
};

function createBaseCacheAction(): CacheAction {
  return { op: 0, fleetId: 0, cacheId: 0, text: "", phrase: 0 };
}

export const CacheAction: MessageFns<CacheAction> = {
  encode(message: CacheAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.op !== 0) {
      writer.uint32(8).int32(message.op);
    }
    if (message.fleetId !== 0) {
      writer.uint32(16).uint32(message.fleetId);
    }
    if (message.cacheId !== 0) {
      writer.uint32(24).uint32(message.cacheId);
    }
    if (message.text !== "") {
      writer.uint32(34).string(message.text);
    }
    if (message.phrase !== 0) {
      writer.uint32(40).uint32(message.phrase);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CacheAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCacheAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.op = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cacheId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.phrase = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CacheAction>, I>>(base?: I): CacheAction {
    return CacheAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CacheAction>, I>>(object: I): CacheAction {
    const message = createBaseCacheAction();
    message.op = object.op ?? 0;
    message.fleetId = object.fleetId ?? 0;
    message.cacheId = object.cacheId ?? 0;
    message.text = object.text ?? "";
    message.phrase = object.phrase ?? 0;
    return message;
  },
};

function createBaseHello(): Hello {
  return {
    protocol: 0,
    cols: 0,
    rows: 0,
    faction: 0,
    owners: new Uint8Array(0),
    blocked: new Uint8Array(0),
    tick: 0,
    sites: [],
    token: "",
    playerId: 0,
    playerName: "",
    homeCell: 0,
    season: 0,
    seasonEndsUnix: 0,
    timescale: 0,
    catalog: undefined,
    worldId: 0,
    worldName: "",
    region: "",
    population: 0,
    worlds: [],
    accountId: 0,
    cataclysm: false,
    honour: 0,
    title: "",
    admin: false,
    truceLeftSec: 0,
    tacticalScale: 0,
    adminReveal: false,
    adminAutopilot: false,
    mode: 0,
    clockSec: 0,
    features: [],
    arcade: undefined,
    build: "",
    pack: "",
    wrecks: [],
    quake: undefined,
    monuments: [],
    namedTrenches: [],
    banners: [],
    featureFlags: [],
    regenCalmMapSec: 0,
    settlement: undefined,
    clockOriginSec: 0,
    depth: new Uint8Array(0),
    currents: new Uint8Array(0),
    survey: new Uint8Array(0),
    pois: [],
    namedSeamounts: [],
    fairways: [],
    buoys: [],
    adminCaches: false,
    adminVeil: false,
    factions: [],
  };
}

export const Hello: MessageFns<Hello> = {
  encode(message: Hello, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.protocol !== 0) {
      writer.uint32(8).uint32(message.protocol);
    }
    if (message.cols !== 0) {
      writer.uint32(16).uint32(message.cols);
    }
    if (message.rows !== 0) {
      writer.uint32(24).uint32(message.rows);
    }
    if (message.faction !== 0) {
      writer.uint32(32).uint32(message.faction);
    }
    if (message.owners.length !== 0) {
      writer.uint32(42).bytes(message.owners);
    }
    if (message.blocked.length !== 0) {
      writer.uint32(50).bytes(message.blocked);
    }
    if (message.tick !== 0) {
      writer.uint32(56).uint64(message.tick);
    }
    for (const v of message.sites) {
      Site.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.token !== "") {
      writer.uint32(74).string(message.token);
    }
    if (message.playerId !== 0) {
      writer.uint32(80).uint32(message.playerId);
    }
    if (message.playerName !== "") {
      writer.uint32(90).string(message.playerName);
    }
    if (message.homeCell !== 0) {
      writer.uint32(96).uint32(message.homeCell);
    }
    if (message.season !== 0) {
      writer.uint32(104).uint32(message.season);
    }
    if (message.seasonEndsUnix !== 0) {
      writer.uint32(112).uint64(message.seasonEndsUnix);
    }
    if (message.timescale !== 0) {
      writer.uint32(121).double(message.timescale);
    }
    if (message.catalog !== undefined) {
      Catalog.encode(message.catalog, writer.uint32(130).fork()).join();
    }
    if (message.worldId !== 0) {
      writer.uint32(136).uint32(message.worldId);
    }
    if (message.worldName !== "") {
      writer.uint32(146).string(message.worldName);
    }
    if (message.region !== "") {
      writer.uint32(154).string(message.region);
    }
    if (message.population !== 0) {
      writer.uint32(160).uint32(message.population);
    }
    for (const v of message.worlds) {
      WorldInfo.encode(v!, writer.uint32(170).fork()).join();
    }
    if (message.accountId !== 0) {
      writer.uint32(176).uint32(message.accountId);
    }
    if (message.cataclysm !== false) {
      writer.uint32(184).bool(message.cataclysm);
    }
    if (message.honour !== 0) {
      writer.uint32(192).uint32(message.honour);
    }
    if (message.title !== "") {
      writer.uint32(202).string(message.title);
    }
    if (message.admin !== false) {
      writer.uint32(208).bool(message.admin);
    }
    if (message.truceLeftSec !== 0) {
      writer.uint32(216).uint32(message.truceLeftSec);
    }
    if (message.tacticalScale !== 0) {
      writer.uint32(225).double(message.tacticalScale);
    }
    if (message.adminReveal !== false) {
      writer.uint32(232).bool(message.adminReveal);
    }
    if (message.adminAutopilot !== false) {
      writer.uint32(240).bool(message.adminAutopilot);
    }
    if (message.mode !== 0) {
      writer.uint32(248).uint32(message.mode);
    }
    if (message.clockSec !== 0) {
      writer.uint32(256).uint32(message.clockSec);
    }
    for (const v of message.features) {
      writer.uint32(266).string(v!);
    }
    if (message.arcade !== undefined) {
      ArcadeInfo.encode(message.arcade, writer.uint32(274).fork()).join();
    }
    if (message.build !== "") {
      writer.uint32(282).string(message.build);
    }
    if (message.pack !== "") {
      writer.uint32(290).string(message.pack);
    }
    for (const v of message.wrecks) {
      Wreck.encode(v!, writer.uint32(298).fork()).join();
    }
    if (message.quake !== undefined) {
      QuakeInfo.encode(message.quake, writer.uint32(306).fork()).join();
    }
    for (const v of message.monuments) {
      Monument.encode(v!, writer.uint32(314).fork()).join();
    }
    for (const v of message.namedTrenches) {
      NamedTrench.encode(v!, writer.uint32(322).fork()).join();
    }
    for (const v of message.banners) {
      WarBanner.encode(v!, writer.uint32(330).fork()).join();
    }
    for (const v of message.featureFlags) {
      writer.uint32(338).string(v!);
    }
    if (message.regenCalmMapSec !== 0) {
      writer.uint32(345).double(message.regenCalmMapSec);
    }
    if (message.settlement !== undefined) {
      SettlementClock.encode(message.settlement, writer.uint32(354).fork()).join();
    }
    if (message.clockOriginSec !== 0) {
      writer.uint32(360).uint32(message.clockOriginSec);
    }
    if (message.depth.length !== 0) {
      writer.uint32(370).bytes(message.depth);
    }
    if (message.currents.length !== 0) {
      writer.uint32(378).bytes(message.currents);
    }
    if (message.survey.length !== 0) {
      writer.uint32(386).bytes(message.survey);
    }
    for (const v of message.pois) {
      PointOfInterest.encode(v!, writer.uint32(394).fork()).join();
    }
    for (const v of message.namedSeamounts) {
      NamedSeamount.encode(v!, writer.uint32(402).fork()).join();
    }
    for (const v of message.fairways) {
      Fairway.encode(v!, writer.uint32(410).fork()).join();
    }
    for (const v of message.buoys) {
      FairwayBuoy.encode(v!, writer.uint32(418).fork()).join();
    }
    if (message.adminCaches !== false) {
      writer.uint32(424).bool(message.adminCaches);
    }
    if (message.adminVeil !== false) {
      writer.uint32(432).bool(message.adminVeil);
    }
    writer.uint32(442).fork();
    for (const v of message.factions) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Hello {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHello();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.protocol = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cols = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.rows = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.owners = reader.bytes();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.blocked = reader.bytes();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.tick = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.sites.push(Site.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.token = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.playerId = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.playerName = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.homeCell = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.season = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.seasonEndsUnix = longToNumber(reader.uint64());
          continue;
        }
        case 15: {
          if (tag !== 121) {
            break;
          }

          message.timescale = reader.double();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.catalog = Catalog.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.worldId = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.worldName = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.region = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.population = reader.uint32();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.worlds.push(WorldInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.accountId = reader.uint32();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.cataclysm = reader.bool();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.honour = reader.uint32();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.admin = reader.bool();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.truceLeftSec = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 225) {
            break;
          }

          message.tacticalScale = reader.double();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.adminReveal = reader.bool();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.adminAutopilot = reader.bool();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.mode = reader.uint32();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.clockSec = reader.uint32();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.features.push(reader.string());
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.arcade = ArcadeInfo.decode(reader, reader.uint32());
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.build = reader.string();
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.pack = reader.string();
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.wrecks.push(Wreck.decode(reader, reader.uint32()));
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.quake = QuakeInfo.decode(reader, reader.uint32());
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.monuments.push(Monument.decode(reader, reader.uint32()));
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.namedTrenches.push(NamedTrench.decode(reader, reader.uint32()));
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.banners.push(WarBanner.decode(reader, reader.uint32()));
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.featureFlags.push(reader.string());
          continue;
        }
        case 43: {
          if (tag !== 345) {
            break;
          }

          message.regenCalmMapSec = reader.double();
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.settlement = SettlementClock.decode(reader, reader.uint32());
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.clockOriginSec = reader.uint32();
          continue;
        }
        case 46: {
          if (tag !== 370) {
            break;
          }

          message.depth = reader.bytes();
          continue;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.currents = reader.bytes();
          continue;
        }
        case 48: {
          if (tag !== 386) {
            break;
          }

          message.survey = reader.bytes();
          continue;
        }
        case 49: {
          if (tag !== 394) {
            break;
          }

          message.pois.push(PointOfInterest.decode(reader, reader.uint32()));
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.namedSeamounts.push(NamedSeamount.decode(reader, reader.uint32()));
          continue;
        }
        case 51: {
          if (tag !== 410) {
            break;
          }

          message.fairways.push(Fairway.decode(reader, reader.uint32()));
          continue;
        }
        case 52: {
          if (tag !== 418) {
            break;
          }

          message.buoys.push(FairwayBuoy.decode(reader, reader.uint32()));
          continue;
        }
        case 53: {
          if (tag !== 424) {
            break;
          }

          message.adminCaches = reader.bool();
          continue;
        }
        case 54: {
          if (tag !== 432) {
            break;
          }

          message.adminVeil = reader.bool();
          continue;
        }
        case 55: {
          if (tag === 440) {
            message.factions.push(reader.uint32());

            continue;
          }

          if (tag === 442) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.factions.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Hello>, I>>(base?: I): Hello {
    return Hello.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Hello>, I>>(object: I): Hello {
    const message = createBaseHello();
    message.protocol = object.protocol ?? 0;
    message.cols = object.cols ?? 0;
    message.rows = object.rows ?? 0;
    message.faction = object.faction ?? 0;
    message.owners = object.owners ?? new Uint8Array(0);
    message.blocked = object.blocked ?? new Uint8Array(0);
    message.tick = object.tick ?? 0;
    message.sites = object.sites?.map((e) => Site.fromPartial(e)) || [];
    message.token = object.token ?? "";
    message.playerId = object.playerId ?? 0;
    message.playerName = object.playerName ?? "";
    message.homeCell = object.homeCell ?? 0;
    message.season = object.season ?? 0;
    message.seasonEndsUnix = object.seasonEndsUnix ?? 0;
    message.timescale = object.timescale ?? 0;
    message.catalog = (object.catalog !== undefined && object.catalog !== null)
      ? Catalog.fromPartial(object.catalog)
      : undefined;
    message.worldId = object.worldId ?? 0;
    message.worldName = object.worldName ?? "";
    message.region = object.region ?? "";
    message.population = object.population ?? 0;
    message.worlds = object.worlds?.map((e) => WorldInfo.fromPartial(e)) || [];
    message.accountId = object.accountId ?? 0;
    message.cataclysm = object.cataclysm ?? false;
    message.honour = object.honour ?? 0;
    message.title = object.title ?? "";
    message.admin = object.admin ?? false;
    message.truceLeftSec = object.truceLeftSec ?? 0;
    message.tacticalScale = object.tacticalScale ?? 0;
    message.adminReveal = object.adminReveal ?? false;
    message.adminAutopilot = object.adminAutopilot ?? false;
    message.mode = object.mode ?? 0;
    message.clockSec = object.clockSec ?? 0;
    message.features = object.features?.map((e) => e) || [];
    message.arcade = (object.arcade !== undefined && object.arcade !== null)
      ? ArcadeInfo.fromPartial(object.arcade)
      : undefined;
    message.build = object.build ?? "";
    message.pack = object.pack ?? "";
    message.wrecks = object.wrecks?.map((e) => Wreck.fromPartial(e)) || [];
    message.quake = (object.quake !== undefined && object.quake !== null)
      ? QuakeInfo.fromPartial(object.quake)
      : undefined;
    message.monuments = object.monuments?.map((e) => Monument.fromPartial(e)) || [];
    message.namedTrenches = object.namedTrenches?.map((e) => NamedTrench.fromPartial(e)) || [];
    message.banners = object.banners?.map((e) => WarBanner.fromPartial(e)) || [];
    message.featureFlags = object.featureFlags?.map((e) => e) || [];
    message.regenCalmMapSec = object.regenCalmMapSec ?? 0;
    message.settlement = (object.settlement !== undefined && object.settlement !== null)
      ? SettlementClock.fromPartial(object.settlement)
      : undefined;
    message.clockOriginSec = object.clockOriginSec ?? 0;
    message.depth = object.depth ?? new Uint8Array(0);
    message.currents = object.currents ?? new Uint8Array(0);
    message.survey = object.survey ?? new Uint8Array(0);
    message.pois = object.pois?.map((e) => PointOfInterest.fromPartial(e)) || [];
    message.namedSeamounts = object.namedSeamounts?.map((e) => NamedSeamount.fromPartial(e)) || [];
    message.fairways = object.fairways?.map((e) => Fairway.fromPartial(e)) || [];
    message.buoys = object.buoys?.map((e) => FairwayBuoy.fromPartial(e)) || [];
    message.adminCaches = object.adminCaches ?? false;
    message.adminVeil = object.adminVeil ?? false;
    message.factions = object.factions?.map((e) => e) || [];
    return message;
  },
};

function createBaseFairway(): Fairway {
  return { chains: [], narrows: [] };
}

export const Fairway: MessageFns<Fairway> = {
  encode(message: Fairway, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.chains) {
      FairwayChain.encode(v!, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.narrows) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Fairway {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFairway();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chains.push(FairwayChain.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.narrows.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.narrows.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Fairway>, I>>(base?: I): Fairway {
    return Fairway.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Fairway>, I>>(object: I): Fairway {
    const message = createBaseFairway();
    message.chains = object.chains?.map((e) => FairwayChain.fromPartial(e)) || [];
    message.narrows = object.narrows?.map((e) => e) || [];
    return message;
  },
};

function createBaseFairwayChain(): FairwayChain {
  return { cells: [] };
}

export const FairwayChain: MessageFns<FairwayChain> = {
  encode(message: FairwayChain, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.cells) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FairwayChain {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFairwayChain();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.cells.push(reader.uint32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.cells.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<FairwayChain>, I>>(base?: I): FairwayChain {
    return FairwayChain.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FairwayChain>, I>>(object: I): FairwayChain {
    const message = createBaseFairwayChain();
    message.cells = object.cells?.map((e) => e) || [];
    return message;
  },
};

function createBaseFairwayBuoy(): FairwayBuoy {
  return { kind: 0, xMpx: 0, yMpx: 0, chain: 0 };
}

export const FairwayBuoy: MessageFns<FairwayBuoy> = {
  encode(message: FairwayBuoy, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.xMpx !== 0) {
      writer.uint32(16).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(24).sint32(message.yMpx);
    }
    if (message.chain !== 0) {
      writer.uint32(32).uint32(message.chain);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FairwayBuoy {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFairwayBuoy();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.chain = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<FairwayBuoy>, I>>(base?: I): FairwayBuoy {
    return FairwayBuoy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FairwayBuoy>, I>>(object: I): FairwayBuoy {
    const message = createBaseFairwayBuoy();
    message.kind = object.kind ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.chain = object.chain ?? 0;
    return message;
  },
};

function createBasePointOfInterest(): PointOfInterest {
  return { id: 0, kind: 0, cell: 0, monster: 0, design: 0, bounty: 0 };
}

export const PointOfInterest: MessageFns<PointOfInterest> = {
  encode(message: PointOfInterest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind);
    }
    if (message.cell !== 0) {
      writer.uint32(24).uint32(message.cell);
    }
    if (message.monster !== 0) {
      writer.uint32(32).int32(message.monster);
    }
    if (message.design !== 0) {
      writer.uint32(40).uint32(message.design);
    }
    if (message.bounty !== 0) {
      writer.uint32(48).uint32(message.bounty);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PointOfInterest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePointOfInterest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.monster = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.design = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.bounty = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<PointOfInterest>, I>>(base?: I): PointOfInterest {
    return PointOfInterest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PointOfInterest>, I>>(object: I): PointOfInterest {
    const message = createBasePointOfInterest();
    message.id = object.id ?? 0;
    message.kind = object.kind ?? 0;
    message.cell = object.cell ?? 0;
    message.monster = object.monster ?? 0;
    message.design = object.design ?? 0;
    message.bounty = object.bounty ?? 0;
    return message;
  },
};

function createBasePoiLive(): PoiLive {
  return { id: 0, stock: 0, leftSec: 0, monster: 0, dug: false };
}

export const PoiLive: MessageFns<PoiLive> = {
  encode(message: PoiLive, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.stock !== 0) {
      writer.uint32(16).uint32(message.stock);
    }
    if (message.leftSec !== 0) {
      writer.uint32(24).uint32(message.leftSec);
    }
    if (message.monster !== 0) {
      writer.uint32(32).int32(message.monster);
    }
    if (message.dug !== false) {
      writer.uint32(40).bool(message.dug);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PoiLive {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoiLive();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.stock = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.leftSec = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.monster = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.dug = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<PoiLive>, I>>(base?: I): PoiLive {
    return PoiLive.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PoiLive>, I>>(object: I): PoiLive {
    const message = createBasePoiLive();
    message.id = object.id ?? 0;
    message.stock = object.stock ?? 0;
    message.leftSec = object.leftSec ?? 0;
    message.monster = object.monster ?? 0;
    message.dug = object.dug ?? false;
    return message;
  },
};

function createBaseNamedSeamount(): NamedSeamount {
  return { body: 0, cell: 0, faction: 0, name: "", commander: "" };
}

export const NamedSeamount: MessageFns<NamedSeamount> = {
  encode(message: NamedSeamount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.body !== 0) {
      writer.uint32(8).uint32(message.body);
    }
    if (message.cell !== 0) {
      writer.uint32(16).uint32(message.cell);
    }
    if (message.faction !== 0) {
      writer.uint32(24).uint32(message.faction);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.commander !== "") {
      writer.uint32(42).string(message.commander);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NamedSeamount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNamedSeamount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.body = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.commander = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<NamedSeamount>, I>>(base?: I): NamedSeamount {
    return NamedSeamount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NamedSeamount>, I>>(object: I): NamedSeamount {
    const message = createBaseNamedSeamount();
    message.body = object.body ?? 0;
    message.cell = object.cell ?? 0;
    message.faction = object.faction ?? 0;
    message.name = object.name ?? "";
    message.commander = object.commander ?? "";
    return message;
  },
};

function createBaseNameSeamount(): NameSeamount {
  return { body: 0, text: "", first: 0, second: 0 };
}

export const NameSeamount: MessageFns<NameSeamount> = {
  encode(message: NameSeamount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.body !== 0) {
      writer.uint32(8).uint32(message.body);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    if (message.first !== 0) {
      writer.uint32(24).uint32(message.first);
    }
    if (message.second !== 0) {
      writer.uint32(32).uint32(message.second);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NameSeamount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNameSeamount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.body = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.first = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.second = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<NameSeamount>, I>>(base?: I): NameSeamount {
    return NameSeamount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NameSeamount>, I>>(object: I): NameSeamount {
    const message = createBaseNameSeamount();
    message.body = object.body ?? 0;
    message.text = object.text ?? "";
    message.first = object.first ?? 0;
    message.second = object.second ?? 0;
    return message;
  },
};

function createBaseSettlementClock(): SettlementClock {
  return { drainEndsUnixMs: 0, endsUnixMs: 0, held: false };
}

export const SettlementClock: MessageFns<SettlementClock> = {
  encode(message: SettlementClock, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.drainEndsUnixMs !== 0) {
      writer.uint32(8).uint64(message.drainEndsUnixMs);
    }
    if (message.endsUnixMs !== 0) {
      writer.uint32(16).uint64(message.endsUnixMs);
    }
    if (message.held !== false) {
      writer.uint32(24).bool(message.held);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SettlementClock {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSettlementClock();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.drainEndsUnixMs = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.endsUnixMs = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.held = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SettlementClock>, I>>(base?: I): SettlementClock {
    return SettlementClock.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SettlementClock>, I>>(object: I): SettlementClock {
    const message = createBaseSettlementClock();
    message.drainEndsUnixMs = object.drainEndsUnixMs ?? 0;
    message.endsUnixMs = object.endsUnixMs ?? 0;
    message.held = object.held ?? false;
    return message;
  },
};

function createBaseWarBanner(): WarBanner {
  return { faction: 0, name: "", tag: "", house: false };
}

export const WarBanner: MessageFns<WarBanner> = {
  encode(message: WarBanner, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.faction !== 0) {
      writer.uint32(8).uint32(message.faction);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.tag !== "") {
      writer.uint32(26).string(message.tag);
    }
    if (message.house !== false) {
      writer.uint32(32).bool(message.house);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WarBanner {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWarBanner();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.house = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<WarBanner>, I>>(base?: I): WarBanner {
    return WarBanner.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WarBanner>, I>>(object: I): WarBanner {
    const message = createBaseWarBanner();
    message.faction = object.faction ?? 0;
    message.name = object.name ?? "";
    message.tag = object.tag ?? "";
    message.house = object.house ?? false;
    return message;
  },
};

function createBaseNamedTrench(): NamedTrench {
  return { cell: 0, name: "", war: 0, clan: "" };
}

export const NamedTrench: MessageFns<NamedTrench> = {
  encode(message: NamedTrench, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cell !== 0) {
      writer.uint32(8).uint32(message.cell);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.war !== 0) {
      writer.uint32(24).uint32(message.war);
    }
    if (message.clan !== "") {
      writer.uint32(34).string(message.clan);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NamedTrench {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNamedTrench();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.war = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.clan = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<NamedTrench>, I>>(base?: I): NamedTrench {
    return NamedTrench.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NamedTrench>, I>>(object: I): NamedTrench {
    const message = createBaseNamedTrench();
    message.cell = object.cell ?? 0;
    message.name = object.name ?? "";
    message.war = object.war ?? 0;
    message.clan = object.clan ?? "";
    return message;
  },
};

function createBaseMonument(): Monument {
  return { kind: 0, cells: [], commander: "", faction: 0, season: 0, score: 0, world: "" };
}

export const Monument: MessageFns<Monument> = {
  encode(message: Monument, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    writer.uint32(18).fork();
    for (const v of message.cells) {
      writer.uint32(v);
    }
    writer.join();
    if (message.commander !== "") {
      writer.uint32(26).string(message.commander);
    }
    if (message.faction !== 0) {
      writer.uint32(32).uint32(message.faction);
    }
    if (message.season !== 0) {
      writer.uint32(40).uint32(message.season);
    }
    if (message.score !== 0) {
      writer.uint32(48).uint32(message.score);
    }
    if (message.world !== "") {
      writer.uint32(58).string(message.world);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Monument {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMonument();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.cells.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.cells.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.commander = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.season = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.score = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.world = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Monument>, I>>(base?: I): Monument {
    return Monument.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Monument>, I>>(object: I): Monument {
    const message = createBaseMonument();
    message.kind = object.kind ?? 0;
    message.cells = object.cells?.map((e) => e) || [];
    message.commander = object.commander ?? "";
    message.faction = object.faction ?? 0;
    message.season = object.season ?? 0;
    message.score = object.score ?? 0;
    message.world = object.world ?? "";
    return message;
  },
};

function createBaseWreck(): Wreck {
  return { fleet: 0, xMpx: 0, yMpx: 0, cls: 0, faction: 0, sunkSec: 0, npc: 0 };
}

export const Wreck: MessageFns<Wreck> = {
  encode(message: Wreck, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fleet !== 0) {
      writer.uint32(8).uint32(message.fleet);
    }
    if (message.xMpx !== 0) {
      writer.uint32(16).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(24).sint32(message.yMpx);
    }
    if (message.cls !== 0) {
      writer.uint32(32).int32(message.cls);
    }
    if (message.faction !== 0) {
      writer.uint32(40).uint32(message.faction);
    }
    if (message.sunkSec !== 0) {
      writer.uint32(48).uint32(message.sunkSec);
    }
    if (message.npc !== 0) {
      writer.uint32(56).int32(message.npc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Wreck {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWreck();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fleet = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.cls = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.sunkSec = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.npc = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Wreck>, I>>(base?: I): Wreck {
    return Wreck.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Wreck>, I>>(object: I): Wreck {
    const message = createBaseWreck();
    message.fleet = object.fleet ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.cls = object.cls ?? 0;
    message.faction = object.faction ?? 0;
    message.sunkSec = object.sunkSec ?? 0;
    message.npc = object.npc ?? 0;
    return message;
  },
};

function createBaseCargoSighting(): CargoSighting {
  return { fleet: 0, take: undefined, seenSec: 0, recovered: false };
}

export const CargoSighting: MessageFns<CargoSighting> = {
  encode(message: CargoSighting, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fleet !== 0) {
      writer.uint32(8).uint32(message.fleet);
    }
    if (message.take !== undefined) {
      Resources.encode(message.take, writer.uint32(18).fork()).join();
    }
    if (message.seenSec !== 0) {
      writer.uint32(24).uint32(message.seenSec);
    }
    if (message.recovered !== false) {
      writer.uint32(32).bool(message.recovered);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CargoSighting {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCargoSighting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fleet = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.take = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.seenSec = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.recovered = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CargoSighting>, I>>(base?: I): CargoSighting {
    return CargoSighting.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CargoSighting>, I>>(object: I): CargoSighting {
    const message = createBaseCargoSighting();
    message.fleet = object.fleet ?? 0;
    message.take = (object.take !== undefined && object.take !== null) ? Resources.fromPartial(object.take) : undefined;
    message.seenSec = object.seenSec ?? 0;
    message.recovered = object.recovered ?? false;
    return message;
  },
};

function createBaseWrecks(): Wrecks {
  return { wrecks: [] };
}

export const Wrecks: MessageFns<Wrecks> = {
  encode(message: Wrecks, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.wrecks) {
      Wreck.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Wrecks {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWrecks();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.wrecks.push(Wreck.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Wrecks>, I>>(base?: I): Wrecks {
    return Wrecks.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Wrecks>, I>>(object: I): Wrecks {
    const message = createBaseWrecks();
    message.wrecks = object.wrecks?.map((e) => Wreck.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWorldInfo(): WorldInfo {
  return { id: 0, name: "", region: "", season: 0, population: 0 };
}

export const WorldInfo: MessageFns<WorldInfo> = {
  encode(message: WorldInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.region !== "") {
      writer.uint32(26).string(message.region);
    }
    if (message.season !== 0) {
      writer.uint32(32).uint32(message.season);
    }
    if (message.population !== 0) {
      writer.uint32(40).uint32(message.population);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorldInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorldInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.region = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.season = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.population = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<WorldInfo>, I>>(base?: I): WorldInfo {
    return WorldInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorldInfo>, I>>(object: I): WorldInfo {
    const message = createBaseWorldInfo();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.region = object.region ?? "";
    message.season = object.season ?? 0;
    message.population = object.population ?? 0;
    return message;
  },
};

function createBaseLevelUnlock(): LevelUnlock {
  return { level: 0, kind: 0, value: 0 };
}

export const LevelUnlock: MessageFns<LevelUnlock> = {
  encode(message: LevelUnlock, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.level !== 0) {
      writer.uint32(8).uint32(message.level);
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind);
    }
    if (message.value !== 0) {
      writer.uint32(24).uint32(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LevelUnlock {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLevelUnlock();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.level = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.value = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<LevelUnlock>, I>>(base?: I): LevelUnlock {
    return LevelUnlock.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LevelUnlock>, I>>(object: I): LevelUnlock {
    const message = createBaseLevelUnlock();
    message.level = object.level ?? 0;
    message.kind = object.kind ?? 0;
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseBuildingSpec(): BuildingSpec {
  return { id: 0, name: "", max: 0, cost: undefined, timeSec: 0, effect: "", tech: 0, unlocks: [] };
}

export const BuildingSpec: MessageFns<BuildingSpec> = {
  encode(message: BuildingSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.max !== 0) {
      writer.uint32(24).uint32(message.max);
    }
    if (message.cost !== undefined) {
      Resources.encode(message.cost, writer.uint32(34).fork()).join();
    }
    if (message.timeSec !== 0) {
      writer.uint32(40).uint32(message.timeSec);
    }
    if (message.effect !== "") {
      writer.uint32(50).string(message.effect);
    }
    if (message.tech !== 0) {
      writer.uint32(56).uint32(message.tech);
    }
    for (const v of message.unlocks) {
      LevelUnlock.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BuildingSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBuildingSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.max = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cost = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.timeSec = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.effect = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.tech = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.unlocks.push(LevelUnlock.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<BuildingSpec>, I>>(base?: I): BuildingSpec {
    return BuildingSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BuildingSpec>, I>>(object: I): BuildingSpec {
    const message = createBaseBuildingSpec();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.max = object.max ?? 0;
    message.cost = (object.cost !== undefined && object.cost !== null) ? Resources.fromPartial(object.cost) : undefined;
    message.timeSec = object.timeSec ?? 0;
    message.effect = object.effect ?? "";
    message.tech = object.tech ?? 0;
    message.unlocks = object.unlocks?.map((e) => LevelUnlock.fromPartial(e)) || [];
    return message;
  },
};

function createBaseShipSpec(): ShipSpec {
  return {
    id: 0,
    name: "",
    weight: 0,
    hull: 0,
    shield: 0,
    speedUh: 0,
    noise: 0,
    cargo: 0,
    cost: undefined,
    timeSec: 0,
    sonar: 0,
    dps: 0,
    range: 0,
    support: false,
    tech: 0,
    torpedoes: [],
    minRange: 0,
    role: "",
    anchorRange: 0,
    wharf: 0,
    draftIsotopes: 0,
    stows: [],
    anchors: false,
    firePeriodSec: 0,
    shotDamageX10: 0,
    leadAttr: 0,
    unarmed: false,
    signature: 0,
    signatureTrigger: 0,
    turnRateDegS: 0,
    gunArcDeg: 0,
    depthRating: 0,
    cap: 0,
  };
}

export const ShipSpec: MessageFns<ShipSpec> = {
  encode(message: ShipSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.weight !== 0) {
      writer.uint32(24).uint32(message.weight);
    }
    if (message.hull !== 0) {
      writer.uint32(32).uint32(message.hull);
    }
    if (message.shield !== 0) {
      writer.uint32(40).uint32(message.shield);
    }
    if (message.speedUh !== 0) {
      writer.uint32(48).uint32(message.speedUh);
    }
    if (message.noise !== 0) {
      writer.uint32(57).double(message.noise);
    }
    if (message.cargo !== 0) {
      writer.uint32(64).uint32(message.cargo);
    }
    if (message.cost !== undefined) {
      Resources.encode(message.cost, writer.uint32(74).fork()).join();
    }
    if (message.timeSec !== 0) {
      writer.uint32(80).uint32(message.timeSec);
    }
    if (message.sonar !== 0) {
      writer.uint32(88).uint32(message.sonar);
    }
    if (message.dps !== 0) {
      writer.uint32(96).uint32(message.dps);
    }
    if (message.range !== 0) {
      writer.uint32(104).uint32(message.range);
    }
    if (message.support !== false) {
      writer.uint32(112).bool(message.support);
    }
    if (message.tech !== 0) {
      writer.uint32(120).uint32(message.tech);
    }
    writer.uint32(130).fork();
    for (const v of message.torpedoes) {
      writer.int32(v);
    }
    writer.join();
    if (message.minRange !== 0) {
      writer.uint32(136).uint32(message.minRange);
    }
    if (message.role !== "") {
      writer.uint32(146).string(message.role);
    }
    if (message.anchorRange !== 0) {
      writer.uint32(152).uint32(message.anchorRange);
    }
    if (message.wharf !== 0) {
      writer.uint32(160).uint32(message.wharf);
    }
    if (message.draftIsotopes !== 0) {
      writer.uint32(168).uint32(message.draftIsotopes);
    }
    writer.uint32(178).fork();
    for (const v of message.stows) {
      writer.int32(v);
    }
    writer.join();
    if (message.anchors !== false) {
      writer.uint32(184).bool(message.anchors);
    }
    if (message.firePeriodSec !== 0) {
      writer.uint32(193).double(message.firePeriodSec);
    }
    if (message.shotDamageX10 !== 0) {
      writer.uint32(200).uint32(message.shotDamageX10);
    }
    if (message.leadAttr !== 0) {
      writer.uint32(208).sint32(message.leadAttr);
    }
    if (message.unarmed !== false) {
      writer.uint32(216).bool(message.unarmed);
    }
    if (message.signature !== 0) {
      writer.uint32(224).int32(message.signature);
    }
    if (message.signatureTrigger !== 0) {
      writer.uint32(232).int32(message.signatureTrigger);
    }
    if (message.turnRateDegS !== 0) {
      writer.uint32(241).double(message.turnRateDegS);
    }
    if (message.gunArcDeg !== 0) {
      writer.uint32(249).double(message.gunArcDeg);
    }
    if (message.depthRating !== 0) {
      writer.uint32(256).int32(message.depthRating);
    }
    if (message.cap !== 0) {
      writer.uint32(264).uint32(message.cap);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ShipSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShipSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.weight = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.hull = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.shield = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.speedUh = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.noise = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.cargo = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.cost = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.timeSec = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.sonar = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.dps = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.range = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.support = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.tech = reader.uint32();
          continue;
        }
        case 16: {
          if (tag === 128) {
            message.torpedoes.push(reader.int32() as any);

            continue;
          }

          if (tag === 130) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.torpedoes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.minRange = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.role = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.anchorRange = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.wharf = reader.uint32();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.draftIsotopes = reader.uint32();
          continue;
        }
        case 22: {
          if (tag === 176) {
            message.stows.push(reader.int32() as any);

            continue;
          }

          if (tag === 178) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.stows.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.anchors = reader.bool();
          continue;
        }
        case 24: {
          if (tag !== 193) {
            break;
          }

          message.firePeriodSec = reader.double();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.shotDamageX10 = reader.uint32();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.leadAttr = reader.sint32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.unarmed = reader.bool();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.signature = reader.int32() as any;
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.signatureTrigger = reader.int32() as any;
          continue;
        }
        case 30: {
          if (tag !== 241) {
            break;
          }

          message.turnRateDegS = reader.double();
          continue;
        }
        case 31: {
          if (tag !== 249) {
            break;
          }

          message.gunArcDeg = reader.double();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.depthRating = reader.int32() as any;
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.cap = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ShipSpec>, I>>(base?: I): ShipSpec {
    return ShipSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ShipSpec>, I>>(object: I): ShipSpec {
    const message = createBaseShipSpec();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.weight = object.weight ?? 0;
    message.hull = object.hull ?? 0;
    message.shield = object.shield ?? 0;
    message.speedUh = object.speedUh ?? 0;
    message.noise = object.noise ?? 0;
    message.cargo = object.cargo ?? 0;
    message.cost = (object.cost !== undefined && object.cost !== null) ? Resources.fromPartial(object.cost) : undefined;
    message.timeSec = object.timeSec ?? 0;
    message.sonar = object.sonar ?? 0;
    message.dps = object.dps ?? 0;
    message.range = object.range ?? 0;
    message.support = object.support ?? false;
    message.tech = object.tech ?? 0;
    message.torpedoes = object.torpedoes?.map((e) => e) || [];
    message.minRange = object.minRange ?? 0;
    message.role = object.role ?? "";
    message.anchorRange = object.anchorRange ?? 0;
    message.wharf = object.wharf ?? 0;
    message.draftIsotopes = object.draftIsotopes ?? 0;
    message.stows = object.stows?.map((e) => e) || [];
    message.anchors = object.anchors ?? false;
    message.firePeriodSec = object.firePeriodSec ?? 0;
    message.shotDamageX10 = object.shotDamageX10 ?? 0;
    message.leadAttr = object.leadAttr ?? 0;
    message.unarmed = object.unarmed ?? false;
    message.signature = object.signature ?? 0;
    message.signatureTrigger = object.signatureTrigger ?? 0;
    message.turnRateDegS = object.turnRateDegS ?? 0;
    message.gunArcDeg = object.gunArcDeg ?? 0;
    message.depthRating = object.depthRating ?? 0;
    message.cap = object.cap ?? 0;
    return message;
  },
};

function createBaseRoleBonus(): RoleBonus {
  return { attacker: "", target: "", mul: 0 };
}

export const RoleBonus: MessageFns<RoleBonus> = {
  encode(message: RoleBonus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attacker !== "") {
      writer.uint32(10).string(message.attacker);
    }
    if (message.target !== "") {
      writer.uint32(18).string(message.target);
    }
    if (message.mul !== 0) {
      writer.uint32(25).double(message.mul);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoleBonus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoleBonus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attacker = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.target = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.mul = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RoleBonus>, I>>(base?: I): RoleBonus {
    return RoleBonus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoleBonus>, I>>(object: I): RoleBonus {
    const message = createBaseRoleBonus();
    message.attacker = object.attacker ?? "";
    message.target = object.target ?? "";
    message.mul = object.mul ?? 0;
    return message;
  },
};

function createBaseTechSpec(): TechSpec {
  return {
    id: 0,
    code: "",
    name: "",
    branch: "",
    tier: 0,
    cost: undefined,
    timeSec: 0,
    requires: [],
    unlocks: "",
    labLevel: 0,
    brief: "",
    baseCap: 0,
  };
}

export const TechSpec: MessageFns<TechSpec> = {
  encode(message: TechSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.branch !== "") {
      writer.uint32(34).string(message.branch);
    }
    if (message.tier !== 0) {
      writer.uint32(40).uint32(message.tier);
    }
    if (message.cost !== undefined) {
      Resources.encode(message.cost, writer.uint32(50).fork()).join();
    }
    if (message.timeSec !== 0) {
      writer.uint32(56).uint32(message.timeSec);
    }
    writer.uint32(66).fork();
    for (const v of message.requires) {
      writer.uint32(v);
    }
    writer.join();
    if (message.unlocks !== "") {
      writer.uint32(74).string(message.unlocks);
    }
    if (message.labLevel !== 0) {
      writer.uint32(80).uint32(message.labLevel);
    }
    if (message.brief !== "") {
      writer.uint32(90).string(message.brief);
    }
    if (message.baseCap !== 0) {
      writer.uint32(96).uint32(message.baseCap);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TechSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTechSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.branch = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.tier = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.cost = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.timeSec = reader.uint32();
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.requires.push(reader.uint32());

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.requires.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.unlocks = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.labLevel = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.brief = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.baseCap = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TechSpec>, I>>(base?: I): TechSpec {
    return TechSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TechSpec>, I>>(object: I): TechSpec {
    const message = createBaseTechSpec();
    message.id = object.id ?? 0;
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.branch = object.branch ?? "";
    message.tier = object.tier ?? 0;
    message.cost = (object.cost !== undefined && object.cost !== null) ? Resources.fromPartial(object.cost) : undefined;
    message.timeSec = object.timeSec ?? 0;
    message.requires = object.requires?.map((e) => e) || [];
    message.unlocks = object.unlocks ?? "";
    message.labLevel = object.labLevel ?? 0;
    message.brief = object.brief ?? "";
    message.baseCap = object.baseCap ?? 0;
    return message;
  },
};

function createBaseTorpedoSpec(): TorpedoSpec {
  return {
    id: 0,
    name: "",
    damage: 0,
    splash: 0,
    speedUh: 0,
    range: 0,
    cost: undefined,
    timeSec: 0,
    cargo: 0,
    fromBase: false,
    tech: 0,
    effect: "",
    friendlyFire: false,
    use: "",
    burstPx: 0,
    own: false,
    auto: false,
    heal: 0,
    burstHostile: false,
    loiterSec: 0,
  };
}

export const TorpedoSpec: MessageFns<TorpedoSpec> = {
  encode(message: TorpedoSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.damage !== 0) {
      writer.uint32(24).uint32(message.damage);
    }
    if (message.splash !== 0) {
      writer.uint32(32).uint32(message.splash);
    }
    if (message.speedUh !== 0) {
      writer.uint32(40).uint32(message.speedUh);
    }
    if (message.range !== 0) {
      writer.uint32(48).uint32(message.range);
    }
    if (message.cost !== undefined) {
      Resources.encode(message.cost, writer.uint32(58).fork()).join();
    }
    if (message.timeSec !== 0) {
      writer.uint32(64).uint32(message.timeSec);
    }
    if (message.cargo !== 0) {
      writer.uint32(72).uint32(message.cargo);
    }
    if (message.fromBase !== false) {
      writer.uint32(80).bool(message.fromBase);
    }
    if (message.tech !== 0) {
      writer.uint32(88).uint32(message.tech);
    }
    if (message.effect !== "") {
      writer.uint32(98).string(message.effect);
    }
    if (message.friendlyFire !== false) {
      writer.uint32(104).bool(message.friendlyFire);
    }
    if (message.use !== "") {
      writer.uint32(114).string(message.use);
    }
    if (message.burstPx !== 0) {
      writer.uint32(120).uint32(message.burstPx);
    }
    if (message.own !== false) {
      writer.uint32(128).bool(message.own);
    }
    if (message.auto !== false) {
      writer.uint32(136).bool(message.auto);
    }
    if (message.heal !== 0) {
      writer.uint32(144).uint32(message.heal);
    }
    if (message.burstHostile !== false) {
      writer.uint32(152).bool(message.burstHostile);
    }
    if (message.loiterSec !== 0) {
      writer.uint32(160).uint32(message.loiterSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TorpedoSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTorpedoSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.damage = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.splash = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.speedUh = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.range = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.cost = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.timeSec = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.cargo = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.fromBase = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.tech = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.effect = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.friendlyFire = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.use = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.burstPx = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.own = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.auto = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.heal = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.burstHostile = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.loiterSec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TorpedoSpec>, I>>(base?: I): TorpedoSpec {
    return TorpedoSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TorpedoSpec>, I>>(object: I): TorpedoSpec {
    const message = createBaseTorpedoSpec();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.damage = object.damage ?? 0;
    message.splash = object.splash ?? 0;
    message.speedUh = object.speedUh ?? 0;
    message.range = object.range ?? 0;
    message.cost = (object.cost !== undefined && object.cost !== null) ? Resources.fromPartial(object.cost) : undefined;
    message.timeSec = object.timeSec ?? 0;
    message.cargo = object.cargo ?? 0;
    message.fromBase = object.fromBase ?? false;
    message.tech = object.tech ?? 0;
    message.effect = object.effect ?? "";
    message.friendlyFire = object.friendlyFire ?? false;
    message.use = object.use ?? "";
    message.burstPx = object.burstPx ?? 0;
    message.own = object.own ?? false;
    message.auto = object.auto ?? false;
    message.heal = object.heal ?? 0;
    message.burstHostile = object.burstHostile ?? false;
    message.loiterSec = object.loiterSec ?? 0;
    return message;
  },
};

function createBaseSeaObjectSpec(): SeaObjectSpec {
  return {
    id: 0,
    name: "",
    seaMine: false,
    cost: undefined,
    timeSec: 0,
    tech: 0,
    depotLevel: 0,
    cargo: 0,
    sonarPx: 0,
    triggerPx: 0,
    hearPx: 0,
    splashPx: 0,
    damage: 0,
    lengthPx: 0,
    reachPx: 0,
    speedMul: 0,
  };
}

export const SeaObjectSpec: MessageFns<SeaObjectSpec> = {
  encode(message: SeaObjectSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.seaMine !== false) {
      writer.uint32(24).bool(message.seaMine);
    }
    if (message.cost !== undefined) {
      Resources.encode(message.cost, writer.uint32(34).fork()).join();
    }
    if (message.timeSec !== 0) {
      writer.uint32(40).uint32(message.timeSec);
    }
    if (message.tech !== 0) {
      writer.uint32(48).uint32(message.tech);
    }
    if (message.depotLevel !== 0) {
      writer.uint32(56).uint32(message.depotLevel);
    }
    if (message.cargo !== 0) {
      writer.uint32(64).uint32(message.cargo);
    }
    if (message.sonarPx !== 0) {
      writer.uint32(72).uint32(message.sonarPx);
    }
    if (message.triggerPx !== 0) {
      writer.uint32(81).double(message.triggerPx);
    }
    if (message.hearPx !== 0) {
      writer.uint32(89).double(message.hearPx);
    }
    if (message.splashPx !== 0) {
      writer.uint32(97).double(message.splashPx);
    }
    if (message.damage !== 0) {
      writer.uint32(105).double(message.damage);
    }
    if (message.lengthPx !== 0) {
      writer.uint32(113).double(message.lengthPx);
    }
    if (message.reachPx !== 0) {
      writer.uint32(121).double(message.reachPx);
    }
    if (message.speedMul !== 0) {
      writer.uint32(129).double(message.speedMul);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeaObjectSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeaObjectSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.seaMine = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cost = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.timeSec = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.tech = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.depotLevel = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.cargo = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.sonarPx = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.triggerPx = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 89) {
            break;
          }

          message.hearPx = reader.double();
          continue;
        }
        case 12: {
          if (tag !== 97) {
            break;
          }

          message.splashPx = reader.double();
          continue;
        }
        case 13: {
          if (tag !== 105) {
            break;
          }

          message.damage = reader.double();
          continue;
        }
        case 14: {
          if (tag !== 113) {
            break;
          }

          message.lengthPx = reader.double();
          continue;
        }
        case 15: {
          if (tag !== 121) {
            break;
          }

          message.reachPx = reader.double();
          continue;
        }
        case 16: {
          if (tag !== 129) {
            break;
          }

          message.speedMul = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SeaObjectSpec>, I>>(base?: I): SeaObjectSpec {
    return SeaObjectSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeaObjectSpec>, I>>(object: I): SeaObjectSpec {
    const message = createBaseSeaObjectSpec();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.seaMine = object.seaMine ?? false;
    message.cost = (object.cost !== undefined && object.cost !== null) ? Resources.fromPartial(object.cost) : undefined;
    message.timeSec = object.timeSec ?? 0;
    message.tech = object.tech ?? 0;
    message.depotLevel = object.depotLevel ?? 0;
    message.cargo = object.cargo ?? 0;
    message.sonarPx = object.sonarPx ?? 0;
    message.triggerPx = object.triggerPx ?? 0;
    message.hearPx = object.hearPx ?? 0;
    message.splashPx = object.splashPx ?? 0;
    message.damage = object.damage ?? 0;
    message.lengthPx = object.lengthPx ?? 0;
    message.reachPx = object.reachPx ?? 0;
    message.speedMul = object.speedMul ?? 0;
    return message;
  },
};

function createBaseMarketListing(): MarketListing {
  return { id: 0, seller: 0, sellerName: "", print: undefined, price: 0, item: 0, qty: 0 };
}

export const MarketListing: MessageFns<MarketListing> = {
  encode(message: MarketListing, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.seller !== 0) {
      writer.uint32(16).uint32(message.seller);
    }
    if (message.sellerName !== "") {
      writer.uint32(26).string(message.sellerName);
    }
    if (message.print !== undefined) {
      Blueprint.encode(message.print, writer.uint32(34).fork()).join();
    }
    if (message.price !== 0) {
      writer.uint32(40).uint32(message.price);
    }
    if (message.item !== 0) {
      writer.uint32(48).int32(message.item);
    }
    if (message.qty !== 0) {
      writer.uint32(56).uint32(message.qty);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarketListing {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarketListing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.seller = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sellerName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.print = Blueprint.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.price = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.item = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.qty = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<MarketListing>, I>>(base?: I): MarketListing {
    return MarketListing.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MarketListing>, I>>(object: I): MarketListing {
    const message = createBaseMarketListing();
    message.id = object.id ?? 0;
    message.seller = object.seller ?? 0;
    message.sellerName = object.sellerName ?? "";
    message.print = (object.print !== undefined && object.print !== null)
      ? Blueprint.fromPartial(object.print)
      : undefined;
    message.price = object.price ?? 0;
    message.item = object.item ?? 0;
    message.qty = object.qty ?? 0;
    return message;
  },
};

function createBaseMarket(): Market {
  return { listings: [] };
}

export const Market: MessageFns<Market> = {
  encode(message: Market, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.listings) {
      MarketListing.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Market {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarket();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.listings.push(MarketListing.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Market>, I>>(base?: I): Market {
    return Market.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Market>, I>>(object: I): Market {
    const message = createBaseMarket();
    message.listings = object.listings?.map((e) => MarketListing.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAdminAction(): AdminAction {
  return { op: "", value: 0 };
}

export const AdminAction: MessageFns<AdminAction> = {
  encode(message: AdminAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.op !== "") {
      writer.uint32(10).string(message.op);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.op = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<AdminAction>, I>>(base?: I): AdminAction {
    return AdminAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminAction>, I>>(object: I): AdminAction {
    const message = createBaseAdminAction();
    message.op = object.op ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseDevBuild(): DevBuild {
  return { build: "", head: "", behind: 0, branch: "" };
}

export const DevBuild: MessageFns<DevBuild> = {
  encode(message: DevBuild, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.build !== "") {
      writer.uint32(10).string(message.build);
    }
    if (message.head !== "") {
      writer.uint32(18).string(message.head);
    }
    if (message.behind !== 0) {
      writer.uint32(24).uint32(message.behind);
    }
    if (message.branch !== "") {
      writer.uint32(34).string(message.branch);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DevBuild {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDevBuild();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.build = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.head = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.behind = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.branch = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<DevBuild>, I>>(base?: I): DevBuild {
    return DevBuild.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DevBuild>, I>>(object: I): DevBuild {
    const message = createBaseDevBuild();
    message.build = object.build ?? "";
    message.head = object.head ?? "";
    message.behind = object.behind ?? 0;
    message.branch = object.branch ?? "";
    return message;
  },
};

function createBaseMarketAction(): MarketAction {
  return { listDesign: 0, price: 0, buy: 0, cancel: 0, listIsotopes: 0 };
}

export const MarketAction: MessageFns<MarketAction> = {
  encode(message: MarketAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.listDesign !== 0) {
      writer.uint32(8).uint32(message.listDesign);
    }
    if (message.price !== 0) {
      writer.uint32(16).uint32(message.price);
    }
    if (message.buy !== 0) {
      writer.uint32(24).uint32(message.buy);
    }
    if (message.cancel !== 0) {
      writer.uint32(32).uint32(message.cancel);
    }
    if (message.listIsotopes !== 0) {
      writer.uint32(40).uint32(message.listIsotopes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarketAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarketAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.listDesign = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.price = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.buy = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.cancel = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.listIsotopes = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<MarketAction>, I>>(base?: I): MarketAction {
    return MarketAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MarketAction>, I>>(object: I): MarketAction {
    const message = createBaseMarketAction();
    message.listDesign = object.listDesign ?? 0;
    message.price = object.price ?? 0;
    message.buy = object.buy ?? 0;
    message.cancel = object.cancel ?? 0;
    message.listIsotopes = object.listIsotopes ?? 0;
    return message;
  },
};

function createBaseCatalog(): Catalog {
  return {
    buildings: [],
    ships: [],
    tech: [],
    attrs: [],
    torpedoes: [],
    expeditions: [],
    weaponTypes: [],
    shieldTypes: [],
    captureSec: 0,
    anchorCycleSec: 0,
    anchorRings: 0,
    events: [],
    eventDefaults: undefined,
    rules: undefined,
    roleBonuses: [],
    modules: [],
    inventionCostShare: 0,
    inventionTimeSec: 0,
    casino: undefined,
    redraftCostShare: 0,
    seaObjects: [],
    beaconBeamSec: 0,
  };
}

export const Catalog: MessageFns<Catalog> = {
  encode(message: Catalog, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.buildings) {
      BuildingSpec.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.ships) {
      ShipSpec.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.tech) {
      TechSpec.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.attrs) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.torpedoes) {
      TorpedoSpec.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.expeditions) {
      ExpeditionSpec.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.weaponTypes) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.shieldTypes) {
      writer.uint32(66).string(v!);
    }
    if (message.captureSec !== 0) {
      writer.uint32(72).uint32(message.captureSec);
    }
    if (message.anchorCycleSec !== 0) {
      writer.uint32(80).uint32(message.anchorCycleSec);
    }
    if (message.anchorRings !== 0) {
      writer.uint32(88).uint32(message.anchorRings);
    }
    for (const v of message.events) {
      EventSpec.encode(v!, writer.uint32(106).fork()).join();
    }
    if (message.eventDefaults !== undefined) {
      EventDefaults.encode(message.eventDefaults, writer.uint32(114).fork()).join();
    }
    if (message.rules !== undefined) {
      CatalogRules.encode(message.rules, writer.uint32(122).fork()).join();
    }
    for (const v of message.roleBonuses) {
      RoleBonus.encode(v!, writer.uint32(130).fork()).join();
    }
    for (const v of message.modules) {
      ModuleSpec.encode(v!, writer.uint32(138).fork()).join();
    }
    if (message.inventionCostShare !== 0) {
      writer.uint32(145).double(message.inventionCostShare);
    }
    if (message.inventionTimeSec !== 0) {
      writer.uint32(152).uint32(message.inventionTimeSec);
    }
    if (message.casino !== undefined) {
      CasinoRules.encode(message.casino, writer.uint32(162).fork()).join();
    }
    if (message.redraftCostShare !== 0) {
      writer.uint32(169).double(message.redraftCostShare);
    }
    for (const v of message.seaObjects) {
      SeaObjectSpec.encode(v!, writer.uint32(178).fork()).join();
    }
    if (message.beaconBeamSec !== 0) {
      writer.uint32(184).uint32(message.beaconBeamSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Catalog {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCatalog();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.buildings.push(BuildingSpec.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ships.push(ShipSpec.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tech.push(TechSpec.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.attrs.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.torpedoes.push(TorpedoSpec.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.expeditions.push(ExpeditionSpec.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.weaponTypes.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.shieldTypes.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.captureSec = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.anchorCycleSec = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.anchorRings = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.events.push(EventSpec.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.eventDefaults = EventDefaults.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.rules = CatalogRules.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.roleBonuses.push(RoleBonus.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.modules.push(ModuleSpec.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 145) {
            break;
          }

          message.inventionCostShare = reader.double();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.inventionTimeSec = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.casino = CasinoRules.decode(reader, reader.uint32());
          continue;
        }
        case 21: {
          if (tag !== 169) {
            break;
          }

          message.redraftCostShare = reader.double();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.seaObjects.push(SeaObjectSpec.decode(reader, reader.uint32()));
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.beaconBeamSec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Catalog>, I>>(base?: I): Catalog {
    return Catalog.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Catalog>, I>>(object: I): Catalog {
    const message = createBaseCatalog();
    message.buildings = object.buildings?.map((e) => BuildingSpec.fromPartial(e)) || [];
    message.ships = object.ships?.map((e) => ShipSpec.fromPartial(e)) || [];
    message.tech = object.tech?.map((e) => TechSpec.fromPartial(e)) || [];
    message.attrs = object.attrs?.map((e) => e) || [];
    message.torpedoes = object.torpedoes?.map((e) => TorpedoSpec.fromPartial(e)) || [];
    message.expeditions = object.expeditions?.map((e) => ExpeditionSpec.fromPartial(e)) || [];
    message.weaponTypes = object.weaponTypes?.map((e) => e) || [];
    message.shieldTypes = object.shieldTypes?.map((e) => e) || [];
    message.captureSec = object.captureSec ?? 0;
    message.anchorCycleSec = object.anchorCycleSec ?? 0;
    message.anchorRings = object.anchorRings ?? 0;
    message.events = object.events?.map((e) => EventSpec.fromPartial(e)) || [];
    message.eventDefaults = (object.eventDefaults !== undefined && object.eventDefaults !== null)
      ? EventDefaults.fromPartial(object.eventDefaults)
      : undefined;
    message.rules = (object.rules !== undefined && object.rules !== null)
      ? CatalogRules.fromPartial(object.rules)
      : undefined;
    message.roleBonuses = object.roleBonuses?.map((e) => RoleBonus.fromPartial(e)) || [];
    message.modules = object.modules?.map((e) => ModuleSpec.fromPartial(e)) || [];
    message.inventionCostShare = object.inventionCostShare ?? 0;
    message.inventionTimeSec = object.inventionTimeSec ?? 0;
    message.casino = (object.casino !== undefined && object.casino !== null)
      ? CasinoRules.fromPartial(object.casino)
      : undefined;
    message.redraftCostShare = object.redraftCostShare ?? 0;
    message.seaObjects = object.seaObjects?.map((e) => SeaObjectSpec.fromPartial(e)) || [];
    message.beaconBeamSec = object.beaconBeamSec ?? 0;
    return message;
  },
};

function createBaseCatalogRules(): CatalogRules {
  return {
    idleCreditsPerHour: 0,
    isotopeLotMin: 0,
    isotopeLotMax: 0,
    standardPrintRuns: 0,
    inventionRollMin: 0,
    inventionRollMax: 0,
    weapTypeShipDesign: 0,
    shieldTypeShipDesign: 0,
    intelTtlSec: 0,
    talentTrainingMul: 0,
    truceSec: 0,
    seasonSec: 0,
    oracleShareComms: 0,
    torpedoFusePx: 0,
    radRiskCutPerLevel: 0,
    prospectingInjuryCutPerPoint: 0,
    isotopeLotsPerRadControlLevel: 0,
    printListingsPerShipDesignLevel: 0,
    keystoneTier: 0,
    tenderAuraPx: 0,
    objWindowSec: 0,
    wreckWindowSec: 0,
    wardAuraPx: 0,
    captain: undefined,
    torpedobankPointDefenceLevel: 0,
    inventionRollSkew: 0,
    moduleGrades: [],
    markerLifeSec: 0,
    tenderRepairRangePx: 0,
    tenderRepairPerMapMinute: 0,
    tenderShieldPerCombatSec: 0,
    tenderRestockEverySec: 0,
    anchorNoiseMul: 0,
    gaugeMax: 0,
    scanRevealSec: 0,
    baseCapDefault: 0,
    expeditionPrepSec: 0,
    settlementDrainSec: 0,
    settlementCardSec: 0,
    approach: undefined,
    routeLegsMax: 0,
    routeLoopPassesMax: 0,
    routeLoopPassesDefault: 0,
    harbourLimitsPx: 0,
    routePlotsMax: 0,
    tidePeriodSec: 0,
    tideSteps: [],
    currentUnitPxH: 0,
    thermocline: [],
    pressurePerMapMinute: 0,
    command: undefined,
    routeLanesMax: 0,
    cacheFeeCredits: 0,
    cacheFindsPerWorldDay: 0,
    cacheDepositsPerSeason: 0,
    cacheHintPx: 0,
    cacheNoteMaxRunes: 0,
    seaObjects: undefined,
    poiGateMul: 0,
    poiGateReachCells: 0,
    poiLairHomePx: 0,
    poiVentStock: 0,
    workFitClasses: [],
    commissionDayCap: 0,
    commissionHoldCap: 0,
    routeLaneLegsMin: 0,
    routeLaneUseMargin: 0,
    routeLaneUseMinPx: 0,
    buoySpeedMul: 0,
    laneSpeedMul: 0,
  };
}

export const CatalogRules: MessageFns<CatalogRules> = {
  encode(message: CatalogRules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.idleCreditsPerHour !== 0) {
      writer.uint32(8).uint32(message.idleCreditsPerHour);
    }
    if (message.isotopeLotMin !== 0) {
      writer.uint32(16).uint32(message.isotopeLotMin);
    }
    if (message.isotopeLotMax !== 0) {
      writer.uint32(24).uint32(message.isotopeLotMax);
    }
    if (message.standardPrintRuns !== 0) {
      writer.uint32(32).uint32(message.standardPrintRuns);
    }
    if (message.inventionRollMin !== 0) {
      writer.uint32(41).double(message.inventionRollMin);
    }
    if (message.inventionRollMax !== 0) {
      writer.uint32(49).double(message.inventionRollMax);
    }
    if (message.weapTypeShipDesign !== 0) {
      writer.uint32(56).uint32(message.weapTypeShipDesign);
    }
    if (message.shieldTypeShipDesign !== 0) {
      writer.uint32(64).uint32(message.shieldTypeShipDesign);
    }
    if (message.intelTtlSec !== 0) {
      writer.uint32(72).uint32(message.intelTtlSec);
    }
    if (message.talentTrainingMul !== 0) {
      writer.uint32(81).double(message.talentTrainingMul);
    }
    if (message.truceSec !== 0) {
      writer.uint32(89).double(message.truceSec);
    }
    if (message.seasonSec !== 0) {
      writer.uint32(105).double(message.seasonSec);
    }
    if (message.oracleShareComms !== 0) {
      writer.uint32(112).uint32(message.oracleShareComms);
    }
    if (message.torpedoFusePx !== 0) {
      writer.uint32(121).double(message.torpedoFusePx);
    }
    if (message.radRiskCutPerLevel !== 0) {
      writer.uint32(129).double(message.radRiskCutPerLevel);
    }
    if (message.prospectingInjuryCutPerPoint !== 0) {
      writer.uint32(137).double(message.prospectingInjuryCutPerPoint);
    }
    if (message.isotopeLotsPerRadControlLevel !== 0) {
      writer.uint32(144).uint32(message.isotopeLotsPerRadControlLevel);
    }
    if (message.printListingsPerShipDesignLevel !== 0) {
      writer.uint32(152).uint32(message.printListingsPerShipDesignLevel);
    }
    if (message.keystoneTier !== 0) {
      writer.uint32(160).uint32(message.keystoneTier);
    }
    if (message.tenderAuraPx !== 0) {
      writer.uint32(177).double(message.tenderAuraPx);
    }
    if (message.objWindowSec !== 0) {
      writer.uint32(185).double(message.objWindowSec);
    }
    if (message.wreckWindowSec !== 0) {
      writer.uint32(193).double(message.wreckWindowSec);
    }
    if (message.wardAuraPx !== 0) {
      writer.uint32(201).double(message.wardAuraPx);
    }
    if (message.captain !== undefined) {
      CaptainRules.encode(message.captain, writer.uint32(210).fork()).join();
    }
    if (message.torpedobankPointDefenceLevel !== 0) {
      writer.uint32(216).uint32(message.torpedobankPointDefenceLevel);
    }
    if (message.inventionRollSkew !== 0) {
      writer.uint32(225).double(message.inventionRollSkew);
    }
    for (const v of message.moduleGrades) {
      ModuleGrade.encode(v!, writer.uint32(234).fork()).join();
    }
    if (message.markerLifeSec !== 0) {
      writer.uint32(241).double(message.markerLifeSec);
    }
    if (message.tenderRepairRangePx !== 0) {
      writer.uint32(249).double(message.tenderRepairRangePx);
    }
    if (message.tenderRepairPerMapMinute !== 0) {
      writer.uint32(257).double(message.tenderRepairPerMapMinute);
    }
    if (message.tenderShieldPerCombatSec !== 0) {
      writer.uint32(265).double(message.tenderShieldPerCombatSec);
    }
    if (message.tenderRestockEverySec !== 0) {
      writer.uint32(273).double(message.tenderRestockEverySec);
    }
    if (message.anchorNoiseMul !== 0) {
      writer.uint32(281).double(message.anchorNoiseMul);
    }
    if (message.gaugeMax !== 0) {
      writer.uint32(289).double(message.gaugeMax);
    }
    if (message.scanRevealSec !== 0) {
      writer.uint32(297).double(message.scanRevealSec);
    }
    if (message.baseCapDefault !== 0) {
      writer.uint32(304).uint32(message.baseCapDefault);
    }
    if (message.expeditionPrepSec !== 0) {
      writer.uint32(312).uint32(message.expeditionPrepSec);
    }
    if (message.settlementDrainSec !== 0) {
      writer.uint32(321).double(message.settlementDrainSec);
    }
    if (message.settlementCardSec !== 0) {
      writer.uint32(329).double(message.settlementCardSec);
    }
    if (message.approach !== undefined) {
      ApproachRules.encode(message.approach, writer.uint32(338).fork()).join();
    }
    if (message.routeLegsMax !== 0) {
      writer.uint32(344).uint32(message.routeLegsMax);
    }
    if (message.routeLoopPassesMax !== 0) {
      writer.uint32(352).uint32(message.routeLoopPassesMax);
    }
    if (message.routeLoopPassesDefault !== 0) {
      writer.uint32(360).uint32(message.routeLoopPassesDefault);
    }
    if (message.harbourLimitsPx !== 0) {
      writer.uint32(369).double(message.harbourLimitsPx);
    }
    if (message.routePlotsMax !== 0) {
      writer.uint32(376).uint32(message.routePlotsMax);
    }
    if (message.tidePeriodSec !== 0) {
      writer.uint32(385).double(message.tidePeriodSec);
    }
    writer.uint32(394).fork();
    for (const v of message.tideSteps) {
      writer.double(v);
    }
    writer.join();
    if (message.currentUnitPxH !== 0) {
      writer.uint32(401).double(message.currentUnitPxH);
    }
    writer.uint32(410).fork();
    for (const v of message.thermocline) {
      writer.double(v);
    }
    writer.join();
    if (message.pressurePerMapMinute !== 0) {
      writer.uint32(417).double(message.pressurePerMapMinute);
    }
    if (message.command !== undefined) {
      CommandShipRules.encode(message.command, writer.uint32(426).fork()).join();
    }
    if (message.routeLanesMax !== 0) {
      writer.uint32(472).uint32(message.routeLanesMax);
    }
    if (message.cacheFeeCredits !== 0) {
      writer.uint32(432).uint32(message.cacheFeeCredits);
    }
    if (message.cacheFindsPerWorldDay !== 0) {
      writer.uint32(440).uint32(message.cacheFindsPerWorldDay);
    }
    if (message.cacheDepositsPerSeason !== 0) {
      writer.uint32(448).uint32(message.cacheDepositsPerSeason);
    }
    if (message.cacheHintPx !== 0) {
      writer.uint32(457).double(message.cacheHintPx);
    }
    if (message.cacheNoteMaxRunes !== 0) {
      writer.uint32(464).uint32(message.cacheNoteMaxRunes);
    }
    if (message.seaObjects !== undefined) {
      SeaObjectRules.encode(message.seaObjects, writer.uint32(482).fork()).join();
    }
    if (message.poiGateMul !== 0) {
      writer.uint32(489).double(message.poiGateMul);
    }
    if (message.poiGateReachCells !== 0) {
      writer.uint32(496).uint32(message.poiGateReachCells);
    }
    if (message.poiLairHomePx !== 0) {
      writer.uint32(505).double(message.poiLairHomePx);
    }
    if (message.poiVentStock !== 0) {
      writer.uint32(512).uint32(message.poiVentStock);
    }
    writer.uint32(522).fork();
    for (const v of message.workFitClasses) {
      writer.int32(v);
    }
    writer.join();
    if (message.commissionDayCap !== 0) {
      writer.uint32(528).uint32(message.commissionDayCap);
    }
    if (message.commissionHoldCap !== 0) {
      writer.uint32(536).uint32(message.commissionHoldCap);
    }
    if (message.routeLaneLegsMin !== 0) {
      writer.uint32(544).uint32(message.routeLaneLegsMin);
    }
    if (message.routeLaneUseMargin !== 0) {
      writer.uint32(553).double(message.routeLaneUseMargin);
    }
    if (message.routeLaneUseMinPx !== 0) {
      writer.uint32(561).double(message.routeLaneUseMinPx);
    }
    if (message.buoySpeedMul !== 0) {
      writer.uint32(569).double(message.buoySpeedMul);
    }
    if (message.laneSpeedMul !== 0) {
      writer.uint32(577).double(message.laneSpeedMul);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CatalogRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCatalogRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.idleCreditsPerHour = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.isotopeLotMin = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isotopeLotMax = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.standardPrintRuns = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.inventionRollMin = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.inventionRollMax = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.weapTypeShipDesign = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.shieldTypeShipDesign = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.intelTtlSec = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.talentTrainingMul = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 89) {
            break;
          }

          message.truceSec = reader.double();
          continue;
        }
        case 13: {
          if (tag !== 105) {
            break;
          }

          message.seasonSec = reader.double();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.oracleShareComms = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 121) {
            break;
          }

          message.torpedoFusePx = reader.double();
          continue;
        }
        case 16: {
          if (tag !== 129) {
            break;
          }

          message.radRiskCutPerLevel = reader.double();
          continue;
        }
        case 17: {
          if (tag !== 137) {
            break;
          }

          message.prospectingInjuryCutPerPoint = reader.double();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.isotopeLotsPerRadControlLevel = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.printListingsPerShipDesignLevel = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.keystoneTier = reader.uint32();
          continue;
        }
        case 22: {
          if (tag !== 177) {
            break;
          }

          message.tenderAuraPx = reader.double();
          continue;
        }
        case 23: {
          if (tag !== 185) {
            break;
          }

          message.objWindowSec = reader.double();
          continue;
        }
        case 24: {
          if (tag !== 193) {
            break;
          }

          message.wreckWindowSec = reader.double();
          continue;
        }
        case 25: {
          if (tag !== 201) {
            break;
          }

          message.wardAuraPx = reader.double();
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.captain = CaptainRules.decode(reader, reader.uint32());
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.torpedobankPointDefenceLevel = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 225) {
            break;
          }

          message.inventionRollSkew = reader.double();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.moduleGrades.push(ModuleGrade.decode(reader, reader.uint32()));
          continue;
        }
        case 30: {
          if (tag !== 241) {
            break;
          }

          message.markerLifeSec = reader.double();
          continue;
        }
        case 31: {
          if (tag !== 249) {
            break;
          }

          message.tenderRepairRangePx = reader.double();
          continue;
        }
        case 32: {
          if (tag !== 257) {
            break;
          }

          message.tenderRepairPerMapMinute = reader.double();
          continue;
        }
        case 33: {
          if (tag !== 265) {
            break;
          }

          message.tenderShieldPerCombatSec = reader.double();
          continue;
        }
        case 34: {
          if (tag !== 273) {
            break;
          }

          message.tenderRestockEverySec = reader.double();
          continue;
        }
        case 35: {
          if (tag !== 281) {
            break;
          }

          message.anchorNoiseMul = reader.double();
          continue;
        }
        case 36: {
          if (tag !== 289) {
            break;
          }

          message.gaugeMax = reader.double();
          continue;
        }
        case 37: {
          if (tag !== 297) {
            break;
          }

          message.scanRevealSec = reader.double();
          continue;
        }
        case 38: {
          if (tag !== 304) {
            break;
          }

          message.baseCapDefault = reader.uint32();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.expeditionPrepSec = reader.uint32();
          continue;
        }
        case 40: {
          if (tag !== 321) {
            break;
          }

          message.settlementDrainSec = reader.double();
          continue;
        }
        case 41: {
          if (tag !== 329) {
            break;
          }

          message.settlementCardSec = reader.double();
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.approach = ApproachRules.decode(reader, reader.uint32());
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.routeLegsMax = reader.uint32();
          continue;
        }
        case 44: {
          if (tag !== 352) {
            break;
          }

          message.routeLoopPassesMax = reader.uint32();
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.routeLoopPassesDefault = reader.uint32();
          continue;
        }
        case 46: {
          if (tag !== 369) {
            break;
          }

          message.harbourLimitsPx = reader.double();
          continue;
        }
        case 47: {
          if (tag !== 376) {
            break;
          }

          message.routePlotsMax = reader.uint32();
          continue;
        }
        case 48: {
          if (tag !== 385) {
            break;
          }

          message.tidePeriodSec = reader.double();
          continue;
        }
        case 49: {
          if (tag === 393) {
            message.tideSteps.push(reader.double());

            continue;
          }

          if (tag === 394) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.tideSteps.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 50: {
          if (tag !== 401) {
            break;
          }

          message.currentUnitPxH = reader.double();
          continue;
        }
        case 51: {
          if (tag === 409) {
            message.thermocline.push(reader.double());

            continue;
          }

          if (tag === 410) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.thermocline.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 52: {
          if (tag !== 417) {
            break;
          }

          message.pressurePerMapMinute = reader.double();
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.command = CommandShipRules.decode(reader, reader.uint32());
          continue;
        }
        case 59: {
          if (tag !== 472) {
            break;
          }

          message.routeLanesMax = reader.uint32();
          continue;
        }
        case 54: {
          if (tag !== 432) {
            break;
          }

          message.cacheFeeCredits = reader.uint32();
          continue;
        }
        case 55: {
          if (tag !== 440) {
            break;
          }

          message.cacheFindsPerWorldDay = reader.uint32();
          continue;
        }
        case 56: {
          if (tag !== 448) {
            break;
          }

          message.cacheDepositsPerSeason = reader.uint32();
          continue;
        }
        case 57: {
          if (tag !== 457) {
            break;
          }

          message.cacheHintPx = reader.double();
          continue;
        }
        case 58: {
          if (tag !== 464) {
            break;
          }

          message.cacheNoteMaxRunes = reader.uint32();
          continue;
        }
        case 60: {
          if (tag !== 482) {
            break;
          }

          message.seaObjects = SeaObjectRules.decode(reader, reader.uint32());
          continue;
        }
        case 61: {
          if (tag !== 489) {
            break;
          }

          message.poiGateMul = reader.double();
          continue;
        }
        case 62: {
          if (tag !== 496) {
            break;
          }

          message.poiGateReachCells = reader.uint32();
          continue;
        }
        case 63: {
          if (tag !== 505) {
            break;
          }

          message.poiLairHomePx = reader.double();
          continue;
        }
        case 64: {
          if (tag !== 512) {
            break;
          }

          message.poiVentStock = reader.uint32();
          continue;
        }
        case 65: {
          if (tag === 520) {
            message.workFitClasses.push(reader.int32() as any);

            continue;
          }

          if (tag === 522) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.workFitClasses.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 66: {
          if (tag !== 528) {
            break;
          }

          message.commissionDayCap = reader.uint32();
          continue;
        }
        case 67: {
          if (tag !== 536) {
            break;
          }

          message.commissionHoldCap = reader.uint32();
          continue;
        }
        case 68: {
          if (tag !== 544) {
            break;
          }

          message.routeLaneLegsMin = reader.uint32();
          continue;
        }
        case 69: {
          if (tag !== 553) {
            break;
          }

          message.routeLaneUseMargin = reader.double();
          continue;
        }
        case 70: {
          if (tag !== 561) {
            break;
          }

          message.routeLaneUseMinPx = reader.double();
          continue;
        }
        case 71: {
          if (tag !== 569) {
            break;
          }

          message.buoySpeedMul = reader.double();
          continue;
        }
        case 72: {
          if (tag !== 577) {
            break;
          }

          message.laneSpeedMul = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CatalogRules>, I>>(base?: I): CatalogRules {
    return CatalogRules.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CatalogRules>, I>>(object: I): CatalogRules {
    const message = createBaseCatalogRules();
    message.idleCreditsPerHour = object.idleCreditsPerHour ?? 0;
    message.isotopeLotMin = object.isotopeLotMin ?? 0;
    message.isotopeLotMax = object.isotopeLotMax ?? 0;
    message.standardPrintRuns = object.standardPrintRuns ?? 0;
    message.inventionRollMin = object.inventionRollMin ?? 0;
    message.inventionRollMax = object.inventionRollMax ?? 0;
    message.weapTypeShipDesign = object.weapTypeShipDesign ?? 0;
    message.shieldTypeShipDesign = object.shieldTypeShipDesign ?? 0;
    message.intelTtlSec = object.intelTtlSec ?? 0;
    message.talentTrainingMul = object.talentTrainingMul ?? 0;
    message.truceSec = object.truceSec ?? 0;
    message.seasonSec = object.seasonSec ?? 0;
    message.oracleShareComms = object.oracleShareComms ?? 0;
    message.torpedoFusePx = object.torpedoFusePx ?? 0;
    message.radRiskCutPerLevel = object.radRiskCutPerLevel ?? 0;
    message.prospectingInjuryCutPerPoint = object.prospectingInjuryCutPerPoint ?? 0;
    message.isotopeLotsPerRadControlLevel = object.isotopeLotsPerRadControlLevel ?? 0;
    message.printListingsPerShipDesignLevel = object.printListingsPerShipDesignLevel ?? 0;
    message.keystoneTier = object.keystoneTier ?? 0;
    message.tenderAuraPx = object.tenderAuraPx ?? 0;
    message.objWindowSec = object.objWindowSec ?? 0;
    message.wreckWindowSec = object.wreckWindowSec ?? 0;
    message.wardAuraPx = object.wardAuraPx ?? 0;
    message.captain = (object.captain !== undefined && object.captain !== null)
      ? CaptainRules.fromPartial(object.captain)
      : undefined;
    message.torpedobankPointDefenceLevel = object.torpedobankPointDefenceLevel ?? 0;
    message.inventionRollSkew = object.inventionRollSkew ?? 0;
    message.moduleGrades = object.moduleGrades?.map((e) => ModuleGrade.fromPartial(e)) || [];
    message.markerLifeSec = object.markerLifeSec ?? 0;
    message.tenderRepairRangePx = object.tenderRepairRangePx ?? 0;
    message.tenderRepairPerMapMinute = object.tenderRepairPerMapMinute ?? 0;
    message.tenderShieldPerCombatSec = object.tenderShieldPerCombatSec ?? 0;
    message.tenderRestockEverySec = object.tenderRestockEverySec ?? 0;
    message.anchorNoiseMul = object.anchorNoiseMul ?? 0;
    message.gaugeMax = object.gaugeMax ?? 0;
    message.scanRevealSec = object.scanRevealSec ?? 0;
    message.baseCapDefault = object.baseCapDefault ?? 0;
    message.expeditionPrepSec = object.expeditionPrepSec ?? 0;
    message.settlementDrainSec = object.settlementDrainSec ?? 0;
    message.settlementCardSec = object.settlementCardSec ?? 0;
    message.approach = (object.approach !== undefined && object.approach !== null)
      ? ApproachRules.fromPartial(object.approach)
      : undefined;
    message.routeLegsMax = object.routeLegsMax ?? 0;
    message.routeLoopPassesMax = object.routeLoopPassesMax ?? 0;
    message.routeLoopPassesDefault = object.routeLoopPassesDefault ?? 0;
    message.harbourLimitsPx = object.harbourLimitsPx ?? 0;
    message.routePlotsMax = object.routePlotsMax ?? 0;
    message.tidePeriodSec = object.tidePeriodSec ?? 0;
    message.tideSteps = object.tideSteps?.map((e) => e) || [];
    message.currentUnitPxH = object.currentUnitPxH ?? 0;
    message.thermocline = object.thermocline?.map((e) => e) || [];
    message.pressurePerMapMinute = object.pressurePerMapMinute ?? 0;
    message.command = (object.command !== undefined && object.command !== null)
      ? CommandShipRules.fromPartial(object.command)
      : undefined;
    message.routeLanesMax = object.routeLanesMax ?? 0;
    message.cacheFeeCredits = object.cacheFeeCredits ?? 0;
    message.cacheFindsPerWorldDay = object.cacheFindsPerWorldDay ?? 0;
    message.cacheDepositsPerSeason = object.cacheDepositsPerSeason ?? 0;
    message.cacheHintPx = object.cacheHintPx ?? 0;
    message.cacheNoteMaxRunes = object.cacheNoteMaxRunes ?? 0;
    message.seaObjects = (object.seaObjects !== undefined && object.seaObjects !== null)
      ? SeaObjectRules.fromPartial(object.seaObjects)
      : undefined;
    message.poiGateMul = object.poiGateMul ?? 0;
    message.poiGateReachCells = object.poiGateReachCells ?? 0;
    message.poiLairHomePx = object.poiLairHomePx ?? 0;
    message.poiVentStock = object.poiVentStock ?? 0;
    message.workFitClasses = object.workFitClasses?.map((e) => e) || [];
    message.commissionDayCap = object.commissionDayCap ?? 0;
    message.commissionHoldCap = object.commissionHoldCap ?? 0;
    message.routeLaneLegsMin = object.routeLaneLegsMin ?? 0;
    message.routeLaneUseMargin = object.routeLaneUseMargin ?? 0;
    message.routeLaneUseMinPx = object.routeLaneUseMinPx ?? 0;
    message.buoySpeedMul = object.buoySpeedMul ?? 0;
    message.laneSpeedMul = object.laneSpeedMul ?? 0;
    return message;
  },
};

function createBaseSeaObjectRules(): SeaObjectRules {
  return {
    armClearPx: 0,
    layNoiseMul: 0,
    layNoiseSec: 0,
    collectPx: 0,
    sweepPx: 0,
    sweepRadiusMul: 0,
    anchorSec: 0,
    palisadeAnchorSec: 0,
    armAfterSec: 0,
    laneChainPx: 0,
    laneSnapPx: 0,
  };
}

export const SeaObjectRules: MessageFns<SeaObjectRules> = {
  encode(message: SeaObjectRules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.armClearPx !== 0) {
      writer.uint32(9).double(message.armClearPx);
    }
    if (message.layNoiseMul !== 0) {
      writer.uint32(17).double(message.layNoiseMul);
    }
    if (message.layNoiseSec !== 0) {
      writer.uint32(25).double(message.layNoiseSec);
    }
    if (message.collectPx !== 0) {
      writer.uint32(33).double(message.collectPx);
    }
    if (message.sweepPx !== 0) {
      writer.uint32(41).double(message.sweepPx);
    }
    if (message.sweepRadiusMul !== 0) {
      writer.uint32(49).double(message.sweepRadiusMul);
    }
    if (message.anchorSec !== 0) {
      writer.uint32(57).double(message.anchorSec);
    }
    if (message.palisadeAnchorSec !== 0) {
      writer.uint32(65).double(message.palisadeAnchorSec);
    }
    if (message.armAfterSec !== 0) {
      writer.uint32(73).double(message.armAfterSec);
    }
    if (message.laneChainPx !== 0) {
      writer.uint32(81).double(message.laneChainPx);
    }
    if (message.laneSnapPx !== 0) {
      writer.uint32(89).double(message.laneSnapPx);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeaObjectRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeaObjectRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.armClearPx = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.layNoiseMul = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.layNoiseSec = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.collectPx = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.sweepPx = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.sweepRadiusMul = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.anchorSec = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.palisadeAnchorSec = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.armAfterSec = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.laneChainPx = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 89) {
            break;
          }

          message.laneSnapPx = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SeaObjectRules>, I>>(base?: I): SeaObjectRules {
    return SeaObjectRules.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeaObjectRules>, I>>(object: I): SeaObjectRules {
    const message = createBaseSeaObjectRules();
    message.armClearPx = object.armClearPx ?? 0;
    message.layNoiseMul = object.layNoiseMul ?? 0;
    message.layNoiseSec = object.layNoiseSec ?? 0;
    message.collectPx = object.collectPx ?? 0;
    message.sweepPx = object.sweepPx ?? 0;
    message.sweepRadiusMul = object.sweepRadiusMul ?? 0;
    message.anchorSec = object.anchorSec ?? 0;
    message.palisadeAnchorSec = object.palisadeAnchorSec ?? 0;
    message.armAfterSec = object.armAfterSec ?? 0;
    message.laneChainPx = object.laneChainPx ?? 0;
    message.laneSnapPx = object.laneSnapPx ?? 0;
    return message;
  },
};

function createBaseApproachRules(): ApproachRules {
  return {
    bowCos: 0,
    sternCos: 0,
    bowMul: 0,
    beamMul: 0,
    sternMul: 0,
    damageCap: 0,
    bafflesCos: 0,
    bafflesHearing: 0,
    ambushMul: 0,
    gunNoiseMul: 0,
    gunNoiseSec: 0,
    quietGateSec: 0,
    rechargeFloorSec: 0,
    belowHullFrac: 0,
    outflankSec: 0,
    outflankSpeedMul: 0,
    braceSec: 0,
    braceDamageTakenMul: 0,
    digInReachPx: 0,
    broadsideShotMul: 0,
    crashDiveSec: 0,
    crashDiveNoiseMul: 0,
    crashDiveSpeedMul: 0,
    canisterSec: 0,
    broadsideSec: 0,
    digInSec: 0,
    broadsideSplashMul: 0,
    getawaySec: 0,
    getawaySpeedMul: 0,
    getawayTurnMul: 0,
  };
}

export const ApproachRules: MessageFns<ApproachRules> = {
  encode(message: ApproachRules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bowCos !== 0) {
      writer.uint32(9).double(message.bowCos);
    }
    if (message.sternCos !== 0) {
      writer.uint32(17).double(message.sternCos);
    }
    if (message.bowMul !== 0) {
      writer.uint32(25).double(message.bowMul);
    }
    if (message.beamMul !== 0) {
      writer.uint32(33).double(message.beamMul);
    }
    if (message.sternMul !== 0) {
      writer.uint32(41).double(message.sternMul);
    }
    if (message.damageCap !== 0) {
      writer.uint32(49).double(message.damageCap);
    }
    if (message.bafflesCos !== 0) {
      writer.uint32(57).double(message.bafflesCos);
    }
    if (message.bafflesHearing !== 0) {
      writer.uint32(65).double(message.bafflesHearing);
    }
    if (message.ambushMul !== 0) {
      writer.uint32(73).double(message.ambushMul);
    }
    if (message.gunNoiseMul !== 0) {
      writer.uint32(81).double(message.gunNoiseMul);
    }
    if (message.gunNoiseSec !== 0) {
      writer.uint32(89).double(message.gunNoiseSec);
    }
    if (message.quietGateSec !== 0) {
      writer.uint32(97).double(message.quietGateSec);
    }
    if (message.rechargeFloorSec !== 0) {
      writer.uint32(105).double(message.rechargeFloorSec);
    }
    if (message.belowHullFrac !== 0) {
      writer.uint32(113).double(message.belowHullFrac);
    }
    if (message.outflankSec !== 0) {
      writer.uint32(121).double(message.outflankSec);
    }
    if (message.outflankSpeedMul !== 0) {
      writer.uint32(129).double(message.outflankSpeedMul);
    }
    if (message.braceSec !== 0) {
      writer.uint32(137).double(message.braceSec);
    }
    if (message.braceDamageTakenMul !== 0) {
      writer.uint32(145).double(message.braceDamageTakenMul);
    }
    if (message.digInReachPx !== 0) {
      writer.uint32(153).double(message.digInReachPx);
    }
    if (message.broadsideShotMul !== 0) {
      writer.uint32(161).double(message.broadsideShotMul);
    }
    if (message.crashDiveSec !== 0) {
      writer.uint32(177).double(message.crashDiveSec);
    }
    if (message.crashDiveNoiseMul !== 0) {
      writer.uint32(185).double(message.crashDiveNoiseMul);
    }
    if (message.crashDiveSpeedMul !== 0) {
      writer.uint32(193).double(message.crashDiveSpeedMul);
    }
    if (message.canisterSec !== 0) {
      writer.uint32(201).double(message.canisterSec);
    }
    if (message.broadsideSec !== 0) {
      writer.uint32(209).double(message.broadsideSec);
    }
    if (message.digInSec !== 0) {
      writer.uint32(217).double(message.digInSec);
    }
    if (message.broadsideSplashMul !== 0) {
      writer.uint32(225).double(message.broadsideSplashMul);
    }
    if (message.getawaySec !== 0) {
      writer.uint32(233).double(message.getawaySec);
    }
    if (message.getawaySpeedMul !== 0) {
      writer.uint32(241).double(message.getawaySpeedMul);
    }
    if (message.getawayTurnMul !== 0) {
      writer.uint32(249).double(message.getawayTurnMul);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApproachRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApproachRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.bowCos = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.sternCos = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.bowMul = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.beamMul = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.sternMul = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.damageCap = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.bafflesCos = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.bafflesHearing = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.ambushMul = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.gunNoiseMul = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 89) {
            break;
          }

          message.gunNoiseSec = reader.double();
          continue;
        }
        case 12: {
          if (tag !== 97) {
            break;
          }

          message.quietGateSec = reader.double();
          continue;
        }
        case 13: {
          if (tag !== 105) {
            break;
          }

          message.rechargeFloorSec = reader.double();
          continue;
        }
        case 14: {
          if (tag !== 113) {
            break;
          }

          message.belowHullFrac = reader.double();
          continue;
        }
        case 15: {
          if (tag !== 121) {
            break;
          }

          message.outflankSec = reader.double();
          continue;
        }
        case 16: {
          if (tag !== 129) {
            break;
          }

          message.outflankSpeedMul = reader.double();
          continue;
        }
        case 17: {
          if (tag !== 137) {
            break;
          }

          message.braceSec = reader.double();
          continue;
        }
        case 18: {
          if (tag !== 145) {
            break;
          }

          message.braceDamageTakenMul = reader.double();
          continue;
        }
        case 19: {
          if (tag !== 153) {
            break;
          }

          message.digInReachPx = reader.double();
          continue;
        }
        case 20: {
          if (tag !== 161) {
            break;
          }

          message.broadsideShotMul = reader.double();
          continue;
        }
        case 22: {
          if (tag !== 177) {
            break;
          }

          message.crashDiveSec = reader.double();
          continue;
        }
        case 23: {
          if (tag !== 185) {
            break;
          }

          message.crashDiveNoiseMul = reader.double();
          continue;
        }
        case 24: {
          if (tag !== 193) {
            break;
          }

          message.crashDiveSpeedMul = reader.double();
          continue;
        }
        case 25: {
          if (tag !== 201) {
            break;
          }

          message.canisterSec = reader.double();
          continue;
        }
        case 26: {
          if (tag !== 209) {
            break;
          }

          message.broadsideSec = reader.double();
          continue;
        }
        case 27: {
          if (tag !== 217) {
            break;
          }

          message.digInSec = reader.double();
          continue;
        }
        case 28: {
          if (tag !== 225) {
            break;
          }

          message.broadsideSplashMul = reader.double();
          continue;
        }
        case 29: {
          if (tag !== 233) {
            break;
          }

          message.getawaySec = reader.double();
          continue;
        }
        case 30: {
          if (tag !== 241) {
            break;
          }

          message.getawaySpeedMul = reader.double();
          continue;
        }
        case 31: {
          if (tag !== 249) {
            break;
          }

          message.getawayTurnMul = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ApproachRules>, I>>(base?: I): ApproachRules {
    return ApproachRules.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApproachRules>, I>>(object: I): ApproachRules {
    const message = createBaseApproachRules();
    message.bowCos = object.bowCos ?? 0;
    message.sternCos = object.sternCos ?? 0;
    message.bowMul = object.bowMul ?? 0;
    message.beamMul = object.beamMul ?? 0;
    message.sternMul = object.sternMul ?? 0;
    message.damageCap = object.damageCap ?? 0;
    message.bafflesCos = object.bafflesCos ?? 0;
    message.bafflesHearing = object.bafflesHearing ?? 0;
    message.ambushMul = object.ambushMul ?? 0;
    message.gunNoiseMul = object.gunNoiseMul ?? 0;
    message.gunNoiseSec = object.gunNoiseSec ?? 0;
    message.quietGateSec = object.quietGateSec ?? 0;
    message.rechargeFloorSec = object.rechargeFloorSec ?? 0;
    message.belowHullFrac = object.belowHullFrac ?? 0;
    message.outflankSec = object.outflankSec ?? 0;
    message.outflankSpeedMul = object.outflankSpeedMul ?? 0;
    message.braceSec = object.braceSec ?? 0;
    message.braceDamageTakenMul = object.braceDamageTakenMul ?? 0;
    message.digInReachPx = object.digInReachPx ?? 0;
    message.broadsideShotMul = object.broadsideShotMul ?? 0;
    message.crashDiveSec = object.crashDiveSec ?? 0;
    message.crashDiveNoiseMul = object.crashDiveNoiseMul ?? 0;
    message.crashDiveSpeedMul = object.crashDiveSpeedMul ?? 0;
    message.canisterSec = object.canisterSec ?? 0;
    message.broadsideSec = object.broadsideSec ?? 0;
    message.digInSec = object.digInSec ?? 0;
    message.broadsideSplashMul = object.broadsideSplashMul ?? 0;
    message.getawaySec = object.getawaySec ?? 0;
    message.getawaySpeedMul = object.getawaySpeedMul ?? 0;
    message.getawayTurnMul = object.getawayTurnMul ?? 0;
    return message;
  },
};

function createBaseCommandShipRules(): CommandShipRules {
  return { auraReachPx: 0, auraShare: 0, musterReachPx: 0, musterBoostMul: 0, auraAttrs: [], arcadeLiftPct: 0 };
}

export const CommandShipRules: MessageFns<CommandShipRules> = {
  encode(message: CommandShipRules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.auraReachPx !== 0) {
      writer.uint32(9).double(message.auraReachPx);
    }
    if (message.auraShare !== 0) {
      writer.uint32(17).double(message.auraShare);
    }
    if (message.musterReachPx !== 0) {
      writer.uint32(25).double(message.musterReachPx);
    }
    if (message.musterBoostMul !== 0) {
      writer.uint32(33).double(message.musterBoostMul);
    }
    writer.uint32(42).fork();
    for (const v of message.auraAttrs) {
      writer.uint32(v);
    }
    writer.join();
    if (message.arcadeLiftPct !== 0) {
      writer.uint32(48).uint32(message.arcadeLiftPct);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommandShipRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommandShipRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.auraReachPx = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.auraShare = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.musterReachPx = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.musterBoostMul = reader.double();
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.auraAttrs.push(reader.uint32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.auraAttrs.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.arcadeLiftPct = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CommandShipRules>, I>>(base?: I): CommandShipRules {
    return CommandShipRules.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommandShipRules>, I>>(object: I): CommandShipRules {
    const message = createBaseCommandShipRules();
    message.auraReachPx = object.auraReachPx ?? 0;
    message.auraShare = object.auraShare ?? 0;
    message.musterReachPx = object.musterReachPx ?? 0;
    message.musterBoostMul = object.musterBoostMul ?? 0;
    message.auraAttrs = object.auraAttrs?.map((e) => e) || [];
    message.arcadeLiftPct = object.arcadeLiftPct ?? 0;
    return message;
  },
};

function createBaseModuleGrade(): ModuleGrade {
  return { code: "", minRoll: 0, maxRoll: 0, chance: 0 };
}

export const ModuleGrade: MessageFns<ModuleGrade> = {
  encode(message: ModuleGrade, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.minRoll !== 0) {
      writer.uint32(17).double(message.minRoll);
    }
    if (message.maxRoll !== 0) {
      writer.uint32(25).double(message.maxRoll);
    }
    if (message.chance !== 0) {
      writer.uint32(33).double(message.chance);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModuleGrade {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleGrade();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.minRoll = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.maxRoll = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.chance = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ModuleGrade>, I>>(base?: I): ModuleGrade {
    return ModuleGrade.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModuleGrade>, I>>(object: I): ModuleGrade {
    const message = createBaseModuleGrade();
    message.code = object.code ?? "";
    message.minRoll = object.minRoll ?? 0;
    message.maxRoll = object.maxRoll ?? 0;
    message.chance = object.chance ?? 0;
    return message;
  },
};

function createBaseCaptainRules(): CaptainRules {
  return {
    perPointPct: [],
    injuryCutPerPointPct: 0,
    silentMaxCutPct: 0,
    peakTrainingFactor: 0,
    attrTrainCap: 0,
    retireBasePct: 0,
    retirePerSeasonPct: 0,
    yearsPerSeason: 0,
    peakAtAge: 0,
    declineAtAge: 0,
    recruitAgeMin: 0,
    recruitAgeMax: 0,
    practiceSeasonCap: 0,
    practiceDeclinePct: 0,
    trainingHoursPerPoint: 0,
    practicePointGrowth: 0,
    helmTurnPerPointPct: 0,
  };
}

export const CaptainRules: MessageFns<CaptainRules> = {
  encode(message: CaptainRules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.perPointPct) {
      writer.double(v);
    }
    writer.join();
    if (message.injuryCutPerPointPct !== 0) {
      writer.uint32(17).double(message.injuryCutPerPointPct);
    }
    if (message.silentMaxCutPct !== 0) {
      writer.uint32(25).double(message.silentMaxCutPct);
    }
    if (message.peakTrainingFactor !== 0) {
      writer.uint32(49).double(message.peakTrainingFactor);
    }
    if (message.attrTrainCap !== 0) {
      writer.uint32(56).uint32(message.attrTrainCap);
    }
    if (message.retireBasePct !== 0) {
      writer.uint32(73).double(message.retireBasePct);
    }
    if (message.retirePerSeasonPct !== 0) {
      writer.uint32(81).double(message.retirePerSeasonPct);
    }
    if (message.yearsPerSeason !== 0) {
      writer.uint32(88).uint32(message.yearsPerSeason);
    }
    if (message.peakAtAge !== 0) {
      writer.uint32(96).uint32(message.peakAtAge);
    }
    if (message.declineAtAge !== 0) {
      writer.uint32(104).uint32(message.declineAtAge);
    }
    if (message.recruitAgeMin !== 0) {
      writer.uint32(112).uint32(message.recruitAgeMin);
    }
    if (message.recruitAgeMax !== 0) {
      writer.uint32(120).uint32(message.recruitAgeMax);
    }
    if (message.practiceSeasonCap !== 0) {
      writer.uint32(128).uint32(message.practiceSeasonCap);
    }
    if (message.practiceDeclinePct !== 0) {
      writer.uint32(137).double(message.practiceDeclinePct);
    }
    if (message.trainingHoursPerPoint !== 0) {
      writer.uint32(145).double(message.trainingHoursPerPoint);
    }
    if (message.practicePointGrowth !== 0) {
      writer.uint32(153).double(message.practicePointGrowth);
    }
    if (message.helmTurnPerPointPct !== 0) {
      writer.uint32(161).double(message.helmTurnPerPointPct);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CaptainRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCaptainRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 9) {
            message.perPointPct.push(reader.double());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.perPointPct.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.injuryCutPerPointPct = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.silentMaxCutPct = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.peakTrainingFactor = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.attrTrainCap = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.retireBasePct = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.retirePerSeasonPct = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.yearsPerSeason = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.peakAtAge = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.declineAtAge = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.recruitAgeMin = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.recruitAgeMax = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.practiceSeasonCap = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 137) {
            break;
          }

          message.practiceDeclinePct = reader.double();
          continue;
        }
        case 18: {
          if (tag !== 145) {
            break;
          }

          message.trainingHoursPerPoint = reader.double();
          continue;
        }
        case 19: {
          if (tag !== 153) {
            break;
          }

          message.practicePointGrowth = reader.double();
          continue;
        }
        case 20: {
          if (tag !== 161) {
            break;
          }

          message.helmTurnPerPointPct = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CaptainRules>, I>>(base?: I): CaptainRules {
    return CaptainRules.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CaptainRules>, I>>(object: I): CaptainRules {
    const message = createBaseCaptainRules();
    message.perPointPct = object.perPointPct?.map((e) => e) || [];
    message.injuryCutPerPointPct = object.injuryCutPerPointPct ?? 0;
    message.silentMaxCutPct = object.silentMaxCutPct ?? 0;
    message.peakTrainingFactor = object.peakTrainingFactor ?? 0;
    message.attrTrainCap = object.attrTrainCap ?? 0;
    message.retireBasePct = object.retireBasePct ?? 0;
    message.retirePerSeasonPct = object.retirePerSeasonPct ?? 0;
    message.yearsPerSeason = object.yearsPerSeason ?? 0;
    message.peakAtAge = object.peakAtAge ?? 0;
    message.declineAtAge = object.declineAtAge ?? 0;
    message.recruitAgeMin = object.recruitAgeMin ?? 0;
    message.recruitAgeMax = object.recruitAgeMax ?? 0;
    message.practiceSeasonCap = object.practiceSeasonCap ?? 0;
    message.practiceDeclinePct = object.practiceDeclinePct ?? 0;
    message.trainingHoursPerPoint = object.trainingHoursPerPoint ?? 0;
    message.practicePointGrowth = object.practicePointGrowth ?? 0;
    message.helmTurnPerPointPct = object.helmTurnPerPointPct ?? 0;
    return message;
  },
};

function createBaseEventSpec(): EventSpec {
  return { id: "", toast: false, sfx: "", toastMs: 0, toastTemplate: "", toastError: false };
}

export const EventSpec: MessageFns<EventSpec> = {
  encode(message: EventSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.toast !== false) {
      writer.uint32(16).bool(message.toast);
    }
    if (message.sfx !== "") {
      writer.uint32(26).string(message.sfx);
    }
    if (message.toastMs !== 0) {
      writer.uint32(32).uint32(message.toastMs);
    }
    if (message.toastTemplate !== "") {
      writer.uint32(50).string(message.toastTemplate);
    }
    if (message.toastError !== false) {
      writer.uint32(56).bool(message.toastError);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EventSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.toast = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sfx = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.toastMs = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.toastTemplate = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.toastError = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<EventSpec>, I>>(base?: I): EventSpec {
    return EventSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EventSpec>, I>>(object: I): EventSpec {
    const message = createBaseEventSpec();
    message.id = object.id ?? "";
    message.toast = object.toast ?? false;
    message.sfx = object.sfx ?? "";
    message.toastMs = object.toastMs ?? 0;
    message.toastTemplate = object.toastTemplate ?? "";
    message.toastError = object.toastError ?? false;
    return message;
  },
};

function createBaseEventDefaults(): EventDefaults {
  return { toastMs: 0, toastDedupMs: 0 };
}

export const EventDefaults: MessageFns<EventDefaults> = {
  encode(message: EventDefaults, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.toastMs !== 0) {
      writer.uint32(8).uint32(message.toastMs);
    }
    if (message.toastDedupMs !== 0) {
      writer.uint32(16).uint32(message.toastDedupMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EventDefaults {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventDefaults();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.toastMs = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.toastDedupMs = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<EventDefaults>, I>>(base?: I): EventDefaults {
    return EventDefaults.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EventDefaults>, I>>(object: I): EventDefaults {
    const message = createBaseEventDefaults();
    message.toastMs = object.toastMs ?? 0;
    message.toastDedupMs = object.toastDedupMs ?? 0;
    return message;
  },
};

function createBaseSovBeam(): SovBeam {
  return {
    sourceId: 0,
    beacon: false,
    faction: 0,
    xMpx: 0,
    yMpx: 0,
    targetCell: 0,
    progress: 0,
    margin10: 0,
    against: 0,
    own: false,
  };
}

export const SovBeam: MessageFns<SovBeam> = {
  encode(message: SovBeam, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sourceId !== 0) {
      writer.uint32(8).uint32(message.sourceId);
    }
    if (message.beacon !== false) {
      writer.uint32(16).bool(message.beacon);
    }
    if (message.faction !== 0) {
      writer.uint32(24).uint32(message.faction);
    }
    if (message.xMpx !== 0) {
      writer.uint32(32).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(40).sint32(message.yMpx);
    }
    if (message.targetCell !== 0) {
      writer.uint32(48).uint32(message.targetCell);
    }
    if (message.progress !== 0) {
      writer.uint32(56).uint32(message.progress);
    }
    if (message.margin10 !== 0) {
      writer.uint32(64).uint32(message.margin10);
    }
    if (message.against !== 0) {
      writer.uint32(72).uint32(message.against);
    }
    if (message.own !== false) {
      writer.uint32(80).bool(message.own);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SovBeam {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSovBeam();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sourceId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.beacon = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.targetCell = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.progress = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.margin10 = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.against = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.own = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SovBeam>, I>>(base?: I): SovBeam {
    return SovBeam.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SovBeam>, I>>(object: I): SovBeam {
    const message = createBaseSovBeam();
    message.sourceId = object.sourceId ?? 0;
    message.beacon = object.beacon ?? false;
    message.faction = object.faction ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.targetCell = object.targetCell ?? 0;
    message.progress = object.progress ?? 0;
    message.margin10 = object.margin10 ?? 0;
    message.against = object.against ?? 0;
    message.own = object.own ?? false;
    return message;
  },
};

function createBaseTorpedoState(): TorpedoState {
  return {
    id: 0,
    faction: 0,
    kind: 0,
    xMpx: 0,
    yMpx: 0,
    headingMrad: 0,
    runPct: 0,
    effect: 0,
    slowed: false,
    loiterPct: 0,
  };
}

export const TorpedoState: MessageFns<TorpedoState> = {
  encode(message: TorpedoState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.faction !== 0) {
      writer.uint32(16).uint32(message.faction);
    }
    if (message.kind !== 0) {
      writer.uint32(24).int32(message.kind);
    }
    if (message.xMpx !== 0) {
      writer.uint32(32).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(40).sint32(message.yMpx);
    }
    if (message.headingMrad !== 0) {
      writer.uint32(48).sint32(message.headingMrad);
    }
    if (message.runPct !== 0) {
      writer.uint32(56).uint32(message.runPct);
    }
    if (message.effect !== 0) {
      writer.uint32(64).uint32(message.effect);
    }
    if (message.slowed !== false) {
      writer.uint32(72).bool(message.slowed);
    }
    if (message.loiterPct !== 0) {
      writer.uint32(80).uint32(message.loiterPct);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TorpedoState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTorpedoState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.headingMrad = reader.sint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.runPct = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.effect = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.slowed = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.loiterPct = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TorpedoState>, I>>(base?: I): TorpedoState {
    return TorpedoState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TorpedoState>, I>>(object: I): TorpedoState {
    const message = createBaseTorpedoState();
    message.id = object.id ?? 0;
    message.faction = object.faction ?? 0;
    message.kind = object.kind ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.headingMrad = object.headingMrad ?? 0;
    message.runPct = object.runPct ?? 0;
    message.effect = object.effect ?? 0;
    message.slowed = object.slowed ?? false;
    message.loiterPct = object.loiterPct ?? 0;
    return message;
  },
};

function createBaseSonarRing(): SonarRing {
  return { xMpx: 0, yMpx: 0, rangePx: 0 };
}

export const SonarRing: MessageFns<SonarRing> = {
  encode(message: SonarRing, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.xMpx !== 0) {
      writer.uint32(8).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(16).sint32(message.yMpx);
    }
    if (message.rangePx !== 0) {
      writer.uint32(24).uint32(message.rangePx);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SonarRing {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSonarRing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.rangePx = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SonarRing>, I>>(base?: I): SonarRing {
    return SonarRing.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SonarRing>, I>>(object: I): SonarRing {
    const message = createBaseSonarRing();
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.rangePx = object.rangePx ?? 0;
    return message;
  },
};

function createBaseFleetState(): FleetState {
  return {
    id: 0,
    faction: 0,
    xMpx: 0,
    yMpx: 0,
    cls: 0,
    hullPct: 0,
    shieldPct: 0,
    mission: 0,
    txMpx: 0,
    tyMpx: 0,
    own: false,
    captainId: 0,
    name: "",
    slowed: false,
    design: 0,
    reloadSec: 0,
    torpedoRange: 0,
    hold: [],
    cargoCap: 0,
    captureLeftSec: 0,
    escorting: 0,
    focus: 0,
    chase: 0,
    weapType: 0,
    shieldType: 0,
    pxMpx: 0,
    pyMpx: 0,
    ownerPlayer: 0,
    ownerName: "",
    deep: false,
    readinessPct: 0,
    readinessFloorPct: 0,
    scanReadySec: 0,
    sonarPx: 0,
    sonarShare: false,
    sonarShareLeftSec: 0,
    anchor: 0,
    anchorLeftSec: 0,
    heard: false,
    deepRun: false,
    shaft: false,
    tending: 0,
    aura: 0,
    battlePlan: 0,
    effect: 0,
    pledgeSite: 0,
    autoFieldOff: false,
    livery: 0,
    hullMax: 0,
    shieldMax: 0,
    holdFire: false,
    reloadFullSec: 0,
    noiseMilli: 0,
    regenInSec: 0,
    decoyReadySec: 0,
    scanLeftSec: 0,
    customName: false,
    rounds: [],
    activeRound: 0,
    guard: undefined,
    headingMrad: 0,
    quiet: false,
    signatureCharge: 0,
    signatureActive: false,
    signatureLeftSec: 0,
    signatureOrder: 0,
    signatureTarget: 0,
    signatureFloorSec: 0,
    legs: [],
    leg: 0,
    pass: 0,
    conditions: [],
    formation: false,
    formationOf: 0,
    npc: 0,
    depthRating: 0,
    searchHint: 0,
    workLeftSec: 0,
    stow: [],
    layReadySec: 0,
    loudLeftSec: 0,
    monsterDesign: 0,
    npcAct: 0,
    npcActLeftMs: 0,
    brotherhood: 0,
    boardingTarget: 0,
    boardedBy: 0,
    boardingMilli: 0,
    boardingLeftMs: 0,
    workFullSec: 0,
    beamLeftSec: 0,
    withdrawing: false,
    holdFast: false,
  };
}

export const FleetState: MessageFns<FleetState> = {
  encode(message: FleetState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.faction !== 0) {
      writer.uint32(16).uint32(message.faction);
    }
    if (message.xMpx !== 0) {
      writer.uint32(24).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(32).sint32(message.yMpx);
    }
    if (message.cls !== 0) {
      writer.uint32(40).int32(message.cls);
    }
    if (message.hullPct !== 0) {
      writer.uint32(56).uint32(message.hullPct);
    }
    if (message.shieldPct !== 0) {
      writer.uint32(64).uint32(message.shieldPct);
    }
    if (message.mission !== 0) {
      writer.uint32(72).int32(message.mission);
    }
    if (message.txMpx !== 0) {
      writer.uint32(80).sint32(message.txMpx);
    }
    if (message.tyMpx !== 0) {
      writer.uint32(88).sint32(message.tyMpx);
    }
    if (message.own !== false) {
      writer.uint32(96).bool(message.own);
    }
    if (message.captainId !== 0) {
      writer.uint32(104).uint32(message.captainId);
    }
    if (message.name !== "") {
      writer.uint32(114).string(message.name);
    }
    if (message.slowed !== false) {
      writer.uint32(128).bool(message.slowed);
    }
    if (message.design !== 0) {
      writer.uint32(136).uint32(message.design);
    }
    if (message.reloadSec !== 0) {
      writer.uint32(152).uint32(message.reloadSec);
    }
    if (message.torpedoRange !== 0) {
      writer.uint32(160).uint32(message.torpedoRange);
    }
    for (const v of message.hold) {
      HoldStack.encode(v!, writer.uint32(178).fork()).join();
    }
    if (message.cargoCap !== 0) {
      writer.uint32(184).uint32(message.cargoCap);
    }
    if (message.captureLeftSec !== 0) {
      writer.uint32(192).uint32(message.captureLeftSec);
    }
    if (message.escorting !== 0) {
      writer.uint32(216).uint32(message.escorting);
    }
    if (message.focus !== 0) {
      writer.uint32(328).uint32(message.focus);
    }
    if (message.chase !== 0) {
      writer.uint32(760).uint32(message.chase);
    }
    if (message.weapType !== 0) {
      writer.uint32(224).uint32(message.weapType);
    }
    if (message.shieldType !== 0) {
      writer.uint32(232).uint32(message.shieldType);
    }
    if (message.pxMpx !== 0) {
      writer.uint32(240).sint32(message.pxMpx);
    }
    if (message.pyMpx !== 0) {
      writer.uint32(248).sint32(message.pyMpx);
    }
    if (message.ownerPlayer !== 0) {
      writer.uint32(200).uint32(message.ownerPlayer);
    }
    if (message.ownerName !== "") {
      writer.uint32(306).string(message.ownerName);
    }
    if (message.deep !== false) {
      writer.uint32(208).bool(message.deep);
    }
    if (message.readinessPct !== 0) {
      writer.uint32(256).uint32(message.readinessPct);
    }
    if (message.readinessFloorPct !== 0) {
      writer.uint32(376).uint32(message.readinessFloorPct);
    }
    if (message.scanReadySec !== 0) {
      writer.uint32(264).uint32(message.scanReadySec);
    }
    if (message.sonarPx !== 0) {
      writer.uint32(272).uint32(message.sonarPx);
    }
    if (message.sonarShare !== false) {
      writer.uint32(312).bool(message.sonarShare);
    }
    if (message.sonarShareLeftSec !== 0) {
      writer.uint32(320).uint32(message.sonarShareLeftSec);
    }
    if (message.anchor !== 0) {
      writer.uint32(280).int32(message.anchor);
    }
    if (message.anchorLeftSec !== 0) {
      writer.uint32(288).uint32(message.anchorLeftSec);
    }
    if (message.heard !== false) {
      writer.uint32(336).bool(message.heard);
    }
    if (message.deepRun !== false) {
      writer.uint32(344).bool(message.deepRun);
    }
    if (message.shaft !== false) {
      writer.uint32(352).bool(message.shaft);
    }
    if (message.tending !== 0) {
      writer.uint32(360).uint32(message.tending);
    }
    if (message.aura !== 0) {
      writer.uint32(368).uint32(message.aura);
    }
    if (message.battlePlan !== 0) {
      writer.uint32(384).uint32(message.battlePlan);
    }
    if (message.effect !== 0) {
      writer.uint32(392).uint32(message.effect);
    }
    if (message.pledgeSite !== 0) {
      writer.uint32(400).uint32(message.pledgeSite);
    }
    if (message.autoFieldOff !== false) {
      writer.uint32(408).bool(message.autoFieldOff);
    }
    if (message.livery !== 0) {
      writer.uint32(416).uint32(message.livery);
    }
    if (message.hullMax !== 0) {
      writer.uint32(424).uint32(message.hullMax);
    }
    if (message.shieldMax !== 0) {
      writer.uint32(432).uint32(message.shieldMax);
    }
    if (message.holdFire !== false) {
      writer.uint32(440).bool(message.holdFire);
    }
    if (message.reloadFullSec !== 0) {
      writer.uint32(448).uint32(message.reloadFullSec);
    }
    if (message.noiseMilli !== 0) {
      writer.uint32(456).uint32(message.noiseMilli);
    }
    if (message.regenInSec !== 0) {
      writer.uint32(464).uint32(message.regenInSec);
    }
    if (message.decoyReadySec !== 0) {
      writer.uint32(472).uint32(message.decoyReadySec);
    }
    if (message.scanLeftSec !== 0) {
      writer.uint32(480).uint32(message.scanLeftSec);
    }
    if (message.customName !== false) {
      writer.uint32(488).bool(message.customName);
    }
    for (const v of message.rounds) {
      TorpedoStock.encode(v!, writer.uint32(498).fork()).join();
    }
    if (message.activeRound !== 0) {
      writer.uint32(504).int32(message.activeRound);
    }
    if (message.guard !== undefined) {
      GuardState.encode(message.guard, writer.uint32(514).fork()).join();
    }
    if (message.headingMrad !== 0) {
      writer.uint32(520).sint32(message.headingMrad);
    }
    if (message.quiet !== false) {
      writer.uint32(528).bool(message.quiet);
    }
    if (message.signatureCharge !== 0) {
      writer.uint32(536).int32(message.signatureCharge);
    }
    if (message.signatureActive !== false) {
      writer.uint32(552).bool(message.signatureActive);
    }
    if (message.signatureLeftSec !== 0) {
      writer.uint32(560).uint32(message.signatureLeftSec);
    }
    if (message.signatureOrder !== 0) {
      writer.uint32(568).int32(message.signatureOrder);
    }
    if (message.signatureTarget !== 0) {
      writer.uint32(576).uint32(message.signatureTarget);
    }
    if (message.signatureFloorSec !== 0) {
      writer.uint32(584).uint32(message.signatureFloorSec);
    }
    for (const v of message.legs) {
      Waypoint.encode(v!, writer.uint32(594).fork()).join();
    }
    if (message.leg !== 0) {
      writer.uint32(600).uint32(message.leg);
    }
    if (message.pass !== 0) {
      writer.uint32(608).uint32(message.pass);
    }
    for (const v of message.conditions) {
      Condition.encode(v!, writer.uint32(618).fork()).join();
    }
    if (message.formation !== false) {
      writer.uint32(624).bool(message.formation);
    }
    if (message.formationOf !== 0) {
      writer.uint32(632).uint32(message.formationOf);
    }
    if (message.npc !== 0) {
      writer.uint32(640).int32(message.npc);
    }
    if (message.depthRating !== 0) {
      writer.uint32(648).int32(message.depthRating);
    }
    if (message.searchHint !== 0) {
      writer.uint32(656).uint32(message.searchHint);
    }
    if (message.workLeftSec !== 0) {
      writer.uint32(664).uint32(message.workLeftSec);
    }
    for (const v of message.stow) {
      SeaObjectStock.encode(v!, writer.uint32(674).fork()).join();
    }
    if (message.layReadySec !== 0) {
      writer.uint32(680).uint32(message.layReadySec);
    }
    if (message.loudLeftSec !== 0) {
      writer.uint32(688).uint32(message.loudLeftSec);
    }
    if (message.monsterDesign !== 0) {
      writer.uint32(696).uint32(message.monsterDesign);
    }
    if (message.npcAct !== 0) {
      writer.uint32(704).int32(message.npcAct);
    }
    if (message.npcActLeftMs !== 0) {
      writer.uint32(712).uint32(message.npcActLeftMs);
    }
    if (message.brotherhood !== 0) {
      writer.uint32(720).int32(message.brotherhood);
    }
    if (message.boardingTarget !== 0) {
      writer.uint32(728).uint32(message.boardingTarget);
    }
    if (message.boardedBy !== 0) {
      writer.uint32(736).uint32(message.boardedBy);
    }
    if (message.boardingMilli !== 0) {
      writer.uint32(744).uint32(message.boardingMilli);
    }
    if (message.boardingLeftMs !== 0) {
      writer.uint32(752).uint32(message.boardingLeftMs);
    }
    if (message.workFullSec !== 0) {
      writer.uint32(768).uint32(message.workFullSec);
    }
    if (message.beamLeftSec !== 0) {
      writer.uint32(776).uint32(message.beamLeftSec);
    }
    if (message.withdrawing !== false) {
      writer.uint32(784).bool(message.withdrawing);
    }
    if (message.holdFast !== false) {
      writer.uint32(792).bool(message.holdFast);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FleetState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFleetState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.cls = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.hullPct = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.shieldPct = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.mission = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.txMpx = reader.sint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.tyMpx = reader.sint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.own = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.captainId = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.slowed = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.design = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.reloadSec = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.torpedoRange = reader.uint32();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.hold.push(HoldStack.decode(reader, reader.uint32()));
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.cargoCap = reader.uint32();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.captureLeftSec = reader.uint32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.escorting = reader.uint32();
          continue;
        }
        case 41: {
          if (tag !== 328) {
            break;
          }

          message.focus = reader.uint32();
          continue;
        }
        case 95: {
          if (tag !== 760) {
            break;
          }

          message.chase = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.weapType = reader.uint32();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.shieldType = reader.uint32();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.pxMpx = reader.sint32();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.pyMpx = reader.sint32();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.ownerPlayer = reader.uint32();
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.ownerName = reader.string();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.deep = reader.bool();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.readinessPct = reader.uint32();
          continue;
        }
        case 47: {
          if (tag !== 376) {
            break;
          }

          message.readinessFloorPct = reader.uint32();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.scanReadySec = reader.uint32();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.sonarPx = reader.uint32();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.sonarShare = reader.bool();
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.sonarShareLeftSec = reader.uint32();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.anchor = reader.int32() as any;
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.anchorLeftSec = reader.uint32();
          continue;
        }
        case 42: {
          if (tag !== 336) {
            break;
          }

          message.heard = reader.bool();
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.deepRun = reader.bool();
          continue;
        }
        case 44: {
          if (tag !== 352) {
            break;
          }

          message.shaft = reader.bool();
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.tending = reader.uint32();
          continue;
        }
        case 46: {
          if (tag !== 368) {
            break;
          }

          message.aura = reader.uint32();
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.battlePlan = reader.uint32();
          continue;
        }
        case 49: {
          if (tag !== 392) {
            break;
          }

          message.effect = reader.uint32();
          continue;
        }
        case 50: {
          if (tag !== 400) {
            break;
          }

          message.pledgeSite = reader.uint32();
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.autoFieldOff = reader.bool();
          continue;
        }
        case 52: {
          if (tag !== 416) {
            break;
          }

          message.livery = reader.uint32();
          continue;
        }
        case 53: {
          if (tag !== 424) {
            break;
          }

          message.hullMax = reader.uint32();
          continue;
        }
        case 54: {
          if (tag !== 432) {
            break;
          }

          message.shieldMax = reader.uint32();
          continue;
        }
        case 55: {
          if (tag !== 440) {
            break;
          }

          message.holdFire = reader.bool();
          continue;
        }
        case 56: {
          if (tag !== 448) {
            break;
          }

          message.reloadFullSec = reader.uint32();
          continue;
        }
        case 57: {
          if (tag !== 456) {
            break;
          }

          message.noiseMilli = reader.uint32();
          continue;
        }
        case 58: {
          if (tag !== 464) {
            break;
          }

          message.regenInSec = reader.uint32();
          continue;
        }
        case 59: {
          if (tag !== 472) {
            break;
          }

          message.decoyReadySec = reader.uint32();
          continue;
        }
        case 60: {
          if (tag !== 480) {
            break;
          }

          message.scanLeftSec = reader.uint32();
          continue;
        }
        case 61: {
          if (tag !== 488) {
            break;
          }

          message.customName = reader.bool();
          continue;
        }
        case 62: {
          if (tag !== 498) {
            break;
          }

          message.rounds.push(TorpedoStock.decode(reader, reader.uint32()));
          continue;
        }
        case 63: {
          if (tag !== 504) {
            break;
          }

          message.activeRound = reader.int32() as any;
          continue;
        }
        case 64: {
          if (tag !== 514) {
            break;
          }

          message.guard = GuardState.decode(reader, reader.uint32());
          continue;
        }
        case 65: {
          if (tag !== 520) {
            break;
          }

          message.headingMrad = reader.sint32();
          continue;
        }
        case 66: {
          if (tag !== 528) {
            break;
          }

          message.quiet = reader.bool();
          continue;
        }
        case 67: {
          if (tag !== 536) {
            break;
          }

          message.signatureCharge = reader.int32() as any;
          continue;
        }
        case 69: {
          if (tag !== 552) {
            break;
          }

          message.signatureActive = reader.bool();
          continue;
        }
        case 70: {
          if (tag !== 560) {
            break;
          }

          message.signatureLeftSec = reader.uint32();
          continue;
        }
        case 71: {
          if (tag !== 568) {
            break;
          }

          message.signatureOrder = reader.int32() as any;
          continue;
        }
        case 72: {
          if (tag !== 576) {
            break;
          }

          message.signatureTarget = reader.uint32();
          continue;
        }
        case 73: {
          if (tag !== 584) {
            break;
          }

          message.signatureFloorSec = reader.uint32();
          continue;
        }
        case 74: {
          if (tag !== 594) {
            break;
          }

          message.legs.push(Waypoint.decode(reader, reader.uint32()));
          continue;
        }
        case 75: {
          if (tag !== 600) {
            break;
          }

          message.leg = reader.uint32();
          continue;
        }
        case 76: {
          if (tag !== 608) {
            break;
          }

          message.pass = reader.uint32();
          continue;
        }
        case 77: {
          if (tag !== 618) {
            break;
          }

          message.conditions.push(Condition.decode(reader, reader.uint32()));
          continue;
        }
        case 78: {
          if (tag !== 624) {
            break;
          }

          message.formation = reader.bool();
          continue;
        }
        case 79: {
          if (tag !== 632) {
            break;
          }

          message.formationOf = reader.uint32();
          continue;
        }
        case 80: {
          if (tag !== 640) {
            break;
          }

          message.npc = reader.int32() as any;
          continue;
        }
        case 81: {
          if (tag !== 648) {
            break;
          }

          message.depthRating = reader.int32() as any;
          continue;
        }
        case 82: {
          if (tag !== 656) {
            break;
          }

          message.searchHint = reader.uint32();
          continue;
        }
        case 83: {
          if (tag !== 664) {
            break;
          }

          message.workLeftSec = reader.uint32();
          continue;
        }
        case 84: {
          if (tag !== 674) {
            break;
          }

          message.stow.push(SeaObjectStock.decode(reader, reader.uint32()));
          continue;
        }
        case 85: {
          if (tag !== 680) {
            break;
          }

          message.layReadySec = reader.uint32();
          continue;
        }
        case 86: {
          if (tag !== 688) {
            break;
          }

          message.loudLeftSec = reader.uint32();
          continue;
        }
        case 87: {
          if (tag !== 696) {
            break;
          }

          message.monsterDesign = reader.uint32();
          continue;
        }
        case 88: {
          if (tag !== 704) {
            break;
          }

          message.npcAct = reader.int32() as any;
          continue;
        }
        case 89: {
          if (tag !== 712) {
            break;
          }

          message.npcActLeftMs = reader.uint32();
          continue;
        }
        case 90: {
          if (tag !== 720) {
            break;
          }

          message.brotherhood = reader.int32() as any;
          continue;
        }
        case 91: {
          if (tag !== 728) {
            break;
          }

          message.boardingTarget = reader.uint32();
          continue;
        }
        case 92: {
          if (tag !== 736) {
            break;
          }

          message.boardedBy = reader.uint32();
          continue;
        }
        case 93: {
          if (tag !== 744) {
            break;
          }

          message.boardingMilli = reader.uint32();
          continue;
        }
        case 94: {
          if (tag !== 752) {
            break;
          }

          message.boardingLeftMs = reader.uint32();
          continue;
        }
        case 96: {
          if (tag !== 768) {
            break;
          }

          message.workFullSec = reader.uint32();
          continue;
        }
        case 97: {
          if (tag !== 776) {
            break;
          }

          message.beamLeftSec = reader.uint32();
          continue;
        }
        case 98: {
          if (tag !== 784) {
            break;
          }

          message.withdrawing = reader.bool();
          continue;
        }
        case 99: {
          if (tag !== 792) {
            break;
          }

          message.holdFast = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<FleetState>, I>>(base?: I): FleetState {
    return FleetState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FleetState>, I>>(object: I): FleetState {
    const message = createBaseFleetState();
    message.id = object.id ?? 0;
    message.faction = object.faction ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.cls = object.cls ?? 0;
    message.hullPct = object.hullPct ?? 0;
    message.shieldPct = object.shieldPct ?? 0;
    message.mission = object.mission ?? 0;
    message.txMpx = object.txMpx ?? 0;
    message.tyMpx = object.tyMpx ?? 0;
    message.own = object.own ?? false;
    message.captainId = object.captainId ?? 0;
    message.name = object.name ?? "";
    message.slowed = object.slowed ?? false;
    message.design = object.design ?? 0;
    message.reloadSec = object.reloadSec ?? 0;
    message.torpedoRange = object.torpedoRange ?? 0;
    message.hold = object.hold?.map((e) => HoldStack.fromPartial(e)) || [];
    message.cargoCap = object.cargoCap ?? 0;
    message.captureLeftSec = object.captureLeftSec ?? 0;
    message.escorting = object.escorting ?? 0;
    message.focus = object.focus ?? 0;
    message.chase = object.chase ?? 0;
    message.weapType = object.weapType ?? 0;
    message.shieldType = object.shieldType ?? 0;
    message.pxMpx = object.pxMpx ?? 0;
    message.pyMpx = object.pyMpx ?? 0;
    message.ownerPlayer = object.ownerPlayer ?? 0;
    message.ownerName = object.ownerName ?? "";
    message.deep = object.deep ?? false;
    message.readinessPct = object.readinessPct ?? 0;
    message.readinessFloorPct = object.readinessFloorPct ?? 0;
    message.scanReadySec = object.scanReadySec ?? 0;
    message.sonarPx = object.sonarPx ?? 0;
    message.sonarShare = object.sonarShare ?? false;
    message.sonarShareLeftSec = object.sonarShareLeftSec ?? 0;
    message.anchor = object.anchor ?? 0;
    message.anchorLeftSec = object.anchorLeftSec ?? 0;
    message.heard = object.heard ?? false;
    message.deepRun = object.deepRun ?? false;
    message.shaft = object.shaft ?? false;
    message.tending = object.tending ?? 0;
    message.aura = object.aura ?? 0;
    message.battlePlan = object.battlePlan ?? 0;
    message.effect = object.effect ?? 0;
    message.pledgeSite = object.pledgeSite ?? 0;
    message.autoFieldOff = object.autoFieldOff ?? false;
    message.livery = object.livery ?? 0;
    message.hullMax = object.hullMax ?? 0;
    message.shieldMax = object.shieldMax ?? 0;
    message.holdFire = object.holdFire ?? false;
    message.reloadFullSec = object.reloadFullSec ?? 0;
    message.noiseMilli = object.noiseMilli ?? 0;
    message.regenInSec = object.regenInSec ?? 0;
    message.decoyReadySec = object.decoyReadySec ?? 0;
    message.scanLeftSec = object.scanLeftSec ?? 0;
    message.customName = object.customName ?? false;
    message.rounds = object.rounds?.map((e) => TorpedoStock.fromPartial(e)) || [];
    message.activeRound = object.activeRound ?? 0;
    message.guard = (object.guard !== undefined && object.guard !== null)
      ? GuardState.fromPartial(object.guard)
      : undefined;
    message.headingMrad = object.headingMrad ?? 0;
    message.quiet = object.quiet ?? false;
    message.signatureCharge = object.signatureCharge ?? 0;
    message.signatureActive = object.signatureActive ?? false;
    message.signatureLeftSec = object.signatureLeftSec ?? 0;
    message.signatureOrder = object.signatureOrder ?? 0;
    message.signatureTarget = object.signatureTarget ?? 0;
    message.signatureFloorSec = object.signatureFloorSec ?? 0;
    message.legs = object.legs?.map((e) => Waypoint.fromPartial(e)) || [];
    message.leg = object.leg ?? 0;
    message.pass = object.pass ?? 0;
    message.conditions = object.conditions?.map((e) => Condition.fromPartial(e)) || [];
    message.formation = object.formation ?? false;
    message.formationOf = object.formationOf ?? 0;
    message.npc = object.npc ?? 0;
    message.depthRating = object.depthRating ?? 0;
    message.searchHint = object.searchHint ?? 0;
    message.workLeftSec = object.workLeftSec ?? 0;
    message.stow = object.stow?.map((e) => SeaObjectStock.fromPartial(e)) || [];
    message.layReadySec = object.layReadySec ?? 0;
    message.loudLeftSec = object.loudLeftSec ?? 0;
    message.monsterDesign = object.monsterDesign ?? 0;
    message.npcAct = object.npcAct ?? 0;
    message.npcActLeftMs = object.npcActLeftMs ?? 0;
    message.brotherhood = object.brotherhood ?? 0;
    message.boardingTarget = object.boardingTarget ?? 0;
    message.boardedBy = object.boardedBy ?? 0;
    message.boardingMilli = object.boardingMilli ?? 0;
    message.boardingLeftMs = object.boardingLeftMs ?? 0;
    message.workFullSec = object.workFullSec ?? 0;
    message.beamLeftSec = object.beamLeftSec ?? 0;
    message.withdrawing = object.withdrawing ?? false;
    message.holdFast = object.holdFast ?? false;
    return message;
  },
};

function createBaseWaypoint(): Waypoint {
  return { xMpx: 0, yMpx: 0, loop: false, passes: 0 };
}

export const Waypoint: MessageFns<Waypoint> = {
  encode(message: Waypoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.xMpx !== 0) {
      writer.uint32(8).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(16).sint32(message.yMpx);
    }
    if (message.loop !== false) {
      writer.uint32(24).bool(message.loop);
    }
    if (message.passes !== 0) {
      writer.uint32(32).uint32(message.passes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Waypoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.loop = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.passes = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Waypoint>, I>>(base?: I): Waypoint {
    return Waypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Waypoint>, I>>(object: I): Waypoint {
    const message = createBaseWaypoint();
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.loop = object.loop ?? false;
    message.passes = object.passes ?? 0;
    return message;
  },
};

function createBaseCondition(): Condition {
  return { key: 0, pct: 0, leftSec: 0 };
}

export const Condition: MessageFns<Condition> = {
  encode(message: Condition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.pct !== 0) {
      writer.uint32(16).uint32(message.pct);
    }
    if (message.leftSec !== 0) {
      writer.uint32(24).uint32(message.leftSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Condition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.pct = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.leftSec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Condition>, I>>(base?: I): Condition {
    return Condition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Condition>, I>>(object: I): Condition {
    const message = createBaseCondition();
    message.key = object.key ?? 0;
    message.pct = object.pct ?? 0;
    message.leftSec = object.leftSec ?? 0;
    return message;
  },
};

function createBaseGuardState(): GuardState {
  return { reachPx: 0, everySec: 0, leftSec: 0 };
}

export const GuardState: MessageFns<GuardState> = {
  encode(message: GuardState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reachPx !== 0) {
      writer.uint32(8).uint32(message.reachPx);
    }
    if (message.everySec !== 0) {
      writer.uint32(16).uint32(message.everySec);
    }
    if (message.leftSec !== 0) {
      writer.uint32(24).uint32(message.leftSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GuardState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGuardState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.reachPx = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.everySec = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.leftSec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<GuardState>, I>>(base?: I): GuardState {
    return GuardState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GuardState>, I>>(object: I): GuardState {
    const message = createBaseGuardState();
    message.reachPx = object.reachPx ?? 0;
    message.everySec = object.everySec ?? 0;
    message.leftSec = object.leftSec ?? 0;
    return message;
  },
};

function createBaseState(): State {
  return {
    tick: 0,
    fleets: [],
    torpedoes: [],
    removed: [],
    full: false,
    gauges: [],
    beams: [],
    flips: [],
    owners: new Uint8Array(0),
    beamsGone: [],
    surveyed: [],
    surveyedBands: new Uint8Array(0),
    surveyedCurrents: new Uint8Array(0),
    survey: new Uint8Array(0),
    pois: [],
    namedSeamounts: [],
    objects: [],
    objectsGone: [],
    poiLive: [],
    adminCaches: undefined,
    cargoSightings: [],
    cargoSightingsGone: [],
  };
}

export const State: MessageFns<State> = {
  encode(message: State, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tick !== 0) {
      writer.uint32(8).uint64(message.tick);
    }
    for (const v of message.fleets) {
      FleetState.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.torpedoes) {
      TorpedoState.encode(v!, writer.uint32(34).fork()).join();
    }
    writer.uint32(42).fork();
    for (const v of message.removed) {
      writer.uint32(v);
    }
    writer.join();
    if (message.full !== false) {
      writer.uint32(48).bool(message.full);
    }
    for (const v of message.gauges) {
      CellGauge.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.beams) {
      SovBeam.encode(v!, writer.uint32(66).fork()).join();
    }
    for (const v of message.flips) {
      CellFlip.encode(v!, writer.uint32(74).fork()).join();
    }
    if (message.owners.length !== 0) {
      writer.uint32(82).bytes(message.owners);
    }
    writer.uint32(90).fork();
    for (const v of message.beamsGone) {
      writer.uint64(v);
    }
    writer.join();
    writer.uint32(98).fork();
    for (const v of message.surveyed) {
      writer.uint32(v);
    }
    writer.join();
    if (message.surveyedBands.length !== 0) {
      writer.uint32(106).bytes(message.surveyedBands);
    }
    if (message.surveyedCurrents.length !== 0) {
      writer.uint32(114).bytes(message.surveyedCurrents);
    }
    if (message.survey.length !== 0) {
      writer.uint32(122).bytes(message.survey);
    }
    for (const v of message.pois) {
      PointOfInterest.encode(v!, writer.uint32(130).fork()).join();
    }
    for (const v of message.namedSeamounts) {
      NamedSeamount.encode(v!, writer.uint32(138).fork()).join();
    }
    for (const v of message.objects) {
      SeaObject.encode(v!, writer.uint32(146).fork()).join();
    }
    writer.uint32(154).fork();
    for (const v of message.objectsGone) {
      writer.uint32(v);
    }
    writer.join();
    for (const v of message.poiLive) {
      PoiLive.encode(v!, writer.uint32(162).fork()).join();
    }
    if (message.adminCaches !== undefined) {
      AdminCaches.encode(message.adminCaches, writer.uint32(170).fork()).join();
    }
    for (const v of message.cargoSightings) {
      CargoSighting.encode(v!, writer.uint32(178).fork()).join();
    }
    writer.uint32(186).fork();
    for (const v of message.cargoSightingsGone) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): State {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tick = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fleets.push(FleetState.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.torpedoes.push(TorpedoState.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.removed.push(reader.uint32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.removed.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.full = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.gauges.push(CellGauge.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.beams.push(SovBeam.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.flips.push(CellFlip.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.owners = reader.bytes();
          continue;
        }
        case 11: {
          if (tag === 88) {
            message.beamsGone.push(longToNumber(reader.uint64()));

            continue;
          }

          if (tag === 90) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.beamsGone.push(longToNumber(reader.uint64()));
            }

            continue;
          }

          break;
        }
        case 12: {
          if (tag === 96) {
            message.surveyed.push(reader.uint32());

            continue;
          }

          if (tag === 98) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.surveyed.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.surveyedBands = reader.bytes();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.surveyedCurrents = reader.bytes();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.survey = reader.bytes();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.pois.push(PointOfInterest.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.namedSeamounts.push(NamedSeamount.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.objects.push(SeaObject.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag === 152) {
            message.objectsGone.push(reader.uint32());

            continue;
          }

          if (tag === 154) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.objectsGone.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.poiLive.push(PoiLive.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.adminCaches = AdminCaches.decode(reader, reader.uint32());
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.cargoSightings.push(CargoSighting.decode(reader, reader.uint32()));
          continue;
        }
        case 23: {
          if (tag === 184) {
            message.cargoSightingsGone.push(reader.uint32());

            continue;
          }

          if (tag === 186) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.cargoSightingsGone.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<State>, I>>(base?: I): State {
    return State.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<State>, I>>(object: I): State {
    const message = createBaseState();
    message.tick = object.tick ?? 0;
    message.fleets = object.fleets?.map((e) => FleetState.fromPartial(e)) || [];
    message.torpedoes = object.torpedoes?.map((e) => TorpedoState.fromPartial(e)) || [];
    message.removed = object.removed?.map((e) => e) || [];
    message.full = object.full ?? false;
    message.gauges = object.gauges?.map((e) => CellGauge.fromPartial(e)) || [];
    message.beams = object.beams?.map((e) => SovBeam.fromPartial(e)) || [];
    message.flips = object.flips?.map((e) => CellFlip.fromPartial(e)) || [];
    message.owners = object.owners ?? new Uint8Array(0);
    message.beamsGone = object.beamsGone?.map((e) => e) || [];
    message.surveyed = object.surveyed?.map((e) => e) || [];
    message.surveyedBands = object.surveyedBands ?? new Uint8Array(0);
    message.surveyedCurrents = object.surveyedCurrents ?? new Uint8Array(0);
    message.survey = object.survey ?? new Uint8Array(0);
    message.pois = object.pois?.map((e) => PointOfInterest.fromPartial(e)) || [];
    message.namedSeamounts = object.namedSeamounts?.map((e) => NamedSeamount.fromPartial(e)) || [];
    message.objects = object.objects?.map((e) => SeaObject.fromPartial(e)) || [];
    message.objectsGone = object.objectsGone?.map((e) => e) || [];
    message.poiLive = object.poiLive?.map((e) => PoiLive.fromPartial(e)) || [];
    message.adminCaches = (object.adminCaches !== undefined && object.adminCaches !== null)
      ? AdminCaches.fromPartial(object.adminCaches)
      : undefined;
    message.cargoSightings = object.cargoSightings?.map((e) => CargoSighting.fromPartial(e)) || [];
    message.cargoSightingsGone = object.cargoSightingsGone?.map((e) => e) || [];
    return message;
  },
};

function createBaseAdminCaches(): AdminCaches {
  return { rows: [] };
}

export const AdminCaches: MessageFns<AdminCaches> = {
  encode(message: AdminCaches, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rows) {
      AdminCache.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminCaches {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminCaches();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rows.push(AdminCache.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<AdminCaches>, I>>(base?: I): AdminCaches {
    return AdminCaches.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminCaches>, I>>(object: I): AdminCaches {
    const message = createBaseAdminCaches();
    message.rows = object.rows?.map((e) => AdminCache.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAdminCache(): AdminCache {
  return { id: 0, kind: 0, cell: 0, taken: false };
}

export const AdminCache: MessageFns<AdminCache> = {
  encode(message: AdminCache, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind);
    }
    if (message.cell !== 0) {
      writer.uint32(24).uint32(message.cell);
    }
    if (message.taken !== false) {
      writer.uint32(32).bool(message.taken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminCache {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminCache();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.taken = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<AdminCache>, I>>(base?: I): AdminCache {
    return AdminCache.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminCache>, I>>(object: I): AdminCache {
    const message = createBaseAdminCache();
    message.id = object.id ?? 0;
    message.kind = object.kind ?? 0;
    message.cell = object.cell ?? 0;
    message.taken = object.taken ?? false;
    return message;
  },
};

function createBaseSeaObject(): SeaObject {
  return {
    id: 0,
    faction: 0,
    kind: 0,
    xMpx: 0,
    yMpx: 0,
    headingMrad: 0,
    armed: false,
    hullPct: 0,
    own: false,
    heard: false,
    leftMapSec: 0,
    armLeftMapMs: 0,
    inert: false,
    target: false,
  };
}

export const SeaObject: MessageFns<SeaObject> = {
  encode(message: SeaObject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.faction !== 0) {
      writer.uint32(16).uint32(message.faction);
    }
    if (message.kind !== 0) {
      writer.uint32(24).int32(message.kind);
    }
    if (message.xMpx !== 0) {
      writer.uint32(32).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(40).sint32(message.yMpx);
    }
    if (message.headingMrad !== 0) {
      writer.uint32(48).sint32(message.headingMrad);
    }
    if (message.armed !== false) {
      writer.uint32(56).bool(message.armed);
    }
    if (message.hullPct !== 0) {
      writer.uint32(64).uint32(message.hullPct);
    }
    if (message.own !== false) {
      writer.uint32(72).bool(message.own);
    }
    if (message.heard !== false) {
      writer.uint32(88).bool(message.heard);
    }
    if (message.leftMapSec !== 0) {
      writer.uint32(96).uint32(message.leftMapSec);
    }
    if (message.armLeftMapMs !== 0) {
      writer.uint32(104).uint32(message.armLeftMapMs);
    }
    if (message.inert !== false) {
      writer.uint32(112).bool(message.inert);
    }
    if (message.target !== false) {
      writer.uint32(120).bool(message.target);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeaObject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeaObject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.headingMrad = reader.sint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.armed = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.hullPct = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.own = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.heard = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.leftMapSec = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.armLeftMapMs = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.inert = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.target = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SeaObject>, I>>(base?: I): SeaObject {
    return SeaObject.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeaObject>, I>>(object: I): SeaObject {
    const message = createBaseSeaObject();
    message.id = object.id ?? 0;
    message.faction = object.faction ?? 0;
    message.kind = object.kind ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.headingMrad = object.headingMrad ?? 0;
    message.armed = object.armed ?? false;
    message.hullPct = object.hullPct ?? 0;
    message.own = object.own ?? false;
    message.heard = object.heard ?? false;
    message.leftMapSec = object.leftMapSec ?? 0;
    message.armLeftMapMs = object.armLeftMapMs ?? 0;
    message.inert = object.inert ?? false;
    message.target = object.target ?? false;
    return message;
  },
};

function createBaseCellGauge(): CellGauge {
  return { index: 0, gauge10: 0 };
}

export const CellGauge: MessageFns<CellGauge> = {
  encode(message: CellGauge, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.index !== 0) {
      writer.uint32(8).uint32(message.index);
    }
    if (message.gauge10 !== 0) {
      writer.uint32(16).uint32(message.gauge10);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CellGauge {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCellGauge();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.index = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.gauge10 = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CellGauge>, I>>(base?: I): CellGauge {
    return CellGauge.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CellGauge>, I>>(object: I): CellGauge {
    const message = createBaseCellGauge();
    message.index = object.index ?? 0;
    message.gauge10 = object.gauge10 ?? 0;
    return message;
  },
};

function createBaseCellFlip(): CellFlip {
  return { index: 0, from: 0, to: 0 };
}

export const CellFlip: MessageFns<CellFlip> = {
  encode(message: CellFlip, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.index !== 0) {
      writer.uint32(8).uint32(message.index);
    }
    if (message.from !== 0) {
      writer.uint32(16).uint32(message.from);
    }
    if (message.to !== 0) {
      writer.uint32(24).uint32(message.to);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CellFlip {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCellFlip();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.index = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.from = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.to = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CellFlip>, I>>(base?: I): CellFlip {
    return CellFlip.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CellFlip>, I>>(object: I): CellFlip {
    const message = createBaseCellFlip();
    message.index = object.index ?? 0;
    message.from = object.from ?? 0;
    message.to = object.to ?? 0;
    return message;
  },
};

function createBasePong(): Pong {
  return { nonce: 0 };
}

export const Pong: MessageFns<Pong> = {
  encode(message: Pong, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nonce !== 0) {
      writer.uint32(8).uint64(message.nonce);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Pong {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePong();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.nonce = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Pong>, I>>(base?: I): Pong {
    return Pong.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Pong>, I>>(object: I): Pong {
    const message = createBasePong();
    message.nonce = object.nonce ?? 0;
    return message;
  },
};

function createBaseSite(): Site {
  return {
    id: 0,
    kind: 0,
    cell: 0,
    faction: 0,
    name: "",
    resource: 0,
    amount: 0,
    ownerPlayer: 0,
    capacity: 0,
    respawnSec: 0,
    commander: "",
    effect: 0,
    clanTag: "",
  };
}

export const Site: MessageFns<Site> = {
  encode(message: Site, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind);
    }
    if (message.cell !== 0) {
      writer.uint32(24).uint32(message.cell);
    }
    if (message.faction !== 0) {
      writer.uint32(32).uint32(message.faction);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.resource !== 0) {
      writer.uint32(48).uint32(message.resource);
    }
    if (message.amount !== 0) {
      writer.uint32(56).uint32(message.amount);
    }
    if (message.ownerPlayer !== 0) {
      writer.uint32(64).uint32(message.ownerPlayer);
    }
    if (message.capacity !== 0) {
      writer.uint32(72).uint32(message.capacity);
    }
    if (message.respawnSec !== 0) {
      writer.uint32(80).uint32(message.respawnSec);
    }
    if (message.commander !== "") {
      writer.uint32(90).string(message.commander);
    }
    if (message.effect !== 0) {
      writer.uint32(96).uint32(message.effect);
    }
    if (message.clanTag !== "") {
      writer.uint32(106).string(message.clanTag);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Site {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSite();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.resource = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.amount = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.ownerPlayer = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.capacity = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.respawnSec = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.commander = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.effect = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.clanTag = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Site>, I>>(base?: I): Site {
    return Site.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Site>, I>>(object: I): Site {
    const message = createBaseSite();
    message.id = object.id ?? 0;
    message.kind = object.kind ?? 0;
    message.cell = object.cell ?? 0;
    message.faction = object.faction ?? 0;
    message.name = object.name ?? "";
    message.resource = object.resource ?? 0;
    message.amount = object.amount ?? 0;
    message.ownerPlayer = object.ownerPlayer ?? 0;
    message.capacity = object.capacity ?? 0;
    message.respawnSec = object.respawnSec ?? 0;
    message.commander = object.commander ?? "";
    message.effect = object.effect ?? 0;
    message.clanTag = object.clanTag ?? "";
    return message;
  },
};

function createBaseSiteOwner(): SiteOwner {
  return { siteId: 0, faction: 0, amount: 0, capacity: 0, respawnSec: 0, effect: 0 };
}

export const SiteOwner: MessageFns<SiteOwner> = {
  encode(message: SiteOwner, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.siteId !== 0) {
      writer.uint32(8).uint32(message.siteId);
    }
    if (message.faction !== 0) {
      writer.uint32(16).uint32(message.faction);
    }
    if (message.amount !== 0) {
      writer.uint32(24).uint32(message.amount);
    }
    if (message.capacity !== 0) {
      writer.uint32(32).uint32(message.capacity);
    }
    if (message.respawnSec !== 0) {
      writer.uint32(40).uint32(message.respawnSec);
    }
    if (message.effect !== 0) {
      writer.uint32(48).uint32(message.effect);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SiteOwner {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSiteOwner();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.siteId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.amount = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.capacity = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.respawnSec = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.effect = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SiteOwner>, I>>(base?: I): SiteOwner {
    return SiteOwner.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SiteOwner>, I>>(object: I): SiteOwner {
    const message = createBaseSiteOwner();
    message.siteId = object.siteId ?? 0;
    message.faction = object.faction ?? 0;
    message.amount = object.amount ?? 0;
    message.capacity = object.capacity ?? 0;
    message.respawnSec = object.respawnSec ?? 0;
    message.effect = object.effect ?? 0;
    return message;
  },
};

function createBaseSiteAdded(): SiteAdded {
  return { site: undefined };
}

export const SiteAdded: MessageFns<SiteAdded> = {
  encode(message: SiteAdded, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.site !== undefined) {
      Site.encode(message.site, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SiteAdded {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSiteAdded();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.site = Site.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SiteAdded>, I>>(base?: I): SiteAdded {
    return SiteAdded.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SiteAdded>, I>>(object: I): SiteAdded {
    const message = createBaseSiteAdded();
    message.site = (object.site !== undefined && object.site !== null) ? Site.fromPartial(object.site) : undefined;
    return message;
  },
};

function createBaseSiteRemoved(): SiteRemoved {
  return { siteId: 0 };
}

export const SiteRemoved: MessageFns<SiteRemoved> = {
  encode(message: SiteRemoved, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.siteId !== 0) {
      writer.uint32(8).uint32(message.siteId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SiteRemoved {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSiteRemoved();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.siteId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SiteRemoved>, I>>(base?: I): SiteRemoved {
    return SiteRemoved.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SiteRemoved>, I>>(object: I): SiteRemoved {
    const message = createBaseSiteRemoved();
    message.siteId = object.siteId ?? 0;
    return message;
  },
};

function createBaseQuakeInfo(): QuakeInfo {
  return { stage: 0, placed: false, xMpx: 0, yMpx: 0, radiusPx: 0, damagePctX10: 0, nextShockSec: 0 };
}

export const QuakeInfo: MessageFns<QuakeInfo> = {
  encode(message: QuakeInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stage !== 0) {
      writer.uint32(8).uint32(message.stage);
    }
    if (message.placed !== false) {
      writer.uint32(16).bool(message.placed);
    }
    if (message.xMpx !== 0) {
      writer.uint32(24).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(32).sint32(message.yMpx);
    }
    if (message.radiusPx !== 0) {
      writer.uint32(40).uint32(message.radiusPx);
    }
    if (message.damagePctX10 !== 0) {
      writer.uint32(48).uint32(message.damagePctX10);
    }
    if (message.nextShockSec !== 0) {
      writer.uint32(56).uint32(message.nextShockSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QuakeInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuakeInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.stage = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.placed = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.radiusPx = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.damagePctX10 = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.nextShockSec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<QuakeInfo>, I>>(base?: I): QuakeInfo {
    return QuakeInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QuakeInfo>, I>>(object: I): QuakeInfo {
    const message = createBaseQuakeInfo();
    message.stage = object.stage ?? 0;
    message.placed = object.placed ?? false;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.radiusPx = object.radiusPx ?? 0;
    message.damagePctX10 = object.damagePctX10 ?? 0;
    message.nextShockSec = object.nextShockSec ?? 0;
    return message;
  },
};

function createBaseMaintenanceInfo(): MaintenanceInfo {
  return { startsAtUnix: 0, endsAtUnix: 0, note: "" };
}

export const MaintenanceInfo: MessageFns<MaintenanceInfo> = {
  encode(message: MaintenanceInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startsAtUnix !== 0) {
      writer.uint32(8).int64(message.startsAtUnix);
    }
    if (message.endsAtUnix !== 0) {
      writer.uint32(16).int64(message.endsAtUnix);
    }
    if (message.note !== "") {
      writer.uint32(26).string(message.note);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MaintenanceInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMaintenanceInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.startsAtUnix = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.endsAtUnix = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.note = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<MaintenanceInfo>, I>>(base?: I): MaintenanceInfo {
    return MaintenanceInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MaintenanceInfo>, I>>(object: I): MaintenanceInfo {
    const message = createBaseMaintenanceInfo();
    message.startsAtUnix = object.startsAtUnix ?? 0;
    message.endsAtUnix = object.endsAtUnix ?? 0;
    message.note = object.note ?? "";
    return message;
  },
};

function createBaseResources(): Resources {
  return { alloy: 0, biomass: 0, volatiles: 0, isotopes: 0, credits: 0 };
}

export const Resources: MessageFns<Resources> = {
  encode(message: Resources, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.alloy !== 0) {
      writer.uint32(8).uint32(message.alloy);
    }
    if (message.biomass !== 0) {
      writer.uint32(16).uint32(message.biomass);
    }
    if (message.volatiles !== 0) {
      writer.uint32(24).uint32(message.volatiles);
    }
    if (message.isotopes !== 0) {
      writer.uint32(32).uint32(message.isotopes);
    }
    if (message.credits !== 0) {
      writer.uint32(40).uint32(message.credits);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Resources {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResources();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.alloy = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.biomass = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.volatiles = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isotopes = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.credits = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Resources>, I>>(base?: I): Resources {
    return Resources.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Resources>, I>>(object: I): Resources {
    const message = createBaseResources();
    message.alloy = object.alloy ?? 0;
    message.biomass = object.biomass ?? 0;
    message.volatiles = object.volatiles ?? 0;
    message.isotopes = object.isotopes ?? 0;
    message.credits = object.credits ?? 0;
    return message;
  },
};

function createBaseLevelEffect(): LevelEffect {
  return { kind: 0, now: 0, next: 0 };
}

export const LevelEffect: MessageFns<LevelEffect> = {
  encode(message: LevelEffect, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.now !== 0) {
      writer.uint32(17).double(message.now);
    }
    if (message.next !== 0) {
      writer.uint32(25).double(message.next);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LevelEffect {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLevelEffect();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.now = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.next = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<LevelEffect>, I>>(base?: I): LevelEffect {
    return LevelEffect.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LevelEffect>, I>>(object: I): LevelEffect {
    const message = createBaseLevelEffect();
    message.kind = object.kind ?? 0;
    message.now = object.now ?? 0;
    message.next = object.next ?? 0;
    return message;
  },
};

function createBasePreviewQuery(): PreviewQuery {
  return { building: 0 };
}

export const PreviewQuery: MessageFns<PreviewQuery> = {
  encode(message: PreviewQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.building !== 0) {
      writer.uint32(8).int32(message.building);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreviewQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreviewQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.building = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<PreviewQuery>, I>>(base?: I): PreviewQuery {
    return PreviewQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PreviewQuery>, I>>(object: I): PreviewQuery {
    const message = createBasePreviewQuery();
    message.building = object.building ?? 0;
    return message;
  },
};

function createBaseBuildingPreview(): BuildingPreview {
  return { building: 0, level: 0, queued: 0, levels: [] };
}

export const BuildingPreview: MessageFns<BuildingPreview> = {
  encode(message: BuildingPreview, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.building !== 0) {
      writer.uint32(8).int32(message.building);
    }
    if (message.level !== 0) {
      writer.uint32(16).uint32(message.level);
    }
    if (message.queued !== 0) {
      writer.uint32(24).uint32(message.queued);
    }
    for (const v of message.levels) {
      LevelPreview.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BuildingPreview {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBuildingPreview();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.building = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.level = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.queued = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.levels.push(LevelPreview.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<BuildingPreview>, I>>(base?: I): BuildingPreview {
    return BuildingPreview.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BuildingPreview>, I>>(object: I): BuildingPreview {
    const message = createBaseBuildingPreview();
    message.building = object.building ?? 0;
    message.level = object.level ?? 0;
    message.queued = object.queued ?? 0;
    message.levels = object.levels?.map((e) => LevelPreview.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLevelPreview(): LevelPreview {
  return { level: 0, cost: undefined, timeSec: 0, effects: [] };
}

export const LevelPreview: MessageFns<LevelPreview> = {
  encode(message: LevelPreview, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.level !== 0) {
      writer.uint32(8).uint32(message.level);
    }
    if (message.cost !== undefined) {
      Resources.encode(message.cost, writer.uint32(18).fork()).join();
    }
    if (message.timeSec !== 0) {
      writer.uint32(24).uint32(message.timeSec);
    }
    for (const v of message.effects) {
      LevelEffect.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LevelPreview {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLevelPreview();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.level = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cost = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.timeSec = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.effects.push(LevelEffect.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<LevelPreview>, I>>(base?: I): LevelPreview {
    return LevelPreview.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LevelPreview>, I>>(object: I): LevelPreview {
    const message = createBaseLevelPreview();
    message.level = object.level ?? 0;
    message.cost = (object.cost !== undefined && object.cost !== null) ? Resources.fromPartial(object.cost) : undefined;
    message.timeSec = object.timeSec ?? 0;
    message.effects = object.effects?.map((e) => LevelEffect.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBuildingLevel(): BuildingLevel {
  return {
    building: 0,
    level: 0,
    nextCost: undefined,
    nextTimeSec: 0,
    maxed: false,
    queued: 0,
    effects: [],
    nextNeedsBase: 0,
  };
}

export const BuildingLevel: MessageFns<BuildingLevel> = {
  encode(message: BuildingLevel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.building !== 0) {
      writer.uint32(8).int32(message.building);
    }
    if (message.level !== 0) {
      writer.uint32(16).uint32(message.level);
    }
    if (message.nextCost !== undefined) {
      Resources.encode(message.nextCost, writer.uint32(26).fork()).join();
    }
    if (message.nextTimeSec !== 0) {
      writer.uint32(32).uint32(message.nextTimeSec);
    }
    if (message.maxed !== false) {
      writer.uint32(40).bool(message.maxed);
    }
    if (message.queued !== 0) {
      writer.uint32(48).uint32(message.queued);
    }
    for (const v of message.effects) {
      LevelEffect.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.nextNeedsBase !== 0) {
      writer.uint32(64).uint32(message.nextNeedsBase);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BuildingLevel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBuildingLevel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.building = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.level = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nextCost = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.nextTimeSec = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.maxed = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.queued = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.effects.push(LevelEffect.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.nextNeedsBase = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<BuildingLevel>, I>>(base?: I): BuildingLevel {
    return BuildingLevel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BuildingLevel>, I>>(object: I): BuildingLevel {
    const message = createBaseBuildingLevel();
    message.building = object.building ?? 0;
    message.level = object.level ?? 0;
    message.nextCost = (object.nextCost !== undefined && object.nextCost !== null)
      ? Resources.fromPartial(object.nextCost)
      : undefined;
    message.nextTimeSec = object.nextTimeSec ?? 0;
    message.maxed = object.maxed ?? false;
    message.queued = object.queued ?? 0;
    message.effects = object.effects?.map((e) => LevelEffect.fromPartial(e)) || [];
    message.nextNeedsBase = object.nextNeedsBase ?? 0;
    return message;
  },
};

function createBaseJob(): Job {
  return {
    id: 0,
    kind: 0,
    target: 0,
    level: 0,
    count: 0,
    remainingMs: 0,
    totalMs: 0,
    active: false,
    rushCost: 0,
    label: "",
    etaSec: 0,
    startSec: 0,
  };
}

export const Job: MessageFns<Job> = {
  encode(message: Job, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind);
    }
    if (message.target !== 0) {
      writer.uint32(24).uint32(message.target);
    }
    if (message.level !== 0) {
      writer.uint32(32).uint32(message.level);
    }
    if (message.count !== 0) {
      writer.uint32(40).uint32(message.count);
    }
    if (message.remainingMs !== 0) {
      writer.uint32(48).uint32(message.remainingMs);
    }
    if (message.totalMs !== 0) {
      writer.uint32(56).uint32(message.totalMs);
    }
    if (message.active !== false) {
      writer.uint32(64).bool(message.active);
    }
    if (message.rushCost !== 0) {
      writer.uint32(72).uint32(message.rushCost);
    }
    if (message.label !== "") {
      writer.uint32(82).string(message.label);
    }
    if (message.etaSec !== 0) {
      writer.uint32(88).uint32(message.etaSec);
    }
    if (message.startSec !== 0) {
      writer.uint32(96).uint32(message.startSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Job {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.target = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.level = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.remainingMs = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.totalMs = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.rushCost = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.etaSec = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.startSec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Job>, I>>(base?: I): Job {
    return Job.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Job>, I>>(object: I): Job {
    const message = createBaseJob();
    message.id = object.id ?? 0;
    message.kind = object.kind ?? 0;
    message.target = object.target ?? 0;
    message.level = object.level ?? 0;
    message.count = object.count ?? 0;
    message.remainingMs = object.remainingMs ?? 0;
    message.totalMs = object.totalMs ?? 0;
    message.active = object.active ?? false;
    message.rushCost = object.rushCost ?? 0;
    message.label = object.label ?? "";
    message.etaSec = object.etaSec ?? 0;
    message.startSec = object.startSec ?? 0;
    return message;
  },
};

function createBaseShipStock(): ShipStock {
  return {
    cls: 0,
    design: 0,
    designName: "",
    wearPct: 0,
    repairCost: undefined,
    repairTimeSec: 0,
    fleetId: 0,
    name: "",
    captainId: 0,
    holdFast: false,
    fit: [],
    weapType: 0,
    shieldType: 0,
    loadMix: [],
    activeRound: 0,
    magazineCargo: 0,
    stow: [],
  };
}

export const ShipStock: MessageFns<ShipStock> = {
  encode(message: ShipStock, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cls !== 0) {
      writer.uint32(8).int32(message.cls);
    }
    if (message.design !== 0) {
      writer.uint32(24).uint32(message.design);
    }
    if (message.designName !== "") {
      writer.uint32(34).string(message.designName);
    }
    if (message.wearPct !== 0) {
      writer.uint32(40).uint32(message.wearPct);
    }
    if (message.repairCost !== undefined) {
      Resources.encode(message.repairCost, writer.uint32(50).fork()).join();
    }
    if (message.repairTimeSec !== 0) {
      writer.uint32(56).uint32(message.repairTimeSec);
    }
    if (message.fleetId !== 0) {
      writer.uint32(64).uint32(message.fleetId);
    }
    if (message.name !== "") {
      writer.uint32(74).string(message.name);
    }
    if (message.captainId !== 0) {
      writer.uint32(80).uint32(message.captainId);
    }
    if (message.holdFast !== false) {
      writer.uint32(96).bool(message.holdFast);
    }
    for (const v of message.fit) {
      Module.encode(v!, writer.uint32(106).fork()).join();
    }
    if (message.weapType !== 0) {
      writer.uint32(112).uint32(message.weapType);
    }
    if (message.shieldType !== 0) {
      writer.uint32(120).uint32(message.shieldType);
    }
    for (const v of message.loadMix) {
      TorpedoStock.encode(v!, writer.uint32(130).fork()).join();
    }
    if (message.activeRound !== 0) {
      writer.uint32(136).int32(message.activeRound);
    }
    if (message.magazineCargo !== 0) {
      writer.uint32(144).uint32(message.magazineCargo);
    }
    for (const v of message.stow) {
      SeaObjectStock.encode(v!, writer.uint32(154).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ShipStock {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShipStock();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.cls = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.design = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.designName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.wearPct = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.repairCost = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.repairTimeSec = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.captainId = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.holdFast = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.fit.push(Module.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.weapType = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.shieldType = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.loadMix.push(TorpedoStock.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.activeRound = reader.int32() as any;
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.magazineCargo = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.stow.push(SeaObjectStock.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ShipStock>, I>>(base?: I): ShipStock {
    return ShipStock.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ShipStock>, I>>(object: I): ShipStock {
    const message = createBaseShipStock();
    message.cls = object.cls ?? 0;
    message.design = object.design ?? 0;
    message.designName = object.designName ?? "";
    message.wearPct = object.wearPct ?? 0;
    message.repairCost = (object.repairCost !== undefined && object.repairCost !== null)
      ? Resources.fromPartial(object.repairCost)
      : undefined;
    message.repairTimeSec = object.repairTimeSec ?? 0;
    message.fleetId = object.fleetId ?? 0;
    message.name = object.name ?? "";
    message.captainId = object.captainId ?? 0;
    message.holdFast = object.holdFast ?? false;
    message.fit = object.fit?.map((e) => Module.fromPartial(e)) || [];
    message.weapType = object.weapType ?? 0;
    message.shieldType = object.shieldType ?? 0;
    message.loadMix = object.loadMix?.map((e) => TorpedoStock.fromPartial(e)) || [];
    message.activeRound = object.activeRound ?? 0;
    message.magazineCargo = object.magazineCargo ?? 0;
    message.stow = object.stow?.map((e) => SeaObjectStock.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCompressedCargo(): CompressedCargo {
  return { fleetId: 0, cargo: undefined };
}

export const CompressedCargo: MessageFns<CompressedCargo> = {
  encode(message: CompressedCargo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fleetId !== 0) {
      writer.uint32(8).uint32(message.fleetId);
    }
    if (message.cargo !== undefined) {
      Resources.encode(message.cargo, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompressedCargo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompressedCargo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cargo = Resources.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CompressedCargo>, I>>(base?: I): CompressedCargo {
    return CompressedCargo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompressedCargo>, I>>(object: I): CompressedCargo {
    const message = createBaseCompressedCargo();
    message.fleetId = object.fleetId ?? 0;
    message.cargo = (object.cargo !== undefined && object.cargo !== null)
      ? Resources.fromPartial(object.cargo)
      : undefined;
    return message;
  },
};

function createBaseFleetFit(): FleetFit {
  return { fleetId: 0, fit: [] };
}

export const FleetFit: MessageFns<FleetFit> = {
  encode(message: FleetFit, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fleetId !== 0) {
      writer.uint32(8).uint32(message.fleetId);
    }
    for (const v of message.fit) {
      Module.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FleetFit {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFleetFit();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fit.push(Module.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<FleetFit>, I>>(base?: I): FleetFit {
    return FleetFit.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FleetFit>, I>>(object: I): FleetFit {
    const message = createBaseFleetFit();
    message.fleetId = object.fleetId ?? 0;
    message.fit = object.fit?.map((e) => Module.fromPartial(e)) || [];
    return message;
  },
};

function createBaseModule(): Module {
  return { family: 0, tier: 0, effectPct: 0, name: "", grade: "" };
}

export const Module: MessageFns<Module> = {
  encode(message: Module, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.family !== 0) {
      writer.uint32(8).int32(message.family);
    }
    if (message.tier !== 0) {
      writer.uint32(16).uint32(message.tier);
    }
    if (message.effectPct !== 0) {
      writer.uint32(24).uint32(message.effectPct);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.grade !== "") {
      writer.uint32(42).string(message.grade);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Module {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModule();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.family = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.tier = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.effectPct = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.grade = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Module>, I>>(base?: I): Module {
    return Module.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Module>, I>>(object: I): Module {
    const message = createBaseModule();
    message.family = object.family ?? 0;
    message.tier = object.tier ?? 0;
    message.effectPct = object.effectPct ?? 0;
    message.name = object.name ?? "";
    message.grade = object.grade ?? "";
    return message;
  },
};

function createBaseModuleSpec(): ModuleSpec {
  return { family: 0, tier: 0, name: "", effectPct: 0, costShare: 0, tech: 0, draftIsotopes: 0, redraftIsotopes: 0 };
}

export const ModuleSpec: MessageFns<ModuleSpec> = {
  encode(message: ModuleSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.family !== 0) {
      writer.uint32(8).int32(message.family);
    }
    if (message.tier !== 0) {
      writer.uint32(16).uint32(message.tier);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.effectPct !== 0) {
      writer.uint32(32).uint32(message.effectPct);
    }
    if (message.costShare !== 0) {
      writer.uint32(41).double(message.costShare);
    }
    if (message.tech !== 0) {
      writer.uint32(48).uint32(message.tech);
    }
    if (message.draftIsotopes !== 0) {
      writer.uint32(56).uint32(message.draftIsotopes);
    }
    if (message.redraftIsotopes !== 0) {
      writer.uint32(64).uint32(message.redraftIsotopes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModuleSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.family = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.tier = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.effectPct = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.costShare = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.tech = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.draftIsotopes = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.redraftIsotopes = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ModuleSpec>, I>>(base?: I): ModuleSpec {
    return ModuleSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModuleSpec>, I>>(object: I): ModuleSpec {
    const message = createBaseModuleSpec();
    message.family = object.family ?? 0;
    message.tier = object.tier ?? 0;
    message.name = object.name ?? "";
    message.effectPct = object.effectPct ?? 0;
    message.costShare = object.costShare ?? 0;
    message.tech = object.tech ?? 0;
    message.draftIsotopes = object.draftIsotopes ?? 0;
    message.redraftIsotopes = object.redraftIsotopes ?? 0;
    return message;
  },
};

function createBaseBlueprint(): Blueprint {
  return {
    id: 0,
    name: "",
    hull: 0,
    modules: [],
    basic: false,
    cost: undefined,
    stock: 0,
    master: false,
    masterId: 0,
    runs: 0,
    generation: 0,
    weapType: 0,
    shieldType: 0,
    inventor: "",
    fitted: undefined,
  };
}

export const Blueprint: MessageFns<Blueprint> = {
  encode(message: Blueprint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.hull !== 0) {
      writer.uint32(24).int32(message.hull);
    }
    for (const v of message.modules) {
      Module.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.basic !== false) {
      writer.uint32(40).bool(message.basic);
    }
    if (message.cost !== undefined) {
      Resources.encode(message.cost, writer.uint32(50).fork()).join();
    }
    if (message.stock !== 0) {
      writer.uint32(56).uint32(message.stock);
    }
    if (message.master !== false) {
      writer.uint32(64).bool(message.master);
    }
    if (message.masterId !== 0) {
      writer.uint32(72).uint32(message.masterId);
    }
    if (message.runs !== 0) {
      writer.uint32(80).uint32(message.runs);
    }
    if (message.generation !== 0) {
      writer.uint32(88).uint32(message.generation);
    }
    if (message.weapType !== 0) {
      writer.uint32(96).uint32(message.weapType);
    }
    if (message.shieldType !== 0) {
      writer.uint32(104).uint32(message.shieldType);
    }
    if (message.inventor !== "") {
      writer.uint32(114).string(message.inventor);
    }
    if (message.fitted !== undefined) {
      FittedFigures.encode(message.fitted, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Blueprint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlueprint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.hull = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.modules.push(Module.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.basic = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.cost = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.stock = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.master = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.masterId = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.runs = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.generation = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.weapType = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.shieldType = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.inventor = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.fitted = FittedFigures.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Blueprint>, I>>(base?: I): Blueprint {
    return Blueprint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Blueprint>, I>>(object: I): Blueprint {
    const message = createBaseBlueprint();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.hull = object.hull ?? 0;
    message.modules = object.modules?.map((e) => Module.fromPartial(e)) || [];
    message.basic = object.basic ?? false;
    message.cost = (object.cost !== undefined && object.cost !== null) ? Resources.fromPartial(object.cost) : undefined;
    message.stock = object.stock ?? 0;
    message.master = object.master ?? false;
    message.masterId = object.masterId ?? 0;
    message.runs = object.runs ?? 0;
    message.generation = object.generation ?? 0;
    message.weapType = object.weapType ?? 0;
    message.shieldType = object.shieldType ?? 0;
    message.inventor = object.inventor ?? "";
    message.fitted = (object.fitted !== undefined && object.fitted !== null)
      ? FittedFigures.fromPartial(object.fitted)
      : undefined;
    return message;
  },
};

function createBaseFittedFigures(): FittedFigures {
  return { shield: 0, speedUh: 0, sonar: 0, shotDamageX10: 0, noise: 0 };
}

export const FittedFigures: MessageFns<FittedFigures> = {
  encode(message: FittedFigures, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.shield !== 0) {
      writer.uint32(8).uint32(message.shield);
    }
    if (message.speedUh !== 0) {
      writer.uint32(16).uint32(message.speedUh);
    }
    if (message.sonar !== 0) {
      writer.uint32(24).uint32(message.sonar);
    }
    if (message.shotDamageX10 !== 0) {
      writer.uint32(32).uint32(message.shotDamageX10);
    }
    if (message.noise !== 0) {
      writer.uint32(41).double(message.noise);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FittedFigures {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFittedFigures();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.shield = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.speedUh = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.sonar = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.shotDamageX10 = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.noise = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<FittedFigures>, I>>(base?: I): FittedFigures {
    return FittedFigures.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FittedFigures>, I>>(object: I): FittedFigures {
    const message = createBaseFittedFigures();
    message.shield = object.shield ?? 0;
    message.speedUh = object.speedUh ?? 0;
    message.sonar = object.sonar ?? 0;
    message.shotDamageX10 = object.shotDamageX10 ?? 0;
    message.noise = object.noise ?? 0;
    return message;
  },
};

function createBaseExpeditionState(): ExpeditionState {
  return { id: 0, depth: 0, captainId: 0, captainName: "", remainingSec: 0, totalSec: 0 };
}

export const ExpeditionState: MessageFns<ExpeditionState> = {
  encode(message: ExpeditionState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.depth !== 0) {
      writer.uint32(16).uint32(message.depth);
    }
    if (message.captainId !== 0) {
      writer.uint32(24).uint32(message.captainId);
    }
    if (message.captainName !== "") {
      writer.uint32(34).string(message.captainName);
    }
    if (message.remainingSec !== 0) {
      writer.uint32(40).uint32(message.remainingSec);
    }
    if (message.totalSec !== 0) {
      writer.uint32(48).uint32(message.totalSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExpeditionState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExpeditionState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.depth = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.captainId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.captainName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.remainingSec = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.totalSec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ExpeditionState>, I>>(base?: I): ExpeditionState {
    return ExpeditionState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExpeditionState>, I>>(object: I): ExpeditionState {
    const message = createBaseExpeditionState();
    message.id = object.id ?? 0;
    message.depth = object.depth ?? 0;
    message.captainId = object.captainId ?? 0;
    message.captainName = object.captainName ?? "";
    message.remainingSec = object.remainingSec ?? 0;
    message.totalSec = object.totalSec ?? 0;
    return message;
  },
};

function createBaseExpeditionSpec(): ExpeditionSpec {
  return { depth: 0, name: "", radControl: 0, tech: 0, durationSec: 0, isotopes: 0, coreChancePct: 0, injuryPct: 0 };
}

export const ExpeditionSpec: MessageFns<ExpeditionSpec> = {
  encode(message: ExpeditionSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.depth !== 0) {
      writer.uint32(8).uint32(message.depth);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.radControl !== 0) {
      writer.uint32(24).uint32(message.radControl);
    }
    if (message.tech !== 0) {
      writer.uint32(32).uint32(message.tech);
    }
    if (message.durationSec !== 0) {
      writer.uint32(40).uint32(message.durationSec);
    }
    if (message.isotopes !== 0) {
      writer.uint32(48).uint32(message.isotopes);
    }
    if (message.coreChancePct !== 0) {
      writer.uint32(56).uint32(message.coreChancePct);
    }
    if (message.injuryPct !== 0) {
      writer.uint32(64).uint32(message.injuryPct);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExpeditionSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExpeditionSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.depth = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.radControl = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.tech = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.durationSec = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isotopes = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.coreChancePct = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.injuryPct = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ExpeditionSpec>, I>>(base?: I): ExpeditionSpec {
    return ExpeditionSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExpeditionSpec>, I>>(object: I): ExpeditionSpec {
    const message = createBaseExpeditionSpec();
    message.depth = object.depth ?? 0;
    message.name = object.name ?? "";
    message.radControl = object.radControl ?? 0;
    message.tech = object.tech ?? 0;
    message.durationSec = object.durationSec ?? 0;
    message.isotopes = object.isotopes ?? 0;
    message.coreChancePct = object.coreChancePct ?? 0;
    message.injuryPct = object.injuryPct ?? 0;
    return message;
  },
};

function createBaseTorpedoStock(): TorpedoStock {
  return { kind: 0, count: 0 };
}

export const TorpedoStock: MessageFns<TorpedoStock> = {
  encode(message: TorpedoStock, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.count !== 0) {
      writer.uint32(16).uint32(message.count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TorpedoStock {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTorpedoStock();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TorpedoStock>, I>>(base?: I): TorpedoStock {
    return TorpedoStock.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TorpedoStock>, I>>(object: I): TorpedoStock {
    const message = createBaseTorpedoStock();
    message.kind = object.kind ?? 0;
    message.count = object.count ?? 0;
    return message;
  },
};

function createBaseCaptain(): Captain {
  return {
    id: 0,
    name: "",
    attrs: [],
    talents: [],
    seasons: 0,
    phase: "",
    fleetId: 0,
    injuredSecs: 0,
    cadet: false,
    expedition: 0,
    capturedBy: "",
    ransom: 0,
    effects: undefined,
    age: 0,
    recruitAge: 0,
    seasonsToNextPhase: 0,
    phaseKind: 0,
    portraitSeed: 0,
    portraitGender: 0,
    practice: [],
    practised: [],
    trainSecs: [],
  };
}

export const Captain: MessageFns<Captain> = {
  encode(message: Captain, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    writer.uint32(26).fork();
    for (const v of message.attrs) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(34).fork();
    for (const v of message.talents) {
      writer.uint32(v);
    }
    writer.join();
    if (message.seasons !== 0) {
      writer.uint32(40).uint32(message.seasons);
    }
    if (message.phase !== "") {
      writer.uint32(50).string(message.phase);
    }
    if (message.fleetId !== 0) {
      writer.uint32(56).uint32(message.fleetId);
    }
    if (message.injuredSecs !== 0) {
      writer.uint32(64).uint32(message.injuredSecs);
    }
    if (message.cadet !== false) {
      writer.uint32(72).bool(message.cadet);
    }
    if (message.expedition !== 0) {
      writer.uint32(80).uint32(message.expedition);
    }
    if (message.capturedBy !== "") {
      writer.uint32(90).string(message.capturedBy);
    }
    if (message.ransom !== 0) {
      writer.uint32(96).uint32(message.ransom);
    }
    if (message.effects !== undefined) {
      CaptainEffects.encode(message.effects, writer.uint32(106).fork()).join();
    }
    if (message.age !== 0) {
      writer.uint32(112).uint32(message.age);
    }
    if (message.recruitAge !== 0) {
      writer.uint32(120).uint32(message.recruitAge);
    }
    if (message.seasonsToNextPhase !== 0) {
      writer.uint32(128).uint32(message.seasonsToNextPhase);
    }
    if (message.phaseKind !== 0) {
      writer.uint32(136).int32(message.phaseKind);
    }
    if (message.portraitSeed !== 0) {
      writer.uint32(144).uint32(message.portraitSeed);
    }
    if (message.portraitGender !== 0) {
      writer.uint32(152).uint32(message.portraitGender);
    }
    writer.uint32(162).fork();
    for (const v of message.practice) {
      writer.float(v);
    }
    writer.join();
    writer.uint32(170).fork();
    for (const v of message.practised) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(178).fork();
    for (const v of message.trainSecs) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Captain {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCaptain();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.attrs.push(reader.uint32());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.attrs.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag === 32) {
            message.talents.push(reader.uint32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.talents.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.seasons = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.phase = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.injuredSecs = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.cadet = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.expedition = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.capturedBy = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.ransom = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.effects = CaptainEffects.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.age = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.recruitAge = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.seasonsToNextPhase = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.phaseKind = reader.int32() as any;
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.portraitSeed = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.portraitGender = reader.uint32();
          continue;
        }
        case 20: {
          if (tag === 165) {
            message.practice.push(reader.float());

            continue;
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.practice.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 21: {
          if (tag === 168) {
            message.practised.push(reader.uint32());

            continue;
          }

          if (tag === 170) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.practised.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 22: {
          if (tag === 176) {
            message.trainSecs.push(reader.uint32());

            continue;
          }

          if (tag === 178) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.trainSecs.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Captain>, I>>(base?: I): Captain {
    return Captain.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Captain>, I>>(object: I): Captain {
    const message = createBaseCaptain();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.attrs = object.attrs?.map((e) => e) || [];
    message.talents = object.talents?.map((e) => e) || [];
    message.seasons = object.seasons ?? 0;
    message.phase = object.phase ?? "";
    message.fleetId = object.fleetId ?? 0;
    message.injuredSecs = object.injuredSecs ?? 0;
    message.cadet = object.cadet ?? false;
    message.expedition = object.expedition ?? 0;
    message.capturedBy = object.capturedBy ?? "";
    message.ransom = object.ransom ?? 0;
    message.effects = (object.effects !== undefined && object.effects !== null)
      ? CaptainEffects.fromPartial(object.effects)
      : undefined;
    message.age = object.age ?? 0;
    message.recruitAge = object.recruitAge ?? 0;
    message.seasonsToNextPhase = object.seasonsToNextPhase ?? 0;
    message.phaseKind = object.phaseKind ?? 0;
    message.portraitSeed = object.portraitSeed ?? 0;
    message.portraitGender = object.portraitGender ?? 0;
    message.practice = object.practice?.map((e) => e) || [];
    message.practised = object.practised?.map((e) => e) || [];
    message.trainSecs = object.trainSecs?.map((e) => e) || [];
    return message;
  },
};

function createBaseCaptainEffects(): CaptainEffects {
  return {
    damagePct: 0,
    speedPct: 0,
    noiseCutPct: 0,
    regenPct: 0,
    floorLiftPct: 0,
    diveYieldPct: 0,
    injuryCutPct: 0,
    retireRiskPct: 0,
  };
}

export const CaptainEffects: MessageFns<CaptainEffects> = {
  encode(message: CaptainEffects, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.damagePct !== 0) {
      writer.uint32(9).double(message.damagePct);
    }
    if (message.speedPct !== 0) {
      writer.uint32(17).double(message.speedPct);
    }
    if (message.noiseCutPct !== 0) {
      writer.uint32(25).double(message.noiseCutPct);
    }
    if (message.regenPct !== 0) {
      writer.uint32(33).double(message.regenPct);
    }
    if (message.floorLiftPct !== 0) {
      writer.uint32(41).double(message.floorLiftPct);
    }
    if (message.diveYieldPct !== 0) {
      writer.uint32(49).double(message.diveYieldPct);
    }
    if (message.injuryCutPct !== 0) {
      writer.uint32(57).double(message.injuryCutPct);
    }
    if (message.retireRiskPct !== 0) {
      writer.uint32(65).double(message.retireRiskPct);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CaptainEffects {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCaptainEffects();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.damagePct = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.speedPct = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.noiseCutPct = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.regenPct = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.floorLiftPct = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.diveYieldPct = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.injuryCutPct = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.retireRiskPct = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CaptainEffects>, I>>(base?: I): CaptainEffects {
    return CaptainEffects.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CaptainEffects>, I>>(object: I): CaptainEffects {
    const message = createBaseCaptainEffects();
    message.damagePct = object.damagePct ?? 0;
    message.speedPct = object.speedPct ?? 0;
    message.noiseCutPct = object.noiseCutPct ?? 0;
    message.regenPct = object.regenPct ?? 0;
    message.floorLiftPct = object.floorLiftPct ?? 0;
    message.diveYieldPct = object.diveYieldPct ?? 0;
    message.injuryCutPct = object.injuryCutPct ?? 0;
    message.retireRiskPct = object.retireRiskPct ?? 0;
    return message;
  },
};

function createBasePrisoner(): Prisoner {
  return { captain: "", owner: "", ransom: 0, captainId: 0, ownerId: 0, heldSec: 0 };
}

export const Prisoner: MessageFns<Prisoner> = {
  encode(message: Prisoner, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.captain !== "") {
      writer.uint32(10).string(message.captain);
    }
    if (message.owner !== "") {
      writer.uint32(18).string(message.owner);
    }
    if (message.ransom !== 0) {
      writer.uint32(24).uint32(message.ransom);
    }
    if (message.captainId !== 0) {
      writer.uint32(32).uint32(message.captainId);
    }
    if (message.ownerId !== 0) {
      writer.uint32(40).uint32(message.ownerId);
    }
    if (message.heldSec !== 0) {
      writer.uint32(48).uint32(message.heldSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Prisoner {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrisoner();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.captain = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.owner = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.ransom = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.captainId = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.ownerId = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.heldSec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Prisoner>, I>>(base?: I): Prisoner {
    return Prisoner.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Prisoner>, I>>(object: I): Prisoner {
    const message = createBasePrisoner();
    message.captain = object.captain ?? "";
    message.owner = object.owner ?? "";
    message.ransom = object.ransom ?? 0;
    message.captainId = object.captainId ?? 0;
    message.ownerId = object.ownerId ?? 0;
    message.heldSec = object.heldSec ?? 0;
    return message;
  },
};

function createBaseQueueRateSource(): QueueRateSource {
  return { kind: 0, name: "", level: 0 };
}

export const QueueRateSource: MessageFns<QueueRateSource> = {
  encode(message: QueueRateSource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.level !== 0) {
      writer.uint32(24).uint32(message.level);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QueueRateSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueueRateSource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.level = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<QueueRateSource>, I>>(base?: I): QueueRateSource {
    return QueueRateSource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QueueRateSource>, I>>(object: I): QueueRateSource {
    const message = createBaseQueueRateSource();
    message.kind = object.kind ?? 0;
    message.name = object.name ?? "";
    message.level = object.level ?? 0;
    return message;
  },
};

function createBaseEmpire(): Empire {
  return {
    playerId: 0,
    res: undefined,
    caps: undefined,
    income: undefined,
    buildings: [],
    queue: [],
    slots: 0,
    stock: [],
    tech: [],
    combatWeight: 0,
    combatCap: 0,
    supportWeight: 0,
    supportCap: 0,
    captains: [],
    captainSlots: 0,
    missions: 0,
    missionCap: 0,
    honour: 0,
    score: 0,
    sonarRange: 0,
    homeCell: 0,
    torpedoes: [],
    clanId: 0,
    clanTag: "",
    blueprints: [],
    moduleSlots: 0,
    expeditions: [],
    dataCores: 0,
    queueWaitSec: 0,
    queueMaxSec: 0,
    brig: [],
    pointDefenceReadySec: 0,
    baseTubesReady: 0,
    baseTubeReadySec: 0,
    sonarRings: [],
    masterSlots: 0,
    copySlots: 0,
    installed: [],
    inboxUnread: 0,
    autoRebuild: false,
    controlGroups: [],
    arcadeSteps: 0,
    passPrice: 0,
    nextOfferSec: 0,
    queueRate: [],
    queueRateSources: [],
    dataCoreSec: 0,
    dredgerBrain: false,
    standingOrders: false,
    advice: undefined,
    fleetFits: [],
    advisorOn: false,
    seaTrials: 0,
    seaTrialsOn: false,
    welcome: false,
    shipRounds: 0,
    shipRoundCap: 0,
    structureGuards: [],
    plots: [],
    seamountFinds: [],
    fragments: [],
    commissions: [],
    lanes: [],
    caches: [],
    cacheFinds: [],
    cacheFindsToday: 0,
    compressed: [],
    depot: undefined,
    chartFragments: [],
    commissionsPaid: [],
    dens: [],
    commissionTakesToday: 0,
  };
}

export const Empire: MessageFns<Empire> = {
  encode(message: Empire, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.playerId !== 0) {
      writer.uint32(8).uint32(message.playerId);
    }
    if (message.res !== undefined) {
      Resources.encode(message.res, writer.uint32(18).fork()).join();
    }
    if (message.caps !== undefined) {
      Resources.encode(message.caps, writer.uint32(26).fork()).join();
    }
    if (message.income !== undefined) {
      Resources.encode(message.income, writer.uint32(34).fork()).join();
    }
    for (const v of message.buildings) {
      BuildingLevel.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.queue) {
      Job.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.slots !== 0) {
      writer.uint32(56).uint32(message.slots);
    }
    for (const v of message.stock) {
      ShipStock.encode(v!, writer.uint32(66).fork()).join();
    }
    writer.uint32(74).fork();
    for (const v of message.tech) {
      writer.uint32(v);
    }
    writer.join();
    if (message.combatWeight !== 0) {
      writer.uint32(80).uint32(message.combatWeight);
    }
    if (message.combatCap !== 0) {
      writer.uint32(88).uint32(message.combatCap);
    }
    if (message.supportWeight !== 0) {
      writer.uint32(96).uint32(message.supportWeight);
    }
    if (message.supportCap !== 0) {
      writer.uint32(104).uint32(message.supportCap);
    }
    for (const v of message.captains) {
      Captain.encode(v!, writer.uint32(114).fork()).join();
    }
    if (message.captainSlots !== 0) {
      writer.uint32(120).uint32(message.captainSlots);
    }
    if (message.missions !== 0) {
      writer.uint32(128).uint32(message.missions);
    }
    if (message.missionCap !== 0) {
      writer.uint32(136).uint32(message.missionCap);
    }
    if (message.honour !== 0) {
      writer.uint32(144).uint32(message.honour);
    }
    if (message.score !== 0) {
      writer.uint32(152).uint32(message.score);
    }
    if (message.sonarRange !== 0) {
      writer.uint32(160).uint32(message.sonarRange);
    }
    if (message.homeCell !== 0) {
      writer.uint32(168).uint32(message.homeCell);
    }
    for (const v of message.torpedoes) {
      TorpedoStock.encode(v!, writer.uint32(178).fork()).join();
    }
    if (message.clanId !== 0) {
      writer.uint32(184).uint32(message.clanId);
    }
    if (message.clanTag !== "") {
      writer.uint32(194).string(message.clanTag);
    }
    for (const v of message.blueprints) {
      Blueprint.encode(v!, writer.uint32(202).fork()).join();
    }
    if (message.moduleSlots !== 0) {
      writer.uint32(216).uint32(message.moduleSlots);
    }
    for (const v of message.expeditions) {
      ExpeditionState.encode(v!, writer.uint32(226).fork()).join();
    }
    if (message.dataCores !== 0) {
      writer.uint32(232).uint32(message.dataCores);
    }
    if (message.queueWaitSec !== 0) {
      writer.uint32(240).uint32(message.queueWaitSec);
    }
    if (message.queueMaxSec !== 0) {
      writer.uint32(248).uint32(message.queueMaxSec);
    }
    for (const v of message.brig) {
      Prisoner.encode(v!, writer.uint32(258).fork()).join();
    }
    if (message.pointDefenceReadySec !== 0) {
      writer.uint32(264).uint32(message.pointDefenceReadySec);
    }
    if (message.baseTubesReady !== 0) {
      writer.uint32(272).uint32(message.baseTubesReady);
    }
    if (message.baseTubeReadySec !== 0) {
      writer.uint32(280).uint32(message.baseTubeReadySec);
    }
    for (const v of message.sonarRings) {
      SonarRing.encode(v!, writer.uint32(290).fork()).join();
    }
    if (message.masterSlots !== 0) {
      writer.uint32(296).uint32(message.masterSlots);
    }
    if (message.copySlots !== 0) {
      writer.uint32(304).uint32(message.copySlots);
    }
    writer.uint32(314).fork();
    for (const v of message.installed) {
      writer.uint32(v);
    }
    writer.join();
    if (message.inboxUnread !== 0) {
      writer.uint32(320).uint32(message.inboxUnread);
    }
    if (message.autoRebuild !== false) {
      writer.uint32(328).bool(message.autoRebuild);
    }
    for (const v of message.controlGroups) {
      ControlGroup.encode(v!, writer.uint32(338).fork()).join();
    }
    if (message.arcadeSteps !== 0) {
      writer.uint32(344).uint32(message.arcadeSteps);
    }
    if (message.passPrice !== 0) {
      writer.uint32(352).uint32(message.passPrice);
    }
    if (message.nextOfferSec !== 0) {
      writer.uint32(360).uint32(message.nextOfferSec);
    }
    writer.uint32(370).fork();
    for (const v of message.queueRate) {
      writer.double(v);
    }
    writer.join();
    for (const v of message.queueRateSources) {
      QueueRateSource.encode(v!, writer.uint32(378).fork()).join();
    }
    if (message.dataCoreSec !== 0) {
      writer.uint32(400).uint32(message.dataCoreSec);
    }
    if (message.dredgerBrain !== false) {
      writer.uint32(408).bool(message.dredgerBrain);
    }
    if (message.standingOrders !== false) {
      writer.uint32(416).bool(message.standingOrders);
    }
    if (message.advice !== undefined) {
      Advice.encode(message.advice, writer.uint32(426).fork()).join();
    }
    for (const v of message.fleetFits) {
      FleetFit.encode(v!, writer.uint32(434).fork()).join();
    }
    if (message.advisorOn !== false) {
      writer.uint32(440).bool(message.advisorOn);
    }
    if (message.seaTrials !== 0) {
      writer.uint32(448).uint32(message.seaTrials);
    }
    if (message.seaTrialsOn !== false) {
      writer.uint32(456).bool(message.seaTrialsOn);
    }
    if (message.welcome !== false) {
      writer.uint32(464).bool(message.welcome);
    }
    if (message.shipRounds !== 0) {
      writer.uint32(472).uint32(message.shipRounds);
    }
    if (message.shipRoundCap !== 0) {
      writer.uint32(480).uint32(message.shipRoundCap);
    }
    for (const v of message.structureGuards) {
      StructureGuard.encode(v!, writer.uint32(490).fork()).join();
    }
    for (const v of message.plots) {
      CoursePlot.encode(v!, writer.uint32(498).fork()).join();
    }
    for (const v of message.seamountFinds) {
      NamedSeamount.encode(v!, writer.uint32(506).fork()).join();
    }
    writer.uint32(514).fork();
    for (const v of message.fragments) {
      writer.uint32(v);
    }
    writer.join();
    for (const v of message.commissions) {
      Commission.encode(v!, writer.uint32(530).fork()).join();
    }
    for (const v of message.lanes) {
      CoursePlot.encode(v!, writer.uint32(562).fork()).join();
    }
    for (const v of message.caches) {
      CacheRow.encode(v!, writer.uint32(538).fork()).join();
    }
    for (const v of message.cacheFinds) {
      CacheRow.encode(v!, writer.uint32(546).fork()).join();
    }
    if (message.cacheFindsToday !== 0) {
      writer.uint32(552).uint32(message.cacheFindsToday);
    }
    for (const v of message.compressed) {
      CompressedCargo.encode(v!, writer.uint32(602).fork()).join();
    }
    if (message.depot !== undefined) {
      DepotState.encode(message.depot, writer.uint32(570).fork()).join();
    }
    for (const v of message.chartFragments) {
      ChartFragment.encode(v!, writer.uint32(578).fork()).join();
    }
    for (const v of message.commissionsPaid) {
      CommissionPaid.encode(v!, writer.uint32(586).fork()).join();
    }
    for (const v of message.dens) {
      DenInfo.encode(v!, writer.uint32(594).fork()).join();
    }
    if (message.commissionTakesToday !== 0) {
      writer.uint32(608).uint32(message.commissionTakesToday);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Empire {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmpire();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.playerId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.res = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.caps = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.income = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.buildings.push(BuildingLevel.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.queue.push(Job.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.slots = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.stock.push(ShipStock.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag === 72) {
            message.tech.push(reader.uint32());

            continue;
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.tech.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.combatWeight = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.combatCap = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.supportWeight = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.supportCap = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.captains.push(Captain.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.captainSlots = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.missions = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.missionCap = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.honour = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.score = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.sonarRange = reader.uint32();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.homeCell = reader.uint32();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.torpedoes.push(TorpedoStock.decode(reader, reader.uint32()));
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.clanId = reader.uint32();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.clanTag = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.blueprints.push(Blueprint.decode(reader, reader.uint32()));
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.moduleSlots = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.expeditions.push(ExpeditionState.decode(reader, reader.uint32()));
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.dataCores = reader.uint32();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.queueWaitSec = reader.uint32();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.queueMaxSec = reader.uint32();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.brig.push(Prisoner.decode(reader, reader.uint32()));
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.pointDefenceReadySec = reader.uint32();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.baseTubesReady = reader.uint32();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.baseTubeReadySec = reader.uint32();
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.sonarRings.push(SonarRing.decode(reader, reader.uint32()));
          continue;
        }
        case 37: {
          if (tag !== 296) {
            break;
          }

          message.masterSlots = reader.uint32();
          continue;
        }
        case 38: {
          if (tag !== 304) {
            break;
          }

          message.copySlots = reader.uint32();
          continue;
        }
        case 39: {
          if (tag === 312) {
            message.installed.push(reader.uint32());

            continue;
          }

          if (tag === 314) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.installed.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.inboxUnread = reader.uint32();
          continue;
        }
        case 41: {
          if (tag !== 328) {
            break;
          }

          message.autoRebuild = reader.bool();
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.controlGroups.push(ControlGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.arcadeSteps = reader.uint32();
          continue;
        }
        case 44: {
          if (tag !== 352) {
            break;
          }

          message.passPrice = reader.uint32();
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.nextOfferSec = reader.uint32();
          continue;
        }
        case 46: {
          if (tag === 369) {
            message.queueRate.push(reader.double());

            continue;
          }

          if (tag === 370) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.queueRate.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.queueRateSources.push(QueueRateSource.decode(reader, reader.uint32()));
          continue;
        }
        case 50: {
          if (tag !== 400) {
            break;
          }

          message.dataCoreSec = reader.uint32();
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.dredgerBrain = reader.bool();
          continue;
        }
        case 52: {
          if (tag !== 416) {
            break;
          }

          message.standingOrders = reader.bool();
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.advice = Advice.decode(reader, reader.uint32());
          continue;
        }
        case 54: {
          if (tag !== 434) {
            break;
          }

          message.fleetFits.push(FleetFit.decode(reader, reader.uint32()));
          continue;
        }
        case 55: {
          if (tag !== 440) {
            break;
          }

          message.advisorOn = reader.bool();
          continue;
        }
        case 56: {
          if (tag !== 448) {
            break;
          }

          message.seaTrials = reader.uint32();
          continue;
        }
        case 57: {
          if (tag !== 456) {
            break;
          }

          message.seaTrialsOn = reader.bool();
          continue;
        }
        case 58: {
          if (tag !== 464) {
            break;
          }

          message.welcome = reader.bool();
          continue;
        }
        case 59: {
          if (tag !== 472) {
            break;
          }

          message.shipRounds = reader.uint32();
          continue;
        }
        case 60: {
          if (tag !== 480) {
            break;
          }

          message.shipRoundCap = reader.uint32();
          continue;
        }
        case 61: {
          if (tag !== 490) {
            break;
          }

          message.structureGuards.push(StructureGuard.decode(reader, reader.uint32()));
          continue;
        }
        case 62: {
          if (tag !== 498) {
            break;
          }

          message.plots.push(CoursePlot.decode(reader, reader.uint32()));
          continue;
        }
        case 63: {
          if (tag !== 506) {
            break;
          }

          message.seamountFinds.push(NamedSeamount.decode(reader, reader.uint32()));
          continue;
        }
        case 64: {
          if (tag === 512) {
            message.fragments.push(reader.uint32());

            continue;
          }

          if (tag === 514) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.fragments.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 66: {
          if (tag !== 530) {
            break;
          }

          message.commissions.push(Commission.decode(reader, reader.uint32()));
          continue;
        }
        case 70: {
          if (tag !== 562) {
            break;
          }

          message.lanes.push(CoursePlot.decode(reader, reader.uint32()));
          continue;
        }
        case 67: {
          if (tag !== 538) {
            break;
          }

          message.caches.push(CacheRow.decode(reader, reader.uint32()));
          continue;
        }
        case 68: {
          if (tag !== 546) {
            break;
          }

          message.cacheFinds.push(CacheRow.decode(reader, reader.uint32()));
          continue;
        }
        case 69: {
          if (tag !== 552) {
            break;
          }

          message.cacheFindsToday = reader.uint32();
          continue;
        }
        case 75: {
          if (tag !== 602) {
            break;
          }

          message.compressed.push(CompressedCargo.decode(reader, reader.uint32()));
          continue;
        }
        case 71: {
          if (tag !== 570) {
            break;
          }

          message.depot = DepotState.decode(reader, reader.uint32());
          continue;
        }
        case 72: {
          if (tag !== 578) {
            break;
          }

          message.chartFragments.push(ChartFragment.decode(reader, reader.uint32()));
          continue;
        }
        case 73: {
          if (tag !== 586) {
            break;
          }

          message.commissionsPaid.push(CommissionPaid.decode(reader, reader.uint32()));
          continue;
        }
        case 74: {
          if (tag !== 594) {
            break;
          }

          message.dens.push(DenInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 76: {
          if (tag !== 608) {
            break;
          }

          message.commissionTakesToday = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Empire>, I>>(base?: I): Empire {
    return Empire.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Empire>, I>>(object: I): Empire {
    const message = createBaseEmpire();
    message.playerId = object.playerId ?? 0;
    message.res = (object.res !== undefined && object.res !== null) ? Resources.fromPartial(object.res) : undefined;
    message.caps = (object.caps !== undefined && object.caps !== null) ? Resources.fromPartial(object.caps) : undefined;
    message.income = (object.income !== undefined && object.income !== null)
      ? Resources.fromPartial(object.income)
      : undefined;
    message.buildings = object.buildings?.map((e) => BuildingLevel.fromPartial(e)) || [];
    message.queue = object.queue?.map((e) => Job.fromPartial(e)) || [];
    message.slots = object.slots ?? 0;
    message.stock = object.stock?.map((e) => ShipStock.fromPartial(e)) || [];
    message.tech = object.tech?.map((e) => e) || [];
    message.combatWeight = object.combatWeight ?? 0;
    message.combatCap = object.combatCap ?? 0;
    message.supportWeight = object.supportWeight ?? 0;
    message.supportCap = object.supportCap ?? 0;
    message.captains = object.captains?.map((e) => Captain.fromPartial(e)) || [];
    message.captainSlots = object.captainSlots ?? 0;
    message.missions = object.missions ?? 0;
    message.missionCap = object.missionCap ?? 0;
    message.honour = object.honour ?? 0;
    message.score = object.score ?? 0;
    message.sonarRange = object.sonarRange ?? 0;
    message.homeCell = object.homeCell ?? 0;
    message.torpedoes = object.torpedoes?.map((e) => TorpedoStock.fromPartial(e)) || [];
    message.clanId = object.clanId ?? 0;
    message.clanTag = object.clanTag ?? "";
    message.blueprints = object.blueprints?.map((e) => Blueprint.fromPartial(e)) || [];
    message.moduleSlots = object.moduleSlots ?? 0;
    message.expeditions = object.expeditions?.map((e) => ExpeditionState.fromPartial(e)) || [];
    message.dataCores = object.dataCores ?? 0;
    message.queueWaitSec = object.queueWaitSec ?? 0;
    message.queueMaxSec = object.queueMaxSec ?? 0;
    message.brig = object.brig?.map((e) => Prisoner.fromPartial(e)) || [];
    message.pointDefenceReadySec = object.pointDefenceReadySec ?? 0;
    message.baseTubesReady = object.baseTubesReady ?? 0;
    message.baseTubeReadySec = object.baseTubeReadySec ?? 0;
    message.sonarRings = object.sonarRings?.map((e) => SonarRing.fromPartial(e)) || [];
    message.masterSlots = object.masterSlots ?? 0;
    message.copySlots = object.copySlots ?? 0;
    message.installed = object.installed?.map((e) => e) || [];
    message.inboxUnread = object.inboxUnread ?? 0;
    message.autoRebuild = object.autoRebuild ?? false;
    message.controlGroups = object.controlGroups?.map((e) => ControlGroup.fromPartial(e)) || [];
    message.arcadeSteps = object.arcadeSteps ?? 0;
    message.passPrice = object.passPrice ?? 0;
    message.nextOfferSec = object.nextOfferSec ?? 0;
    message.queueRate = object.queueRate?.map((e) => e) || [];
    message.queueRateSources = object.queueRateSources?.map((e) => QueueRateSource.fromPartial(e)) || [];
    message.dataCoreSec = object.dataCoreSec ?? 0;
    message.dredgerBrain = object.dredgerBrain ?? false;
    message.standingOrders = object.standingOrders ?? false;
    message.advice = (object.advice !== undefined && object.advice !== null)
      ? Advice.fromPartial(object.advice)
      : undefined;
    message.fleetFits = object.fleetFits?.map((e) => FleetFit.fromPartial(e)) || [];
    message.advisorOn = object.advisorOn ?? false;
    message.seaTrials = object.seaTrials ?? 0;
    message.seaTrialsOn = object.seaTrialsOn ?? false;
    message.welcome = object.welcome ?? false;
    message.shipRounds = object.shipRounds ?? 0;
    message.shipRoundCap = object.shipRoundCap ?? 0;
    message.structureGuards = object.structureGuards?.map((e) => StructureGuard.fromPartial(e)) || [];
    message.plots = object.plots?.map((e) => CoursePlot.fromPartial(e)) || [];
    message.seamountFinds = object.seamountFinds?.map((e) => NamedSeamount.fromPartial(e)) || [];
    message.fragments = object.fragments?.map((e) => e) || [];
    message.commissions = object.commissions?.map((e) => Commission.fromPartial(e)) || [];
    message.lanes = object.lanes?.map((e) => CoursePlot.fromPartial(e)) || [];
    message.caches = object.caches?.map((e) => CacheRow.fromPartial(e)) || [];
    message.cacheFinds = object.cacheFinds?.map((e) => CacheRow.fromPartial(e)) || [];
    message.cacheFindsToday = object.cacheFindsToday ?? 0;
    message.compressed = object.compressed?.map((e) => CompressedCargo.fromPartial(e)) || [];
    message.depot = (object.depot !== undefined && object.depot !== null)
      ? DepotState.fromPartial(object.depot)
      : undefined;
    message.chartFragments = object.chartFragments?.map((e) => ChartFragment.fromPartial(e)) || [];
    message.commissionsPaid = object.commissionsPaid?.map((e) => CommissionPaid.fromPartial(e)) || [];
    message.dens = object.dens?.map((e) => DenInfo.fromPartial(e)) || [];
    message.commissionTakesToday = object.commissionTakesToday ?? 0;
    return message;
  },
};

function createBaseCommissionPaid(): CommissionPaid {
  return { offer: undefined, fleetName: "", paidSec: 0 };
}

export const CommissionPaid: MessageFns<CommissionPaid> = {
  encode(message: CommissionPaid, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.offer !== undefined) {
      Commission.encode(message.offer, writer.uint32(10).fork()).join();
    }
    if (message.fleetName !== "") {
      writer.uint32(18).string(message.fleetName);
    }
    if (message.paidSec !== 0) {
      writer.uint32(25).double(message.paidSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommissionPaid {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommissionPaid();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.offer = Commission.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fleetName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.paidSec = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CommissionPaid>, I>>(base?: I): CommissionPaid {
    return CommissionPaid.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommissionPaid>, I>>(object: I): CommissionPaid {
    const message = createBaseCommissionPaid();
    message.offer = (object.offer !== undefined && object.offer !== null)
      ? Commission.fromPartial(object.offer)
      : undefined;
    message.fleetName = object.fleetName ?? "";
    message.paidSec = object.paidSec ?? 0;
    return message;
  },
};

function createBaseDenInfo(): DenInfo {
  return { den: 0, cell: 0, brotherhood: 0, design: 0, state: 0, respawnSec: 0, cache: 0, prize: undefined };
}

export const DenInfo: MessageFns<DenInfo> = {
  encode(message: DenInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.den !== 0) {
      writer.uint32(8).uint32(message.den);
    }
    if (message.cell !== 0) {
      writer.uint32(16).uint32(message.cell);
    }
    if (message.brotherhood !== 0) {
      writer.uint32(24).int32(message.brotherhood);
    }
    if (message.design !== 0) {
      writer.uint32(32).uint32(message.design);
    }
    if (message.state !== 0) {
      writer.uint32(40).int32(message.state);
    }
    if (message.respawnSec !== 0) {
      writer.uint32(48).uint32(message.respawnSec);
    }
    if (message.cache !== 0) {
      writer.uint32(56).int32(message.cache);
    }
    if (message.prize !== undefined) {
      Resources.encode(message.prize, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DenInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDenInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.den = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.brotherhood = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.design = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.respawnSec = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.cache = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.prize = Resources.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<DenInfo>, I>>(base?: I): DenInfo {
    return DenInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DenInfo>, I>>(object: I): DenInfo {
    const message = createBaseDenInfo();
    message.den = object.den ?? 0;
    message.cell = object.cell ?? 0;
    message.brotherhood = object.brotherhood ?? 0;
    message.design = object.design ?? 0;
    message.state = object.state ?? 0;
    message.respawnSec = object.respawnSec ?? 0;
    message.cache = object.cache ?? 0;
    message.prize = (object.prize !== undefined && object.prize !== null)
      ? Resources.fromPartial(object.prize)
      : undefined;
    return message;
  },
};

function createBaseChartFragment(): ChartFragment {
  return { den: 0, cell: 0, taken: false, xMpx: 0, yMpx: 0 };
}

export const ChartFragment: MessageFns<ChartFragment> = {
  encode(message: ChartFragment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.den !== 0) {
      writer.uint32(8).uint32(message.den);
    }
    if (message.cell !== 0) {
      writer.uint32(16).uint32(message.cell);
    }
    if (message.taken !== false) {
      writer.uint32(24).bool(message.taken);
    }
    if (message.xMpx !== 0) {
      writer.uint32(32).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(40).sint32(message.yMpx);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChartFragment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChartFragment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.den = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.taken = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ChartFragment>, I>>(base?: I): ChartFragment {
    return ChartFragment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChartFragment>, I>>(object: I): ChartFragment {
    const message = createBaseChartFragment();
    message.den = object.den ?? 0;
    message.cell = object.cell ?? 0;
    message.taken = object.taken ?? false;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    return message;
  },
};

function createBaseDepotState(): DepotState {
  return {
    stock: [],
    stocked: 0,
    rack: 0,
    liveSeaMines: 0,
    seaMinesCap: 0,
    liveDeployables: 0,
    deployablesCap: 0,
    livePalisades: 0,
    palisadesCap: 0,
    liveLaneLights: 0,
    laneLightsCap: 0,
  };
}

export const DepotState: MessageFns<DepotState> = {
  encode(message: DepotState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.stock) {
      SeaObjectStock.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.stocked !== 0) {
      writer.uint32(16).uint32(message.stocked);
    }
    if (message.rack !== 0) {
      writer.uint32(24).uint32(message.rack);
    }
    if (message.liveSeaMines !== 0) {
      writer.uint32(32).uint32(message.liveSeaMines);
    }
    if (message.seaMinesCap !== 0) {
      writer.uint32(40).uint32(message.seaMinesCap);
    }
    if (message.liveDeployables !== 0) {
      writer.uint32(48).uint32(message.liveDeployables);
    }
    if (message.deployablesCap !== 0) {
      writer.uint32(56).uint32(message.deployablesCap);
    }
    if (message.livePalisades !== 0) {
      writer.uint32(64).uint32(message.livePalisades);
    }
    if (message.palisadesCap !== 0) {
      writer.uint32(72).uint32(message.palisadesCap);
    }
    if (message.liveLaneLights !== 0) {
      writer.uint32(80).uint32(message.liveLaneLights);
    }
    if (message.laneLightsCap !== 0) {
      writer.uint32(88).uint32(message.laneLightsCap);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DepotState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDepotState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stock.push(SeaObjectStock.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.stocked = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.rack = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.liveSeaMines = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.seaMinesCap = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.liveDeployables = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.deployablesCap = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.livePalisades = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.palisadesCap = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.liveLaneLights = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.laneLightsCap = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<DepotState>, I>>(base?: I): DepotState {
    return DepotState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DepotState>, I>>(object: I): DepotState {
    const message = createBaseDepotState();
    message.stock = object.stock?.map((e) => SeaObjectStock.fromPartial(e)) || [];
    message.stocked = object.stocked ?? 0;
    message.rack = object.rack ?? 0;
    message.liveSeaMines = object.liveSeaMines ?? 0;
    message.seaMinesCap = object.seaMinesCap ?? 0;
    message.liveDeployables = object.liveDeployables ?? 0;
    message.deployablesCap = object.deployablesCap ?? 0;
    message.livePalisades = object.livePalisades ?? 0;
    message.palisadesCap = object.palisadesCap ?? 0;
    message.liveLaneLights = object.liveLaneLights ?? 0;
    message.laneLightsCap = object.laneLightsCap ?? 0;
    return message;
  },
};

function createBaseSeaObjectStock(): SeaObjectStock {
  return { kind: 0, count: 0 };
}

export const SeaObjectStock: MessageFns<SeaObjectStock> = {
  encode(message: SeaObjectStock, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.count !== 0) {
      writer.uint32(16).uint32(message.count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeaObjectStock {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeaObjectStock();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SeaObjectStock>, I>>(base?: I): SeaObjectStock {
    return SeaObjectStock.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeaObjectStock>, I>>(object: I): SeaObjectStock {
    const message = createBaseSeaObjectStock();
    message.kind = object.kind ?? 0;
    message.count = object.count ?? 0;
    return message;
  },
};

function createBaseCacheRow(): CacheRow {
  return { id: 0, kind: 0, cell: 0, note: "", freeNote: false, noteSet: false, finds: 0, label: "" };
}

export const CacheRow: MessageFns<CacheRow> = {
  encode(message: CacheRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind);
    }
    if (message.cell !== 0) {
      writer.uint32(24).uint32(message.cell);
    }
    if (message.note !== "") {
      writer.uint32(34).string(message.note);
    }
    if (message.freeNote !== false) {
      writer.uint32(40).bool(message.freeNote);
    }
    if (message.noteSet !== false) {
      writer.uint32(48).bool(message.noteSet);
    }
    if (message.finds !== 0) {
      writer.uint32(56).uint32(message.finds);
    }
    if (message.label !== "") {
      writer.uint32(66).string(message.label);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CacheRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCacheRow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.note = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.freeNote = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.noteSet = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.finds = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.label = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CacheRow>, I>>(base?: I): CacheRow {
    return CacheRow.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CacheRow>, I>>(object: I): CacheRow {
    const message = createBaseCacheRow();
    message.id = object.id ?? 0;
    message.kind = object.kind ?? 0;
    message.cell = object.cell ?? 0;
    message.note = object.note ?? "";
    message.freeNote = object.freeNote ?? false;
    message.noteSet = object.noteSet ?? false;
    message.finds = object.finds ?? 0;
    message.label = object.label ?? "";
    return message;
  },
};

function createBaseCommission(): Commission {
  return {
    id: 0,
    kind: 0,
    cell: 0,
    leftSec: 0,
    reward: 0,
    resources: undefined,
    rounds: 0,
    roundKind: 0,
    practice: 0,
    ship: 0,
    fleetId: 0,
    done: false,
    escortPct: 0,
  };
}

export const Commission: MessageFns<Commission> = {
  encode(message: Commission, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind);
    }
    if (message.cell !== 0) {
      writer.uint32(24).uint32(message.cell);
    }
    if (message.leftSec !== 0) {
      writer.uint32(33).double(message.leftSec);
    }
    if (message.reward !== 0) {
      writer.uint32(40).int32(message.reward);
    }
    if (message.resources !== undefined) {
      Resources.encode(message.resources, writer.uint32(50).fork()).join();
    }
    if (message.rounds !== 0) {
      writer.uint32(56).uint32(message.rounds);
    }
    if (message.roundKind !== 0) {
      writer.uint32(64).int32(message.roundKind);
    }
    if (message.practice !== 0) {
      writer.uint32(73).double(message.practice);
    }
    if (message.ship !== 0) {
      writer.uint32(80).int32(message.ship);
    }
    if (message.fleetId !== 0) {
      writer.uint32(88).uint32(message.fleetId);
    }
    if (message.done !== false) {
      writer.uint32(96).bool(message.done);
    }
    if (message.escortPct !== 0) {
      writer.uint32(104).uint32(message.escortPct);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Commission {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommission();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.leftSec = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.reward = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.resources = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.rounds = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.roundKind = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.practice = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.ship = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.done = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.escortPct = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Commission>, I>>(base?: I): Commission {
    return Commission.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Commission>, I>>(object: I): Commission {
    const message = createBaseCommission();
    message.id = object.id ?? 0;
    message.kind = object.kind ?? 0;
    message.cell = object.cell ?? 0;
    message.leftSec = object.leftSec ?? 0;
    message.reward = object.reward ?? 0;
    message.resources = (object.resources !== undefined && object.resources !== null)
      ? Resources.fromPartial(object.resources)
      : undefined;
    message.rounds = object.rounds ?? 0;
    message.roundKind = object.roundKind ?? 0;
    message.practice = object.practice ?? 0;
    message.ship = object.ship ?? 0;
    message.fleetId = object.fleetId ?? 0;
    message.done = object.done ?? false;
    message.escortPct = object.escortPct ?? 0;
    return message;
  },
};

function createBaseCoursePlot(): CoursePlot {
  return {
    id: 0,
    name: "",
    legs: [],
    lane: false,
    owner: 0,
    ownerName: "",
    road: 0,
    roadName: "",
    liftMin: 0,
    quiet: false,
    gaps: [],
    lighters: [],
  };
}

export const CoursePlot: MessageFns<CoursePlot> = {
  encode(message: CoursePlot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    for (const v of message.legs) {
      Waypoint.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.lane !== false) {
      writer.uint32(32).bool(message.lane);
    }
    if (message.owner !== 0) {
      writer.uint32(40).uint32(message.owner);
    }
    if (message.ownerName !== "") {
      writer.uint32(50).string(message.ownerName);
    }
    if (message.road !== 0) {
      writer.uint32(56).uint32(message.road);
    }
    if (message.roadName !== "") {
      writer.uint32(66).string(message.roadName);
    }
    if (message.liftMin !== 0) {
      writer.uint32(72).uint32(message.liftMin);
    }
    if (message.quiet !== false) {
      writer.uint32(80).bool(message.quiet);
    }
    for (const v of message.gaps) {
      LaneGap.encode(v!, writer.uint32(90).fork()).join();
    }
    for (const v of message.lighters) {
      LaneLighter.encode(v!, writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CoursePlot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCoursePlot();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.legs.push(Waypoint.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.lane = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.owner = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ownerName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.road = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.roadName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.liftMin = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.quiet = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.gaps.push(LaneGap.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.lighters.push(LaneLighter.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CoursePlot>, I>>(base?: I): CoursePlot {
    return CoursePlot.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CoursePlot>, I>>(object: I): CoursePlot {
    const message = createBaseCoursePlot();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.legs = object.legs?.map((e) => Waypoint.fromPartial(e)) || [];
    message.lane = object.lane ?? false;
    message.owner = object.owner ?? 0;
    message.ownerName = object.ownerName ?? "";
    message.road = object.road ?? 0;
    message.roadName = object.roadName ?? "";
    message.liftMin = object.liftMin ?? 0;
    message.quiet = object.quiet ?? false;
    message.gaps = object.gaps?.map((e) => LaneGap.fromPartial(e)) || [];
    message.lighters = object.lighters?.map((e) => LaneLighter.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLaneGap(): LaneGap {
  return { xMpx: 0, yMpx: 0, leg: 0 };
}

export const LaneGap: MessageFns<LaneGap> = {
  encode(message: LaneGap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.xMpx !== 0) {
      writer.uint32(8).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(16).sint32(message.yMpx);
    }
    if (message.leg !== 0) {
      writer.uint32(24).uint32(message.leg);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LaneGap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLaneGap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.leg = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<LaneGap>, I>>(base?: I): LaneGap {
    return LaneGap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LaneGap>, I>>(object: I): LaneGap {
    const message = createBaseLaneGap();
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.leg = object.leg ?? 0;
    return message;
  },
};

function createBaseLaneLighter(): LaneLighter {
  return { name: "", lights: 0 };
}

export const LaneLighter: MessageFns<LaneLighter> = {
  encode(message: LaneLighter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.lights !== 0) {
      writer.uint32(16).uint32(message.lights);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LaneLighter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLaneLighter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.lights = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<LaneLighter>, I>>(base?: I): LaneLighter {
    return LaneLighter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LaneLighter>, I>>(object: I): LaneLighter {
    const message = createBaseLaneLighter();
    message.name = object.name ?? "";
    message.lights = object.lights ?? 0;
    return message;
  },
};

function createBaseStructureGuard(): StructureGuard {
  return { siteId: 0, owner: 0, leftSec: 0 };
}

export const StructureGuard: MessageFns<StructureGuard> = {
  encode(message: StructureGuard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.siteId !== 0) {
      writer.uint32(8).uint32(message.siteId);
    }
    if (message.owner !== 0) {
      writer.uint32(16).uint32(message.owner);
    }
    if (message.leftSec !== 0) {
      writer.uint32(25).double(message.leftSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StructureGuard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStructureGuard();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.siteId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.owner = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.leftSec = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<StructureGuard>, I>>(base?: I): StructureGuard {
    return StructureGuard.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StructureGuard>, I>>(object: I): StructureGuard {
    const message = createBaseStructureGuard();
    message.siteId = object.siteId ?? 0;
    message.owner = object.owner ?? 0;
    message.leftSec = object.leftSec ?? 0;
    return message;
  },
};

function createBaseAdvice(): Advice {
  return { kind: 0, id: 0, amount: 0, reason: 0, heldPermille: 0 };
}

export const Advice: MessageFns<Advice> = {
  encode(message: Advice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.id !== 0) {
      writer.uint32(16).uint32(message.id);
    }
    if (message.amount !== 0) {
      writer.uint32(24).uint32(message.amount);
    }
    if (message.reason !== 0) {
      writer.uint32(32).int32(message.reason);
    }
    if (message.heldPermille !== 0) {
      writer.uint32(40).uint32(message.heldPermille);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Advice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdvice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.amount = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.reason = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.heldPermille = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Advice>, I>>(base?: I): Advice {
    return Advice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Advice>, I>>(object: I): Advice {
    const message = createBaseAdvice();
    message.kind = object.kind ?? 0;
    message.id = object.id ?? 0;
    message.amount = object.amount ?? 0;
    message.reason = object.reason ?? 0;
    message.heldPermille = object.heldPermille ?? 0;
    return message;
  },
};

function createBaseEvent(): Event {
  return {
    kind: 0,
    xMpx: 0,
    yMpx: 0,
    faction: 0,
    actor: 0,
    subject: 0,
    damageX10: 0,
    victim: 0,
    splash: false,
    sourceXMpx: 0,
    sourceYMpx: 0,
    victimFaction: 0,
    torpedoKind: 0,
    headingMrad: 0,
    aspect: 0,
    ambush: false,
    signature: 0,
    fleet: 0,
    heal: false,
    seaObject: 0,
    roundKillSource: 0,
  };
}

export const Event: MessageFns<Event> = {
  encode(message: Event, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.xMpx !== 0) {
      writer.uint32(16).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(24).sint32(message.yMpx);
    }
    if (message.faction !== 0) {
      writer.uint32(32).uint32(message.faction);
    }
    if (message.actor !== 0) {
      writer.uint32(40).uint32(message.actor);
    }
    if (message.subject !== 0) {
      writer.uint32(48).uint32(message.subject);
    }
    if (message.damageX10 !== 0) {
      writer.uint32(56).uint32(message.damageX10);
    }
    if (message.victim !== 0) {
      writer.uint32(64).uint32(message.victim);
    }
    if (message.splash !== false) {
      writer.uint32(72).bool(message.splash);
    }
    if (message.sourceXMpx !== 0) {
      writer.uint32(80).sint32(message.sourceXMpx);
    }
    if (message.sourceYMpx !== 0) {
      writer.uint32(88).sint32(message.sourceYMpx);
    }
    if (message.victimFaction !== 0) {
      writer.uint32(96).uint32(message.victimFaction);
    }
    if (message.torpedoKind !== 0) {
      writer.uint32(104).uint32(message.torpedoKind);
    }
    if (message.headingMrad !== 0) {
      writer.uint32(112).sint32(message.headingMrad);
    }
    if (message.aspect !== 0) {
      writer.uint32(120).int32(message.aspect);
    }
    if (message.ambush !== false) {
      writer.uint32(128).bool(message.ambush);
    }
    if (message.signature !== 0) {
      writer.uint32(136).int32(message.signature);
    }
    if (message.fleet !== 0) {
      writer.uint32(144).uint32(message.fleet);
    }
    if (message.heal !== false) {
      writer.uint32(152).bool(message.heal);
    }
    if (message.seaObject !== 0) {
      writer.uint32(160).uint32(message.seaObject);
    }
    if (message.roundKillSource !== 0) {
      writer.uint32(168).int32(message.roundKillSource);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Event {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.actor = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.subject = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.damageX10 = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.victim = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.splash = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.sourceXMpx = reader.sint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.sourceYMpx = reader.sint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.victimFaction = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.torpedoKind = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.headingMrad = reader.sint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.aspect = reader.int32() as any;
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.ambush = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.signature = reader.int32() as any;
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.fleet = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.heal = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.seaObject = reader.uint32();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.roundKillSource = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Event>, I>>(base?: I): Event {
    return Event.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Event>, I>>(object: I): Event {
    const message = createBaseEvent();
    message.kind = object.kind ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.faction = object.faction ?? 0;
    message.actor = object.actor ?? 0;
    message.subject = object.subject ?? 0;
    message.damageX10 = object.damageX10 ?? 0;
    message.victim = object.victim ?? 0;
    message.splash = object.splash ?? false;
    message.sourceXMpx = object.sourceXMpx ?? 0;
    message.sourceYMpx = object.sourceYMpx ?? 0;
    message.victimFaction = object.victimFaction ?? 0;
    message.torpedoKind = object.torpedoKind ?? 0;
    message.headingMrad = object.headingMrad ?? 0;
    message.aspect = object.aspect ?? 0;
    message.ambush = object.ambush ?? false;
    message.signature = object.signature ?? 0;
    message.fleet = object.fleet ?? 0;
    message.heal = object.heal ?? false;
    message.seaObject = object.seaObject ?? 0;
    message.roundKillSource = object.roundKillSource ?? 0;
    return message;
  },
};

function createBaseEvents(): Events {
  return { events: [] };
}

export const Events: MessageFns<Events> = {
  encode(message: Events, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.events) {
      Event.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Events {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvents();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.events.push(Event.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Events>, I>>(base?: I): Events {
    return Events.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Events>, I>>(object: I): Events {
    const message = createBaseEvents();
    message.events = object.events?.map((e) => Event.fromPartial(e)) || [];
    return message;
  },
};

function createBaseNotice(): Notice {
  return { text: "", error: false, kind: 0, event: "", keep: false, cell: 0, fleet: 0 };
}

export const Notice: MessageFns<Notice> = {
  encode(message: Notice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    if (message.error !== false) {
      writer.uint32(16).bool(message.error);
    }
    if (message.kind !== 0) {
      writer.uint32(24).int32(message.kind);
    }
    if (message.event !== "") {
      writer.uint32(34).string(message.event);
    }
    if (message.keep !== false) {
      writer.uint32(40).bool(message.keep);
    }
    if (message.cell !== 0) {
      writer.uint32(48).uint32(message.cell);
    }
    if (message.fleet !== 0) {
      writer.uint32(56).uint32(message.fleet);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Notice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.error = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.event = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.keep = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.fleet = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Notice>, I>>(base?: I): Notice {
    return Notice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Notice>, I>>(object: I): Notice {
    const message = createBaseNotice();
    message.text = object.text ?? "";
    message.error = object.error ?? false;
    message.kind = object.kind ?? 0;
    message.event = object.event ?? "";
    message.keep = object.keep ?? false;
    message.cell = object.cell ?? 0;
    message.fleet = object.fleet ?? 0;
    return message;
  },
};

function createBaseHoldStack(): HoldStack {
  return { resource: 0, amount: 0 };
}

export const HoldStack: MessageFns<HoldStack> = {
  encode(message: HoldStack, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.resource !== 0) {
      writer.uint32(8).uint32(message.resource);
    }
    if (message.amount !== 0) {
      writer.uint32(16).uint32(message.amount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HoldStack {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHoldStack();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.resource = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.amount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<HoldStack>, I>>(base?: I): HoldStack {
    return HoldStack.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HoldStack>, I>>(object: I): HoldStack {
    const message = createBaseHoldStack();
    message.resource = object.resource ?? 0;
    message.amount = object.amount ?? 0;
    return message;
  },
};

function createBaseScanReport(): ScanReport {
  return { fleets: [], cell: 0 };
}

export const ScanReport: MessageFns<ScanReport> = {
  encode(message: ScanReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fleets) {
      ScannedFleet.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cell !== 0) {
      writer.uint32(16).uint32(message.cell);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScanReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanReport();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fleets.push(ScannedFleet.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ScanReport>, I>>(base?: I): ScanReport {
    return ScanReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanReport>, I>>(object: I): ScanReport {
    const message = createBaseScanReport();
    message.fleets = object.fleets?.map((e) => ScannedFleet.fromPartial(e)) || [];
    message.cell = object.cell ?? 0;
    return message;
  },
};

function createBaseScannedFleet(): ScannedFleet {
  return { faction: 0, cls: 0, hullPct: 0, xMpx: 0, yMpx: 0, weapType: 0, shieldType: 0, ownerName: "", ownerId: 0 };
}

export const ScannedFleet: MessageFns<ScannedFleet> = {
  encode(message: ScannedFleet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.faction !== 0) {
      writer.uint32(8).uint32(message.faction);
    }
    if (message.cls !== 0) {
      writer.uint32(16).int32(message.cls);
    }
    if (message.hullPct !== 0) {
      writer.uint32(32).uint32(message.hullPct);
    }
    if (message.xMpx !== 0) {
      writer.uint32(40).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(48).sint32(message.yMpx);
    }
    if (message.weapType !== 0) {
      writer.uint32(56).uint32(message.weapType);
    }
    if (message.shieldType !== 0) {
      writer.uint32(64).uint32(message.shieldType);
    }
    if (message.ownerName !== "") {
      writer.uint32(74).string(message.ownerName);
    }
    if (message.ownerId !== 0) {
      writer.uint32(80).uint32(message.ownerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScannedFleet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScannedFleet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cls = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.hullPct = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.weapType = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.shieldType = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.ownerName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.ownerId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ScannedFleet>, I>>(base?: I): ScannedFleet {
    return ScannedFleet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScannedFleet>, I>>(object: I): ScannedFleet {
    const message = createBaseScannedFleet();
    message.faction = object.faction ?? 0;
    message.cls = object.cls ?? 0;
    message.hullPct = object.hullPct ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.weapType = object.weapType ?? 0;
    message.shieldType = object.shieldType ?? 0;
    message.ownerName = object.ownerName ?? "";
    message.ownerId = object.ownerId ?? 0;
    return message;
  },
};

function createBaseChatMsg(): ChatMsg {
  return {
    channel: 0,
    fromId: 0,
    fromName: "",
    text: "",
    unix: 0,
    faction: 0,
    clanTag: "",
    history: false,
    report: undefined,
    marker: undefined,
    lineId: 0,
    quick: 0,
    quickPos: undefined,
  };
}

export const ChatMsg: MessageFns<ChatMsg> = {
  encode(message: ChatMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channel !== 0) {
      writer.uint32(8).int32(message.channel);
    }
    if (message.fromId !== 0) {
      writer.uint32(16).uint32(message.fromId);
    }
    if (message.fromName !== "") {
      writer.uint32(26).string(message.fromName);
    }
    if (message.text !== "") {
      writer.uint32(34).string(message.text);
    }
    if (message.unix !== 0) {
      writer.uint32(40).uint64(message.unix);
    }
    if (message.faction !== 0) {
      writer.uint32(48).uint32(message.faction);
    }
    if (message.clanTag !== "") {
      writer.uint32(58).string(message.clanTag);
    }
    if (message.history !== false) {
      writer.uint32(64).bool(message.history);
    }
    if (message.report !== undefined) {
      ScanReport.encode(message.report, writer.uint32(74).fork()).join();
    }
    if (message.marker !== undefined) {
      MapMarker.encode(message.marker, writer.uint32(82).fork()).join();
    }
    if (message.lineId !== 0) {
      writer.uint32(88).uint64(message.lineId);
    }
    if (message.quick !== 0) {
      writer.uint32(96).uint32(message.quick);
    }
    if (message.quickPos !== undefined) {
      QuickPos.encode(message.quickPos, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.channel = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.fromId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fromName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.unix = longToNumber(reader.uint64());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.clanTag = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.history = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.report = ScanReport.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.marker = MapMarker.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.lineId = longToNumber(reader.uint64());
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.quick = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.quickPos = QuickPos.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ChatMsg>, I>>(base?: I): ChatMsg {
    return ChatMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatMsg>, I>>(object: I): ChatMsg {
    const message = createBaseChatMsg();
    message.channel = object.channel ?? 0;
    message.fromId = object.fromId ?? 0;
    message.fromName = object.fromName ?? "";
    message.text = object.text ?? "";
    message.unix = object.unix ?? 0;
    message.faction = object.faction ?? 0;
    message.clanTag = object.clanTag ?? "";
    message.history = object.history ?? false;
    message.report = (object.report !== undefined && object.report !== null)
      ? ScanReport.fromPartial(object.report)
      : undefined;
    message.marker = (object.marker !== undefined && object.marker !== null)
      ? MapMarker.fromPartial(object.marker)
      : undefined;
    message.lineId = object.lineId ?? 0;
    message.quick = object.quick ?? 0;
    message.quickPos = (object.quickPos !== undefined && object.quickPos !== null)
      ? QuickPos.fromPartial(object.quickPos)
      : undefined;
    return message;
  },
};

function createBaseSiegeInfo(): SiegeInfo {
  return {
    siteId: 0,
    siteName: "",
    cell: 0,
    owner: 0,
    kind: 0,
    kindName: "",
    windowHour: 0,
    windowInSec: 0,
    gauge10: 0,
    contested: false,
    youCommitted: false,
    attacker: 0,
    ownCommits: 0,
    enemyPledged: false,
    yourFleets: [],
    healBlocked: false,
    benefit: 0,
    benefit2: 0,
    featured: false,
    squadIn: 0,
    youIn: false,
  };
}

export const SiegeInfo: MessageFns<SiegeInfo> = {
  encode(message: SiegeInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.siteId !== 0) {
      writer.uint32(8).uint32(message.siteId);
    }
    if (message.siteName !== "") {
      writer.uint32(18).string(message.siteName);
    }
    if (message.cell !== 0) {
      writer.uint32(24).uint32(message.cell);
    }
    if (message.owner !== 0) {
      writer.uint32(32).uint32(message.owner);
    }
    if (message.kind !== 0) {
      writer.uint32(40).uint32(message.kind);
    }
    if (message.kindName !== "") {
      writer.uint32(50).string(message.kindName);
    }
    if (message.windowHour !== 0) {
      writer.uint32(56).uint32(message.windowHour);
    }
    if (message.windowInSec !== 0) {
      writer.uint32(64).sint32(message.windowInSec);
    }
    if (message.gauge10 !== 0) {
      writer.uint32(72).uint32(message.gauge10);
    }
    if (message.contested !== false) {
      writer.uint32(96).bool(message.contested);
    }
    if (message.youCommitted !== false) {
      writer.uint32(104).bool(message.youCommitted);
    }
    if (message.attacker !== 0) {
      writer.uint32(120).uint32(message.attacker);
    }
    if (message.ownCommits !== 0) {
      writer.uint32(128).uint32(message.ownCommits);
    }
    if (message.enemyPledged !== false) {
      writer.uint32(136).bool(message.enemyPledged);
    }
    for (const v of message.yourFleets) {
      PledgedFleet.encode(v!, writer.uint32(146).fork()).join();
    }
    if (message.healBlocked !== false) {
      writer.uint32(152).bool(message.healBlocked);
    }
    if (message.benefit !== 0) {
      writer.uint32(161).double(message.benefit);
    }
    if (message.benefit2 !== 0) {
      writer.uint32(169).double(message.benefit2);
    }
    if (message.featured !== false) {
      writer.uint32(176).bool(message.featured);
    }
    if (message.squadIn !== 0) {
      writer.uint32(184).uint32(message.squadIn);
    }
    if (message.youIn !== false) {
      writer.uint32(192).bool(message.youIn);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SiegeInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSiegeInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.siteId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.siteName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.owner = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.kind = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.kindName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.windowHour = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.windowInSec = reader.sint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.gauge10 = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.contested = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.youCommitted = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.attacker = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.ownCommits = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.enemyPledged = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.yourFleets.push(PledgedFleet.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.healBlocked = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 161) {
            break;
          }

          message.benefit = reader.double();
          continue;
        }
        case 21: {
          if (tag !== 169) {
            break;
          }

          message.benefit2 = reader.double();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.featured = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.squadIn = reader.uint32();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.youIn = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SiegeInfo>, I>>(base?: I): SiegeInfo {
    return SiegeInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SiegeInfo>, I>>(object: I): SiegeInfo {
    const message = createBaseSiegeInfo();
    message.siteId = object.siteId ?? 0;
    message.siteName = object.siteName ?? "";
    message.cell = object.cell ?? 0;
    message.owner = object.owner ?? 0;
    message.kind = object.kind ?? 0;
    message.kindName = object.kindName ?? "";
    message.windowHour = object.windowHour ?? 0;
    message.windowInSec = object.windowInSec ?? 0;
    message.gauge10 = object.gauge10 ?? 0;
    message.contested = object.contested ?? false;
    message.youCommitted = object.youCommitted ?? false;
    message.attacker = object.attacker ?? 0;
    message.ownCommits = object.ownCommits ?? 0;
    message.enemyPledged = object.enemyPledged ?? false;
    message.yourFleets = object.yourFleets?.map((e) => PledgedFleet.fromPartial(e)) || [];
    message.healBlocked = object.healBlocked ?? false;
    message.benefit = object.benefit ?? 0;
    message.benefit2 = object.benefit2 ?? 0;
    message.featured = object.featured ?? false;
    message.squadIn = object.squadIn ?? 0;
    message.youIn = object.youIn ?? false;
    return message;
  },
};

function createBasePledgedFleet(): PledgedFleet {
  return { fleetId: 0, name: "", battlePlan: 0 };
}

export const PledgedFleet: MessageFns<PledgedFleet> = {
  encode(message: PledgedFleet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fleetId !== 0) {
      writer.uint32(8).uint32(message.fleetId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.battlePlan !== 0) {
      writer.uint32(24).uint32(message.battlePlan);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PledgedFleet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePledgedFleet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.battlePlan = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<PledgedFleet>, I>>(base?: I): PledgedFleet {
    return PledgedFleet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PledgedFleet>, I>>(object: I): PledgedFleet {
    const message = createBasePledgedFleet();
    message.fleetId = object.fleetId ?? 0;
    message.name = object.name ?? "";
    message.battlePlan = object.battlePlan ?? 0;
    return message;
  },
};

function createBaseSieges(): Sieges {
  return { sieges: [] };
}

export const Sieges: MessageFns<Sieges> = {
  encode(message: Sieges, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.sieges) {
      SiegeInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Sieges {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSieges();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sieges.push(SiegeInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Sieges>, I>>(base?: I): Sieges {
    return Sieges.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Sieges>, I>>(object: I): Sieges {
    const message = createBaseSieges();
    message.sieges = object.sieges?.map((e) => SiegeInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWarQuery(): WarQuery {
  return {};
}

export const WarQuery: MessageFns<WarQuery> = {
  encode(_: WarQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WarQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWarQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<WarQuery>, I>>(base?: I): WarQuery {
    return WarQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WarQuery>, I>>(_: I): WarQuery {
    const message = createBaseWarQuery();
    return message;
  },
};

function createBaseWarState(): WarState {
  return { sov: [], sampleEverySec: 0, players: [], squads: [], log: [], intel: [] };
}

export const WarState: MessageFns<WarState> = {
  encode(message: WarState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.sov) {
      SovSample.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.sampleEverySec !== 0) {
      writer.uint32(16).uint32(message.sampleEverySec);
    }
    for (const v of message.players) {
      SovLedgerRow.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.squads) {
      SovLedgerRow.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.log) {
      CaptureLogEntry.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.intel) {
      IntelEntry.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WarState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWarState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sov.push(SovSample.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sampleEverySec = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.players.push(SovLedgerRow.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.squads.push(SovLedgerRow.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.log.push(CaptureLogEntry.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.intel.push(IntelEntry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<WarState>, I>>(base?: I): WarState {
    return WarState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WarState>, I>>(object: I): WarState {
    const message = createBaseWarState();
    message.sov = object.sov?.map((e) => SovSample.fromPartial(e)) || [];
    message.sampleEverySec = object.sampleEverySec ?? 0;
    message.players = object.players?.map((e) => SovLedgerRow.fromPartial(e)) || [];
    message.squads = object.squads?.map((e) => SovLedgerRow.fromPartial(e)) || [];
    message.log = object.log?.map((e) => CaptureLogEntry.fromPartial(e)) || [];
    message.intel = object.intel?.map((e) => IntelEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSovSample(): SovSample {
  return { tSec: 0, cells: [] };
}

export const SovSample: MessageFns<SovSample> = {
  encode(message: SovSample, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tSec !== 0) {
      writer.uint32(8).uint32(message.tSec);
    }
    writer.uint32(18).fork();
    for (const v of message.cells) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SovSample {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSovSample();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tSec = reader.uint32();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.cells.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.cells.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SovSample>, I>>(base?: I): SovSample {
    return SovSample.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SovSample>, I>>(object: I): SovSample {
    const message = createBaseSovSample();
    message.tSec = object.tSec ?? 0;
    message.cells = object.cells?.map((e) => e) || [];
    return message;
  },
};

function createBaseProductionQuery(): ProductionQuery {
  return {};
}

export const ProductionQuery: MessageFns<ProductionQuery> = {
  encode(_: ProductionQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProductionQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProductionQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ProductionQuery>, I>>(base?: I): ProductionQuery {
    return ProductionQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProductionQuery>, I>>(_: I): ProductionQuery {
    const message = createBaseProductionQuery();
    return message;
  },
};

function createBaseProductionState(): ProductionState {
  return { samples: [], sampleEverySec: 0 };
}

export const ProductionState: MessageFns<ProductionState> = {
  encode(message: ProductionState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.samples) {
      ProductionSample.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.sampleEverySec !== 0) {
      writer.uint32(16).uint32(message.sampleEverySec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProductionState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProductionState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.samples.push(ProductionSample.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sampleEverySec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ProductionState>, I>>(base?: I): ProductionState {
    return ProductionState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProductionState>, I>>(object: I): ProductionState {
    const message = createBaseProductionState();
    message.samples = object.samples?.map((e) => ProductionSample.fromPartial(e)) || [];
    message.sampleEverySec = object.sampleEverySec ?? 0;
    return message;
  },
};

function createBaseProductionSample(): ProductionSample {
  return { tSec: 0, mined: [], gathered: [] };
}

export const ProductionSample: MessageFns<ProductionSample> = {
  encode(message: ProductionSample, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tSec !== 0) {
      writer.uint32(8).uint32(message.tSec);
    }
    writer.uint32(18).fork();
    for (const v of message.mined) {
      writer.uint64(v);
    }
    writer.join();
    writer.uint32(26).fork();
    for (const v of message.gathered) {
      writer.uint64(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProductionSample {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProductionSample();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tSec = reader.uint32();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.mined.push(longToNumber(reader.uint64()));

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.mined.push(longToNumber(reader.uint64()));
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag === 24) {
            message.gathered.push(longToNumber(reader.uint64()));

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.gathered.push(longToNumber(reader.uint64()));
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ProductionSample>, I>>(base?: I): ProductionSample {
    return ProductionSample.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProductionSample>, I>>(object: I): ProductionSample {
    const message = createBaseProductionSample();
    message.tSec = object.tSec ?? 0;
    message.mined = object.mined?.map((e) => e) || [];
    message.gathered = object.gathered?.map((e) => e) || [];
    return message;
  },
};

function createBaseInboxLedgerQuery(): InboxLedgerQuery {
  return {};
}

export const InboxLedgerQuery: MessageFns<InboxLedgerQuery> = {
  encode(_: InboxLedgerQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxLedgerQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxLedgerQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxLedgerQuery>, I>>(base?: I): InboxLedgerQuery {
    return InboxLedgerQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxLedgerQuery>, I>>(_: I): InboxLedgerQuery {
    const message = createBaseInboxLedgerQuery();
    return message;
  },
};

function createBaseInboxLedgerState(): InboxLedgerState {
  return { keyCount: 0, hours: [], days: [], awayUnix: 0, nowUnix: 0 };
}

export const InboxLedgerState: MessageFns<InboxLedgerState> = {
  encode(message: InboxLedgerState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.keyCount !== 0) {
      writer.uint32(8).uint32(message.keyCount);
    }
    for (const v of message.hours) {
      InboxLedgerRow.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.days) {
      InboxLedgerRow.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.awayUnix !== 0) {
      writer.uint32(32).uint64(message.awayUnix);
    }
    if (message.nowUnix !== 0) {
      writer.uint32(40).uint64(message.nowUnix);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxLedgerState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxLedgerState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.keyCount = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.hours.push(InboxLedgerRow.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.days.push(InboxLedgerRow.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.awayUnix = longToNumber(reader.uint64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.nowUnix = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxLedgerState>, I>>(base?: I): InboxLedgerState {
    return InboxLedgerState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxLedgerState>, I>>(object: I): InboxLedgerState {
    const message = createBaseInboxLedgerState();
    message.keyCount = object.keyCount ?? 0;
    message.hours = object.hours?.map((e) => InboxLedgerRow.fromPartial(e)) || [];
    message.days = object.days?.map((e) => InboxLedgerRow.fromPartial(e)) || [];
    message.awayUnix = object.awayUnix ?? 0;
    message.nowUnix = object.nowUnix ?? 0;
    return message;
  },
};

function createBaseInboxLedgerRow(): InboxLedgerRow {
  return { startUnix: 0, counts: [] };
}

export const InboxLedgerRow: MessageFns<InboxLedgerRow> = {
  encode(message: InboxLedgerRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startUnix !== 0) {
      writer.uint32(8).uint64(message.startUnix);
    }
    writer.uint32(18).fork();
    for (const v of message.counts) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxLedgerRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxLedgerRow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.startUnix = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.counts.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.counts.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxLedgerRow>, I>>(base?: I): InboxLedgerRow {
    return InboxLedgerRow.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxLedgerRow>, I>>(object: I): InboxLedgerRow {
    const message = createBaseInboxLedgerRow();
    message.startUnix = object.startUnix ?? 0;
    message.counts = object.counts?.map((e) => e) || [];
    return message;
  },
};

function createBaseTimelapseQuery(): TimelapseQuery {
  return {};
}

export const TimelapseQuery: MessageFns<TimelapseQuery> = {
  encode(_: TimelapseQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TimelapseQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimelapseQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TimelapseQuery>, I>>(base?: I): TimelapseQuery {
    return TimelapseQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimelapseQuery>, I>>(_: I): TimelapseQuery {
    const message = createBaseTimelapseQuery();
    return message;
  },
};

function createBaseTimelapseState(): TimelapseState {
  return { data: new Uint8Array(0) };
}

export const TimelapseState: MessageFns<TimelapseState> = {
  encode(message: TimelapseState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TimelapseState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimelapseState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TimelapseState>, I>>(base?: I): TimelapseState {
    return TimelapseState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimelapseState>, I>>(object: I): TimelapseState {
    const message = createBaseTimelapseState();
    message.data = object.data ?? new Uint8Array(0);
    return message;
  },
};

function createBaseSovLedgerRow(): SovLedgerRow {
  return { name: "", faction: 0, owned: 0, captured: 0 };
}

export const SovLedgerRow: MessageFns<SovLedgerRow> = {
  encode(message: SovLedgerRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.faction !== 0) {
      writer.uint32(16).uint32(message.faction);
    }
    if (message.owned !== 0) {
      writer.uint32(24).uint32(message.owned);
    }
    if (message.captured !== 0) {
      writer.uint32(32).uint32(message.captured);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SovLedgerRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSovLedgerRow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.owned = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.captured = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SovLedgerRow>, I>>(base?: I): SovLedgerRow {
    return SovLedgerRow.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SovLedgerRow>, I>>(object: I): SovLedgerRow {
    const message = createBaseSovLedgerRow();
    message.name = object.name ?? "";
    message.faction = object.faction ?? 0;
    message.owned = object.owned ?? 0;
    message.captured = object.captured ?? 0;
    return message;
  },
};

function createBaseCaptureLogEntry(): CaptureLogEntry {
  return { cell: 0, taker: 0, from: 0, atSec: 0, fleetName: "", ownerName: "" };
}

export const CaptureLogEntry: MessageFns<CaptureLogEntry> = {
  encode(message: CaptureLogEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cell !== 0) {
      writer.uint32(8).uint32(message.cell);
    }
    if (message.taker !== 0) {
      writer.uint32(16).uint32(message.taker);
    }
    if (message.from !== 0) {
      writer.uint32(24).uint32(message.from);
    }
    if (message.atSec !== 0) {
      writer.uint32(32).uint32(message.atSec);
    }
    if (message.fleetName !== "") {
      writer.uint32(42).string(message.fleetName);
    }
    if (message.ownerName !== "") {
      writer.uint32(50).string(message.ownerName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CaptureLogEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCaptureLogEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.taker = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.from = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.atSec = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fleetName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ownerName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CaptureLogEntry>, I>>(base?: I): CaptureLogEntry {
    return CaptureLogEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CaptureLogEntry>, I>>(object: I): CaptureLogEntry {
    const message = createBaseCaptureLogEntry();
    message.cell = object.cell ?? 0;
    message.taker = object.taker ?? 0;
    message.from = object.from ?? 0;
    message.atSec = object.atSec ?? 0;
    message.fleetName = object.fleetName ?? "";
    message.ownerName = object.ownerName ?? "";
    return message;
  },
};

function createBaseIntelEntry(): IntelEntry {
  return { fleet: undefined, fleetId: 0, scanner: "", ageSec: 0 };
}

export const IntelEntry: MessageFns<IntelEntry> = {
  encode(message: IntelEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fleet !== undefined) {
      ScannedFleet.encode(message.fleet, writer.uint32(10).fork()).join();
    }
    if (message.fleetId !== 0) {
      writer.uint32(16).uint32(message.fleetId);
    }
    if (message.scanner !== "") {
      writer.uint32(26).string(message.scanner);
    }
    if (message.ageSec !== 0) {
      writer.uint32(32).uint32(message.ageSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntelEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntelEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fleet = ScannedFleet.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scanner = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.ageSec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<IntelEntry>, I>>(base?: I): IntelEntry {
    return IntelEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IntelEntry>, I>>(object: I): IntelEntry {
    const message = createBaseIntelEntry();
    message.fleet = (object.fleet !== undefined && object.fleet !== null)
      ? ScannedFleet.fromPartial(object.fleet)
      : undefined;
    message.fleetId = object.fleetId ?? 0;
    message.scanner = object.scanner ?? "";
    message.ageSec = object.ageSec ?? 0;
    return message;
  },
};

function createBaseStanding(): Standing {
  return {
    rank: 0,
    accountId: 0,
    name: "",
    clanTag: "",
    faction: 0,
    score: 0,
    honour: 0,
    honourRank: 0,
    title: "",
    cells: 0,
    kills: 0,
    sieges: 0,
    gathered: 0,
  };
}

export const Standing: MessageFns<Standing> = {
  encode(message: Standing, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rank !== 0) {
      writer.uint32(8).uint32(message.rank);
    }
    if (message.accountId !== 0) {
      writer.uint32(16).uint32(message.accountId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.clanTag !== "") {
      writer.uint32(34).string(message.clanTag);
    }
    if (message.faction !== 0) {
      writer.uint32(40).uint32(message.faction);
    }
    if (message.score !== 0) {
      writer.uint32(48).uint32(message.score);
    }
    if (message.honour !== 0) {
      writer.uint32(56).uint32(message.honour);
    }
    if (message.honourRank !== 0) {
      writer.uint32(64).uint32(message.honourRank);
    }
    if (message.title !== "") {
      writer.uint32(74).string(message.title);
    }
    if (message.cells !== 0) {
      writer.uint32(80).uint32(message.cells);
    }
    if (message.kills !== 0) {
      writer.uint32(88).uint32(message.kills);
    }
    if (message.sieges !== 0) {
      writer.uint32(96).uint32(message.sieges);
    }
    if (message.gathered !== 0) {
      writer.uint32(104).uint32(message.gathered);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Standing {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStanding();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.rank = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.accountId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.clanTag = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.score = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.honour = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.honourRank = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.cells = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.kills = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.sieges = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.gathered = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Standing>, I>>(base?: I): Standing {
    return Standing.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Standing>, I>>(object: I): Standing {
    const message = createBaseStanding();
    message.rank = object.rank ?? 0;
    message.accountId = object.accountId ?? 0;
    message.name = object.name ?? "";
    message.clanTag = object.clanTag ?? "";
    message.faction = object.faction ?? 0;
    message.score = object.score ?? 0;
    message.honour = object.honour ?? 0;
    message.honourRank = object.honourRank ?? 0;
    message.title = object.title ?? "";
    message.cells = object.cells ?? 0;
    message.kills = object.kills ?? 0;
    message.sieges = object.sieges ?? 0;
    message.gathered = object.gathered ?? 0;
    return message;
  },
};

function createBaseScoreboard(): Scoreboard {
  return {
    season: 0,
    cataclysm: false,
    seasonLeftSec: 0,
    rows: [],
    you: undefined,
    quakeStage: 0,
    timescale: 0,
    truceLeftSec: 0,
    tacticalScale: 0,
    settlementLeftSec: 0,
    clockSec: 0,
    clockOriginSec: 0,
  };
}

export const Scoreboard: MessageFns<Scoreboard> = {
  encode(message: Scoreboard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.season !== 0) {
      writer.uint32(8).uint32(message.season);
    }
    if (message.cataclysm !== false) {
      writer.uint32(16).bool(message.cataclysm);
    }
    if (message.seasonLeftSec !== 0) {
      writer.uint32(24).uint32(message.seasonLeftSec);
    }
    for (const v of message.rows) {
      Standing.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.you !== undefined) {
      Standing.encode(message.you, writer.uint32(42).fork()).join();
    }
    if (message.quakeStage !== 0) {
      writer.uint32(48).uint32(message.quakeStage);
    }
    if (message.timescale !== 0) {
      writer.uint32(57).double(message.timescale);
    }
    if (message.truceLeftSec !== 0) {
      writer.uint32(64).uint32(message.truceLeftSec);
    }
    if (message.tacticalScale !== 0) {
      writer.uint32(73).double(message.tacticalScale);
    }
    if (message.settlementLeftSec !== 0) {
      writer.uint32(80).uint32(message.settlementLeftSec);
    }
    if (message.clockSec !== 0) {
      writer.uint32(88).uint32(message.clockSec);
    }
    if (message.clockOriginSec !== 0) {
      writer.uint32(104).uint32(message.clockOriginSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Scoreboard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScoreboard();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.season = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cataclysm = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.seasonLeftSec = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.rows.push(Standing.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.you = Standing.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.quakeStage = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.timescale = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.truceLeftSec = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.tacticalScale = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.settlementLeftSec = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.clockSec = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.clockOriginSec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Scoreboard>, I>>(base?: I): Scoreboard {
    return Scoreboard.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Scoreboard>, I>>(object: I): Scoreboard {
    const message = createBaseScoreboard();
    message.season = object.season ?? 0;
    message.cataclysm = object.cataclysm ?? false;
    message.seasonLeftSec = object.seasonLeftSec ?? 0;
    message.rows = object.rows?.map((e) => Standing.fromPartial(e)) || [];
    message.you = (object.you !== undefined && object.you !== null) ? Standing.fromPartial(object.you) : undefined;
    message.quakeStage = object.quakeStage ?? 0;
    message.timescale = object.timescale ?? 0;
    message.truceLeftSec = object.truceLeftSec ?? 0;
    message.tacticalScale = object.tacticalScale ?? 0;
    message.settlementLeftSec = object.settlementLeftSec ?? 0;
    message.clockSec = object.clockSec ?? 0;
    message.clockOriginSec = object.clockOriginSec ?? 0;
    return message;
  },
};

function createBaseSeasonReport(): SeasonReport {
  return {
    season: 0,
    rank: 0,
    score: 0,
    honourGained: 0,
    honour: 0,
    honourRankNow: 0,
    title: "",
    cells: 0,
    kills: 0,
    sieges: 0,
    expeditions: 0,
    unix: 0,
  };
}

export const SeasonReport: MessageFns<SeasonReport> = {
  encode(message: SeasonReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.season !== 0) {
      writer.uint32(8).uint32(message.season);
    }
    if (message.rank !== 0) {
      writer.uint32(16).uint32(message.rank);
    }
    if (message.score !== 0) {
      writer.uint32(24).uint32(message.score);
    }
    if (message.honourGained !== 0) {
      writer.uint32(32).uint32(message.honourGained);
    }
    if (message.honour !== 0) {
      writer.uint32(40).uint32(message.honour);
    }
    if (message.honourRankNow !== 0) {
      writer.uint32(48).uint32(message.honourRankNow);
    }
    if (message.title !== "") {
      writer.uint32(58).string(message.title);
    }
    if (message.cells !== 0) {
      writer.uint32(64).uint32(message.cells);
    }
    if (message.kills !== 0) {
      writer.uint32(72).uint32(message.kills);
    }
    if (message.sieges !== 0) {
      writer.uint32(80).uint32(message.sieges);
    }
    if (message.expeditions !== 0) {
      writer.uint32(88).uint32(message.expeditions);
    }
    if (message.unix !== 0) {
      writer.uint32(96).uint64(message.unix);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeasonReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeasonReport();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.season = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.rank = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.score = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.honourGained = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.honour = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.honourRankNow = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.cells = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.kills = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.sieges = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.expeditions = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.unix = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SeasonReport>, I>>(base?: I): SeasonReport {
    return SeasonReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeasonReport>, I>>(object: I): SeasonReport {
    const message = createBaseSeasonReport();
    message.season = object.season ?? 0;
    message.rank = object.rank ?? 0;
    message.score = object.score ?? 0;
    message.honourGained = object.honourGained ?? 0;
    message.honour = object.honour ?? 0;
    message.honourRankNow = object.honourRankNow ?? 0;
    message.title = object.title ?? "";
    message.cells = object.cells ?? 0;
    message.kills = object.kills ?? 0;
    message.sieges = object.sieges ?? 0;
    message.expeditions = object.expeditions ?? 0;
    message.unix = object.unix ?? 0;
    return message;
  },
};

function createBaseSeasonSummary(): SeasonSummary {
  return {
    mode: 0,
    season: 0,
    held: false,
    nextSeasonInSec: 0,
    rows: [],
    you: undefined,
    stats: undefined,
    banners: [],
    seasonStartedUnix: 0,
    roadBuilder: "",
    roadBuilderHours: 0,
  };
}

export const SeasonSummary: MessageFns<SeasonSummary> = {
  encode(message: SeasonSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== 0) {
      writer.uint32(8).uint32(message.mode);
    }
    if (message.season !== 0) {
      writer.uint32(16).uint32(message.season);
    }
    if (message.held !== false) {
      writer.uint32(24).bool(message.held);
    }
    if (message.nextSeasonInSec !== 0) {
      writer.uint32(32).uint32(message.nextSeasonInSec);
    }
    for (const v of message.rows) {
      Standing.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.you !== undefined) {
      Standing.encode(message.you, writer.uint32(50).fork()).join();
    }
    if (message.stats !== undefined) {
      SeasonSummaryStats.encode(message.stats, writer.uint32(58).fork()).join();
    }
    for (const v of message.banners) {
      SeasonSummaryBanner.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.seasonStartedUnix !== 0) {
      writer.uint32(72).uint64(message.seasonStartedUnix);
    }
    if (message.roadBuilder !== "") {
      writer.uint32(82).string(message.roadBuilder);
    }
    if (message.roadBuilderHours !== 0) {
      writer.uint32(88).uint32(message.roadBuilderHours);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeasonSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeasonSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.mode = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.season = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.held = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.nextSeasonInSec = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.rows.push(Standing.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.you = Standing.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.stats = SeasonSummaryStats.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.banners.push(SeasonSummaryBanner.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.seasonStartedUnix = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.roadBuilder = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.roadBuilderHours = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SeasonSummary>, I>>(base?: I): SeasonSummary {
    return SeasonSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeasonSummary>, I>>(object: I): SeasonSummary {
    const message = createBaseSeasonSummary();
    message.mode = object.mode ?? 0;
    message.season = object.season ?? 0;
    message.held = object.held ?? false;
    message.nextSeasonInSec = object.nextSeasonInSec ?? 0;
    message.rows = object.rows?.map((e) => Standing.fromPartial(e)) || [];
    message.you = (object.you !== undefined && object.you !== null) ? Standing.fromPartial(object.you) : undefined;
    message.stats = (object.stats !== undefined && object.stats !== null)
      ? SeasonSummaryStats.fromPartial(object.stats)
      : undefined;
    message.banners = object.banners?.map((e) => SeasonSummaryBanner.fromPartial(e)) || [];
    message.seasonStartedUnix = object.seasonStartedUnix ?? 0;
    message.roadBuilder = object.roadBuilder ?? "";
    message.roadBuilderHours = object.roadBuilderHours ?? 0;
    return message;
  },
};

function createBaseSeasonSummaryStats(): SeasonSummaryStats {
  return {
    scoreBySource: [],
    honour: 0,
    fleetsLost: 0,
    siegesLost: 0,
    gathered: 0,
    expeditions: 0,
    buildingLevels: 0,
    techRecovered: 0,
    throneHours: 0,
    captainsLost: 0,
    prisoners: 0,
    trades: 0,
  };
}

export const SeasonSummaryStats: MessageFns<SeasonSummaryStats> = {
  encode(message: SeasonSummaryStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.scoreBySource) {
      writer.uint32(v);
    }
    writer.join();
    if (message.honour !== 0) {
      writer.uint32(16).uint32(message.honour);
    }
    if (message.fleetsLost !== 0) {
      writer.uint32(24).uint32(message.fleetsLost);
    }
    if (message.siegesLost !== 0) {
      writer.uint32(32).uint32(message.siegesLost);
    }
    if (message.gathered !== 0) {
      writer.uint32(40).uint32(message.gathered);
    }
    if (message.expeditions !== 0) {
      writer.uint32(48).uint32(message.expeditions);
    }
    if (message.buildingLevels !== 0) {
      writer.uint32(56).uint32(message.buildingLevels);
    }
    if (message.techRecovered !== 0) {
      writer.uint32(64).uint32(message.techRecovered);
    }
    if (message.throneHours !== 0) {
      writer.uint32(72).uint32(message.throneHours);
    }
    if (message.captainsLost !== 0) {
      writer.uint32(80).uint32(message.captainsLost);
    }
    if (message.prisoners !== 0) {
      writer.uint32(88).uint32(message.prisoners);
    }
    if (message.trades !== 0) {
      writer.uint32(96).uint32(message.trades);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeasonSummaryStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeasonSummaryStats();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.scoreBySource.push(reader.uint32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.scoreBySource.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.honour = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fleetsLost = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.siegesLost = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.gathered = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.expeditions = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.buildingLevels = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.techRecovered = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.throneHours = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.captainsLost = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.prisoners = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.trades = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SeasonSummaryStats>, I>>(base?: I): SeasonSummaryStats {
    return SeasonSummaryStats.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeasonSummaryStats>, I>>(object: I): SeasonSummaryStats {
    const message = createBaseSeasonSummaryStats();
    message.scoreBySource = object.scoreBySource?.map((e) => e) || [];
    message.honour = object.honour ?? 0;
    message.fleetsLost = object.fleetsLost ?? 0;
    message.siegesLost = object.siegesLost ?? 0;
    message.gathered = object.gathered ?? 0;
    message.expeditions = object.expeditions ?? 0;
    message.buildingLevels = object.buildingLevels ?? 0;
    message.techRecovered = object.techRecovered ?? 0;
    message.throneHours = object.throneHours ?? 0;
    message.captainsLost = object.captainsLost ?? 0;
    message.prisoners = object.prisoners ?? 0;
    message.trades = object.trades ?? 0;
    return message;
  },
};

function createBaseSeasonSummaryBanner(): SeasonSummaryBanner {
  return { rank: 0, faction: 0, name: "", tag: "", house: false, score: 0, seats: 0 };
}

export const SeasonSummaryBanner: MessageFns<SeasonSummaryBanner> = {
  encode(message: SeasonSummaryBanner, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rank !== 0) {
      writer.uint32(8).uint32(message.rank);
    }
    if (message.faction !== 0) {
      writer.uint32(16).uint32(message.faction);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.tag !== "") {
      writer.uint32(34).string(message.tag);
    }
    if (message.house !== false) {
      writer.uint32(40).bool(message.house);
    }
    if (message.score !== 0) {
      writer.uint32(48).uint32(message.score);
    }
    if (message.seats !== 0) {
      writer.uint32(56).uint32(message.seats);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SeasonSummaryBanner {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSeasonSummaryBanner();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.rank = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.house = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.score = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.seats = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SeasonSummaryBanner>, I>>(base?: I): SeasonSummaryBanner {
    return SeasonSummaryBanner.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SeasonSummaryBanner>, I>>(object: I): SeasonSummaryBanner {
    const message = createBaseSeasonSummaryBanner();
    message.rank = object.rank ?? 0;
    message.faction = object.faction ?? 0;
    message.name = object.name ?? "";
    message.tag = object.tag ?? "";
    message.house = object.house ?? false;
    message.score = object.score ?? 0;
    message.seats = object.seats ?? 0;
    return message;
  },
};

function createBaseInboxMsg(): InboxMsg {
  return {
    id: 0,
    kind: 0,
    unix: 0,
    title: "",
    body: "",
    cell: 0,
    replay: undefined,
    read: false,
    expiresUnix: 0,
    replace: undefined,
    event: "",
    bucket: "",
    params: {},
    rows: [],
    count: 0,
    firstUnix: 0,
    members: [],
    needs: false,
  };
}

export const InboxMsg: MessageFns<InboxMsg> = {
  encode(message: InboxMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind);
    }
    if (message.unix !== 0) {
      writer.uint32(24).uint64(message.unix);
    }
    if (message.title !== "") {
      writer.uint32(34).string(message.title);
    }
    if (message.body !== "") {
      writer.uint32(42).string(message.body);
    }
    if (message.cell !== 0) {
      writer.uint32(48).uint32(message.cell);
    }
    if (message.replay !== undefined) {
      ReplayRef.encode(message.replay, writer.uint32(58).fork()).join();
    }
    if (message.read !== false) {
      writer.uint32(64).bool(message.read);
    }
    if (message.expiresUnix !== 0) {
      writer.uint32(72).uint64(message.expiresUnix);
    }
    if (message.replace !== undefined) {
      ReplaceOffer.encode(message.replace, writer.uint32(82).fork()).join();
    }
    if (message.event !== "") {
      writer.uint32(90).string(message.event);
    }
    if (message.bucket !== "") {
      writer.uint32(98).string(message.bucket);
    }
    globalThis.Object.entries(message.params).forEach(([key, value]: [string, string]) => {
      InboxMsg_ParamsEntry.encode({ key: key as any, value }, writer.uint32(106).fork()).join();
    });
    for (const v of message.rows) {
      InboxTable.encode(v!, writer.uint32(114).fork()).join();
    }
    if (message.count !== 0) {
      writer.uint32(120).uint32(message.count);
    }
    if (message.firstUnix !== 0) {
      writer.uint32(128).uint64(message.firstUnix);
    }
    for (const v of message.members) {
      InboxMember.encode(v!, writer.uint32(138).fork()).join();
    }
    if (message.needs !== false) {
      writer.uint32(144).bool(message.needs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.unix = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.body = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.replay = ReplayRef.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.read = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.expiresUnix = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.replace = ReplaceOffer.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.event = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.bucket = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          const entry13 = InboxMsg_ParamsEntry.decode(reader, reader.uint32());
          if (entry13.value !== undefined) {
            message.params[entry13.key] = entry13.value;
          }
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.rows.push(InboxTable.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.firstUnix = longToNumber(reader.uint64());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.members.push(InboxMember.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.needs = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxMsg>, I>>(base?: I): InboxMsg {
    return InboxMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxMsg>, I>>(object: I): InboxMsg {
    const message = createBaseInboxMsg();
    message.id = object.id ?? 0;
    message.kind = object.kind ?? 0;
    message.unix = object.unix ?? 0;
    message.title = object.title ?? "";
    message.body = object.body ?? "";
    message.cell = object.cell ?? 0;
    message.replay = (object.replay !== undefined && object.replay !== null)
      ? ReplayRef.fromPartial(object.replay)
      : undefined;
    message.read = object.read ?? false;
    message.expiresUnix = object.expiresUnix ?? 0;
    message.replace = (object.replace !== undefined && object.replace !== null)
      ? ReplaceOffer.fromPartial(object.replace)
      : undefined;
    message.event = object.event ?? "";
    message.bucket = object.bucket ?? "";
    message.params = (globalThis.Object.entries(object.params ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.rows = object.rows?.map((e) => InboxTable.fromPartial(e)) || [];
    message.count = object.count ?? 0;
    message.firstUnix = object.firstUnix ?? 0;
    message.members = object.members?.map((e) => InboxMember.fromPartial(e)) || [];
    message.needs = object.needs ?? false;
    return message;
  },
};

function createBaseInboxMsg_ParamsEntry(): InboxMsg_ParamsEntry {
  return { key: "", value: "" };
}

export const InboxMsg_ParamsEntry: MessageFns<InboxMsg_ParamsEntry> = {
  encode(message: InboxMsg_ParamsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxMsg_ParamsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxMsg_ParamsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxMsg_ParamsEntry>, I>>(base?: I): InboxMsg_ParamsEntry {
    return InboxMsg_ParamsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxMsg_ParamsEntry>, I>>(object: I): InboxMsg_ParamsEntry {
    const message = createBaseInboxMsg_ParamsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseInboxTable(): InboxTable {
  return { name: "", rows: [] };
}

export const InboxTable: MessageFns<InboxTable> = {
  encode(message: InboxTable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    for (const v of message.rows) {
      InboxRow.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxTable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxTable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rows.push(InboxRow.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxTable>, I>>(base?: I): InboxTable {
    return InboxTable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxTable>, I>>(object: I): InboxTable {
    const message = createBaseInboxTable();
    message.name = object.name ?? "";
    message.rows = object.rows?.map((e) => InboxRow.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInboxRow(): InboxRow {
  return { cells: {} };
}

export const InboxRow: MessageFns<InboxRow> = {
  encode(message: InboxRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.cells).forEach(([key, value]: [string, string]) => {
      InboxRow_CellsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxRow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = InboxRow_CellsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.cells[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxRow>, I>>(base?: I): InboxRow {
    return InboxRow.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxRow>, I>>(object: I): InboxRow {
    const message = createBaseInboxRow();
    message.cells = (globalThis.Object.entries(object.cells ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseInboxRow_CellsEntry(): InboxRow_CellsEntry {
  return { key: "", value: "" };
}

export const InboxRow_CellsEntry: MessageFns<InboxRow_CellsEntry> = {
  encode(message: InboxRow_CellsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxRow_CellsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxRow_CellsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxRow_CellsEntry>, I>>(base?: I): InboxRow_CellsEntry {
    return InboxRow_CellsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxRow_CellsEntry>, I>>(object: I): InboxRow_CellsEntry {
    const message = createBaseInboxRow_CellsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseInboxMember(): InboxMember {
  return { unix: 0, params: {}, rows: [], cell: 0, replay: undefined };
}

export const InboxMember: MessageFns<InboxMember> = {
  encode(message: InboxMember, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.unix !== 0) {
      writer.uint32(8).uint64(message.unix);
    }
    globalThis.Object.entries(message.params).forEach(([key, value]: [string, string]) => {
      InboxMember_ParamsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    for (const v of message.rows) {
      InboxTable.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.cell !== 0) {
      writer.uint32(32).uint32(message.cell);
    }
    if (message.replay !== undefined) {
      ReplayRef.encode(message.replay, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxMember {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxMember();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.unix = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = InboxMember_ParamsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.params[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rows.push(InboxTable.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.replay = ReplayRef.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxMember>, I>>(base?: I): InboxMember {
    return InboxMember.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxMember>, I>>(object: I): InboxMember {
    const message = createBaseInboxMember();
    message.unix = object.unix ?? 0;
    message.params = (globalThis.Object.entries(object.params ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.rows = object.rows?.map((e) => InboxTable.fromPartial(e)) || [];
    message.cell = object.cell ?? 0;
    message.replay = (object.replay !== undefined && object.replay !== null)
      ? ReplayRef.fromPartial(object.replay)
      : undefined;
    return message;
  },
};

function createBaseInboxMember_ParamsEntry(): InboxMember_ParamsEntry {
  return { key: "", value: "" };
}

export const InboxMember_ParamsEntry: MessageFns<InboxMember_ParamsEntry> = {
  encode(message: InboxMember_ParamsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxMember_ParamsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxMember_ParamsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxMember_ParamsEntry>, I>>(base?: I): InboxMember_ParamsEntry {
    return InboxMember_ParamsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxMember_ParamsEntry>, I>>(object: I): InboxMember_ParamsEntry {
    const message = createBaseInboxMember_ParamsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseReplaceOffer(): ReplaceOffer {
  return { design: 0, hull: 0, price: undefined, queued: false, refusal: "" };
}

export const ReplaceOffer: MessageFns<ReplaceOffer> = {
  encode(message: ReplaceOffer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.design !== 0) {
      writer.uint32(8).uint32(message.design);
    }
    if (message.hull !== 0) {
      writer.uint32(16).int32(message.hull);
    }
    if (message.price !== undefined) {
      Resources.encode(message.price, writer.uint32(26).fork()).join();
    }
    if (message.queued !== false) {
      writer.uint32(32).bool(message.queued);
    }
    if (message.refusal !== "") {
      writer.uint32(42).string(message.refusal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReplaceOffer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReplaceOffer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.design = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hull = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.price = Resources.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.queued = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.refusal = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ReplaceOffer>, I>>(base?: I): ReplaceOffer {
    return ReplaceOffer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReplaceOffer>, I>>(object: I): ReplaceOffer {
    const message = createBaseReplaceOffer();
    message.design = object.design ?? 0;
    message.hull = object.hull ?? 0;
    message.price = (object.price !== undefined && object.price !== null)
      ? Resources.fromPartial(object.price)
      : undefined;
    message.queued = object.queued ?? false;
    message.refusal = object.refusal ?? "";
    return message;
  },
};

function createBaseInboxReplace(): InboxReplace {
  return { msgId: 0 };
}

export const InboxReplace: MessageFns<InboxReplace> = {
  encode(message: InboxReplace, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.msgId !== 0) {
      writer.uint32(8).uint32(message.msgId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxReplace {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxReplace();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.msgId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxReplace>, I>>(base?: I): InboxReplace {
    return InboxReplace.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxReplace>, I>>(object: I): InboxReplace {
    const message = createBaseInboxReplace();
    message.msgId = object.msgId ?? 0;
    return message;
  },
};

function createBaseInbox(): Inbox {
  return { msgs: [] };
}

export const Inbox: MessageFns<Inbox> = {
  encode(message: Inbox, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.msgs) {
      InboxMsg.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Inbox {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInbox();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.msgs.push(InboxMsg.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Inbox>, I>>(base?: I): Inbox {
    return Inbox.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Inbox>, I>>(object: I): Inbox {
    const message = createBaseInbox();
    message.msgs = object.msgs?.map((e) => InboxMsg.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInboxAction(): InboxAction {
  return { fetch: false, markRead: 0, markAll: false, fetchReplay: undefined, markIds: [] };
}

export const InboxAction: MessageFns<InboxAction> = {
  encode(message: InboxAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fetch !== false) {
      writer.uint32(8).bool(message.fetch);
    }
    if (message.markRead !== 0) {
      writer.uint32(16).uint32(message.markRead);
    }
    if (message.markAll !== false) {
      writer.uint32(24).bool(message.markAll);
    }
    if (message.fetchReplay !== undefined) {
      ReplayRef.encode(message.fetchReplay, writer.uint32(34).fork()).join();
    }
    writer.uint32(42).fork();
    for (const v of message.markIds) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboxAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInboxAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fetch = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.markRead = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.markAll = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fetchReplay = ReplayRef.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.markIds.push(reader.uint32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.markIds.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InboxAction>, I>>(base?: I): InboxAction {
    return InboxAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboxAction>, I>>(object: I): InboxAction {
    const message = createBaseInboxAction();
    message.fetch = object.fetch ?? false;
    message.markRead = object.markRead ?? 0;
    message.markAll = object.markAll ?? false;
    message.fetchReplay = (object.fetchReplay !== undefined && object.fetchReplay !== null)
      ? ReplayRef.fromPartial(object.fetchReplay)
      : undefined;
    message.markIds = object.markIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseReplayRef(): ReplayRef {
  return { kind: 0, fleets: [], t0Ms: 0, t1Ms: 0, cell: 0 };
}

export const ReplayRef: MessageFns<ReplayRef> = {
  encode(message: ReplayRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    writer.uint32(18).fork();
    for (const v of message.fleets) {
      writer.uint32(v);
    }
    writer.join();
    if (message.t0Ms !== 0) {
      writer.uint32(24).uint64(message.t0Ms);
    }
    if (message.t1Ms !== 0) {
      writer.uint32(32).uint64(message.t1Ms);
    }
    if (message.cell !== 0) {
      writer.uint32(40).uint32(message.cell);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReplayRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReplayRef();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.fleets.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.fleets.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.t0Ms = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.t1Ms = longToNumber(reader.uint64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ReplayRef>, I>>(base?: I): ReplayRef {
    return ReplayRef.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReplayRef>, I>>(object: I): ReplayRef {
    const message = createBaseReplayRef();
    message.kind = object.kind ?? 0;
    message.fleets = object.fleets?.map((e) => e) || [];
    message.t0Ms = object.t0Ms ?? 0;
    message.t1Ms = object.t1Ms ?? 0;
    message.cell = object.cell ?? 0;
    return message;
  },
};

function createBaseReplayHull(): ReplayHull {
  return { id: 0, faction: 0, cls: 0, name: "", commander: "", npc: 0 };
}

export const ReplayHull: MessageFns<ReplayHull> = {
  encode(message: ReplayHull, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.faction !== 0) {
      writer.uint32(16).uint32(message.faction);
    }
    if (message.cls !== 0) {
      writer.uint32(24).int32(message.cls);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.commander !== "") {
      writer.uint32(42).string(message.commander);
    }
    if (message.npc !== 0) {
      writer.uint32(48).int32(message.npc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReplayHull {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReplayHull();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cls = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.commander = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.npc = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ReplayHull>, I>>(base?: I): ReplayHull {
    return ReplayHull.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReplayHull>, I>>(object: I): ReplayHull {
    const message = createBaseReplayHull();
    message.id = object.id ?? 0;
    message.faction = object.faction ?? 0;
    message.cls = object.cls ?? 0;
    message.name = object.name ?? "";
    message.commander = object.commander ?? "";
    message.npc = object.npc ?? 0;
    return message;
  },
};

function createBaseReplayPoint(): ReplayPoint {
  return { tDs: 0, xMpx: 0, yMpx: 0, hullPct: 0, shieldPct: 0 };
}

export const ReplayPoint: MessageFns<ReplayPoint> = {
  encode(message: ReplayPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tDs !== 0) {
      writer.uint32(8).uint32(message.tDs);
    }
    if (message.xMpx !== 0) {
      writer.uint32(16).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(24).sint32(message.yMpx);
    }
    if (message.hullPct !== 0) {
      writer.uint32(32).uint32(message.hullPct);
    }
    if (message.shieldPct !== 0) {
      writer.uint32(40).uint32(message.shieldPct);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReplayPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReplayPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tDs = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.hullPct = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.shieldPct = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ReplayPoint>, I>>(base?: I): ReplayPoint {
    return ReplayPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReplayPoint>, I>>(object: I): ReplayPoint {
    const message = createBaseReplayPoint();
    message.tDs = object.tDs ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.hullPct = object.hullPct ?? 0;
    message.shieldPct = object.shieldPct ?? 0;
    return message;
  },
};

function createBaseReplayTrack(): ReplayTrack {
  return { hull: 0, points: [], sunk: false, sunkTDs: 0, withdrawn: false, withdrawnTDs: 0 };
}

export const ReplayTrack: MessageFns<ReplayTrack> = {
  encode(message: ReplayTrack, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hull !== 0) {
      writer.uint32(8).uint32(message.hull);
    }
    for (const v of message.points) {
      ReplayPoint.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.sunk !== false) {
      writer.uint32(24).bool(message.sunk);
    }
    if (message.sunkTDs !== 0) {
      writer.uint32(32).uint32(message.sunkTDs);
    }
    if (message.withdrawn !== false) {
      writer.uint32(40).bool(message.withdrawn);
    }
    if (message.withdrawnTDs !== 0) {
      writer.uint32(48).uint32(message.withdrawnTDs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReplayTrack {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReplayTrack();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hull = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.points.push(ReplayPoint.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.sunk = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.sunkTDs = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.withdrawn = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.withdrawnTDs = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ReplayTrack>, I>>(base?: I): ReplayTrack {
    return ReplayTrack.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReplayTrack>, I>>(object: I): ReplayTrack {
    const message = createBaseReplayTrack();
    message.hull = object.hull ?? 0;
    message.points = object.points?.map((e) => ReplayPoint.fromPartial(e)) || [];
    message.sunk = object.sunk ?? false;
    message.sunkTDs = object.sunkTDs ?? 0;
    message.withdrawn = object.withdrawn ?? false;
    message.withdrawnTDs = object.withdrawnTDs ?? 0;
    return message;
  },
};

function createBaseReplayHit(): ReplayHit {
  return {
    t0Ds: 0,
    t1Ds: 0,
    victim: 0,
    source: 0,
    kind: 0,
    torpedo: 0,
    sourceLabel: "",
    shots: 0,
    damageX10: 0,
    shieldBeforeX10: 0,
    shieldAfterX10: 0,
    hullBeforeX10: 0,
    hullAfterX10: 0,
    sxMpx: 0,
    syMpx: 0,
    vxMpx: 0,
    vyMpx: 0,
    launchTDs: 0,
    sourceText: "",
    kindWord: "",
    unix: 0,
    sourceFaction: 0,
    sourceCommander: "",
  };
}

export const ReplayHit: MessageFns<ReplayHit> = {
  encode(message: ReplayHit, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.t0Ds !== 0) {
      writer.uint32(8).uint32(message.t0Ds);
    }
    if (message.t1Ds !== 0) {
      writer.uint32(16).uint32(message.t1Ds);
    }
    if (message.victim !== 0) {
      writer.uint32(24).uint32(message.victim);
    }
    if (message.source !== 0) {
      writer.uint32(32).sint32(message.source);
    }
    if (message.kind !== 0) {
      writer.uint32(40).int32(message.kind);
    }
    if (message.torpedo !== 0) {
      writer.uint32(48).int32(message.torpedo);
    }
    if (message.sourceLabel !== "") {
      writer.uint32(58).string(message.sourceLabel);
    }
    if (message.shots !== 0) {
      writer.uint32(64).uint32(message.shots);
    }
    if (message.damageX10 !== 0) {
      writer.uint32(72).uint32(message.damageX10);
    }
    if (message.shieldBeforeX10 !== 0) {
      writer.uint32(80).uint32(message.shieldBeforeX10);
    }
    if (message.shieldAfterX10 !== 0) {
      writer.uint32(88).uint32(message.shieldAfterX10);
    }
    if (message.hullBeforeX10 !== 0) {
      writer.uint32(96).uint32(message.hullBeforeX10);
    }
    if (message.hullAfterX10 !== 0) {
      writer.uint32(104).uint32(message.hullAfterX10);
    }
    if (message.sxMpx !== 0) {
      writer.uint32(112).sint32(message.sxMpx);
    }
    if (message.syMpx !== 0) {
      writer.uint32(120).sint32(message.syMpx);
    }
    if (message.vxMpx !== 0) {
      writer.uint32(128).sint32(message.vxMpx);
    }
    if (message.vyMpx !== 0) {
      writer.uint32(136).sint32(message.vyMpx);
    }
    if (message.launchTDs !== 0) {
      writer.uint32(144).uint32(message.launchTDs);
    }
    if (message.sourceText !== "") {
      writer.uint32(154).string(message.sourceText);
    }
    if (message.kindWord !== "") {
      writer.uint32(162).string(message.kindWord);
    }
    if (message.unix !== 0) {
      writer.uint32(168).uint64(message.unix);
    }
    if (message.sourceFaction !== 0) {
      writer.uint32(176).uint32(message.sourceFaction);
    }
    if (message.sourceCommander !== "") {
      writer.uint32(186).string(message.sourceCommander);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReplayHit {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReplayHit();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.t0Ds = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.t1Ds = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.victim = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.source = reader.sint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.torpedo = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.sourceLabel = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.shots = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.damageX10 = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.shieldBeforeX10 = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.shieldAfterX10 = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.hullBeforeX10 = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.hullAfterX10 = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.sxMpx = reader.sint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.syMpx = reader.sint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.vxMpx = reader.sint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.vyMpx = reader.sint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.launchTDs = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.sourceText = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.kindWord = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.unix = longToNumber(reader.uint64());
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.sourceFaction = reader.uint32();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.sourceCommander = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ReplayHit>, I>>(base?: I): ReplayHit {
    return ReplayHit.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReplayHit>, I>>(object: I): ReplayHit {
    const message = createBaseReplayHit();
    message.t0Ds = object.t0Ds ?? 0;
    message.t1Ds = object.t1Ds ?? 0;
    message.victim = object.victim ?? 0;
    message.source = object.source ?? 0;
    message.kind = object.kind ?? 0;
    message.torpedo = object.torpedo ?? 0;
    message.sourceLabel = object.sourceLabel ?? "";
    message.shots = object.shots ?? 0;
    message.damageX10 = object.damageX10 ?? 0;
    message.shieldBeforeX10 = object.shieldBeforeX10 ?? 0;
    message.shieldAfterX10 = object.shieldAfterX10 ?? 0;
    message.hullBeforeX10 = object.hullBeforeX10 ?? 0;
    message.hullAfterX10 = object.hullAfterX10 ?? 0;
    message.sxMpx = object.sxMpx ?? 0;
    message.syMpx = object.syMpx ?? 0;
    message.vxMpx = object.vxMpx ?? 0;
    message.vyMpx = object.vyMpx ?? 0;
    message.launchTDs = object.launchTDs ?? 0;
    message.sourceText = object.sourceText ?? "";
    message.kindWord = object.kindWord ?? "";
    message.unix = object.unix ?? 0;
    message.sourceFaction = object.sourceFaction ?? 0;
    message.sourceCommander = object.sourceCommander ?? "";
    return message;
  },
};

function createBaseReplay(): Replay {
  return { ref: undefined, title: "", durationDs: 0, cell: 0, unix: 0, hulls: [], tracks: [], hits: [] };
}

export const Replay: MessageFns<Replay> = {
  encode(message: Replay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref !== undefined) {
      ReplayRef.encode(message.ref, writer.uint32(10).fork()).join();
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.durationDs !== 0) {
      writer.uint32(24).uint32(message.durationDs);
    }
    if (message.cell !== 0) {
      writer.uint32(32).uint32(message.cell);
    }
    if (message.unix !== 0) {
      writer.uint32(40).uint64(message.unix);
    }
    for (const v of message.hulls) {
      ReplayHull.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.tracks) {
      ReplayTrack.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.hits) {
      ReplayHit.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Replay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReplay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref = ReplayRef.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.durationDs = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.unix = longToNumber(reader.uint64());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.hulls.push(ReplayHull.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tracks.push(ReplayTrack.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.hits.push(ReplayHit.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Replay>, I>>(base?: I): Replay {
    return Replay.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Replay>, I>>(object: I): Replay {
    const message = createBaseReplay();
    message.ref = (object.ref !== undefined && object.ref !== null) ? ReplayRef.fromPartial(object.ref) : undefined;
    message.title = object.title ?? "";
    message.durationDs = object.durationDs ?? 0;
    message.cell = object.cell ?? 0;
    message.unix = object.unix ?? 0;
    message.hulls = object.hulls?.map((e) => ReplayHull.fromPartial(e)) || [];
    message.tracks = object.tracks?.map((e) => ReplayTrack.fromPartial(e)) || [];
    message.hits = object.hits?.map((e) => ReplayHit.fromPartial(e)) || [];
    return message;
  },
};

function createBaseHeatmap(): Heatmap {
  return { kind: 0, cells: new Uint8Array(0) };
}

export const Heatmap: MessageFns<Heatmap> = {
  encode(message: Heatmap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.cells.length !== 0) {
      writer.uint32(18).bytes(message.cells);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Heatmap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeatmap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cells = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Heatmap>, I>>(base?: I): Heatmap {
    return Heatmap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Heatmap>, I>>(object: I): Heatmap {
    const message = createBaseHeatmap();
    message.kind = object.kind ?? 0;
    message.cells = object.cells ?? new Uint8Array(0);
    return message;
  },
};

function createBaseHeatmapMode(): HeatmapMode {
  return { kind: 0 };
}

export const HeatmapMode: MessageFns<HeatmapMode> = {
  encode(message: HeatmapMode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HeatmapMode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeatmapMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<HeatmapMode>, I>>(base?: I): HeatmapMode {
    return HeatmapMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HeatmapMode>, I>>(object: I): HeatmapMode {
    const message = createBaseHeatmapMode();
    message.kind = object.kind ?? 0;
    return message;
  },
};

function createBaseEmpireSetting(): EmpireSetting {
  return { key: "", on: false };
}

export const EmpireSetting: MessageFns<EmpireSetting> = {
  encode(message: EmpireSetting, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.on !== false) {
      writer.uint32(16).bool(message.on);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmpireSetting {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmpireSetting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.on = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<EmpireSetting>, I>>(base?: I): EmpireSetting {
    return EmpireSetting.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmpireSetting>, I>>(object: I): EmpireSetting {
    const message = createBaseEmpireSetting();
    message.key = object.key ?? "";
    message.on = object.on ?? false;
    return message;
  },
};

function createBaseClanMember(): ClanMember {
  return { accountId: 0, name: "", faction: 0, squad: 0, online: false, comms: 0, reserve: false, committed: [] };
}

export const ClanMember: MessageFns<ClanMember> = {
  encode(message: ClanMember, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== 0) {
      writer.uint32(8).uint32(message.accountId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.faction !== 0) {
      writer.uint32(24).uint32(message.faction);
    }
    if (message.squad !== 0) {
      writer.uint32(32).uint32(message.squad);
    }
    if (message.online !== false) {
      writer.uint32(40).bool(message.online);
    }
    if (message.comms !== 0) {
      writer.uint32(48).uint32(message.comms);
    }
    if (message.reserve !== false) {
      writer.uint32(56).bool(message.reserve);
    }
    writer.uint32(66).fork();
    for (const v of message.committed) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClanMember {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClanMember();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.accountId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.squad = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.online = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.comms = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.reserve = reader.bool();
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.committed.push(reader.uint32());

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.committed.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ClanMember>, I>>(base?: I): ClanMember {
    return ClanMember.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClanMember>, I>>(object: I): ClanMember {
    const message = createBaseClanMember();
    message.accountId = object.accountId ?? 0;
    message.name = object.name ?? "";
    message.faction = object.faction ?? 0;
    message.squad = object.squad ?? 0;
    message.online = object.online ?? false;
    message.comms = object.comms ?? 0;
    message.reserve = object.reserve ?? false;
    message.committed = object.committed?.map((e) => e) || [];
    return message;
  },
};

function createBaseClanInfo(): ClanInfo {
  return { id: 0, name: "", tag: "", squad: 0, comms: 0, members: [], bonuses: [], npc: false };
}

export const ClanInfo: MessageFns<ClanInfo> = {
  encode(message: ClanInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.tag !== "") {
      writer.uint32(26).string(message.tag);
    }
    if (message.squad !== 0) {
      writer.uint32(32).uint32(message.squad);
    }
    if (message.comms !== 0) {
      writer.uint32(40).uint32(message.comms);
    }
    for (const v of message.members) {
      ClanMember.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.bonuses) {
      writer.uint32(58).string(v!);
    }
    if (message.npc !== false) {
      writer.uint32(64).bool(message.npc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClanInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClanInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.squad = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.comms = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.members.push(ClanMember.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.bonuses.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.npc = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ClanInfo>, I>>(base?: I): ClanInfo {
    return ClanInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClanInfo>, I>>(object: I): ClanInfo {
    const message = createBaseClanInfo();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.tag = object.tag ?? "";
    message.squad = object.squad ?? 0;
    message.comms = object.comms ?? 0;
    message.members = object.members?.map((e) => ClanMember.fromPartial(e)) || [];
    message.bonuses = object.bonuses?.map((e) => e) || [];
    message.npc = object.npc ?? false;
    return message;
  },
};

function createBaseFleetOrder(): FleetOrder {
  return { fleetId: 0, xMpx: 0, yMpx: 0, mission: 0, legs: [], headingMrad: 0, throttle: 0 };
}

export const FleetOrder: MessageFns<FleetOrder> = {
  encode(message: FleetOrder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fleetId !== 0) {
      writer.uint32(8).uint32(message.fleetId);
    }
    if (message.xMpx !== 0) {
      writer.uint32(16).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(24).sint32(message.yMpx);
    }
    if (message.mission !== 0) {
      writer.uint32(32).int32(message.mission);
    }
    for (const v of message.legs) {
      Waypoint.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.headingMrad !== 0) {
      writer.uint32(48).sint32(message.headingMrad);
    }
    if (message.throttle !== 0) {
      writer.uint32(56).uint32(message.throttle);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FleetOrder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFleetOrder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.mission = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.legs.push(Waypoint.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.headingMrad = reader.sint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.throttle = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<FleetOrder>, I>>(base?: I): FleetOrder {
    return FleetOrder.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FleetOrder>, I>>(object: I): FleetOrder {
    const message = createBaseFleetOrder();
    message.fleetId = object.fleetId ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.mission = object.mission ?? 0;
    message.legs = object.legs?.map((e) => Waypoint.fromPartial(e)) || [];
    message.headingMrad = object.headingMrad ?? 0;
    message.throttle = object.throttle ?? 0;
    return message;
  },
};

function createBaseCommissionAction(): CommissionAction {
  return { op: 0, id: 0, fleetId: 0 };
}

export const CommissionAction: MessageFns<CommissionAction> = {
  encode(message: CommissionAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.op !== 0) {
      writer.uint32(8).int32(message.op);
    }
    if (message.id !== 0) {
      writer.uint32(16).uint32(message.id);
    }
    if (message.fleetId !== 0) {
      writer.uint32(24).uint32(message.fleetId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommissionAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommissionAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.op = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CommissionAction>, I>>(base?: I): CommissionAction {
    return CommissionAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommissionAction>, I>>(object: I): CommissionAction {
    const message = createBaseCommissionAction();
    message.op = object.op ?? 0;
    message.id = object.id ?? 0;
    message.fleetId = object.fleetId ?? 0;
    return message;
  },
};

function createBasePlotAction(): PlotAction {
  return { op: 0, plotId: 0, name: "", legs: [], lane: false };
}

export const PlotAction: MessageFns<PlotAction> = {
  encode(message: PlotAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.op !== 0) {
      writer.uint32(8).int32(message.op);
    }
    if (message.plotId !== 0) {
      writer.uint32(16).uint32(message.plotId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    for (const v of message.legs) {
      Waypoint.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.lane !== false) {
      writer.uint32(40).bool(message.lane);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlotAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlotAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.op = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.plotId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.legs.push(Waypoint.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.lane = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<PlotAction>, I>>(base?: I): PlotAction {
    return PlotAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlotAction>, I>>(object: I): PlotAction {
    const message = createBasePlotAction();
    message.op = object.op ?? 0;
    message.plotId = object.plotId ?? 0;
    message.name = object.name ?? "";
    message.legs = object.legs?.map((e) => Waypoint.fromPartial(e)) || [];
    message.lane = object.lane ?? false;
    return message;
  },
};

function createBaseViewport(): Viewport {
  return { x0Mpx: 0, y0Mpx: 0, x1Mpx: 0, y1Mpx: 0 };
}

export const Viewport: MessageFns<Viewport> = {
  encode(message: Viewport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x0Mpx !== 0) {
      writer.uint32(8).sint32(message.x0Mpx);
    }
    if (message.y0Mpx !== 0) {
      writer.uint32(16).sint32(message.y0Mpx);
    }
    if (message.x1Mpx !== 0) {
      writer.uint32(24).sint32(message.x1Mpx);
    }
    if (message.y1Mpx !== 0) {
      writer.uint32(32).sint32(message.y1Mpx);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Viewport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseViewport();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.x0Mpx = reader.sint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.y0Mpx = reader.sint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.x1Mpx = reader.sint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.y1Mpx = reader.sint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Viewport>, I>>(base?: I): Viewport {
    return Viewport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Viewport>, I>>(object: I): Viewport {
    const message = createBaseViewport();
    message.x0Mpx = object.x0Mpx ?? 0;
    message.y0Mpx = object.y0Mpx ?? 0;
    message.x1Mpx = object.x1Mpx ?? 0;
    message.y1Mpx = object.y1Mpx ?? 0;
    return message;
  },
};

function createBasePing(): Ping {
  return { nonce: 0 };
}

export const Ping: MessageFns<Ping> = {
  encode(message: Ping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nonce !== 0) {
      writer.uint32(8).uint64(message.nonce);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Ping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.nonce = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Ping>, I>>(base?: I): Ping {
    return Ping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Ping>, I>>(object: I): Ping {
    const message = createBasePing();
    message.nonce = object.nonce ?? 0;
    return message;
  },
};

function createBaseResync(): Resync {
  return {};
}

export const Resync: MessageFns<Resync> = {
  encode(_: Resync, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Resync {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResync();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Resync>, I>>(base?: I): Resync {
    return Resync.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Resync>, I>>(_: I): Resync {
    const message = createBaseResync();
    return message;
  },
};

function createBaseEnqueue(): Enqueue {
  return { kind: 0, target: 0, count: 0 };
}

export const Enqueue: MessageFns<Enqueue> = {
  encode(message: Enqueue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.target !== 0) {
      writer.uint32(16).uint32(message.target);
    }
    if (message.count !== 0) {
      writer.uint32(24).uint32(message.count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Enqueue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnqueue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.target = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Enqueue>, I>>(base?: I): Enqueue {
    return Enqueue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Enqueue>, I>>(object: I): Enqueue {
    const message = createBaseEnqueue();
    message.kind = object.kind ?? 0;
    message.target = object.target ?? 0;
    message.count = object.count ?? 0;
    return message;
  },
};

function createBaseJobAction(): JobAction {
  return { jobId: 0, cancel: false, move: 0 };
}

export const JobAction: MessageFns<JobAction> = {
  encode(message: JobAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== 0) {
      writer.uint32(8).uint32(message.jobId);
    }
    if (message.cancel !== false) {
      writer.uint32(16).bool(message.cancel);
    }
    if (message.move !== 0) {
      writer.uint32(24).sint32(message.move);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.jobId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cancel = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.move = reader.sint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<JobAction>, I>>(base?: I): JobAction {
    return JobAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobAction>, I>>(object: I): JobAction {
    const message = createBaseJobAction();
    message.jobId = object.jobId ?? 0;
    message.cancel = object.cancel ?? false;
    message.move = object.move ?? 0;
    return message;
  },
};

function createBaseCreateFleet(): CreateFleet {
  return { cls: 0, captainId: 0, design: 0, xMpx: 0, yMpx: 0, mission: 0, fleetId: 0, loadMix: [] };
}

export const CreateFleet: MessageFns<CreateFleet> = {
  encode(message: CreateFleet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cls !== 0) {
      writer.uint32(8).int32(message.cls);
    }
    if (message.captainId !== 0) {
      writer.uint32(24).uint32(message.captainId);
    }
    if (message.design !== 0) {
      writer.uint32(32).uint32(message.design);
    }
    if (message.xMpx !== 0) {
      writer.uint32(40).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(48).sint32(message.yMpx);
    }
    if (message.mission !== 0) {
      writer.uint32(56).int32(message.mission);
    }
    if (message.fleetId !== 0) {
      writer.uint32(72).uint32(message.fleetId);
    }
    for (const v of message.loadMix) {
      TorpedoStock.encode(v!, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateFleet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateFleet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.cls = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.captainId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.design = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.mission = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.loadMix.push(TorpedoStock.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CreateFleet>, I>>(base?: I): CreateFleet {
    return CreateFleet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateFleet>, I>>(object: I): CreateFleet {
    const message = createBaseCreateFleet();
    message.cls = object.cls ?? 0;
    message.captainId = object.captainId ?? 0;
    message.design = object.design ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.mission = object.mission ?? 0;
    message.fleetId = object.fleetId ?? 0;
    message.loadMix = object.loadMix?.map((e) => TorpedoStock.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFleetAction(): FleetAction {
  return { fleetId: 0, op: 0, arg: 0, load: [], stow: [] };
}

export const FleetAction: MessageFns<FleetAction> = {
  encode(message: FleetAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fleetId !== 0) {
      writer.uint32(8).uint32(message.fleetId);
    }
    if (message.op !== 0) {
      writer.uint32(16).int32(message.op);
    }
    if (message.arg !== 0) {
      writer.uint32(24).uint32(message.arg);
    }
    for (const v of message.load) {
      TorpedoStock.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.stow) {
      SeaObjectStock.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FleetAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFleetAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.op = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.arg = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.load.push(TorpedoStock.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.stow.push(SeaObjectStock.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<FleetAction>, I>>(base?: I): FleetAction {
    return FleetAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FleetAction>, I>>(object: I): FleetAction {
    const message = createBaseFleetAction();
    message.fleetId = object.fleetId ?? 0;
    message.op = object.op ?? 0;
    message.arg = object.arg ?? 0;
    message.load = object.load?.map((e) => TorpedoStock.fromPartial(e)) || [];
    message.stow = object.stow?.map((e) => SeaObjectStock.fromPartial(e)) || [];
    return message;
  },
};

function createBaseControlGroup(): ControlGroup {
  return { slot: 0, fleetId: 0 };
}

export const ControlGroup: MessageFns<ControlGroup> = {
  encode(message: ControlGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.slot !== 0) {
      writer.uint32(8).uint32(message.slot);
    }
    if (message.fleetId !== 0) {
      writer.uint32(16).uint32(message.fleetId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ControlGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControlGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.slot = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ControlGroup>, I>>(base?: I): ControlGroup {
    return ControlGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControlGroup>, I>>(object: I): ControlGroup {
    const message = createBaseControlGroup();
    message.slot = object.slot ?? 0;
    message.fleetId = object.fleetId ?? 0;
    return message;
  },
};

function createBaseControlGroupRecall(): ControlGroupRecall {
  return { slot: 0 };
}

export const ControlGroupRecall: MessageFns<ControlGroupRecall> = {
  encode(message: ControlGroupRecall, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.slot !== 0) {
      writer.uint32(8).uint32(message.slot);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ControlGroupRecall {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControlGroupRecall();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.slot = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ControlGroupRecall>, I>>(base?: I): ControlGroupRecall {
    return ControlGroupRecall.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControlGroupRecall>, I>>(object: I): ControlGroupRecall {
    const message = createBaseControlGroupRecall();
    message.slot = object.slot ?? 0;
    return message;
  },
};

function createBaseChat(): Chat {
  return { channel: 0, text: "", quick: 0, quickRef: undefined };
}

export const Chat: MessageFns<Chat> = {
  encode(message: Chat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channel !== 0) {
      writer.uint32(8).int32(message.channel);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    if (message.quick !== 0) {
      writer.uint32(24).uint32(message.quick);
    }
    if (message.quickRef !== undefined) {
      QuickRef.encode(message.quickRef, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Chat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.channel = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.quick = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.quickRef = QuickRef.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Chat>, I>>(base?: I): Chat {
    return Chat.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Chat>, I>>(object: I): Chat {
    const message = createBaseChat();
    message.channel = object.channel ?? 0;
    message.text = object.text ?? "";
    message.quick = object.quick ?? 0;
    message.quickRef = (object.quickRef !== undefined && object.quickRef !== null)
      ? QuickRef.fromPartial(object.quickRef)
      : undefined;
    return message;
  },
};

function createBaseInvent(): Invent {
  return { hull: 0, modules: [], weapType: 0, shieldType: 0 };
}

export const Invent: MessageFns<Invent> = {
  encode(message: Invent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hull !== 0) {
      writer.uint32(8).int32(message.hull);
    }
    for (const v of message.modules) {
      Module.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.weapType !== 0) {
      writer.uint32(24).uint32(message.weapType);
    }
    if (message.shieldType !== 0) {
      writer.uint32(32).uint32(message.shieldType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Invent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hull = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modules.push(Module.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.weapType = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.shieldType = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Invent>, I>>(base?: I): Invent {
    return Invent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Invent>, I>>(object: I): Invent {
    const message = createBaseInvent();
    message.hull = object.hull ?? 0;
    message.modules = object.modules?.map((e) => Module.fromPartial(e)) || [];
    message.weapType = object.weapType ?? 0;
    message.shieldType = object.shieldType ?? 0;
    return message;
  },
};

function createBaseDesignAction(): DesignAction {
  return {
    design: 0,
    scrap: false,
    useDataCore: false,
    printRuns: 0,
    convertFrom: 0,
    count: 0,
    install: false,
    redraft: false,
    redraftSlot: 0,
  };
}

export const DesignAction: MessageFns<DesignAction> = {
  encode(message: DesignAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.design !== 0) {
      writer.uint32(8).uint32(message.design);
    }
    if (message.scrap !== false) {
      writer.uint32(16).bool(message.scrap);
    }
    if (message.useDataCore !== false) {
      writer.uint32(24).bool(message.useDataCore);
    }
    if (message.printRuns !== 0) {
      writer.uint32(32).uint32(message.printRuns);
    }
    if (message.convertFrom !== 0) {
      writer.uint32(40).uint32(message.convertFrom);
    }
    if (message.count !== 0) {
      writer.uint32(56).uint32(message.count);
    }
    if (message.install !== false) {
      writer.uint32(64).bool(message.install);
    }
    if (message.redraft !== false) {
      writer.uint32(72).bool(message.redraft);
    }
    if (message.redraftSlot !== 0) {
      writer.uint32(80).uint32(message.redraftSlot);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DesignAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDesignAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.design = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.scrap = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.useDataCore = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.printRuns = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.convertFrom = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.install = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.redraft = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.redraftSlot = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<DesignAction>, I>>(base?: I): DesignAction {
    return DesignAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DesignAction>, I>>(object: I): DesignAction {
    const message = createBaseDesignAction();
    message.design = object.design ?? 0;
    message.scrap = object.scrap ?? false;
    message.useDataCore = object.useDataCore ?? false;
    message.printRuns = object.printRuns ?? 0;
    message.convertFrom = object.convertFrom ?? 0;
    message.count = object.count ?? 0;
    message.install = object.install ?? false;
    message.redraft = object.redraft ?? false;
    message.redraftSlot = object.redraftSlot ?? 0;
    return message;
  },
};

function createBaseExpeditionOrder(): ExpeditionOrder {
  return { depth: 0, captainId: 0 };
}

export const ExpeditionOrder: MessageFns<ExpeditionOrder> = {
  encode(message: ExpeditionOrder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.depth !== 0) {
      writer.uint32(8).uint32(message.depth);
    }
    if (message.captainId !== 0) {
      writer.uint32(16).uint32(message.captainId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExpeditionOrder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExpeditionOrder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.depth = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.captainId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ExpeditionOrder>, I>>(base?: I): ExpeditionOrder {
    return ExpeditionOrder.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExpeditionOrder>, I>>(object: I): ExpeditionOrder {
    const message = createBaseExpeditionOrder();
    message.depth = object.depth ?? 0;
    message.captainId = object.captainId ?? 0;
    return message;
  },
};

function createBaseFireOrder(): FireOrder {
  return { fleetId: 0, xMpx: 0, yMpx: 0, lockFleetId: 0, kind: 0 };
}

export const FireOrder: MessageFns<FireOrder> = {
  encode(message: FireOrder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fleetId !== 0) {
      writer.uint32(8).uint32(message.fleetId);
    }
    if (message.xMpx !== 0) {
      writer.uint32(16).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(24).sint32(message.yMpx);
    }
    if (message.lockFleetId !== 0) {
      writer.uint32(32).uint32(message.lockFleetId);
    }
    if (message.kind !== 0) {
      writer.uint32(40).int32(message.kind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FireOrder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFireOrder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.lockFleetId = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<FireOrder>, I>>(base?: I): FireOrder {
    return FireOrder.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FireOrder>, I>>(object: I): FireOrder {
    const message = createBaseFireOrder();
    message.fleetId = object.fleetId ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.lockFleetId = object.lockFleetId ?? 0;
    message.kind = object.kind ?? 0;
    return message;
  },
};

function createBaseSiegeAction(): SiegeAction {
  return { op: 0, siteId: 0, fleetId: 0 };
}

export const SiegeAction: MessageFns<SiegeAction> = {
  encode(message: SiegeAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.op !== 0) {
      writer.uint32(8).int32(message.op);
    }
    if (message.siteId !== 0) {
      writer.uint32(16).uint32(message.siteId);
    }
    if (message.fleetId !== 0) {
      writer.uint32(24).uint32(message.fleetId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SiegeAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSiegeAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.op = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.siteId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<SiegeAction>, I>>(base?: I): SiegeAction {
    return SiegeAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SiegeAction>, I>>(object: I): SiegeAction {
    const message = createBaseSiegeAction();
    message.op = object.op ?? 0;
    message.siteId = object.siteId ?? 0;
    message.fleetId = object.fleetId ?? 0;
    return message;
  },
};

function createBaseClanAction(): ClanAction {
  return { create: false, join: false, leave: false, name: "", tag: "", squad: 0 };
}

export const ClanAction: MessageFns<ClanAction> = {
  encode(message: ClanAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.create !== false) {
      writer.uint32(8).bool(message.create);
    }
    if (message.join !== false) {
      writer.uint32(16).bool(message.join);
    }
    if (message.leave !== false) {
      writer.uint32(24).bool(message.leave);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.tag !== "") {
      writer.uint32(42).string(message.tag);
    }
    if (message.squad !== 0) {
      writer.uint32(48).uint32(message.squad);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClanAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClanAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.create = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.join = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.leave = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.squad = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ClanAction>, I>>(base?: I): ClanAction {
    return ClanAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClanAction>, I>>(object: I): ClanAction {
    const message = createBaseClanAction();
    message.create = object.create ?? false;
    message.join = object.join ?? false;
    message.leave = object.leave ?? false;
    message.name = object.name ?? "";
    message.tag = object.tag ?? "";
    message.squad = object.squad ?? 0;
    return message;
  },
};

function createBaseCaptainAction(): CaptainAction {
  return { captainId: 0, recruit: false, dismiss: false, assignFleet: 0, ransom: false, release: false, ownerId: 0 };
}

export const CaptainAction: MessageFns<CaptainAction> = {
  encode(message: CaptainAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.captainId !== 0) {
      writer.uint32(8).uint32(message.captainId);
    }
    if (message.recruit !== false) {
      writer.uint32(16).bool(message.recruit);
    }
    if (message.dismiss !== false) {
      writer.uint32(24).bool(message.dismiss);
    }
    if (message.assignFleet !== 0) {
      writer.uint32(32).uint32(message.assignFleet);
    }
    if (message.ransom !== false) {
      writer.uint32(40).bool(message.ransom);
    }
    if (message.release !== false) {
      writer.uint32(48).bool(message.release);
    }
    if (message.ownerId !== 0) {
      writer.uint32(56).uint32(message.ownerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CaptainAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCaptainAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.captainId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.recruit = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.dismiss = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assignFleet = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.ransom = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.release = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.ownerId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CaptainAction>, I>>(base?: I): CaptainAction {
    return CaptainAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CaptainAction>, I>>(object: I): CaptainAction {
    const message = createBaseCaptainAction();
    message.captainId = object.captainId ?? 0;
    message.recruit = object.recruit ?? false;
    message.dismiss = object.dismiss ?? false;
    message.assignFleet = object.assignFleet ?? 0;
    message.ransom = object.ransom ?? false;
    message.release = object.release ?? false;
    message.ownerId = object.ownerId ?? 0;
    return message;
  },
};

function createBaseArcadeQueueJoin(): ArcadeQueueJoin {
  return { category: "", quickjoin: false, partyId: "" };
}

export const ArcadeQueueJoin: MessageFns<ArcadeQueueJoin> = {
  encode(message: ArcadeQueueJoin, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.category !== "") {
      writer.uint32(10).string(message.category);
    }
    if (message.quickjoin !== false) {
      writer.uint32(16).bool(message.quickjoin);
    }
    if (message.partyId !== "") {
      writer.uint32(26).string(message.partyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeQueueJoin {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeQueueJoin();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.quickjoin = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.partyId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeQueueJoin>, I>>(base?: I): ArcadeQueueJoin {
    return ArcadeQueueJoin.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeQueueJoin>, I>>(object: I): ArcadeQueueJoin {
    const message = createBaseArcadeQueueJoin();
    message.category = object.category ?? "";
    message.quickjoin = object.quickjoin ?? false;
    message.partyId = object.partyId ?? "";
    return message;
  },
};

function createBaseArcadeQueueLeave(): ArcadeQueueLeave {
  return {};
}

export const ArcadeQueueLeave: MessageFns<ArcadeQueueLeave> = {
  encode(_: ArcadeQueueLeave, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeQueueLeave {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeQueueLeave();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeQueueLeave>, I>>(base?: I): ArcadeQueueLeave {
    return ArcadeQueueLeave.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeQueueLeave>, I>>(_: I): ArcadeQueueLeave {
    const message = createBaseArcadeQueueLeave();
    return message;
  },
};

function createBaseArcadeDrill(): ArcadeDrill {
  return { category: "", mapId: "" };
}

export const ArcadeDrill: MessageFns<ArcadeDrill> = {
  encode(message: ArcadeDrill, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.category !== "") {
      writer.uint32(10).string(message.category);
    }
    if (message.mapId !== "") {
      writer.uint32(18).string(message.mapId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeDrill {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeDrill();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mapId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeDrill>, I>>(base?: I): ArcadeDrill {
    return ArcadeDrill.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeDrill>, I>>(object: I): ArcadeDrill {
    const message = createBaseArcadeDrill();
    message.category = object.category ?? "";
    message.mapId = object.mapId ?? "";
    return message;
  },
};

function createBaseArcadeDrillNext(): ArcadeDrillNext {
  return { step: 0 };
}

export const ArcadeDrillNext: MessageFns<ArcadeDrillNext> = {
  encode(message: ArcadeDrillNext, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.step !== 0) {
      writer.uint32(8).uint32(message.step);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeDrillNext {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeDrillNext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.step = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeDrillNext>, I>>(base?: I): ArcadeDrillNext {
    return ArcadeDrillNext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeDrillNext>, I>>(object: I): ArcadeDrillNext {
    const message = createBaseArcadeDrillNext();
    message.step = object.step ?? 0;
    return message;
  },
};

function createBaseArcadeSurrender(): ArcadeSurrender {
  return {};
}

export const ArcadeSurrender: MessageFns<ArcadeSurrender> = {
  encode(_: ArcadeSurrender, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeSurrender {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeSurrender();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeSurrender>, I>>(base?: I): ArcadeSurrender {
    return ArcadeSurrender.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeSurrender>, I>>(_: I): ArcadeSurrender {
    const message = createBaseArcadeSurrender();
    return message;
  },
};

function createBaseArcadeBuild(): ArcadeBuild {
  return { variantName: "", torpedoKind: 0, seaObjectKind: 0 };
}

export const ArcadeBuild: MessageFns<ArcadeBuild> = {
  encode(message: ArcadeBuild, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.variantName !== "") {
      writer.uint32(10).string(message.variantName);
    }
    if (message.torpedoKind !== 0) {
      writer.uint32(16).int32(message.torpedoKind);
    }
    if (message.seaObjectKind !== 0) {
      writer.uint32(24).int32(message.seaObjectKind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeBuild {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeBuild();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.variantName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.torpedoKind = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.seaObjectKind = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeBuild>, I>>(base?: I): ArcadeBuild {
    return ArcadeBuild.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeBuild>, I>>(object: I): ArcadeBuild {
    const message = createBaseArcadeBuild();
    message.variantName = object.variantName ?? "";
    message.torpedoKind = object.torpedoKind ?? 0;
    message.seaObjectKind = object.seaObjectKind ?? 0;
    return message;
  },
};

function createBaseArcadeQueue(): ArcadeQueue {
  return {
    state: 0,
    category: "",
    seatsFilled: 0,
    seatsTotal: 0,
    fillLeftSec: 0,
    waitedSec: 0,
    position: 0,
    reason: "",
    runsLeft: 0,
    runsUnlimited: false,
  };
}

export const ArcadeQueue: MessageFns<ArcadeQueue> = {
  encode(message: ArcadeQueue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state);
    }
    if (message.category !== "") {
      writer.uint32(18).string(message.category);
    }
    if (message.seatsFilled !== 0) {
      writer.uint32(24).uint32(message.seatsFilled);
    }
    if (message.seatsTotal !== 0) {
      writer.uint32(32).uint32(message.seatsTotal);
    }
    if (message.fillLeftSec !== 0) {
      writer.uint32(40).uint32(message.fillLeftSec);
    }
    if (message.waitedSec !== 0) {
      writer.uint32(48).uint32(message.waitedSec);
    }
    if (message.position !== 0) {
      writer.uint32(56).uint32(message.position);
    }
    if (message.reason !== "") {
      writer.uint32(66).string(message.reason);
    }
    if (message.runsLeft !== 0) {
      writer.uint32(72).uint32(message.runsLeft);
    }
    if (message.runsUnlimited !== false) {
      writer.uint32(80).bool(message.runsUnlimited);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeQueue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeQueue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.seatsFilled = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.seatsTotal = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.fillLeftSec = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.waitedSec = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.runsLeft = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.runsUnlimited = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeQueue>, I>>(base?: I): ArcadeQueue {
    return ArcadeQueue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeQueue>, I>>(object: I): ArcadeQueue {
    const message = createBaseArcadeQueue();
    message.state = object.state ?? 0;
    message.category = object.category ?? "";
    message.seatsFilled = object.seatsFilled ?? 0;
    message.seatsTotal = object.seatsTotal ?? 0;
    message.fillLeftSec = object.fillLeftSec ?? 0;
    message.waitedSec = object.waitedSec ?? 0;
    message.position = object.position ?? 0;
    message.reason = object.reason ?? "";
    message.runsLeft = object.runsLeft ?? 0;
    message.runsUnlimited = object.runsUnlimited ?? false;
    return message;
  },
};

function createBaseArcadeMatchFound(): ArcadeMatchFound {
  return { worldId: 0, mapName: "", category: "", slot: 0, team: 0, seats: 0, humans: 0 };
}

export const ArcadeMatchFound: MessageFns<ArcadeMatchFound> = {
  encode(message: ArcadeMatchFound, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.worldId !== 0) {
      writer.uint32(8).uint32(message.worldId);
    }
    if (message.mapName !== "") {
      writer.uint32(18).string(message.mapName);
    }
    if (message.category !== "") {
      writer.uint32(26).string(message.category);
    }
    if (message.slot !== 0) {
      writer.uint32(32).uint32(message.slot);
    }
    if (message.team !== 0) {
      writer.uint32(40).uint32(message.team);
    }
    if (message.seats !== 0) {
      writer.uint32(48).uint32(message.seats);
    }
    if (message.humans !== 0) {
      writer.uint32(56).uint32(message.humans);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeMatchFound {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeMatchFound();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.worldId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mapName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.slot = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.team = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.seats = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.humans = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeMatchFound>, I>>(base?: I): ArcadeMatchFound {
    return ArcadeMatchFound.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeMatchFound>, I>>(object: I): ArcadeMatchFound {
    const message = createBaseArcadeMatchFound();
    message.worldId = object.worldId ?? 0;
    message.mapName = object.mapName ?? "";
    message.category = object.category ?? "";
    message.slot = object.slot ?? 0;
    message.team = object.team ?? 0;
    message.seats = object.seats ?? 0;
    message.humans = object.humans ?? 0;
    return message;
  },
};

function createBaseArcadePhase(): ArcadePhase {
  return {
    phase: 0,
    leftSec: 0,
    elapsedSec: 0,
    loadedSlots: [],
    holdTeam: 0,
    holdLeftSec: 0,
    autoSpawnInSec: [],
    spectators: 0,
    opsSpectators: 0,
    drillStep: 0,
    captures: [],
    drillResets: 0,
  };
}

export const ArcadePhase: MessageFns<ArcadePhase> = {
  encode(message: ArcadePhase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.phase !== 0) {
      writer.uint32(8).int32(message.phase);
    }
    if (message.leftSec !== 0) {
      writer.uint32(16).uint32(message.leftSec);
    }
    if (message.elapsedSec !== 0) {
      writer.uint32(24).uint32(message.elapsedSec);
    }
    writer.uint32(34).fork();
    for (const v of message.loadedSlots) {
      writer.uint32(v);
    }
    writer.join();
    if (message.holdTeam !== 0) {
      writer.uint32(40).uint32(message.holdTeam);
    }
    if (message.holdLeftSec !== 0) {
      writer.uint32(49).double(message.holdLeftSec);
    }
    writer.uint32(58).fork();
    for (const v of message.autoSpawnInSec) {
      writer.double(v);
    }
    writer.join();
    if (message.spectators !== 0) {
      writer.uint32(64).uint32(message.spectators);
    }
    if (message.opsSpectators !== 0) {
      writer.uint32(72).uint32(message.opsSpectators);
    }
    if (message.drillStep !== 0) {
      writer.uint32(80).uint32(message.drillStep);
    }
    for (const v of message.captures) {
      ArcadeCapture.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.drillResets !== 0) {
      writer.uint32(96).uint32(message.drillResets);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadePhase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadePhase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.phase = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.leftSec = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.elapsedSec = reader.uint32();
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.loadedSlots.push(reader.uint32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.loadedSlots.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.holdTeam = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.holdLeftSec = reader.double();
          continue;
        }
        case 7: {
          if (tag === 57) {
            message.autoSpawnInSec.push(reader.double());

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.autoSpawnInSec.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.spectators = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.opsSpectators = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.drillStep = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.captures.push(ArcadeCapture.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.drillResets = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadePhase>, I>>(base?: I): ArcadePhase {
    return ArcadePhase.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadePhase>, I>>(object: I): ArcadePhase {
    const message = createBaseArcadePhase();
    message.phase = object.phase ?? 0;
    message.leftSec = object.leftSec ?? 0;
    message.elapsedSec = object.elapsedSec ?? 0;
    message.loadedSlots = object.loadedSlots?.map((e) => e) || [];
    message.holdTeam = object.holdTeam ?? 0;
    message.holdLeftSec = object.holdLeftSec ?? 0;
    message.autoSpawnInSec = object.autoSpawnInSec?.map((e) => e) || [];
    message.spectators = object.spectators ?? 0;
    message.opsSpectators = object.opsSpectators ?? 0;
    message.drillStep = object.drillStep ?? 0;
    message.captures = object.captures?.map((e) => ArcadeCapture.fromPartial(e)) || [];
    message.drillResets = object.drillResets ?? 0;
    return message;
  },
};

function createBaseArcadeCapture(): ArcadeCapture {
  return { siteId: 0, owner: 0, taker: 0, leftSec: 0 };
}

export const ArcadeCapture: MessageFns<ArcadeCapture> = {
  encode(message: ArcadeCapture, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.siteId !== 0) {
      writer.uint32(8).uint32(message.siteId);
    }
    if (message.owner !== 0) {
      writer.uint32(16).uint32(message.owner);
    }
    if (message.taker !== 0) {
      writer.uint32(24).uint32(message.taker);
    }
    if (message.leftSec !== 0) {
      writer.uint32(33).double(message.leftSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeCapture {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeCapture();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.siteId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.owner = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.taker = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.leftSec = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeCapture>, I>>(base?: I): ArcadeCapture {
    return ArcadeCapture.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeCapture>, I>>(object: I): ArcadeCapture {
    const message = createBaseArcadeCapture();
    message.siteId = object.siteId ?? 0;
    message.owner = object.owner ?? 0;
    message.taker = object.taker ?? 0;
    message.leftSec = object.leftSec ?? 0;
    return message;
  },
};

function createBaseArcadeStructure(): ArcadeStructure {
  return { siteId: 0, cell: 0, kind: 0, capturable: false, objective: false, reachPx: 0, reloadSec: 0 };
}

export const ArcadeStructure: MessageFns<ArcadeStructure> = {
  encode(message: ArcadeStructure, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.siteId !== 0) {
      writer.uint32(8).uint32(message.siteId);
    }
    if (message.cell !== 0) {
      writer.uint32(16).uint32(message.cell);
    }
    if (message.kind !== 0) {
      writer.uint32(24).int32(message.kind);
    }
    if (message.capturable !== false) {
      writer.uint32(32).bool(message.capturable);
    }
    if (message.objective !== false) {
      writer.uint32(40).bool(message.objective);
    }
    if (message.reachPx !== 0) {
      writer.uint32(48).uint32(message.reachPx);
    }
    if (message.reloadSec !== 0) {
      writer.uint32(57).double(message.reloadSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeStructure {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeStructure();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.siteId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.capturable = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.objective = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.reachPx = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.reloadSec = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeStructure>, I>>(base?: I): ArcadeStructure {
    return ArcadeStructure.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeStructure>, I>>(object: I): ArcadeStructure {
    const message = createBaseArcadeStructure();
    message.siteId = object.siteId ?? 0;
    message.cell = object.cell ?? 0;
    message.kind = object.kind ?? 0;
    message.capturable = object.capturable ?? false;
    message.objective = object.objective ?? false;
    message.reachPx = object.reachPx ?? 0;
    message.reloadSec = object.reloadSec ?? 0;
    return message;
  },
};

function createBaseArcadeWin(): ArcadeWin {
  return { type: "", percent: 0, holdSec: 0, cell: 0, units: 0, className: "", count: 0, means: "", line: "" };
}

export const ArcadeWin: MessageFns<ArcadeWin> = {
  encode(message: ArcadeWin, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.percent !== 0) {
      writer.uint32(17).double(message.percent);
    }
    if (message.holdSec !== 0) {
      writer.uint32(25).double(message.holdSec);
    }
    if (message.cell !== 0) {
      writer.uint32(32).uint32(message.cell);
    }
    if (message.units !== 0) {
      writer.uint32(40).uint32(message.units);
    }
    if (message.className !== "") {
      writer.uint32(50).string(message.className);
    }
    if (message.count !== 0) {
      writer.uint32(56).uint32(message.count);
    }
    if (message.means !== "") {
      writer.uint32(66).string(message.means);
    }
    if (message.line !== "") {
      writer.uint32(74).string(message.line);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeWin {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeWin();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.percent = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.holdSec = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.units = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.className = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.means = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.line = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeWin>, I>>(base?: I): ArcadeWin {
    return ArcadeWin.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeWin>, I>>(object: I): ArcadeWin {
    const message = createBaseArcadeWin();
    message.type = object.type ?? "";
    message.percent = object.percent ?? 0;
    message.holdSec = object.holdSec ?? 0;
    message.cell = object.cell ?? 0;
    message.units = object.units ?? 0;
    message.className = object.className ?? "";
    message.count = object.count ?? 0;
    message.means = object.means ?? "";
    message.line = object.line ?? "";
    return message;
  },
};

function createBaseArcadeVariant(): ArcadeVariant {
  return { name: "", cls: 0, className: "", priceCredits: 0, modules: [], support: false, rounds: [], stow: [] };
}

export const ArcadeVariant: MessageFns<ArcadeVariant> = {
  encode(message: ArcadeVariant, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.cls !== 0) {
      writer.uint32(16).int32(message.cls);
    }
    if (message.className !== "") {
      writer.uint32(26).string(message.className);
    }
    if (message.priceCredits !== 0) {
      writer.uint32(32).uint32(message.priceCredits);
    }
    for (const v of message.modules) {
      writer.uint32(42).string(v!);
    }
    if (message.support !== false) {
      writer.uint32(48).bool(message.support);
    }
    for (const v of message.rounds) {
      TorpedoStock.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.stow) {
      SeaObjectStock.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeVariant {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeVariant();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cls = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.className = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.priceCredits = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modules.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.support = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.rounds.push(TorpedoStock.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.stow.push(SeaObjectStock.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeVariant>, I>>(base?: I): ArcadeVariant {
    return ArcadeVariant.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeVariant>, I>>(object: I): ArcadeVariant {
    const message = createBaseArcadeVariant();
    message.name = object.name ?? "";
    message.cls = object.cls ?? 0;
    message.className = object.className ?? "";
    message.priceCredits = object.priceCredits ?? 0;
    message.modules = object.modules?.map((e) => e) || [];
    message.support = object.support ?? false;
    message.rounds = object.rounds?.map((e) => TorpedoStock.fromPartial(e)) || [];
    message.stow = object.stow?.map((e) => SeaObjectStock.fromPartial(e)) || [];
    return message;
  },
};

function createBaseArcadeSeaObject(): ArcadeSeaObject {
  return { kind: 0, name: "", priceCredits: 0, cap: 0, seaMine: false };
}

export const ArcadeSeaObject: MessageFns<ArcadeSeaObject> = {
  encode(message: ArcadeSeaObject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.priceCredits !== 0) {
      writer.uint32(24).uint32(message.priceCredits);
    }
    if (message.cap !== 0) {
      writer.uint32(32).uint32(message.cap);
    }
    if (message.seaMine !== false) {
      writer.uint32(40).bool(message.seaMine);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeSeaObject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeSeaObject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.priceCredits = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.cap = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.seaMine = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeSeaObject>, I>>(base?: I): ArcadeSeaObject {
    return ArcadeSeaObject.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeSeaObject>, I>>(object: I): ArcadeSeaObject {
    const message = createBaseArcadeSeaObject();
    message.kind = object.kind ?? 0;
    message.name = object.name ?? "";
    message.priceCredits = object.priceCredits ?? 0;
    message.cap = object.cap ?? 0;
    message.seaMine = object.seaMine ?? false;
    return message;
  },
};

function createBaseArcadeTorpedo(): ArcadeTorpedo {
  return { kind: 0, name: "", priceCredits: 0, fromBase: false };
}

export const ArcadeTorpedo: MessageFns<ArcadeTorpedo> = {
  encode(message: ArcadeTorpedo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.priceCredits !== 0) {
      writer.uint32(24).uint32(message.priceCredits);
    }
    if (message.fromBase !== false) {
      writer.uint32(32).bool(message.fromBase);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeTorpedo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeTorpedo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.priceCredits = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.fromBase = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeTorpedo>, I>>(base?: I): ArcadeTorpedo {
    return ArcadeTorpedo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeTorpedo>, I>>(object: I): ArcadeTorpedo {
    const message = createBaseArcadeTorpedo();
    message.kind = object.kind ?? 0;
    message.name = object.name ?? "";
    message.priceCredits = object.priceCredits ?? 0;
    message.fromBase = object.fromBase ?? false;
    return message;
  },
};

function createBaseArcadeSeatInfo(): ArcadeSeatInfo {
  return { slot: 0, team: 0, playerId: 0, name: "", bot: false, loaded: false, hasLadder: false, ladder: 0 };
}

export const ArcadeSeatInfo: MessageFns<ArcadeSeatInfo> = {
  encode(message: ArcadeSeatInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.slot !== 0) {
      writer.uint32(8).uint32(message.slot);
    }
    if (message.team !== 0) {
      writer.uint32(16).uint32(message.team);
    }
    if (message.playerId !== 0) {
      writer.uint32(24).uint32(message.playerId);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.bot !== false) {
      writer.uint32(40).bool(message.bot);
    }
    if (message.loaded !== false) {
      writer.uint32(48).bool(message.loaded);
    }
    if (message.hasLadder !== false) {
      writer.uint32(56).bool(message.hasLadder);
    }
    if (message.ladder !== 0) {
      writer.uint32(64).sint32(message.ladder);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeSeatInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeSeatInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.slot = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.team = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.playerId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.bot = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.loaded = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.hasLadder = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.ladder = reader.sint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeSeatInfo>, I>>(base?: I): ArcadeSeatInfo {
    return ArcadeSeatInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeSeatInfo>, I>>(object: I): ArcadeSeatInfo {
    const message = createBaseArcadeSeatInfo();
    message.slot = object.slot ?? 0;
    message.team = object.team ?? 0;
    message.playerId = object.playerId ?? 0;
    message.name = object.name ?? "";
    message.bot = object.bot ?? false;
    message.loaded = object.loaded ?? false;
    message.hasLadder = object.hasLadder ?? false;
    message.ladder = object.ladder ?? 0;
    return message;
  },
};

function createBaseArcadeInfo(): ArcadeInfo {
  return {
    mapName: "",
    category: "",
    description: "",
    win: undefined,
    timeoutSec: 0,
    creditsPerSec: 0,
    startingCredits: 0,
    minedCreditRate: 0,
    ships: [],
    torpedoes: [],
    sovEnabled: false,
    seats: [],
    scanCooldownSec: 0,
    slot: 0,
    team: 0,
    phase: 0,
    phaseLeftSec: 0,
    baseCanFireTorpedoes: false,
    markers: [],
    autoSpawns: [],
    recordInput: false,
    replayCode: "",
    spectateDelaySec: 0,
    drillSteps: [],
    drillStep: 0,
    structures: [],
    rules: undefined,
    seaObjects: [],
  };
}

export const ArcadeInfo: MessageFns<ArcadeInfo> = {
  encode(message: ArcadeInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mapName !== "") {
      writer.uint32(10).string(message.mapName);
    }
    if (message.category !== "") {
      writer.uint32(18).string(message.category);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.win !== undefined) {
      ArcadeWin.encode(message.win, writer.uint32(34).fork()).join();
    }
    if (message.timeoutSec !== 0) {
      writer.uint32(40).uint32(message.timeoutSec);
    }
    if (message.creditsPerSec !== 0) {
      writer.uint32(49).double(message.creditsPerSec);
    }
    if (message.startingCredits !== 0) {
      writer.uint32(56).uint32(message.startingCredits);
    }
    if (message.minedCreditRate !== 0) {
      writer.uint32(65).double(message.minedCreditRate);
    }
    for (const v of message.ships) {
      ArcadeVariant.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.torpedoes) {
      ArcadeTorpedo.encode(v!, writer.uint32(82).fork()).join();
    }
    if (message.sovEnabled !== false) {
      writer.uint32(88).bool(message.sovEnabled);
    }
    for (const v of message.seats) {
      ArcadeSeatInfo.encode(v!, writer.uint32(106).fork()).join();
    }
    if (message.scanCooldownSec !== 0) {
      writer.uint32(112).uint32(message.scanCooldownSec);
    }
    if (message.slot !== 0) {
      writer.uint32(120).uint32(message.slot);
    }
    if (message.team !== 0) {
      writer.uint32(128).uint32(message.team);
    }
    if (message.phase !== 0) {
      writer.uint32(136).int32(message.phase);
    }
    if (message.phaseLeftSec !== 0) {
      writer.uint32(144).uint32(message.phaseLeftSec);
    }
    if (message.baseCanFireTorpedoes !== false) {
      writer.uint32(152).bool(message.baseCanFireTorpedoes);
    }
    for (const v of message.markers) {
      ArcadeMarker.encode(v!, writer.uint32(162).fork()).join();
    }
    for (const v of message.autoSpawns) {
      ArcadeAutoSpawn.encode(v!, writer.uint32(170).fork()).join();
    }
    if (message.recordInput !== false) {
      writer.uint32(176).bool(message.recordInput);
    }
    if (message.replayCode !== "") {
      writer.uint32(186).string(message.replayCode);
    }
    if (message.spectateDelaySec !== 0) {
      writer.uint32(192).uint32(message.spectateDelaySec);
    }
    for (const v of message.drillSteps) {
      ArcadeDrillStep.encode(v!, writer.uint32(202).fork()).join();
    }
    if (message.drillStep !== 0) {
      writer.uint32(208).uint32(message.drillStep);
    }
    for (const v of message.structures) {
      ArcadeStructure.encode(v!, writer.uint32(218).fork()).join();
    }
    if (message.rules !== undefined) {
      ArcadeRules.encode(message.rules, writer.uint32(226).fork()).join();
    }
    for (const v of message.seaObjects) {
      ArcadeSeaObject.encode(v!, writer.uint32(242).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mapName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.win = ArcadeWin.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.timeoutSec = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.creditsPerSec = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.startingCredits = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.minedCreditRate = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.ships.push(ArcadeVariant.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.torpedoes.push(ArcadeTorpedo.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.sovEnabled = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.seats.push(ArcadeSeatInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.scanCooldownSec = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.slot = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.team = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.phase = reader.int32() as any;
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.phaseLeftSec = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.baseCanFireTorpedoes = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.markers.push(ArcadeMarker.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.autoSpawns.push(ArcadeAutoSpawn.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.recordInput = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.replayCode = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.spectateDelaySec = reader.uint32();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.drillSteps.push(ArcadeDrillStep.decode(reader, reader.uint32()));
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.drillStep = reader.uint32();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.structures.push(ArcadeStructure.decode(reader, reader.uint32()));
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.rules = ArcadeRules.decode(reader, reader.uint32());
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.seaObjects.push(ArcadeSeaObject.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeInfo>, I>>(base?: I): ArcadeInfo {
    return ArcadeInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeInfo>, I>>(object: I): ArcadeInfo {
    const message = createBaseArcadeInfo();
    message.mapName = object.mapName ?? "";
    message.category = object.category ?? "";
    message.description = object.description ?? "";
    message.win = (object.win !== undefined && object.win !== null) ? ArcadeWin.fromPartial(object.win) : undefined;
    message.timeoutSec = object.timeoutSec ?? 0;
    message.creditsPerSec = object.creditsPerSec ?? 0;
    message.startingCredits = object.startingCredits ?? 0;
    message.minedCreditRate = object.minedCreditRate ?? 0;
    message.ships = object.ships?.map((e) => ArcadeVariant.fromPartial(e)) || [];
    message.torpedoes = object.torpedoes?.map((e) => ArcadeTorpedo.fromPartial(e)) || [];
    message.sovEnabled = object.sovEnabled ?? false;
    message.seats = object.seats?.map((e) => ArcadeSeatInfo.fromPartial(e)) || [];
    message.scanCooldownSec = object.scanCooldownSec ?? 0;
    message.slot = object.slot ?? 0;
    message.team = object.team ?? 0;
    message.phase = object.phase ?? 0;
    message.phaseLeftSec = object.phaseLeftSec ?? 0;
    message.baseCanFireTorpedoes = object.baseCanFireTorpedoes ?? false;
    message.markers = object.markers?.map((e) => ArcadeMarker.fromPartial(e)) || [];
    message.autoSpawns = object.autoSpawns?.map((e) => ArcadeAutoSpawn.fromPartial(e)) || [];
    message.recordInput = object.recordInput ?? false;
    message.replayCode = object.replayCode ?? "";
    message.spectateDelaySec = object.spectateDelaySec ?? 0;
    message.drillSteps = object.drillSteps?.map((e) => ArcadeDrillStep.fromPartial(e)) || [];
    message.drillStep = object.drillStep ?? 0;
    message.structures = object.structures?.map((e) => ArcadeStructure.fromPartial(e)) || [];
    message.rules = (object.rules !== undefined && object.rules !== null)
      ? ArcadeRules.fromPartial(object.rules)
      : undefined;
    message.seaObjects = object.seaObjects?.map((e) => ArcadeSeaObject.fromPartial(e)) || [];
    return message;
  },
};

function createBaseArcadeRules(): ArcadeRules {
  return {
    depth: false,
    currents: false,
    currentScale: 0,
    plot: false,
    fairways: false,
    pirates: false,
    monsters: false,
    seaObjects: false,
    commandShip: false,
  };
}

export const ArcadeRules: MessageFns<ArcadeRules> = {
  encode(message: ArcadeRules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.depth !== false) {
      writer.uint32(8).bool(message.depth);
    }
    if (message.currents !== false) {
      writer.uint32(16).bool(message.currents);
    }
    if (message.currentScale !== 0) {
      writer.uint32(25).double(message.currentScale);
    }
    if (message.plot !== false) {
      writer.uint32(32).bool(message.plot);
    }
    if (message.fairways !== false) {
      writer.uint32(40).bool(message.fairways);
    }
    if (message.pirates !== false) {
      writer.uint32(48).bool(message.pirates);
    }
    if (message.monsters !== false) {
      writer.uint32(56).bool(message.monsters);
    }
    if (message.seaObjects !== false) {
      writer.uint32(64).bool(message.seaObjects);
    }
    if (message.commandShip !== false) {
      writer.uint32(72).bool(message.commandShip);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.depth = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.currents = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.currentScale = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.plot = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.fairways = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.pirates = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.monsters = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.seaObjects = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.commandShip = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeRules>, I>>(base?: I): ArcadeRules {
    return ArcadeRules.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeRules>, I>>(object: I): ArcadeRules {
    const message = createBaseArcadeRules();
    message.depth = object.depth ?? false;
    message.currents = object.currents ?? false;
    message.currentScale = object.currentScale ?? 0;
    message.plot = object.plot ?? false;
    message.fairways = object.fairways ?? false;
    message.pirates = object.pirates ?? false;
    message.monsters = object.monsters ?? false;
    message.seaObjects = object.seaObjects ?? false;
    message.commandShip = object.commandShip ?? false;
    return message;
  },
};

function createBaseArcadeDrillStep(): ArcadeDrillStep {
  return {
    id: "",
    text: "",
    chrome: "",
    spot: undefined,
    done: "",
    count: 0,
    win: undefined,
    camera: undefined,
    touch: "",
    mouse: "",
    select: "",
  };
}

export const ArcadeDrillStep: MessageFns<ArcadeDrillStep> = {
  encode(message: ArcadeDrillStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    if (message.chrome !== "") {
      writer.uint32(26).string(message.chrome);
    }
    if (message.spot !== undefined) {
      ArcadeDrillSpot.encode(message.spot, writer.uint32(34).fork()).join();
    }
    if (message.done !== "") {
      writer.uint32(42).string(message.done);
    }
    if (message.count !== 0) {
      writer.uint32(48).uint32(message.count);
    }
    if (message.win !== undefined) {
      ArcadeWin.encode(message.win, writer.uint32(58).fork()).join();
    }
    if (message.camera !== undefined) {
      ArcadeDrillPoint.encode(message.camera, writer.uint32(66).fork()).join();
    }
    if (message.touch !== "") {
      writer.uint32(74).string(message.touch);
    }
    if (message.mouse !== "") {
      writer.uint32(82).string(message.mouse);
    }
    if (message.select !== "") {
      writer.uint32(90).string(message.select);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeDrillStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeDrillStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.chrome = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.spot = ArcadeDrillSpot.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.done = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.win = ArcadeWin.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.camera = ArcadeDrillPoint.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.touch = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.mouse = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.select = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeDrillStep>, I>>(base?: I): ArcadeDrillStep {
    return ArcadeDrillStep.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeDrillStep>, I>>(object: I): ArcadeDrillStep {
    const message = createBaseArcadeDrillStep();
    message.id = object.id ?? "";
    message.text = object.text ?? "";
    message.chrome = object.chrome ?? "";
    message.spot = (object.spot !== undefined && object.spot !== null)
      ? ArcadeDrillSpot.fromPartial(object.spot)
      : undefined;
    message.done = object.done ?? "";
    message.count = object.count ?? 0;
    message.win = (object.win !== undefined && object.win !== null) ? ArcadeWin.fromPartial(object.win) : undefined;
    message.camera = (object.camera !== undefined && object.camera !== null)
      ? ArcadeDrillPoint.fromPartial(object.camera)
      : undefined;
    message.touch = object.touch ?? "";
    message.mouse = object.mouse ?? "";
    message.select = object.select ?? "";
    return message;
  },
};

function createBaseArcadeDrillPoint(): ArcadeDrillPoint {
  return { xMpx: 0, yMpx: 0 };
}

export const ArcadeDrillPoint: MessageFns<ArcadeDrillPoint> = {
  encode(message: ArcadeDrillPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.xMpx !== 0) {
      writer.uint32(8).int32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(16).int32(message.yMpx);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeDrillPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeDrillPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.xMpx = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.yMpx = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeDrillPoint>, I>>(base?: I): ArcadeDrillPoint {
    return ArcadeDrillPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeDrillPoint>, I>>(object: I): ArcadeDrillPoint {
    const message = createBaseArcadeDrillPoint();
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    return message;
  },
};

function createBaseArcadeDrillSpot(): ArcadeDrillSpot {
  return { cell: 0, xMpx: 0, yMpx: 0, rMpx: 0 };
}

export const ArcadeDrillSpot: MessageFns<ArcadeDrillSpot> = {
  encode(message: ArcadeDrillSpot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cell !== 0) {
      writer.uint32(8).uint32(message.cell);
    }
    if (message.xMpx !== 0) {
      writer.uint32(16).int32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(24).int32(message.yMpx);
    }
    if (message.rMpx !== 0) {
      writer.uint32(32).uint32(message.rMpx);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeDrillSpot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeDrillSpot();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.xMpx = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.yMpx = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.rMpx = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeDrillSpot>, I>>(base?: I): ArcadeDrillSpot {
    return ArcadeDrillSpot.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeDrillSpot>, I>>(object: I): ArcadeDrillSpot {
    const message = createBaseArcadeDrillSpot();
    message.cell = object.cell ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.rMpx = object.rMpx ?? 0;
    return message;
  },
};

function createBaseArcadeAutoSpawn(): ArcadeAutoSpawn {
  return { name: "", torpedo: false, everySec: 0, inSec: 0 };
}

export const ArcadeAutoSpawn: MessageFns<ArcadeAutoSpawn> = {
  encode(message: ArcadeAutoSpawn, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.torpedo !== false) {
      writer.uint32(16).bool(message.torpedo);
    }
    if (message.everySec !== 0) {
      writer.uint32(25).double(message.everySec);
    }
    if (message.inSec !== 0) {
      writer.uint32(33).double(message.inSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeAutoSpawn {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeAutoSpawn();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.torpedo = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.everySec = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.inSec = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeAutoSpawn>, I>>(base?: I): ArcadeAutoSpawn {
    return ArcadeAutoSpawn.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeAutoSpawn>, I>>(object: I): ArcadeAutoSpawn {
    const message = createBaseArcadeAutoSpawn();
    message.name = object.name ?? "";
    message.torpedo = object.torpedo ?? false;
    message.everySec = object.everySec ?? 0;
    message.inSec = object.inSec ?? 0;
    return message;
  },
};

function createBaseArcadeMarker(): ArcadeMarker {
  return { cell: 0, shape: "", color: 0, heading: 0 };
}

export const ArcadeMarker: MessageFns<ArcadeMarker> = {
  encode(message: ArcadeMarker, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cell !== 0) {
      writer.uint32(8).uint32(message.cell);
    }
    if (message.shape !== "") {
      writer.uint32(18).string(message.shape);
    }
    if (message.color !== 0) {
      writer.uint32(24).uint32(message.color);
    }
    if (message.heading !== 0) {
      writer.uint32(32).uint32(message.heading);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeMarker {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeMarker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.shape = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.color = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.heading = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeMarker>, I>>(base?: I): ArcadeMarker {
    return ArcadeMarker.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeMarker>, I>>(object: I): ArcadeMarker {
    const message = createBaseArcadeMarker();
    message.cell = object.cell ?? 0;
    message.shape = object.shape ?? "";
    message.color = object.color ?? 0;
    message.heading = object.heading ?? 0;
    return message;
  },
};

function createBaseArcadePlayerStats(): ArcadePlayerStats {
  return {
    slot: 0,
    team: 0,
    playerId: 0,
    name: "",
    bot: false,
    killsByShip: 0,
    killsByTorpedo: 0,
    losses: 0,
    cellsTaken: 0,
    unitsMined: 0,
    creditsEarned: 0,
    creditsSpent: 0,
    scans: 0,
    rated: false,
    ladderBefore: 0,
    ladderAfter: 0,
  };
}

export const ArcadePlayerStats: MessageFns<ArcadePlayerStats> = {
  encode(message: ArcadePlayerStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.slot !== 0) {
      writer.uint32(8).uint32(message.slot);
    }
    if (message.team !== 0) {
      writer.uint32(16).uint32(message.team);
    }
    if (message.playerId !== 0) {
      writer.uint32(24).uint32(message.playerId);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.bot !== false) {
      writer.uint32(40).bool(message.bot);
    }
    if (message.killsByShip !== 0) {
      writer.uint32(48).uint32(message.killsByShip);
    }
    if (message.killsByTorpedo !== 0) {
      writer.uint32(56).uint32(message.killsByTorpedo);
    }
    if (message.losses !== 0) {
      writer.uint32(64).uint32(message.losses);
    }
    if (message.cellsTaken !== 0) {
      writer.uint32(72).uint32(message.cellsTaken);
    }
    if (message.unitsMined !== 0) {
      writer.uint32(80).uint32(message.unitsMined);
    }
    if (message.creditsEarned !== 0) {
      writer.uint32(88).uint32(message.creditsEarned);
    }
    if (message.creditsSpent !== 0) {
      writer.uint32(96).uint32(message.creditsSpent);
    }
    if (message.scans !== 0) {
      writer.uint32(104).uint32(message.scans);
    }
    if (message.rated !== false) {
      writer.uint32(112).bool(message.rated);
    }
    if (message.ladderBefore !== 0) {
      writer.uint32(120).sint32(message.ladderBefore);
    }
    if (message.ladderAfter !== 0) {
      writer.uint32(128).sint32(message.ladderAfter);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadePlayerStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadePlayerStats();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.slot = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.team = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.playerId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.bot = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.killsByShip = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.killsByTorpedo = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.losses = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.cellsTaken = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.unitsMined = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.creditsEarned = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.creditsSpent = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.scans = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.rated = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.ladderBefore = reader.sint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.ladderAfter = reader.sint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadePlayerStats>, I>>(base?: I): ArcadePlayerStats {
    return ArcadePlayerStats.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadePlayerStats>, I>>(object: I): ArcadePlayerStats {
    const message = createBaseArcadePlayerStats();
    message.slot = object.slot ?? 0;
    message.team = object.team ?? 0;
    message.playerId = object.playerId ?? 0;
    message.name = object.name ?? "";
    message.bot = object.bot ?? false;
    message.killsByShip = object.killsByShip ?? 0;
    message.killsByTorpedo = object.killsByTorpedo ?? 0;
    message.losses = object.losses ?? 0;
    message.cellsTaken = object.cellsTaken ?? 0;
    message.unitsMined = object.unitsMined ?? 0;
    message.creditsEarned = object.creditsEarned ?? 0;
    message.creditsSpent = object.creditsSpent ?? 0;
    message.scans = object.scans ?? 0;
    message.rated = object.rated ?? false;
    message.ladderBefore = object.ladderBefore ?? 0;
    message.ladderAfter = object.ladderAfter ?? 0;
    return message;
  },
};

function createBaseArcadeSummary(): ArcadeSummary {
  return {
    verdict: 0,
    reason: "",
    winTeam: 0,
    elapsedSec: 0,
    mapName: "",
    rows: [],
    achievements: [],
    ladder: 0,
    reasonCode: undefined,
  };
}

export const ArcadeSummary: MessageFns<ArcadeSummary> = {
  encode(message: ArcadeSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.verdict !== 0) {
      writer.uint32(8).int32(message.verdict);
    }
    if (message.reason !== "") {
      writer.uint32(18).string(message.reason);
    }
    if (message.winTeam !== 0) {
      writer.uint32(24).uint32(message.winTeam);
    }
    if (message.elapsedSec !== 0) {
      writer.uint32(32).uint32(message.elapsedSec);
    }
    if (message.mapName !== "") {
      writer.uint32(42).string(message.mapName);
    }
    for (const v of message.rows) {
      ArcadePlayerStats.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.achievements) {
      AchievementUnlock.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.ladder !== 0) {
      writer.uint32(64).int32(message.ladder);
    }
    if (message.reasonCode !== undefined) {
      ArcadeReason.encode(message.reasonCode, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.verdict = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.winTeam = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.elapsedSec = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.mapName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.rows.push(ArcadePlayerStats.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.achievements.push(AchievementUnlock.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.ladder = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.reasonCode = ArcadeReason.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeSummary>, I>>(base?: I): ArcadeSummary {
    return ArcadeSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeSummary>, I>>(object: I): ArcadeSummary {
    const message = createBaseArcadeSummary();
    message.verdict = object.verdict ?? 0;
    message.reason = object.reason ?? "";
    message.winTeam = object.winTeam ?? 0;
    message.elapsedSec = object.elapsedSec ?? 0;
    message.mapName = object.mapName ?? "";
    message.rows = object.rows?.map((e) => ArcadePlayerStats.fromPartial(e)) || [];
    message.achievements = object.achievements?.map((e) => AchievementUnlock.fromPartial(e)) || [];
    message.ladder = object.ladder ?? 0;
    message.reasonCode = (object.reasonCode !== undefined && object.reasonCode !== null)
      ? ArcadeReason.fromPartial(object.reasonCode)
      : undefined;
    return message;
  },
};

function createBaseArcadeReason(): ArcadeReason {
  return { id: "", team: 0, figure: 0, className: "", led: "" };
}

export const ArcadeReason: MessageFns<ArcadeReason> = {
  encode(message: ArcadeReason, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.team !== 0) {
      writer.uint32(16).uint32(message.team);
    }
    if (message.figure !== 0) {
      writer.uint32(25).double(message.figure);
    }
    if (message.className !== "") {
      writer.uint32(34).string(message.className);
    }
    if (message.led !== "") {
      writer.uint32(42).string(message.led);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeReason {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeReason();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.team = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.figure = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.className = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.led = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeReason>, I>>(base?: I): ArcadeReason {
    return ArcadeReason.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeReason>, I>>(object: I): ArcadeReason {
    const message = createBaseArcadeReason();
    message.id = object.id ?? "";
    message.team = object.team ?? 0;
    message.figure = object.figure ?? 0;
    message.className = object.className ?? "";
    message.led = object.led ?? "";
    return message;
  },
};

function createBaseReplayChunk(): ReplayChunk {
  return {
    records: new Uint8Array(0),
    count: 0,
    live: false,
    caughtUp: false,
    edgeWallMs: 0,
    fromKeyframe: false,
    historyBytes: 0,
  };
}

export const ReplayChunk: MessageFns<ReplayChunk> = {
  encode(message: ReplayChunk, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.records.length !== 0) {
      writer.uint32(10).bytes(message.records);
    }
    if (message.count !== 0) {
      writer.uint32(16).uint32(message.count);
    }
    if (message.live !== false) {
      writer.uint32(24).bool(message.live);
    }
    if (message.caughtUp !== false) {
      writer.uint32(32).bool(message.caughtUp);
    }
    if (message.edgeWallMs !== 0) {
      writer.uint32(40).uint64(message.edgeWallMs);
    }
    if (message.fromKeyframe !== false) {
      writer.uint32(48).bool(message.fromKeyframe);
    }
    if (message.historyBytes !== 0) {
      writer.uint32(56).uint64(message.historyBytes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReplayChunk {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReplayChunk();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.records = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.live = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.caughtUp = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.edgeWallMs = longToNumber(reader.uint64());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.fromKeyframe = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.historyBytes = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ReplayChunk>, I>>(base?: I): ReplayChunk {
    return ReplayChunk.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReplayChunk>, I>>(object: I): ReplayChunk {
    const message = createBaseReplayChunk();
    message.records = object.records ?? new Uint8Array(0);
    message.count = object.count ?? 0;
    message.live = object.live ?? false;
    message.caughtUp = object.caughtUp ?? false;
    message.edgeWallMs = object.edgeWallMs ?? 0;
    message.fromKeyframe = object.fromKeyframe ?? false;
    message.historyBytes = object.historyBytes ?? 0;
    return message;
  },
};

function createBaseArcadeInput(): ArcadeInput {
  return { tMs: 0, taps: [], hotkeys: [], zoomMinPct: 0, zoomMaxPct: 0, view: undefined, viewChanges: 0, scrollPx: 0 };
}

export const ArcadeInput: MessageFns<ArcadeInput> = {
  encode(message: ArcadeInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tMs !== 0) {
      writer.uint32(8).uint64(message.tMs);
    }
    for (const v of message.taps) {
      ArcadeTap.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.hotkeys) {
      writer.uint32(26).string(v!);
    }
    if (message.zoomMinPct !== 0) {
      writer.uint32(32).uint32(message.zoomMinPct);
    }
    if (message.zoomMaxPct !== 0) {
      writer.uint32(40).uint32(message.zoomMaxPct);
    }
    if (message.view !== undefined) {
      Viewport.encode(message.view, writer.uint32(50).fork()).join();
    }
    if (message.viewChanges !== 0) {
      writer.uint32(56).uint32(message.viewChanges);
    }
    if (message.scrollPx !== 0) {
      writer.uint32(64).uint32(message.scrollPx);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tMs = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.taps.push(ArcadeTap.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.hotkeys.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.zoomMinPct = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.zoomMaxPct = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.view = Viewport.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.viewChanges = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.scrollPx = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeInput>, I>>(base?: I): ArcadeInput {
    return ArcadeInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeInput>, I>>(object: I): ArcadeInput {
    const message = createBaseArcadeInput();
    message.tMs = object.tMs ?? 0;
    message.taps = object.taps?.map((e) => ArcadeTap.fromPartial(e)) || [];
    message.hotkeys = object.hotkeys?.map((e) => e) || [];
    message.zoomMinPct = object.zoomMinPct ?? 0;
    message.zoomMaxPct = object.zoomMaxPct ?? 0;
    message.view = (object.view !== undefined && object.view !== null) ? Viewport.fromPartial(object.view) : undefined;
    message.viewChanges = object.viewChanges ?? 0;
    message.scrollPx = object.scrollPx ?? 0;
    return message;
  },
};

function createBaseArcadeTap(): ArcadeTap {
  return { dtMs: 0, sx: 0, sy: 0, xMpx: 0, yMpx: 0, kind: 0 };
}

export const ArcadeTap: MessageFns<ArcadeTap> = {
  encode(message: ArcadeTap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dtMs !== 0) {
      writer.uint32(8).uint32(message.dtMs);
    }
    if (message.sx !== 0) {
      writer.uint32(16).uint32(message.sx);
    }
    if (message.sy !== 0) {
      writer.uint32(24).uint32(message.sy);
    }
    if (message.xMpx !== 0) {
      writer.uint32(32).sint32(message.xMpx);
    }
    if (message.yMpx !== 0) {
      writer.uint32(40).sint32(message.yMpx);
    }
    if (message.kind !== 0) {
      writer.uint32(48).uint32(message.kind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeTap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeTap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.dtMs = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sx = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.sy = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.xMpx = reader.sint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.yMpx = reader.sint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.kind = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeTap>, I>>(base?: I): ArcadeTap {
    return ArcadeTap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeTap>, I>>(object: I): ArcadeTap {
    const message = createBaseArcadeTap();
    message.dtMs = object.dtMs ?? 0;
    message.sx = object.sx ?? 0;
    message.sy = object.sy ?? 0;
    message.xMpx = object.xMpx ?? 0;
    message.yMpx = object.yMpx ?? 0;
    message.kind = object.kind ?? 0;
    return message;
  },
};

function createBaseArcadeHost(): ArcadeHost {
  return {};
}

export const ArcadeHost: MessageFns<ArcadeHost> = {
  encode(_: ArcadeHost, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeHost {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeHost();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeHost>, I>>(base?: I): ArcadeHost {
    return ArcadeHost.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeHost>, I>>(_: I): ArcadeHost {
    const message = createBaseArcadeHost();
    return message;
  },
};

function createBaseArcadeHostJoin(): ArcadeHostJoin {
  return { code: "" };
}

export const ArcadeHostJoin: MessageFns<ArcadeHostJoin> = {
  encode(message: ArcadeHostJoin, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeHostJoin {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeHostJoin();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeHostJoin>, I>>(base?: I): ArcadeHostJoin {
    return ArcadeHostJoin.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeHostJoin>, I>>(object: I): ArcadeHostJoin {
    const message = createBaseArcadeHostJoin();
    message.code = object.code ?? "";
    return message;
  },
};

function createBaseArcadeHostAction(): ArcadeHostAction {
  return { kind: 0, slot: 0, accountId: 0, category: "", mapId: "", delaySec: 0 };
}

export const ArcadeHostAction: MessageFns<ArcadeHostAction> = {
  encode(message: ArcadeHostAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.slot !== 0) {
      writer.uint32(16).uint32(message.slot);
    }
    if (message.accountId !== 0) {
      writer.uint32(24).uint32(message.accountId);
    }
    if (message.category !== "") {
      writer.uint32(34).string(message.category);
    }
    if (message.mapId !== "") {
      writer.uint32(42).string(message.mapId);
    }
    if (message.delaySec !== 0) {
      writer.uint32(48).uint32(message.delaySec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeHostAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeHostAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.slot = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.accountId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.mapId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.delaySec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeHostAction>, I>>(base?: I): ArcadeHostAction {
    return ArcadeHostAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeHostAction>, I>>(object: I): ArcadeHostAction {
    const message = createBaseArcadeHostAction();
    message.kind = object.kind ?? 0;
    message.slot = object.slot ?? 0;
    message.accountId = object.accountId ?? 0;
    message.category = object.category ?? "";
    message.mapId = object.mapId ?? "";
    message.delaySec = object.delaySec ?? 0;
    return message;
  },
};

function createBaseArcadeHostPerson(): ArcadeHostPerson {
  return { accountId: 0, name: "", host: false };
}

export const ArcadeHostPerson: MessageFns<ArcadeHostPerson> = {
  encode(message: ArcadeHostPerson, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== 0) {
      writer.uint32(8).uint32(message.accountId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.host !== false) {
      writer.uint32(24).bool(message.host);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeHostPerson {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeHostPerson();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.accountId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.host = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeHostPerson>, I>>(base?: I): ArcadeHostPerson {
    return ArcadeHostPerson.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeHostPerson>, I>>(object: I): ArcadeHostPerson {
    const message = createBaseArcadeHostPerson();
    message.accountId = object.accountId ?? 0;
    message.name = object.name ?? "";
    message.host = object.host ?? false;
    return message;
  },
};

function createBaseArcadeHostSeat(): ArcadeHostSeat {
  return { slot: 0, team: 0, kind: 0, who: undefined };
}

export const ArcadeHostSeat: MessageFns<ArcadeHostSeat> = {
  encode(message: ArcadeHostSeat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.slot !== 0) {
      writer.uint32(8).uint32(message.slot);
    }
    if (message.team !== 0) {
      writer.uint32(16).uint32(message.team);
    }
    if (message.kind !== 0) {
      writer.uint32(24).uint32(message.kind);
    }
    if (message.who !== undefined) {
      ArcadeHostPerson.encode(message.who, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeHostSeat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeHostSeat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.slot = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.team = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.kind = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.who = ArcadeHostPerson.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeHostSeat>, I>>(base?: I): ArcadeHostSeat {
    return ArcadeHostSeat.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeHostSeat>, I>>(object: I): ArcadeHostSeat {
    const message = createBaseArcadeHostSeat();
    message.slot = object.slot ?? 0;
    message.team = object.team ?? 0;
    message.kind = object.kind ?? 0;
    message.who = (object.who !== undefined && object.who !== null)
      ? ArcadeHostPerson.fromPartial(object.who)
      : undefined;
    return message;
  },
};

function createBaseArcadeHosting(): ArcadeHosting {
  return {
    code: "",
    link: "",
    hostAccount: 0,
    youAreHost: false,
    yourSlot: 0,
    category: "",
    mapId: "",
    mapName: "",
    mapRevision: 0,
    winLine: "",
    cols: 0,
    rows: 0,
    seats: [],
    observers: [],
    delaySec: 0,
    timeoutSec: 0,
    timeoutLeftSec: 0,
    canStart: false,
    ended: false,
    reason: 0,
  };
}

export const ArcadeHosting: MessageFns<ArcadeHosting> = {
  encode(message: ArcadeHosting, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.link !== "") {
      writer.uint32(18).string(message.link);
    }
    if (message.hostAccount !== 0) {
      writer.uint32(24).uint32(message.hostAccount);
    }
    if (message.youAreHost !== false) {
      writer.uint32(32).bool(message.youAreHost);
    }
    if (message.yourSlot !== 0) {
      writer.uint32(40).uint32(message.yourSlot);
    }
    if (message.category !== "") {
      writer.uint32(50).string(message.category);
    }
    if (message.mapId !== "") {
      writer.uint32(58).string(message.mapId);
    }
    if (message.mapName !== "") {
      writer.uint32(66).string(message.mapName);
    }
    if (message.mapRevision !== 0) {
      writer.uint32(72).uint32(message.mapRevision);
    }
    if (message.winLine !== "") {
      writer.uint32(82).string(message.winLine);
    }
    if (message.cols !== 0) {
      writer.uint32(88).uint32(message.cols);
    }
    if (message.rows !== 0) {
      writer.uint32(96).uint32(message.rows);
    }
    for (const v of message.seats) {
      ArcadeHostSeat.encode(v!, writer.uint32(106).fork()).join();
    }
    for (const v of message.observers) {
      ArcadeHostPerson.encode(v!, writer.uint32(114).fork()).join();
    }
    if (message.delaySec !== 0) {
      writer.uint32(120).uint32(message.delaySec);
    }
    if (message.timeoutSec !== 0) {
      writer.uint32(128).uint32(message.timeoutSec);
    }
    if (message.timeoutLeftSec !== 0) {
      writer.uint32(136).uint32(message.timeoutLeftSec);
    }
    if (message.canStart !== false) {
      writer.uint32(144).bool(message.canStart);
    }
    if (message.ended !== false) {
      writer.uint32(152).bool(message.ended);
    }
    if (message.reason !== 0) {
      writer.uint32(160).int32(message.reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArcadeHosting {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArcadeHosting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.link = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.hostAccount = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.youAreHost = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.yourSlot = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.mapId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.mapName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.mapRevision = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.winLine = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.cols = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.rows = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.seats.push(ArcadeHostSeat.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.observers.push(ArcadeHostPerson.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.delaySec = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.timeoutSec = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.timeoutLeftSec = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.canStart = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.ended = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.reason = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ArcadeHosting>, I>>(base?: I): ArcadeHosting {
    return ArcadeHosting.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArcadeHosting>, I>>(object: I): ArcadeHosting {
    const message = createBaseArcadeHosting();
    message.code = object.code ?? "";
    message.link = object.link ?? "";
    message.hostAccount = object.hostAccount ?? 0;
    message.youAreHost = object.youAreHost ?? false;
    message.yourSlot = object.yourSlot ?? 0;
    message.category = object.category ?? "";
    message.mapId = object.mapId ?? "";
    message.mapName = object.mapName ?? "";
    message.mapRevision = object.mapRevision ?? 0;
    message.winLine = object.winLine ?? "";
    message.cols = object.cols ?? 0;
    message.rows = object.rows ?? 0;
    message.seats = object.seats?.map((e) => ArcadeHostSeat.fromPartial(e)) || [];
    message.observers = object.observers?.map((e) => ArcadeHostPerson.fromPartial(e)) || [];
    message.delaySec = object.delaySec ?? 0;
    message.timeoutSec = object.timeoutSec ?? 0;
    message.timeoutLeftSec = object.timeoutLeftSec ?? 0;
    message.canStart = object.canStart ?? false;
    message.ended = object.ended ?? false;
    message.reason = object.reason ?? 0;
    return message;
  },
};

function createBaseCasinoQueueJoin(): CasinoQueueJoin {
  return { game: 0, stakeTier: 0 };
}

export const CasinoQueueJoin: MessageFns<CasinoQueueJoin> = {
  encode(message: CasinoQueueJoin, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.game !== 0) {
      writer.uint32(8).int32(message.game);
    }
    if (message.stakeTier !== 0) {
      writer.uint32(16).uint32(message.stakeTier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoQueueJoin {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoQueueJoin();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.game = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.stakeTier = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoQueueJoin>, I>>(base?: I): CasinoQueueJoin {
    return CasinoQueueJoin.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoQueueJoin>, I>>(object: I): CasinoQueueJoin {
    const message = createBaseCasinoQueueJoin();
    message.game = object.game ?? 0;
    message.stakeTier = object.stakeTier ?? 0;
    return message;
  },
};

function createBaseCasinoQueueLeave(): CasinoQueueLeave {
  return {};
}

export const CasinoQueueLeave: MessageFns<CasinoQueueLeave> = {
  encode(_: CasinoQueueLeave, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoQueueLeave {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoQueueLeave();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoQueueLeave>, I>>(base?: I): CasinoQueueLeave {
    return CasinoQueueLeave.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoQueueLeave>, I>>(_: I): CasinoQueueLeave {
    const message = createBaseCasinoQueueLeave();
    return message;
  },
};

function createBaseCasinoJoinTable(): CasinoJoinTable {
  return { tableId: 0 };
}

export const CasinoJoinTable: MessageFns<CasinoJoinTable> = {
  encode(message: CasinoJoinTable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tableId !== 0) {
      writer.uint32(8).uint32(message.tableId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoJoinTable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoJoinTable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tableId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoJoinTable>, I>>(base?: I): CasinoJoinTable {
    return CasinoJoinTable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoJoinTable>, I>>(object: I): CasinoJoinTable {
    const message = createBaseCasinoJoinTable();
    message.tableId = object.tableId ?? 0;
    return message;
  },
};

function createBaseCasinoLeave(): CasinoLeave {
  return {};
}

export const CasinoLeave: MessageFns<CasinoLeave> = {
  encode(_: CasinoLeave, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoLeave {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoLeave();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoLeave>, I>>(base?: I): CasinoLeave {
    return CasinoLeave.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoLeave>, I>>(_: I): CasinoLeave {
    const message = createBaseCasinoLeave();
    return message;
  },
};

function createBaseCasinoAct(): CasinoAct {
  return { action: 0, amount: 0, betKind: 0, betNumbers: [] };
}

export const CasinoAct: MessageFns<CasinoAct> = {
  encode(message: CasinoAct, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.action !== 0) {
      writer.uint32(8).int32(message.action);
    }
    if (message.amount !== 0) {
      writer.uint32(16).uint32(message.amount);
    }
    if (message.betKind !== 0) {
      writer.uint32(24).uint32(message.betKind);
    }
    writer.uint32(34).fork();
    for (const v of message.betNumbers) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoAct {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoAct();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.action = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.amount = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.betKind = reader.uint32();
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.betNumbers.push(reader.uint32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.betNumbers.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoAct>, I>>(base?: I): CasinoAct {
    return CasinoAct.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoAct>, I>>(object: I): CasinoAct {
    const message = createBaseCasinoAct();
    message.action = object.action ?? 0;
    message.amount = object.amount ?? 0;
    message.betKind = object.betKind ?? 0;
    message.betNumbers = object.betNumbers?.map((e) => e) || [];
    return message;
  },
};

function createBaseMapMarker(): MapMarker {
  return { id: 0, ownerId: 0, ownerName: "", kind: 0, cell: 0, audience: 0, expiresUnix: 0 };
}

export const MapMarker: MessageFns<MapMarker> = {
  encode(message: MapMarker, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.ownerId !== 0) {
      writer.uint32(16).uint32(message.ownerId);
    }
    if (message.ownerName !== "") {
      writer.uint32(26).string(message.ownerName);
    }
    if (message.kind !== 0) {
      writer.uint32(32).int32(message.kind);
    }
    if (message.cell !== 0) {
      writer.uint32(40).uint32(message.cell);
    }
    if (message.audience !== 0) {
      writer.uint32(48).int32(message.audience);
    }
    if (message.expiresUnix !== 0) {
      writer.uint32(56).uint64(message.expiresUnix);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MapMarker {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMapMarker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.ownerId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ownerName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.audience = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.expiresUnix = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<MapMarker>, I>>(base?: I): MapMarker {
    return MapMarker.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MapMarker>, I>>(object: I): MapMarker {
    const message = createBaseMapMarker();
    message.id = object.id ?? 0;
    message.ownerId = object.ownerId ?? 0;
    message.ownerName = object.ownerName ?? "";
    message.kind = object.kind ?? 0;
    message.cell = object.cell ?? 0;
    message.audience = object.audience ?? 0;
    message.expiresUnix = object.expiresUnix ?? 0;
    return message;
  },
};

function createBaseMarkerAction(): MarkerAction {
  return { kind: 0, cell: 0, audience: 0, removeId: 0 };
}

export const MarkerAction: MessageFns<MarkerAction> = {
  encode(message: MarkerAction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.cell !== 0) {
      writer.uint32(16).uint32(message.cell);
    }
    if (message.audience !== 0) {
      writer.uint32(24).int32(message.audience);
    }
    if (message.removeId !== 0) {
      writer.uint32(32).uint32(message.removeId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarkerAction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarkerAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.audience = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.removeId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<MarkerAction>, I>>(base?: I): MarkerAction {
    return MarkerAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MarkerAction>, I>>(object: I): MarkerAction {
    const message = createBaseMarkerAction();
    message.kind = object.kind ?? 0;
    message.cell = object.cell ?? 0;
    message.audience = object.audience ?? 0;
    message.removeId = object.removeId ?? 0;
    return message;
  },
};

function createBaseReport(): Report {
  return { kind: 0, lineId: 0, accountId: 0, fleetId: 0, reason: "", note: "", body: 0, cache: 0 };
}

export const Report: MessageFns<Report> = {
  encode(message: Report, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.lineId !== 0) {
      writer.uint32(16).uint64(message.lineId);
    }
    if (message.accountId !== 0) {
      writer.uint32(24).uint32(message.accountId);
    }
    if (message.fleetId !== 0) {
      writer.uint32(32).uint32(message.fleetId);
    }
    if (message.reason !== "") {
      writer.uint32(42).string(message.reason);
    }
    if (message.note !== "") {
      writer.uint32(50).string(message.note);
    }
    if (message.body !== 0) {
      writer.uint32(56).uint32(message.body);
    }
    if (message.cache !== 0) {
      writer.uint32(64).uint32(message.cache);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Report {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReport();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.lineId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.accountId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.note = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.body = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.cache = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Report>, I>>(base?: I): Report {
    return Report.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Report>, I>>(object: I): Report {
    const message = createBaseReport();
    message.kind = object.kind ?? 0;
    message.lineId = object.lineId ?? 0;
    message.accountId = object.accountId ?? 0;
    message.fleetId = object.fleetId ?? 0;
    message.reason = object.reason ?? "";
    message.note = object.note ?? "";
    message.body = object.body ?? 0;
    message.cache = object.cache ?? 0;
    return message;
  },
};

function createBaseBlock(): Block {
  return { accountId: 0 };
}

export const Block: MessageFns<Block> = {
  encode(message: Block, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== 0) {
      writer.uint32(8).uint32(message.accountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Block {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlock();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.accountId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Block>, I>>(base?: I): Block {
    return Block.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Block>, I>>(object: I): Block {
    const message = createBaseBlock();
    message.accountId = object.accountId ?? 0;
    return message;
  },
};

function createBaseMarkers(): Markers {
  return { markers: [] };
}

export const Markers: MessageFns<Markers> = {
  encode(message: Markers, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.markers) {
      MapMarker.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Markers {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarkers();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.markers.push(MapMarker.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Markers>, I>>(base?: I): Markers {
    return Markers.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Markers>, I>>(object: I): Markers {
    const message = createBaseMarkers();
    message.markers = object.markers?.map((e) => MapMarker.fromPartial(e)) || [];
    return message;
  },
};

function createBaseQuickRef(): QuickRef {
  return { kind: 0, id: 0 };
}

export const QuickRef: MessageFns<QuickRef> = {
  encode(message: QuickRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.id !== 0) {
      writer.uint32(16).uint32(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QuickRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuickRef();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<QuickRef>, I>>(base?: I): QuickRef {
    return QuickRef.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QuickRef>, I>>(object: I): QuickRef {
    const message = createBaseQuickRef();
    message.kind = object.kind ?? 0;
    message.id = object.id ?? 0;
    return message;
  },
};

function createBaseQuickPos(): QuickPos {
  return { kind: 0, cell: 0, siteId: 0, fleetName: "" };
}

export const QuickPos: MessageFns<QuickPos> = {
  encode(message: QuickPos, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.cell !== 0) {
      writer.uint32(16).uint32(message.cell);
    }
    if (message.siteId !== 0) {
      writer.uint32(24).uint32(message.siteId);
    }
    if (message.fleetName !== "") {
      writer.uint32(34).string(message.fleetName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QuickPos {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuickPos();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.siteId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fleetName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<QuickPos>, I>>(base?: I): QuickPos {
    return QuickPos.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QuickPos>, I>>(object: I): QuickPos {
    const message = createBaseQuickPos();
    message.kind = object.kind ?? 0;
    message.cell = object.cell ?? 0;
    message.siteId = object.siteId ?? 0;
    message.fleetName = object.fleetName ?? "";
    return message;
  },
};

function createBaseRenameFleet(): RenameFleet {
  return { fleetId: 0, name: "" };
}

export const RenameFleet: MessageFns<RenameFleet> = {
  encode(message: RenameFleet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fleetId !== 0) {
      writer.uint32(8).uint32(message.fleetId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RenameFleet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRenameFleet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fleetId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RenameFleet>, I>>(base?: I): RenameFleet {
    return RenameFleet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RenameFleet>, I>>(object: I): RenameFleet {
    const message = createBaseRenameFleet();
    message.fleetId = object.fleetId ?? 0;
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseCasinoSpin(): CasinoSpin {
  return { stakeTier: 0 };
}

export const CasinoSpin: MessageFns<CasinoSpin> = {
  encode(message: CasinoSpin, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stakeTier !== 0) {
      writer.uint32(8).uint32(message.stakeTier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoSpin {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoSpin();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.stakeTier = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoSpin>, I>>(base?: I): CasinoSpin {
    return CasinoSpin.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoSpin>, I>>(object: I): CasinoSpin {
    const message = createBaseCasinoSpin();
    message.stakeTier = object.stakeTier ?? 0;
    return message;
  },
};

function createBaseCasinoLobbyTable(): CasinoLobbyTable {
  return { id: 0, game: 0, stakeTier: 0, seats: 0, seated: 0, humans: 0, phase: 0, leftSec: 0 };
}

export const CasinoLobbyTable: MessageFns<CasinoLobbyTable> = {
  encode(message: CasinoLobbyTable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.game !== 0) {
      writer.uint32(16).int32(message.game);
    }
    if (message.stakeTier !== 0) {
      writer.uint32(24).uint32(message.stakeTier);
    }
    if (message.seats !== 0) {
      writer.uint32(32).uint32(message.seats);
    }
    if (message.seated !== 0) {
      writer.uint32(40).uint32(message.seated);
    }
    if (message.humans !== 0) {
      writer.uint32(48).uint32(message.humans);
    }
    if (message.phase !== 0) {
      writer.uint32(56).int32(message.phase);
    }
    if (message.leftSec !== 0) {
      writer.uint32(64).uint32(message.leftSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoLobbyTable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoLobbyTable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.game = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.stakeTier = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.seats = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.seated = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.humans = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.phase = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.leftSec = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoLobbyTable>, I>>(base?: I): CasinoLobbyTable {
    return CasinoLobbyTable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoLobbyTable>, I>>(object: I): CasinoLobbyTable {
    const message = createBaseCasinoLobbyTable();
    message.id = object.id ?? 0;
    message.game = object.game ?? 0;
    message.stakeTier = object.stakeTier ?? 0;
    message.seats = object.seats ?? 0;
    message.seated = object.seated ?? 0;
    message.humans = object.humans ?? 0;
    message.phase = object.phase ?? 0;
    message.leftSec = object.leftSec ?? 0;
    return message;
  },
};

function createBaseCasinoLobby(): CasinoLobby {
  return {
    tables: [],
    queueState: 0,
    queueGame: 0,
    queueStakeTier: 0,
    waitedSec: 0,
    fillLeftSec: 0,
    yourTable: 0,
    closed: false,
    queueSeats: 0,
    queueFilled: 0,
    clubFaction: 0,
    clubNet: 0,
    clubCarry: 0,
    clubMembers: 0,
    clubCells: [],
  };
}

export const CasinoLobby: MessageFns<CasinoLobby> = {
  encode(message: CasinoLobby, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tables) {
      CasinoLobbyTable.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.queueState !== 0) {
      writer.uint32(16).int32(message.queueState);
    }
    if (message.queueGame !== 0) {
      writer.uint32(24).int32(message.queueGame);
    }
    if (message.queueStakeTier !== 0) {
      writer.uint32(32).uint32(message.queueStakeTier);
    }
    if (message.waitedSec !== 0) {
      writer.uint32(40).uint32(message.waitedSec);
    }
    if (message.fillLeftSec !== 0) {
      writer.uint32(48).uint32(message.fillLeftSec);
    }
    if (message.yourTable !== 0) {
      writer.uint32(56).uint32(message.yourTable);
    }
    if (message.closed !== false) {
      writer.uint32(64).bool(message.closed);
    }
    if (message.queueSeats !== 0) {
      writer.uint32(72).uint32(message.queueSeats);
    }
    if (message.queueFilled !== 0) {
      writer.uint32(80).uint32(message.queueFilled);
    }
    if (message.clubFaction !== 0) {
      writer.uint32(88).uint32(message.clubFaction);
    }
    if (message.clubNet !== 0) {
      writer.uint32(96).sint64(message.clubNet);
    }
    if (message.clubCarry !== 0) {
      writer.uint32(104).uint32(message.clubCarry);
    }
    if (message.clubMembers !== 0) {
      writer.uint32(112).uint32(message.clubMembers);
    }
    writer.uint32(122).fork();
    for (const v of message.clubCells) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoLobby {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoLobby();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tables.push(CasinoLobbyTable.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.queueState = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.queueGame = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.queueStakeTier = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.waitedSec = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.fillLeftSec = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.yourTable = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.closed = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.queueSeats = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.queueFilled = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.clubFaction = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.clubNet = longToNumber(reader.sint64());
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.clubCarry = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.clubMembers = reader.uint32();
          continue;
        }
        case 15: {
          if (tag === 120) {
            message.clubCells.push(reader.uint32());

            continue;
          }

          if (tag === 122) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.clubCells.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoLobby>, I>>(base?: I): CasinoLobby {
    return CasinoLobby.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoLobby>, I>>(object: I): CasinoLobby {
    const message = createBaseCasinoLobby();
    message.tables = object.tables?.map((e) => CasinoLobbyTable.fromPartial(e)) || [];
    message.queueState = object.queueState ?? 0;
    message.queueGame = object.queueGame ?? 0;
    message.queueStakeTier = object.queueStakeTier ?? 0;
    message.waitedSec = object.waitedSec ?? 0;
    message.fillLeftSec = object.fillLeftSec ?? 0;
    message.yourTable = object.yourTable ?? 0;
    message.closed = object.closed ?? false;
    message.queueSeats = object.queueSeats ?? 0;
    message.queueFilled = object.queueFilled ?? 0;
    message.clubFaction = object.clubFaction ?? 0;
    message.clubNet = object.clubNet ?? 0;
    message.clubCarry = object.clubCarry ?? 0;
    message.clubMembers = object.clubMembers ?? 0;
    message.clubCells = object.clubCells?.map((e) => e) || [];
    return message;
  },
};

function createBaseCasinoBet(): CasinoBet {
  return { kind: 0, numbers: [], amount: 0 };
}

export const CasinoBet: MessageFns<CasinoBet> = {
  encode(message: CasinoBet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).uint32(message.kind);
    }
    writer.uint32(18).fork();
    for (const v of message.numbers) {
      writer.uint32(v);
    }
    writer.join();
    if (message.amount !== 0) {
      writer.uint32(24).uint32(message.amount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoBet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoBet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.uint32();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.numbers.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.numbers.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.amount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoBet>, I>>(base?: I): CasinoBet {
    return CasinoBet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoBet>, I>>(object: I): CasinoBet {
    const message = createBaseCasinoBet();
    message.kind = object.kind ?? 0;
    message.numbers = object.numbers?.map((e) => e) || [];
    message.amount = object.amount ?? 0;
    return message;
  },
};

function createBaseCasinoSeatView(): CasinoSeatView {
  return {
    seat: 0,
    playerId: 0,
    name: "",
    chips: 0,
    bet: 0,
    folded: false,
    fictive: false,
    bot: false,
    isYou: false,
    cards: [],
    insured: false,
    sittingOut: false,
    allIn: false,
    faction: 0,
  };
}

export const CasinoSeatView: MessageFns<CasinoSeatView> = {
  encode(message: CasinoSeatView, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.seat !== 0) {
      writer.uint32(8).uint32(message.seat);
    }
    if (message.playerId !== 0) {
      writer.uint32(16).uint32(message.playerId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.chips !== 0) {
      writer.uint32(32).uint32(message.chips);
    }
    if (message.bet !== 0) {
      writer.uint32(40).uint32(message.bet);
    }
    if (message.folded !== false) {
      writer.uint32(48).bool(message.folded);
    }
    if (message.fictive !== false) {
      writer.uint32(56).bool(message.fictive);
    }
    if (message.bot !== false) {
      writer.uint32(64).bool(message.bot);
    }
    if (message.isYou !== false) {
      writer.uint32(72).bool(message.isYou);
    }
    writer.uint32(82).fork();
    for (const v of message.cards) {
      writer.uint32(v);
    }
    writer.join();
    if (message.insured !== false) {
      writer.uint32(88).bool(message.insured);
    }
    if (message.sittingOut !== false) {
      writer.uint32(96).bool(message.sittingOut);
    }
    if (message.allIn !== false) {
      writer.uint32(104).bool(message.allIn);
    }
    if (message.faction !== 0) {
      writer.uint32(112).uint32(message.faction);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoSeatView {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoSeatView();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.seat = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.playerId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.chips = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.bet = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.folded = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.fictive = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.bot = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.isYou = reader.bool();
          continue;
        }
        case 10: {
          if (tag === 80) {
            message.cards.push(reader.uint32());

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.cards.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.insured = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.sittingOut = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.allIn = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.faction = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoSeatView>, I>>(base?: I): CasinoSeatView {
    return CasinoSeatView.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoSeatView>, I>>(object: I): CasinoSeatView {
    const message = createBaseCasinoSeatView();
    message.seat = object.seat ?? 0;
    message.playerId = object.playerId ?? 0;
    message.name = object.name ?? "";
    message.chips = object.chips ?? 0;
    message.bet = object.bet ?? 0;
    message.folded = object.folded ?? false;
    message.fictive = object.fictive ?? false;
    message.bot = object.bot ?? false;
    message.isYou = object.isYou ?? false;
    message.cards = object.cards?.map((e) => e) || [];
    message.insured = object.insured ?? false;
    message.sittingOut = object.sittingOut ?? false;
    message.allIn = object.allIn ?? false;
    message.faction = object.faction ?? 0;
    return message;
  },
};

function createBaseCasinoTable(): CasinoTable {
  return {
    id: 0,
    game: 0,
    stakeTier: 0,
    phase: 0,
    turnSeat: 0,
    actLeftSec: 0,
    seats: [],
    allowedActions: [],
    yourBets: [],
    board: [],
    yourHole: [],
    dealerUp: 0,
    dealerCards: [],
    pot: 0,
    buttonSeat: 0,
    handId: 0,
    minBet: 0,
    toCall: 0,
    minRaise: 0,
    yourSeat: 0,
  };
}

export const CasinoTable: MessageFns<CasinoTable> = {
  encode(message: CasinoTable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.game !== 0) {
      writer.uint32(16).int32(message.game);
    }
    if (message.stakeTier !== 0) {
      writer.uint32(24).uint32(message.stakeTier);
    }
    if (message.phase !== 0) {
      writer.uint32(32).int32(message.phase);
    }
    if (message.turnSeat !== 0) {
      writer.uint32(40).uint32(message.turnSeat);
    }
    if (message.actLeftSec !== 0) {
      writer.uint32(48).uint32(message.actLeftSec);
    }
    for (const v of message.seats) {
      CasinoSeatView.encode(v!, writer.uint32(58).fork()).join();
    }
    writer.uint32(66).fork();
    for (const v of message.allowedActions) {
      writer.int32(v);
    }
    writer.join();
    for (const v of message.yourBets) {
      CasinoBet.encode(v!, writer.uint32(74).fork()).join();
    }
    writer.uint32(82).fork();
    for (const v of message.board) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(90).fork();
    for (const v of message.yourHole) {
      writer.uint32(v);
    }
    writer.join();
    if (message.dealerUp !== 0) {
      writer.uint32(96).uint32(message.dealerUp);
    }
    writer.uint32(106).fork();
    for (const v of message.dealerCards) {
      writer.uint32(v);
    }
    writer.join();
    if (message.pot !== 0) {
      writer.uint32(112).uint32(message.pot);
    }
    if (message.buttonSeat !== 0) {
      writer.uint32(120).uint32(message.buttonSeat);
    }
    if (message.handId !== 0) {
      writer.uint32(128).uint32(message.handId);
    }
    if (message.minBet !== 0) {
      writer.uint32(136).uint32(message.minBet);
    }
    if (message.toCall !== 0) {
      writer.uint32(144).uint32(message.toCall);
    }
    if (message.minRaise !== 0) {
      writer.uint32(152).uint32(message.minRaise);
    }
    if (message.yourSeat !== 0) {
      writer.uint32(160).uint32(message.yourSeat);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoTable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoTable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.game = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.stakeTier = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.phase = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.turnSeat = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.actLeftSec = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.seats.push(CasinoSeatView.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.allowedActions.push(reader.int32() as any);

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.allowedActions.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.yourBets.push(CasinoBet.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag === 80) {
            message.board.push(reader.uint32());

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.board.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 11: {
          if (tag === 88) {
            message.yourHole.push(reader.uint32());

            continue;
          }

          if (tag === 90) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.yourHole.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.dealerUp = reader.uint32();
          continue;
        }
        case 13: {
          if (tag === 104) {
            message.dealerCards.push(reader.uint32());

            continue;
          }

          if (tag === 106) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.dealerCards.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.pot = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.buttonSeat = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.handId = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.minBet = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.toCall = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.minRaise = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.yourSeat = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoTable>, I>>(base?: I): CasinoTable {
    return CasinoTable.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoTable>, I>>(object: I): CasinoTable {
    const message = createBaseCasinoTable();
    message.id = object.id ?? 0;
    message.game = object.game ?? 0;
    message.stakeTier = object.stakeTier ?? 0;
    message.phase = object.phase ?? 0;
    message.turnSeat = object.turnSeat ?? 0;
    message.actLeftSec = object.actLeftSec ?? 0;
    message.seats = object.seats?.map((e) => CasinoSeatView.fromPartial(e)) || [];
    message.allowedActions = object.allowedActions?.map((e) => e) || [];
    message.yourBets = object.yourBets?.map((e) => CasinoBet.fromPartial(e)) || [];
    message.board = object.board?.map((e) => e) || [];
    message.yourHole = object.yourHole?.map((e) => e) || [];
    message.dealerUp = object.dealerUp ?? 0;
    message.dealerCards = object.dealerCards?.map((e) => e) || [];
    message.pot = object.pot ?? 0;
    message.buttonSeat = object.buttonSeat ?? 0;
    message.handId = object.handId ?? 0;
    message.minBet = object.minBet ?? 0;
    message.toCall = object.toCall ?? 0;
    message.minRaise = object.minRaise ?? 0;
    message.yourSeat = object.yourSeat ?? 0;
    return message;
  },
};

function createBaseCasinoSeatResult(): CasinoSeatResult {
  return { seat: 0, delta: 0, handRankLine: "" };
}

export const CasinoSeatResult: MessageFns<CasinoSeatResult> = {
  encode(message: CasinoSeatResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.seat !== 0) {
      writer.uint32(8).uint32(message.seat);
    }
    if (message.delta !== 0) {
      writer.uint32(16).int64(message.delta);
    }
    if (message.handRankLine !== "") {
      writer.uint32(26).string(message.handRankLine);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoSeatResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoSeatResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.seat = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.delta = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.handRankLine = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoSeatResult>, I>>(base?: I): CasinoSeatResult {
    return CasinoSeatResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoSeatResult>, I>>(object: I): CasinoSeatResult {
    const message = createBaseCasinoSeatResult();
    message.seat = object.seat ?? 0;
    message.delta = object.delta ?? 0;
    message.handRankLine = object.handRankLine ?? "";
    return message;
  },
};

function createBaseCasinoResult(): CasinoResult {
  return {
    tableId: 0,
    handId: 0,
    game: 0,
    seats: [],
    rouletteNumber: 0,
    reels: [],
    slotPays: 0,
    rake: 0,
    aborted: false,
    yourDelta: 0,
    line: "",
    yourStake: 0,
  };
}

export const CasinoResult: MessageFns<CasinoResult> = {
  encode(message: CasinoResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tableId !== 0) {
      writer.uint32(8).uint32(message.tableId);
    }
    if (message.handId !== 0) {
      writer.uint32(16).uint32(message.handId);
    }
    if (message.game !== 0) {
      writer.uint32(24).int32(message.game);
    }
    for (const v of message.seats) {
      CasinoSeatResult.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.rouletteNumber !== 0) {
      writer.uint32(40).uint32(message.rouletteNumber);
    }
    writer.uint32(50).fork();
    for (const v of message.reels) {
      writer.uint32(v);
    }
    writer.join();
    if (message.slotPays !== 0) {
      writer.uint32(56).uint32(message.slotPays);
    }
    if (message.rake !== 0) {
      writer.uint32(64).uint32(message.rake);
    }
    if (message.aborted !== false) {
      writer.uint32(72).bool(message.aborted);
    }
    if (message.yourDelta !== 0) {
      writer.uint32(80).int64(message.yourDelta);
    }
    if (message.line !== "") {
      writer.uint32(90).string(message.line);
    }
    if (message.yourStake !== 0) {
      writer.uint32(96).uint32(message.yourStake);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tableId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.handId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.game = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.seats.push(CasinoSeatResult.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.rouletteNumber = reader.uint32();
          continue;
        }
        case 6: {
          if (tag === 48) {
            message.reels.push(reader.uint32());

            continue;
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.reels.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.slotPays = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.rake = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.aborted = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.yourDelta = longToNumber(reader.int64());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.line = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.yourStake = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoResult>, I>>(base?: I): CasinoResult {
    return CasinoResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoResult>, I>>(object: I): CasinoResult {
    const message = createBaseCasinoResult();
    message.tableId = object.tableId ?? 0;
    message.handId = object.handId ?? 0;
    message.game = object.game ?? 0;
    message.seats = object.seats?.map((e) => CasinoSeatResult.fromPartial(e)) || [];
    message.rouletteNumber = object.rouletteNumber ?? 0;
    message.reels = object.reels?.map((e) => e) || [];
    message.slotPays = object.slotPays ?? 0;
    message.rake = object.rake ?? 0;
    message.aborted = object.aborted ?? false;
    message.yourDelta = object.yourDelta ?? 0;
    message.line = object.line ?? "";
    message.yourStake = object.yourStake ?? 0;
    return message;
  },
};

function createBaseCasinoStake(): CasinoStake {
  return { tier: 0, minBet: 0, buyInMin: 0, buyInMax: 0, smallBlind: 0 };
}

export const CasinoStake: MessageFns<CasinoStake> = {
  encode(message: CasinoStake, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tier !== 0) {
      writer.uint32(8).uint32(message.tier);
    }
    if (message.minBet !== 0) {
      writer.uint32(16).uint32(message.minBet);
    }
    if (message.buyInMin !== 0) {
      writer.uint32(24).uint32(message.buyInMin);
    }
    if (message.buyInMax !== 0) {
      writer.uint32(32).uint32(message.buyInMax);
    }
    if (message.smallBlind !== 0) {
      writer.uint32(40).uint32(message.smallBlind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoStake {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoStake();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tier = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.minBet = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.buyInMin = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.buyInMax = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.smallBlind = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoStake>, I>>(base?: I): CasinoStake {
    return CasinoStake.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoStake>, I>>(object: I): CasinoStake {
    const message = createBaseCasinoStake();
    message.tier = object.tier ?? 0;
    message.minBet = object.minBet ?? 0;
    message.buyInMin = object.buyInMin ?? 0;
    message.buyInMax = object.buyInMax ?? 0;
    message.smallBlind = object.smallBlind ?? 0;
    return message;
  },
};

function createBaseCasinoRoulettePayout(): CasinoRoulettePayout {
  return { kind: 0, code: "", pays: 0, covers: 0 };
}

export const CasinoRoulettePayout: MessageFns<CasinoRoulettePayout> = {
  encode(message: CasinoRoulettePayout, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).uint32(message.kind);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.pays !== 0) {
      writer.uint32(24).uint32(message.pays);
    }
    if (message.covers !== 0) {
      writer.uint32(32).uint32(message.covers);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoRoulettePayout {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoRoulettePayout();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pays = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.covers = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoRoulettePayout>, I>>(base?: I): CasinoRoulettePayout {
    return CasinoRoulettePayout.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoRoulettePayout>, I>>(object: I): CasinoRoulettePayout {
    const message = createBaseCasinoRoulettePayout();
    message.kind = object.kind ?? 0;
    message.code = object.code ?? "";
    message.pays = object.pays ?? 0;
    message.covers = object.covers ?? 0;
    return message;
  },
};

function createBaseCasinoSlotPay(): CasinoSlotPay {
  return { code: "", pays: 0 };
}

export const CasinoSlotPay: MessageFns<CasinoSlotPay> = {
  encode(message: CasinoSlotPay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.pays !== 0) {
      writer.uint32(16).uint32(message.pays);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoSlotPay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoSlotPay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.pays = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoSlotPay>, I>>(base?: I): CasinoSlotPay {
    return CasinoSlotPay.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoSlotPay>, I>>(object: I): CasinoSlotPay {
    const message = createBaseCasinoSlotPay();
    message.code = object.code ?? "";
    message.pays = object.pays ?? 0;
    return message;
  },
};

function createBaseCasinoRules(): CasinoRules {
  return {
    stakes: [],
    roulette: [],
    roulettePockets: 0,
    blackjackDecks: 0,
    blackjackPaysNum: 0,
    blackjackPaysDen: 0,
    insurancePays: 0,
    slotsRtpPct: 0,
    slotPaytable: [],
    slotSymbols: [],
    holdemSeats: 0,
    rakePct: 0,
    rakeCapBb: 0,
    actSec: 0,
    fillAfterSec: 0,
    rouletteBetSec: 0,
    rouletteSpinSec: 0,
    humanAbsentSec: 0,
    rejoinCooldownSec: 0,
    blackjackEdgePct: 0,
    clubShare: 0,
    blackjackSpanishShoe: false,
  };
}

export const CasinoRules: MessageFns<CasinoRules> = {
  encode(message: CasinoRules, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.stakes) {
      CasinoStake.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.roulette) {
      CasinoRoulettePayout.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.roulettePockets !== 0) {
      writer.uint32(24).uint32(message.roulettePockets);
    }
    if (message.blackjackDecks !== 0) {
      writer.uint32(32).uint32(message.blackjackDecks);
    }
    if (message.blackjackPaysNum !== 0) {
      writer.uint32(40).uint32(message.blackjackPaysNum);
    }
    if (message.blackjackPaysDen !== 0) {
      writer.uint32(48).uint32(message.blackjackPaysDen);
    }
    if (message.insurancePays !== 0) {
      writer.uint32(56).uint32(message.insurancePays);
    }
    if (message.slotsRtpPct !== 0) {
      writer.uint32(64).uint32(message.slotsRtpPct);
    }
    for (const v of message.slotPaytable) {
      CasinoSlotPay.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.slotSymbols) {
      writer.uint32(82).string(v!);
    }
    if (message.holdemSeats !== 0) {
      writer.uint32(88).uint32(message.holdemSeats);
    }
    if (message.rakePct !== 0) {
      writer.uint32(97).double(message.rakePct);
    }
    if (message.rakeCapBb !== 0) {
      writer.uint32(104).uint32(message.rakeCapBb);
    }
    if (message.actSec !== 0) {
      writer.uint32(112).uint32(message.actSec);
    }
    if (message.fillAfterSec !== 0) {
      writer.uint32(120).uint32(message.fillAfterSec);
    }
    if (message.rouletteBetSec !== 0) {
      writer.uint32(128).uint32(message.rouletteBetSec);
    }
    if (message.rouletteSpinSec !== 0) {
      writer.uint32(136).uint32(message.rouletteSpinSec);
    }
    if (message.humanAbsentSec !== 0) {
      writer.uint32(144).uint32(message.humanAbsentSec);
    }
    if (message.rejoinCooldownSec !== 0) {
      writer.uint32(152).uint32(message.rejoinCooldownSec);
    }
    if (message.blackjackEdgePct !== 0) {
      writer.uint32(161).double(message.blackjackEdgePct);
    }
    if (message.clubShare !== 0) {
      writer.uint32(169).double(message.clubShare);
    }
    if (message.blackjackSpanishShoe !== false) {
      writer.uint32(176).bool(message.blackjackSpanishShoe);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CasinoRules {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCasinoRules();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stakes.push(CasinoStake.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.roulette.push(CasinoRoulettePayout.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.roulettePockets = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.blackjackDecks = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.blackjackPaysNum = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.blackjackPaysDen = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.insurancePays = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.slotsRtpPct = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.slotPaytable.push(CasinoSlotPay.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.slotSymbols.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.holdemSeats = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 97) {
            break;
          }

          message.rakePct = reader.double();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.rakeCapBb = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.actSec = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.fillAfterSec = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.rouletteBetSec = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.rouletteSpinSec = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.humanAbsentSec = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.rejoinCooldownSec = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 161) {
            break;
          }

          message.blackjackEdgePct = reader.double();
          continue;
        }
        case 21: {
          if (tag !== 169) {
            break;
          }

          message.clubShare = reader.double();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.blackjackSpanishShoe = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<CasinoRules>, I>>(base?: I): CasinoRules {
    return CasinoRules.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CasinoRules>, I>>(object: I): CasinoRules {
    const message = createBaseCasinoRules();
    message.stakes = object.stakes?.map((e) => CasinoStake.fromPartial(e)) || [];
    message.roulette = object.roulette?.map((e) => CasinoRoulettePayout.fromPartial(e)) || [];
    message.roulettePockets = object.roulettePockets ?? 0;
    message.blackjackDecks = object.blackjackDecks ?? 0;
    message.blackjackPaysNum = object.blackjackPaysNum ?? 0;
    message.blackjackPaysDen = object.blackjackPaysDen ?? 0;
    message.insurancePays = object.insurancePays ?? 0;
    message.slotsRtpPct = object.slotsRtpPct ?? 0;
    message.slotPaytable = object.slotPaytable?.map((e) => CasinoSlotPay.fromPartial(e)) || [];
    message.slotSymbols = object.slotSymbols?.map((e) => e) || [];
    message.holdemSeats = object.holdemSeats ?? 0;
    message.rakePct = object.rakePct ?? 0;
    message.rakeCapBb = object.rakeCapBb ?? 0;
    message.actSec = object.actSec ?? 0;
    message.fillAfterSec = object.fillAfterSec ?? 0;
    message.rouletteBetSec = object.rouletteBetSec ?? 0;
    message.rouletteSpinSec = object.rouletteSpinSec ?? 0;
    message.humanAbsentSec = object.humanAbsentSec ?? 0;
    message.rejoinCooldownSec = object.rejoinCooldownSec ?? 0;
    message.blackjackEdgePct = object.blackjackEdgePct ?? 0;
    message.clubShare = object.clubShare ?? 0;
    message.blackjackSpanishShoe = object.blackjackSpanishShoe ?? false;
    return message;
  },
};

function createBaseReturnBriefing(): ReturnBriefing {
  return {
    awaySec: 0,
    leftAtSec: 0,
    sieges: [],
    cellsWon: 0,
    cellsLost: 0,
    fleetsSunk: 0,
    fleetsLost: 0,
    sickbay: [],
    lotsSold: 0,
    saleCredits: 0,
    builds: [],
    techs: [],
    sinceMsg: 0,
    covered: false,
    squadChat: [],
    squadChatMore: 0,
    factionChat: 0,
    markers: [],
    windows: [],
  };
}

export const ReturnBriefing: MessageFns<ReturnBriefing> = {
  encode(message: ReturnBriefing, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.awaySec !== 0) {
      writer.uint32(9).double(message.awaySec);
    }
    if (message.leftAtSec !== 0) {
      writer.uint32(17).double(message.leftAtSec);
    }
    for (const v of message.sieges) {
      BriefingSiege.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.cellsWon !== 0) {
      writer.uint32(32).uint32(message.cellsWon);
    }
    if (message.cellsLost !== 0) {
      writer.uint32(40).uint32(message.cellsLost);
    }
    if (message.fleetsSunk !== 0) {
      writer.uint32(48).uint32(message.fleetsSunk);
    }
    if (message.fleetsLost !== 0) {
      writer.uint32(56).uint32(message.fleetsLost);
    }
    for (const v of message.sickbay) {
      BriefingCaptain.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.lotsSold !== 0) {
      writer.uint32(72).uint32(message.lotsSold);
    }
    if (message.saleCredits !== 0) {
      writer.uint32(80).uint32(message.saleCredits);
    }
    for (const v of message.builds) {
      BriefingBuild.encode(v!, writer.uint32(90).fork()).join();
    }
    writer.uint32(98).fork();
    for (const v of message.techs) {
      writer.uint32(v);
    }
    writer.join();
    if (message.sinceMsg !== 0) {
      writer.uint32(104).uint32(message.sinceMsg);
    }
    if (message.covered !== false) {
      writer.uint32(112).bool(message.covered);
    }
    for (const v of message.squadChat) {
      ChatMsg.encode(v!, writer.uint32(122).fork()).join();
    }
    if (message.squadChatMore !== 0) {
      writer.uint32(128).uint32(message.squadChatMore);
    }
    if (message.factionChat !== 0) {
      writer.uint32(136).uint32(message.factionChat);
    }
    for (const v of message.markers) {
      MapMarker.encode(v!, writer.uint32(146).fork()).join();
    }
    for (const v of message.windows) {
      BriefingWindow.encode(v!, writer.uint32(154).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReturnBriefing {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReturnBriefing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.awaySec = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.leftAtSec = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sieges.push(BriefingSiege.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.cellsWon = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.cellsLost = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.fleetsSunk = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.fleetsLost = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.sickbay.push(BriefingCaptain.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.lotsSold = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.saleCredits = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.builds.push(BriefingBuild.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag === 96) {
            message.techs.push(reader.uint32());

            continue;
          }

          if (tag === 98) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.techs.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.sinceMsg = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.covered = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.squadChat.push(ChatMsg.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.squadChatMore = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.factionChat = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.markers.push(MapMarker.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.windows.push(BriefingWindow.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ReturnBriefing>, I>>(base?: I): ReturnBriefing {
    return ReturnBriefing.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReturnBriefing>, I>>(object: I): ReturnBriefing {
    const message = createBaseReturnBriefing();
    message.awaySec = object.awaySec ?? 0;
    message.leftAtSec = object.leftAtSec ?? 0;
    message.sieges = object.sieges?.map((e) => BriefingSiege.fromPartial(e)) || [];
    message.cellsWon = object.cellsWon ?? 0;
    message.cellsLost = object.cellsLost ?? 0;
    message.fleetsSunk = object.fleetsSunk ?? 0;
    message.fleetsLost = object.fleetsLost ?? 0;
    message.sickbay = object.sickbay?.map((e) => BriefingCaptain.fromPartial(e)) || [];
    message.lotsSold = object.lotsSold ?? 0;
    message.saleCredits = object.saleCredits ?? 0;
    message.builds = object.builds?.map((e) => BriefingBuild.fromPartial(e)) || [];
    message.techs = object.techs?.map((e) => e) || [];
    message.sinceMsg = object.sinceMsg ?? 0;
    message.covered = object.covered ?? false;
    message.squadChat = object.squadChat?.map((e) => ChatMsg.fromPartial(e)) || [];
    message.squadChatMore = object.squadChatMore ?? 0;
    message.factionChat = object.factionChat ?? 0;
    message.markers = object.markers?.map((e) => MapMarker.fromPartial(e)) || [];
    message.windows = object.windows?.map((e) => BriefingWindow.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBriefingWindow(): BriefingWindow {
  return { siteId: 0, siteName: "", cell: 0, windowHour: 0, attack: false, squadIn: 0, youIn: false };
}

export const BriefingWindow: MessageFns<BriefingWindow> = {
  encode(message: BriefingWindow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.siteId !== 0) {
      writer.uint32(8).uint32(message.siteId);
    }
    if (message.siteName !== "") {
      writer.uint32(18).string(message.siteName);
    }
    if (message.cell !== 0) {
      writer.uint32(24).uint32(message.cell);
    }
    if (message.windowHour !== 0) {
      writer.uint32(32).uint32(message.windowHour);
    }
    if (message.attack !== false) {
      writer.uint32(40).bool(message.attack);
    }
    if (message.squadIn !== 0) {
      writer.uint32(48).uint32(message.squadIn);
    }
    if (message.youIn !== false) {
      writer.uint32(56).bool(message.youIn);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BriefingWindow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBriefingWindow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.siteId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.siteName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.windowHour = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.attack = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.squadIn = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.youIn = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<BriefingWindow>, I>>(base?: I): BriefingWindow {
    return BriefingWindow.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BriefingWindow>, I>>(object: I): BriefingWindow {
    const message = createBaseBriefingWindow();
    message.siteId = object.siteId ?? 0;
    message.siteName = object.siteName ?? "";
    message.cell = object.cell ?? 0;
    message.windowHour = object.windowHour ?? 0;
    message.attack = object.attack ?? false;
    message.squadIn = object.squadIn ?? 0;
    message.youIn = object.youIn ?? false;
    return message;
  },
};

function createBaseBriefingSiege(): BriefingSiege {
  return { siteId: 0, siteName: "", cell: 0, attacker: 0, windowHour: 0 };
}

export const BriefingSiege: MessageFns<BriefingSiege> = {
  encode(message: BriefingSiege, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.siteId !== 0) {
      writer.uint32(8).uint32(message.siteId);
    }
    if (message.siteName !== "") {
      writer.uint32(18).string(message.siteName);
    }
    if (message.cell !== 0) {
      writer.uint32(24).uint32(message.cell);
    }
    if (message.attacker !== 0) {
      writer.uint32(32).uint32(message.attacker);
    }
    if (message.windowHour !== 0) {
      writer.uint32(40).uint32(message.windowHour);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BriefingSiege {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBriefingSiege();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.siteId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.siteName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cell = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.attacker = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.windowHour = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<BriefingSiege>, I>>(base?: I): BriefingSiege {
    return BriefingSiege.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BriefingSiege>, I>>(object: I): BriefingSiege {
    const message = createBaseBriefingSiege();
    message.siteId = object.siteId ?? 0;
    message.siteName = object.siteName ?? "";
    message.cell = object.cell ?? 0;
    message.attacker = object.attacker ?? 0;
    message.windowHour = object.windowHour ?? 0;
    return message;
  },
};

function createBaseBriefingCaptain(): BriefingCaptain {
  return { id: 0, name: "", backAtSec: 0 };
}

export const BriefingCaptain: MessageFns<BriefingCaptain> = {
  encode(message: BriefingCaptain, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.backAtSec !== 0) {
      writer.uint32(25).double(message.backAtSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BriefingCaptain {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBriefingCaptain();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.backAtSec = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<BriefingCaptain>, I>>(base?: I): BriefingCaptain {
    return BriefingCaptain.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BriefingCaptain>, I>>(object: I): BriefingCaptain {
    const message = createBaseBriefingCaptain();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.backAtSec = object.backAtSec ?? 0;
    return message;
  },
};

function createBaseBriefingBuild(): BriefingBuild {
  return { building: 0, level: 0, raised: 0 };
}

export const BriefingBuild: MessageFns<BriefingBuild> = {
  encode(message: BriefingBuild, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.building !== 0) {
      writer.uint32(8).int32(message.building);
    }
    if (message.level !== 0) {
      writer.uint32(16).uint32(message.level);
    }
    if (message.raised !== 0) {
      writer.uint32(24).uint32(message.raised);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BriefingBuild {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBriefingBuild();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.building = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.level = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.raised = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<BriefingBuild>, I>>(base?: I): BriefingBuild {
    return BriefingBuild.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BriefingBuild>, I>>(object: I): BriefingBuild {
    const message = createBaseBriefingBuild();
    message.building = object.building ?? 0;
    message.level = object.level ?? 0;
    message.raised = object.raised ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
